//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export * as Client from './axios-client/Client';

export * as Query from './axios-client/Query';



//-----Types.File-----
export class AcceptPlatformInvitationCommand implements IAcceptPlatformInvitationCommand {
    invitationToken!: string | null;

    constructor(data?: IAcceptPlatformInvitationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitationToken = _data["invitationToken"];
        }
    }

    static fromJS(data: any): AcceptPlatformInvitationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptPlatformInvitationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationToken"] = this.invitationToken;
        return data;
    }
}

export interface IAcceptPlatformInvitationCommand {
    invitationToken: string | null;
}

export class AcceptPlatformInvitationCommandResponse implements IAcceptPlatformInvitationCommandResponse {
    authenticationUserGuid!: string;
    resetPasswordToken?: string | null;

    constructor(data?: IAcceptPlatformInvitationCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationUserGuid = _data["authenticationUserGuid"];
            this.resetPasswordToken = _data["resetPasswordToken"];
        }
    }

    static fromJS(data: any): AcceptPlatformInvitationCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptPlatformInvitationCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationUserGuid"] = this.authenticationUserGuid;
        data["resetPasswordToken"] = this.resetPasswordToken;
        return data;
    }
}

export interface IAcceptPlatformInvitationCommandResponse {
    authenticationUserGuid: string;
    resetPasswordToken?: string | null;
}

export enum AccessTokenType {
    NotSet = "NotSet",
    External = "External",
    Widget = "Widget",
}

export enum AccountMethodEnum {
    Checking = "Checking",
    Savings = "Savings",
    CorporateChecking = "CorporateChecking",
    CorporateSavings = "CorporateSavings",
}

export class AddAgentBrokerCommand implements IAddAgentBrokerCommand {
    firstName!: string | null;
    lastName!: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;

    constructor(data?: IAddAgentBrokerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): AddAgentBrokerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddAgentBrokerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IAddAgentBrokerCommand {
    firstName: string | null;
    lastName: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
}

export class AddBookingAddonCommand implements IAddBookingAddonCommand {
    addonGuid?: string;
    name?: string | null;
    description?: string | null;
    vendorGuid?: string;
    categoryGuid?: string;
    pricingModel?: PricingModel;
    bookability?: AddonBookability;
    quantity?: number;
    days?: number | null;
    unitBasePrice?: number;
    taxes?: TaxItemRequest[] | null;
    commissionable?: boolean;
    commissionRatePercentage?: number;
    note?: string | null;
    selectionType?: AddonSelectionType;
    selectedOptionGuid?: string | null;
    selectedOptionName?: string | null;

    constructor(data?: IAddBookingAddonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addonGuid = _data["addonGuid"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.vendorGuid = _data["vendorGuid"];
            this.categoryGuid = _data["categoryGuid"];
            this.pricingModel = _data["pricingModel"];
            this.bookability = _data["bookability"];
            this.quantity = _data["quantity"];
            this.days = _data["days"];
            this.unitBasePrice = _data["unitBasePrice"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TaxItemRequest.fromJS(item));
            }
            this.commissionable = _data["commissionable"];
            this.commissionRatePercentage = _data["commissionRatePercentage"];
            this.note = _data["note"];
            this.selectionType = _data["selectionType"];
            this.selectedOptionGuid = _data["selectedOptionGuid"];
            this.selectedOptionName = _data["selectedOptionName"];
        }
    }

    static fromJS(data: any): AddBookingAddonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddBookingAddonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addonGuid"] = this.addonGuid;
        data["name"] = this.name;
        data["description"] = this.description;
        data["vendorGuid"] = this.vendorGuid;
        data["categoryGuid"] = this.categoryGuid;
        data["pricingModel"] = this.pricingModel;
        data["bookability"] = this.bookability;
        data["quantity"] = this.quantity;
        data["days"] = this.days;
        data["unitBasePrice"] = this.unitBasePrice;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        data["commissionable"] = this.commissionable;
        data["commissionRatePercentage"] = this.commissionRatePercentage;
        data["note"] = this.note;
        data["selectionType"] = this.selectionType;
        data["selectedOptionGuid"] = this.selectedOptionGuid;
        data["selectedOptionName"] = this.selectedOptionName;
        return data;
    }
}

export interface IAddBookingAddonCommand {
    addonGuid?: string;
    name?: string | null;
    description?: string | null;
    vendorGuid?: string;
    categoryGuid?: string;
    pricingModel?: PricingModel;
    bookability?: AddonBookability;
    quantity?: number;
    days?: number | null;
    unitBasePrice?: number;
    taxes?: TaxItemRequest[] | null;
    commissionable?: boolean;
    commissionRatePercentage?: number;
    note?: string | null;
    selectionType?: AddonSelectionType;
    selectedOptionGuid?: string | null;
    selectedOptionName?: string | null;
}

export class AddBookingToMultibookingCommand implements IAddBookingToMultibookingCommand {
    bookingGuid!: string;

    constructor(data?: IAddBookingToMultibookingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
        }
    }

    static fromJS(data: any): AddBookingToMultibookingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddBookingToMultibookingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        return data;
    }
}

export interface IAddBookingToMultibookingCommand {
    bookingGuid: string;
}

export class AddCampaignUrlCommand implements IAddCampaignUrlCommand {
    url!: string | null;
    description!: string | null;

    constructor(data?: IAddCampaignUrlCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AddCampaignUrlCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddCampaignUrlCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["description"] = this.description;
        return data;
    }
}

export interface IAddCampaignUrlCommand {
    url: string | null;
    description: string | null;
}

export class AddConversionTrackingDomainConfigCommand implements IAddConversionTrackingDomainConfigCommand {
    domain!: string | null;

    constructor(data?: IAddConversionTrackingDomainConfigCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): AddConversionTrackingDomainConfigCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddConversionTrackingDomainConfigCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        return data;
    }
}

export interface IAddConversionTrackingDomainConfigCommand {
    domain: string | null;
}

export class AddSalesLeadNoteRequest implements IAddSalesLeadNoteRequest {
    content!: string | null;

    constructor(data?: IAddSalesLeadNoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): AddSalesLeadNoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddSalesLeadNoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        return data;
    }
}

export interface IAddSalesLeadNoteRequest {
    content: string | null;
}

export class AdditionalBookingFeeItemDto implements IAdditionalBookingFeeItemDto {
    additionalFeeTypeGuid?: string;
    amount?: number;
    taxes?: TaxItemRequest[] | null;

    constructor(data?: IAdditionalBookingFeeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalFeeTypeGuid = _data["additionalFeeTypeGuid"];
            this.amount = _data["amount"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TaxItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdditionalBookingFeeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalBookingFeeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalFeeTypeGuid"] = this.additionalFeeTypeGuid;
        data["amount"] = this.amount;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdditionalBookingFeeItemDto {
    additionalFeeTypeGuid?: string;
    amount?: number;
    taxes?: TaxItemRequest[] | null;
}

export class AdditionalFeeItem implements IAdditionalFeeItem {
    additionalFeeTypeGuid?: string;
    code?: string | null;
    name?: string | null;
    amount?: number;

    constructor(data?: IAdditionalFeeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalFeeTypeGuid = _data["additionalFeeTypeGuid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): AdditionalFeeItem {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalFeeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalFeeTypeGuid"] = this.additionalFeeTypeGuid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IAdditionalFeeItem {
    additionalFeeTypeGuid?: string;
    code?: string | null;
    name?: string | null;
    amount?: number;
}

export class AdditionalFeeItemDto implements IAdditionalFeeItemDto {
    additionalFeeTypeGuid?: string;
    amount?: number;
    taxes?: TaxItemRequest[] | null;

    constructor(data?: IAdditionalFeeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalFeeTypeGuid = _data["additionalFeeTypeGuid"];
            this.amount = _data["amount"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TaxItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdditionalFeeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalFeeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalFeeTypeGuid"] = this.additionalFeeTypeGuid;
        data["amount"] = this.amount;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdditionalFeeItemDto {
    additionalFeeTypeGuid?: string;
    amount?: number;
    taxes?: TaxItemRequest[] | null;
}

export class AdditionalFeeItemRequest implements IAdditionalFeeItemRequest {
    additionalFeeTypeGuid?: string;
    amount?: number;
    taxes?: TaxItemRequest[] | null;

    constructor(data?: IAdditionalFeeItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalFeeTypeGuid = _data["additionalFeeTypeGuid"];
            this.amount = _data["amount"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TaxItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdditionalFeeItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalFeeItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalFeeTypeGuid"] = this.additionalFeeTypeGuid;
        data["amount"] = this.amount;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdditionalFeeItemRequest {
    additionalFeeTypeGuid?: string;
    amount?: number;
    taxes?: TaxItemRequest[] | null;
}

export class AdditionalFeeTypeItem implements IAdditionalFeeTypeItem {
    guid?: string;
    code?: string | null;
    name?: string | null;
    isActive?: boolean;
    displayOrder?: number;
    defaultTaxes?: TaxLine[] | null;

    constructor(data?: IAdditionalFeeTypeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdditionalFeeTypeItem {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalFeeTypeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdditionalFeeTypeItem {
    guid?: string;
    code?: string | null;
    name?: string | null;
    isActive?: boolean;
    displayOrder?: number;
    defaultTaxes?: TaxLine[] | null;
}

export enum AddonBookability {
    NotSet = "NotSet",
    Instant = "Instant",
    OnRequest = "OnRequest",
}

export class AddonCategoryDto implements IAddonCategoryDto {
    guid!: string;
    name!: string | null;
    publishStatus!: PublishStatus;
    createdAt!: Date;
    updatedAt?: Date | null;

    constructor(data?: IAddonCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.publishStatus = _data["publishStatus"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AddonCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddonCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["publishStatus"] = this.publishStatus;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        return data;
    }
}

export interface IAddonCategoryDto {
    guid: string;
    name: string | null;
    publishStatus: PublishStatus;
    createdAt: Date;
    updatedAt?: Date | null;
}

export class AddonDto implements IAddonDto {
    guid!: string;
    name!: string | null;
    description?: string | null;
    categoryGuid!: string;
    categoryName!: string | null;
    vendorGuid!: string;
    vendorName!: string | null;
    pricingModel!: PricingModel;
    basePrice!: number;
    defaultTaxes!: TaxLine[] | null;
    commissionable!: boolean;
    commissionRatePercentage!: number;
    bookability!: AddonBookability;
    maxQuantity?: number | null;
    selectionType!: AddonSelectionType;
    options?: AddonOptionDto[] | null;
    publishStatus!: PublishStatus;
    createdAt!: Date;
    updatedAt?: Date | null;

    constructor(data?: IAddonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.categoryGuid = _data["categoryGuid"];
            this.categoryName = _data["categoryName"];
            this.vendorGuid = _data["vendorGuid"];
            this.vendorName = _data["vendorName"];
            this.pricingModel = _data["pricingModel"];
            this.basePrice = _data["basePrice"];
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
            this.commissionable = _data["commissionable"];
            this.commissionRatePercentage = _data["commissionRatePercentage"];
            this.bookability = _data["bookability"];
            this.maxQuantity = _data["maxQuantity"];
            this.selectionType = _data["selectionType"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(AddonOptionDto.fromJS(item));
            }
            this.publishStatus = _data["publishStatus"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AddonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["description"] = this.description;
        data["categoryGuid"] = this.categoryGuid;
        data["categoryName"] = this.categoryName;
        data["vendorGuid"] = this.vendorGuid;
        data["vendorName"] = this.vendorName;
        data["pricingModel"] = this.pricingModel;
        data["basePrice"] = this.basePrice;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        data["commissionable"] = this.commissionable;
        data["commissionRatePercentage"] = this.commissionRatePercentage;
        data["bookability"] = this.bookability;
        data["maxQuantity"] = this.maxQuantity;
        data["selectionType"] = this.selectionType;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["publishStatus"] = this.publishStatus;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        return data;
    }
}

export interface IAddonDto {
    guid: string;
    name: string | null;
    description?: string | null;
    categoryGuid: string;
    categoryName: string | null;
    vendorGuid: string;
    vendorName: string | null;
    pricingModel: PricingModel;
    basePrice: number;
    defaultTaxes: TaxLine[] | null;
    commissionable: boolean;
    commissionRatePercentage: number;
    bookability: AddonBookability;
    maxQuantity?: number | null;
    selectionType: AddonSelectionType;
    options?: AddonOptionDto[] | null;
    publishStatus: PublishStatus;
    createdAt: Date;
    updatedAt?: Date | null;
}

export class AddonDtoPaginatedResult implements IAddonDtoPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: AddonDto[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IAddonDtoPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AddonDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): AddonDtoPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new AddonDtoPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IAddonDtoPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: AddonDto[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class AddonOptionDto implements IAddonOptionDto {
    guid!: string;
    name!: string | null;
    description?: string | null;
    basePrice!: number;
    isDefault!: boolean;
    sortOrder!: number;

    constructor(data?: IAddonOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.basePrice = _data["basePrice"];
            this.isDefault = _data["isDefault"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): AddonOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddonOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["description"] = this.description;
        data["basePrice"] = this.basePrice;
        data["isDefault"] = this.isDefault;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IAddonOptionDto {
    guid: string;
    name: string | null;
    description?: string | null;
    basePrice: number;
    isDefault: boolean;
    sortOrder: number;
}

export enum AddonSelectionType {
    Simple = "Simple",
    SingleSelect = "SingleSelect",
}

export enum AddonSortOptions {
    Name = "Name",
    UpdatedAtUtc = "UpdatedAtUtc",
}

export class AffectedCustomPriceInfo implements IAffectedCustomPriceInfo {
    listingGuid!: string;
    date!: Date;
    basePrice!: number;

    constructor(data?: IAffectedCustomPriceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingGuid = _data["listingGuid"];
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
            this.basePrice = _data["basePrice"];
        }
    }

    static fromJS(data: any): AffectedCustomPriceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AffectedCustomPriceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingGuid"] = this.listingGuid;
        data["date"] = this.date && formatDate(this.date);
        data["basePrice"] = this.basePrice;
        return data;
    }
}

export interface IAffectedCustomPriceInfo {
    listingGuid: string;
    date: Date;
    basePrice: number;
}

export enum AgentSortOptions {
    Name = "Name",
    Group = "Group",
    CreatedAtUtc = "CreatedAtUtc",
}

export class AircallCallData implements IAircallCallData {
    id?: number;
    call_uuid?: string | null;
    direction?: string | null;
    status?: string | null;
    started_at?: number | null;
    answered_at?: number | null;
    ended_at?: number | null;
    duration?: number | null;
    raw_digits?: string | null;
    recording?: string | null;
    voicemail?: string | null;
    tags?: AircallTag[] | null;
    comments?: AircallComment[] | null;
    user?: AircallUser;
    number?: AircallNumber;
    contact?: AircallContact;

    constructor(data?: IAircallCallData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.call_uuid = _data["call_uuid"];
            this.direction = _data["direction"];
            this.status = _data["status"];
            this.started_at = _data["started_at"];
            this.answered_at = _data["answered_at"];
            this.ended_at = _data["ended_at"];
            this.duration = _data["duration"];
            this.raw_digits = _data["raw_digits"];
            this.recording = _data["recording"];
            this.voicemail = _data["voicemail"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(AircallTag.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(AircallComment.fromJS(item));
            }
            this.user = _data["user"] ? AircallUser.fromJS(_data["user"]) : <any>null;
            this.number = _data["number"] ? AircallNumber.fromJS(_data["number"]) : <any>null;
            this.contact = _data["contact"] ? AircallContact.fromJS(_data["contact"]) : <any>null;
        }
    }

    static fromJS(data: any): AircallCallData {
        data = typeof data === 'object' ? data : {};
        let result = new AircallCallData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["call_uuid"] = this.call_uuid;
        data["direction"] = this.direction;
        data["status"] = this.status;
        data["started_at"] = this.started_at;
        data["answered_at"] = this.answered_at;
        data["ended_at"] = this.ended_at;
        data["duration"] = this.duration;
        data["raw_digits"] = this.raw_digits;
        data["recording"] = this.recording;
        data["voicemail"] = this.voicemail;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : this.user;
        data["number"] = this.number ? this.number.toJSON() : this.number;
        data["contact"] = this.contact ? this.contact.toJSON() : this.contact;
        return data;
    }
}

export interface IAircallCallData {
    id?: number;
    call_uuid?: string | null;
    direction?: string | null;
    status?: string | null;
    started_at?: number | null;
    answered_at?: number | null;
    ended_at?: number | null;
    duration?: number | null;
    raw_digits?: string | null;
    recording?: string | null;
    voicemail?: string | null;
    tags?: AircallTag[] | null;
    comments?: AircallComment[] | null;
    user?: AircallUser;
    number?: AircallNumber;
    contact?: AircallContact;
}

export class AircallCallWebhookRequest implements IAircallCallWebhookRequest {
    event?: string | null;
    data?: AircallCallData;

    constructor(data?: IAircallCallWebhookRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"];
            this.data = _data["data"] ? AircallCallData.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): AircallCallWebhookRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AircallCallWebhookRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["data"] = this.data ? this.data.toJSON() : this.data;
        return data;
    }
}

export interface IAircallCallWebhookRequest {
    event?: string | null;
    data?: AircallCallData;
}

export class AircallComment implements IAircallComment {
    id?: number;
    content?: string | null;
    posted_at?: string | null;
    posted_by?: AircallUser;

    constructor(data?: IAircallComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.posted_at = _data["posted_at"];
            this.posted_by = _data["posted_by"] ? AircallUser.fromJS(_data["posted_by"]) : <any>null;
        }
    }

    static fromJS(data: any): AircallComment {
        data = typeof data === 'object' ? data : {};
        let result = new AircallComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["posted_at"] = this.posted_at;
        data["posted_by"] = this.posted_by ? this.posted_by.toJSON() : this.posted_by;
        return data;
    }
}

export interface IAircallComment {
    id?: number;
    content?: string | null;
    posted_at?: string | null;
    posted_by?: AircallUser;
}

export class AircallContact implements IAircallContact {
    first_name?: string | null;
    last_name?: string | null;

    constructor(data?: IAircallContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
        }
    }

    static fromJS(data: any): AircallContact {
        data = typeof data === 'object' ? data : {};
        let result = new AircallContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        return data;
    }
}

export interface IAircallContact {
    first_name?: string | null;
    last_name?: string | null;
}

export class AircallDataResult implements IAircallDataResult {
    aircallId?: number;
    direction?: string | null;
    duration?: number | null;
    status?: string | null;
    startedAt?: Date | null;
    answeredAt?: Date | null;
    endedAt?: Date | null;
    recording?: string | null;
    voicemail?: string | null;
    tags?: string[] | null;
    comments?: string | null;
    user?: AircallUserResult;
    number?: AircallNumberResult;
    summary?: AircallSummaryResult;
    sentiment?: string | null;

    constructor(data?: IAircallDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aircallId = _data["aircallId"];
            this.direction = _data["direction"];
            this.duration = _data["duration"];
            this.status = _data["status"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>null;
            this.answeredAt = _data["answeredAt"] ? new Date(_data["answeredAt"].toString()) : <any>null;
            this.endedAt = _data["endedAt"] ? new Date(_data["endedAt"].toString()) : <any>null;
            this.recording = _data["recording"];
            this.voicemail = _data["voicemail"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.comments = _data["comments"];
            this.user = _data["user"] ? AircallUserResult.fromJS(_data["user"]) : <any>null;
            this.number = _data["number"] ? AircallNumberResult.fromJS(_data["number"]) : <any>null;
            this.summary = _data["summary"] ? AircallSummaryResult.fromJS(_data["summary"]) : <any>null;
            this.sentiment = _data["sentiment"];
        }
    }

    static fromJS(data: any): AircallDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new AircallDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aircallId"] = this.aircallId;
        data["direction"] = this.direction;
        data["duration"] = this.duration;
        data["status"] = this.status;
        data["startedAt"] = this.startedAt && this.startedAt.toISOString();
        data["answeredAt"] = this.answeredAt && this.answeredAt.toISOString();
        data["endedAt"] = this.endedAt && this.endedAt.toISOString();
        data["recording"] = this.recording;
        data["voicemail"] = this.voicemail;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["comments"] = this.comments;
        data["user"] = this.user ? this.user.toJSON() : this.user;
        data["number"] = this.number ? this.number.toJSON() : this.number;
        data["summary"] = this.summary ? this.summary.toJSON() : this.summary;
        data["sentiment"] = this.sentiment;
        return data;
    }
}

export interface IAircallDataResult {
    aircallId?: number;
    direction?: string | null;
    duration?: number | null;
    status?: string | null;
    startedAt?: Date | null;
    answeredAt?: Date | null;
    endedAt?: Date | null;
    recording?: string | null;
    voicemail?: string | null;
    tags?: string[] | null;
    comments?: string | null;
    user?: AircallUserResult;
    number?: AircallNumberResult;
    summary?: AircallSummaryResult;
    sentiment?: string | null;
}

export class AircallIntelligenceData implements IAircallIntelligenceData {
    call_id?: number;
    content?: string | null;

    constructor(data?: IAircallIntelligenceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.call_id = _data["call_id"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): AircallIntelligenceData {
        data = typeof data === 'object' ? data : {};
        let result = new AircallIntelligenceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["call_id"] = this.call_id;
        data["content"] = this.content;
        return data;
    }
}

export interface IAircallIntelligenceData {
    call_id?: number;
    content?: string | null;
}

export class AircallIntelligenceWebhookRequest implements IAircallIntelligenceWebhookRequest {
    event?: string | null;
    timestamp?: number | null;
    data?: AircallIntelligenceData;

    constructor(data?: IAircallIntelligenceWebhookRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"];
            this.timestamp = _data["timestamp"];
            this.data = _data["data"] ? AircallIntelligenceData.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): AircallIntelligenceWebhookRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AircallIntelligenceWebhookRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["timestamp"] = this.timestamp;
        data["data"] = this.data ? this.data.toJSON() : this.data;
        return data;
    }
}

export interface IAircallIntelligenceWebhookRequest {
    event?: string | null;
    timestamp?: number | null;
    data?: AircallIntelligenceData;
}

export class AircallNumber implements IAircallNumber {
    id?: number;
    name?: string | null;
    digits?: string | null;

    constructor(data?: IAircallNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.digits = _data["digits"];
        }
    }

    static fromJS(data: any): AircallNumber {
        data = typeof data === 'object' ? data : {};
        let result = new AircallNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["digits"] = this.digits;
        return data;
    }
}

export interface IAircallNumber {
    id?: number;
    name?: string | null;
    digits?: string | null;
}

export class AircallNumberResult implements IAircallNumberResult {
    aircallId?: number;
    name?: string | null;
    digits?: string | null;
    digitsE164?: string | null;

    constructor(data?: IAircallNumberResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aircallId = _data["aircallId"];
            this.name = _data["name"];
            this.digits = _data["digits"];
            this.digitsE164 = _data["digitsE164"];
        }
    }

    static fromJS(data: any): AircallNumberResult {
        data = typeof data === 'object' ? data : {};
        let result = new AircallNumberResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aircallId"] = this.aircallId;
        data["name"] = this.name;
        data["digits"] = this.digits;
        data["digitsE164"] = this.digitsE164;
        return data;
    }
}

export interface IAircallNumberResult {
    aircallId?: number;
    name?: string | null;
    digits?: string | null;
    digitsE164?: string | null;
}

export enum AircallParticipantType {
    Unknown = "Unknown",
    Agent = "Agent",
    Customer = "Customer",
    VoiceVirtualAgent = "VoiceVirtualAgent",
}

export enum AircallSalesLeadSortOptions {
    Name = "Name",
    Status = "Status",
    Assignee = "Assignee",
    CustomerNumber = "CustomerNumber",
    SubmissionDate = "SubmissionDate",
    CallDate = "CallDate",
    Duration = "Duration",
    Direction = "Direction",
}

export class AircallSettingsDTO implements IAircallSettingsDTO {
    apiId!: string | null;
    apiToken!: string | null;

    constructor(data?: IAircallSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiId = _data["apiId"];
            this.apiToken = _data["apiToken"];
        }
    }

    static fromJS(data: any): AircallSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AircallSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiId"] = this.apiId;
        data["apiToken"] = this.apiToken;
        return data;
    }
}

export interface IAircallSettingsDTO {
    apiId: string | null;
    apiToken: string | null;
}

export class AircallSummaryResult implements IAircallSummaryResult {
    createdAt?: Date | null;
    content?: string | null;

    constructor(data?: IAircallSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): AircallSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new AircallSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["content"] = this.content;
        return data;
    }
}

export interface IAircallSummaryResult {
    createdAt?: Date | null;
    content?: string | null;
}

export class AircallTag implements IAircallTag {
    id?: number;
    name?: string | null;

    constructor(data?: IAircallTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AircallTag {
        data = typeof data === 'object' ? data : {};
        let result = new AircallTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAircallTag {
    id?: number;
    name?: string | null;
}

export class AircallTranscriptionResult implements IAircallTranscriptionResult {
    utterances?: AircallTranscriptionUtteranceResult[] | null;

    constructor(data?: IAircallTranscriptionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["utterances"])) {
                this.utterances = [] as any;
                for (let item of _data["utterances"])
                    this.utterances!.push(AircallTranscriptionUtteranceResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AircallTranscriptionResult {
        data = typeof data === 'object' ? data : {};
        let result = new AircallTranscriptionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.utterances)) {
            data["utterances"] = [];
            for (let item of this.utterances)
                data["utterances"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAircallTranscriptionResult {
    utterances?: AircallTranscriptionUtteranceResult[] | null;
}

export class AircallTranscriptionUtteranceResult implements IAircallTranscriptionUtteranceResult {
    participantType?: AircallParticipantType;
    text?: string | null;
    startTime?: number | null;

    constructor(data?: IAircallTranscriptionUtteranceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantType = _data["participantType"];
            this.text = _data["text"];
            this.startTime = _data["startTime"];
        }
    }

    static fromJS(data: any): AircallTranscriptionUtteranceResult {
        data = typeof data === 'object' ? data : {};
        let result = new AircallTranscriptionUtteranceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantType"] = this.participantType;
        data["text"] = this.text;
        data["startTime"] = this.startTime;
        return data;
    }
}

export interface IAircallTranscriptionUtteranceResult {
    participantType?: AircallParticipantType;
    text?: string | null;
    startTime?: number | null;
}

export class AircallUser implements IAircallUser {
    id?: number;
    name?: string | null;
    email?: string | null;

    constructor(data?: IAircallUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AircallUser {
        data = typeof data === 'object' ? data : {};
        let result = new AircallUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IAircallUser {
    id?: number;
    name?: string | null;
    email?: string | null;
}

export class AircallUserResult implements IAircallUserResult {
    aircallId?: number;
    name?: string | null;
    email?: string | null;

    constructor(data?: IAircallUserResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aircallId = _data["aircallId"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AircallUserResult {
        data = typeof data === 'object' ? data : {};
        let result = new AircallUserResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aircallId"] = this.aircallId;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IAircallUserResult {
    aircallId?: number;
    name?: string | null;
    email?: string | null;
}

export class ApplyRecalculatedBookingPriceCommand implements IApplyRecalculatedBookingPriceCommand {
    date?: Date | null;
    pricingGuid?: string | null;
    readonly hasOverrides?: boolean;

    constructor(data?: IApplyRecalculatedBookingPriceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
            this.pricingGuid = _data["pricingGuid"];
            (<any>this).hasOverrides = _data["hasOverrides"];
        }
    }

    static fromJS(data: any): ApplyRecalculatedBookingPriceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyRecalculatedBookingPriceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date && formatDate(this.date);
        data["pricingGuid"] = this.pricingGuid;
        data["hasOverrides"] = this.hasOverrides;
        return data;
    }
}

export interface IApplyRecalculatedBookingPriceCommand {
    date?: Date | null;
    pricingGuid?: string | null;
    hasOverrides?: boolean;
}

export class AssignBookingSalesPersonRequest implements IAssignBookingSalesPersonRequest {
    salesPersonGuid!: string;

    constructor(data?: IAssignBookingSalesPersonRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesPersonGuid = _data["salesPersonGuid"];
        }
    }

    static fromJS(data: any): AssignBookingSalesPersonRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignBookingSalesPersonRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesPersonGuid"] = this.salesPersonGuid;
        return data;
    }
}

export interface IAssignBookingSalesPersonRequest {
    salesPersonGuid: string;
}

export class AssignSalesLeadRequest implements IAssignSalesLeadRequest {
    assigneeGuid!: string;

    constructor(data?: IAssignSalesLeadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assigneeGuid = _data["assigneeGuid"];
        }
    }

    static fromJS(data: any): AssignSalesLeadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignSalesLeadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assigneeGuid"] = this.assigneeGuid;
        return data;
    }
}

export interface IAssignSalesLeadRequest {
    assigneeGuid: string;
}

export class AuthorizeNetCheckoutSessionLineItem implements IAuthorizeNetCheckoutSessionLineItem {
    readonly guid?: string;
    name?: string | null;
    unitPrice?: number;
    quantity?: number;
    readonly totalPrice?: number;

    constructor(data?: IAuthorizeNetCheckoutSessionLineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.name = _data["name"];
            this.unitPrice = _data["unitPrice"];
            this.quantity = _data["quantity"];
            (<any>this).totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): AuthorizeNetCheckoutSessionLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeNetCheckoutSessionLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["unitPrice"] = this.unitPrice;
        data["quantity"] = this.quantity;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IAuthorizeNetCheckoutSessionLineItem {
    guid?: string;
    name?: string | null;
    unitPrice?: number;
    quantity?: number;
    totalPrice?: number;
}

export class AuthorizeNetPaymentInfo implements IAuthorizeNetPaymentInfo {
    readonly guid?: string;
    readonly transactionId?: string | null;
    readonly customerProfileId?: string | null;
    readonly checkoutSessionGuid?: string | null;
    readonly checkoutSessionUrl?: string | null;
    readonly authorizationCode?: string | null;
    transactionStatus?: AuthorizeNetTransactionStatus;
    readonly errorCode?: string | null;
    readonly errorMessage?: string | null;
    paymentProcessorCost?: number | null;
    paymentProfileInfo?: AuthorizeNetPaymentProfileInfo;

    constructor(data?: IAuthorizeNetPaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).transactionId = _data["transactionId"];
            (<any>this).customerProfileId = _data["customerProfileId"];
            (<any>this).checkoutSessionGuid = _data["checkoutSessionGuid"];
            (<any>this).checkoutSessionUrl = _data["checkoutSessionUrl"];
            (<any>this).authorizationCode = _data["authorizationCode"];
            this.transactionStatus = _data["transactionStatus"];
            (<any>this).errorCode = _data["errorCode"];
            (<any>this).errorMessage = _data["errorMessage"];
            this.paymentProcessorCost = _data["paymentProcessorCost"];
            this.paymentProfileInfo = _data["paymentProfileInfo"] ? AuthorizeNetPaymentProfileInfo.fromJS(_data["paymentProfileInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): AuthorizeNetPaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeNetPaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["transactionId"] = this.transactionId;
        data["customerProfileId"] = this.customerProfileId;
        data["checkoutSessionGuid"] = this.checkoutSessionGuid;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        data["authorizationCode"] = this.authorizationCode;
        data["transactionStatus"] = this.transactionStatus;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["paymentProcessorCost"] = this.paymentProcessorCost;
        data["paymentProfileInfo"] = this.paymentProfileInfo ? this.paymentProfileInfo.toJSON() : this.paymentProfileInfo;
        return data;
    }
}

export interface IAuthorizeNetPaymentInfo {
    guid?: string;
    transactionId?: string | null;
    customerProfileId?: string | null;
    checkoutSessionGuid?: string | null;
    checkoutSessionUrl?: string | null;
    authorizationCode?: string | null;
    transactionStatus?: AuthorizeNetTransactionStatus;
    errorCode?: string | null;
    errorMessage?: string | null;
    paymentProcessorCost?: number | null;
    paymentProfileInfo?: AuthorizeNetPaymentProfileInfo;
}

export enum AuthorizeNetPaymentMethodType {
    NotSet = "NotSet",
    CreditCard = "CreditCard",
    BankAccount = "BankAccount",
}

export class AuthorizeNetPaymentProfileInfo implements IAuthorizeNetPaymentProfileInfo {
    paymentProfileId?: string | null;
    maskedCardNumber?: string | null;
    expirationDate?: Date | null;
    cardType?: string | null;
    maskedAccountNumber?: string | null;
    maskedRoutingNumber?: string | null;
    bankName?: string | null;
    paymentMethod?: AuthorizeNetPaymentMethodType;

    constructor(data?: IAuthorizeNetPaymentProfileInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentProfileId = _data["paymentProfileId"];
            this.maskedCardNumber = _data["maskedCardNumber"];
            this.expirationDate = _data["expirationDate"] ? parseDateOnly(_data["expirationDate"].toString()) : <any>null;
            this.cardType = _data["cardType"];
            this.maskedAccountNumber = _data["maskedAccountNumber"];
            this.maskedRoutingNumber = _data["maskedRoutingNumber"];
            this.bankName = _data["bankName"];
            this.paymentMethod = _data["paymentMethod"];
        }
    }

    static fromJS(data: any): AuthorizeNetPaymentProfileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeNetPaymentProfileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProfileId"] = this.paymentProfileId;
        data["maskedCardNumber"] = this.maskedCardNumber;
        data["expirationDate"] = this.expirationDate && formatDate(this.expirationDate);
        data["cardType"] = this.cardType;
        data["maskedAccountNumber"] = this.maskedAccountNumber;
        data["maskedRoutingNumber"] = this.maskedRoutingNumber;
        data["bankName"] = this.bankName;
        data["paymentMethod"] = this.paymentMethod;
        return data;
    }
}

export interface IAuthorizeNetPaymentProfileInfo {
    paymentProfileId?: string | null;
    maskedCardNumber?: string | null;
    expirationDate?: Date | null;
    cardType?: string | null;
    maskedAccountNumber?: string | null;
    maskedRoutingNumber?: string | null;
    bankName?: string | null;
    paymentMethod?: AuthorizeNetPaymentMethodType;
}

export class AuthorizeNetPaymentProfileResponse implements IAuthorizeNetPaymentProfileResponse {
    paymentProfileId?: string | null;
    creditCardPayment?: CreditCardPaymentMethodResponse;
    bankAccountPayment?: BankAccountPaymentMethodResponse;

    constructor(data?: IAuthorizeNetPaymentProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentProfileId = _data["paymentProfileId"];
            this.creditCardPayment = _data["creditCardPayment"] ? CreditCardPaymentMethodResponse.fromJS(_data["creditCardPayment"]) : <any>null;
            this.bankAccountPayment = _data["bankAccountPayment"] ? BankAccountPaymentMethodResponse.fromJS(_data["bankAccountPayment"]) : <any>null;
        }
    }

    static fromJS(data: any): AuthorizeNetPaymentProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeNetPaymentProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProfileId"] = this.paymentProfileId;
        data["creditCardPayment"] = this.creditCardPayment ? this.creditCardPayment.toJSON() : this.creditCardPayment;
        data["bankAccountPayment"] = this.bankAccountPayment ? this.bankAccountPayment.toJSON() : this.bankAccountPayment;
        return data;
    }
}

export interface IAuthorizeNetPaymentProfileResponse {
    paymentProfileId?: string | null;
    creditCardPayment?: CreditCardPaymentMethodResponse;
    bankAccountPayment?: BankAccountPaymentMethodResponse;
}

export enum AuthorizeNetTransactionStatus {
    Unknown = "Unknown",
    ApprovedReview = "ApprovedReview",
    AuthorizedHeldPendingRelease = "AuthorizedHeldPendingRelease",
    AuthorizedPendingCapture = "AuthorizedPendingCapture",
    CapturedPendingSettlement = "CapturedPendingSettlement",
    CouldNotVoid = "CouldNotVoid",
    Declined = "Declined",
    Expired = "Expired",
    FailedReview = "FailedReview",
    FDSAuthorizedPendingReview = "FDSAuthorizedPendingReview",
    FDSPendingReview = "FDSPendingReview",
    PendingFinalSettlement = "PendingFinalSettlement",
    PendingSettlement = "PendingSettlement",
    Refund = "Refund",
    RefundPendingSettlement = "RefundPendingSettlement",
    SettledSuccessfully = "SettledSuccessfully",
    SettlementError = "SettlementError",
    UnderReview = "UnderReview",
    Voided = "Voided",
}

export enum BalanceAccountActivityType {
    NotSet = "NotSet",
    Customer_TopUp = "Customer_TopUp",
    Customer_BookingPaymentDeduction_UsingCardOrExternal = "Customer_BookingPaymentDeduction_UsingCardOrExternal",
    Customer_BookingPaymentDeduction_UsingBalance = "Customer_BookingPaymentDeduction_UsingBalance",
    Customer_ProcessingFeeDeduction = "Customer_ProcessingFeeDeduction",
    Customer_Refund = "Customer_Refund",
    Customer_BookingPaymentRefund_UsingCardOrExternal = "Customer_BookingPaymentRefund_UsingCardOrExternal",
    Customer_BookingPaymentRefund_UsingBalance = "Customer_BookingPaymentRefund_UsingBalance",
    Operator_BookingRevenueDeposit = "Operator_BookingRevenueDeposit",
    Operator_TopUpDeduction = "Operator_TopUpDeduction",
    Operator_PropellerTakeRateDeduction = "Operator_PropellerTakeRateDeduction",
    Operator_BoatOwnerTakeDeduction = "Operator_BoatOwnerTakeDeduction",
    Operator_TopUp = "Operator_TopUp",
    Operator_ProcessingFeeDeduction = "Operator_ProcessingFeeDeduction",
    Operator_BookingRevenueRefund = "Operator_BookingRevenueRefund",
    Operator_PropellerTakeRateRefund = "Operator_PropellerTakeRateRefund",
    Operator_ProcessingFeeRefund = "Operator_ProcessingFeeRefund",
    Propeller_ProcessingFeeDeposit = "Propeller_ProcessingFeeDeposit",
    Propeller_PropellerCommissionDeposit = "Propeller_PropellerCommissionDeposit",
    Propeller_ThirdPartyFeeDeduction = "Propeller_ThirdPartyFeeDeduction",
    BoatOwner_BoatOwnerTakeDeposit = "BoatOwner_BoatOwnerTakeDeposit",
}

export enum BalanceAccountOwnerType {
    NotSet = "NotSet",
    Customer = "Customer",
    Operator = "Operator",
    BoatOwner = "BoatOwner",
    Propeller = "Propeller",
    External = "External",
}

export enum BalanceActivityMovementType {
    NotSet = "NotSet",
    Deposit = "Deposit",
    Deduction = "Deduction",
}

export enum BalanceActivitySortOptions {
    NotSet = "NotSet",
    PaidOn = "PaidOn",
    Type = "Type",
    Amount = "Amount",
    CreatedByFullName = "CreatedByFullName",
    Target = "Target",
    BookingId = "BookingId",
    BalanceAfter = "BalanceAfter",
    PaymentGuid = "PaymentGuid",
}

export class BalancePaymentInfo implements IBalancePaymentInfo {
    balanceGuid?: string;

    constructor(data?: IBalancePaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balanceGuid = _data["balanceGuid"];
        }
    }

    static fromJS(data: any): BalancePaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BalancePaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balanceGuid"] = this.balanceGuid;
        return data;
    }
}

export interface IBalancePaymentInfo {
    balanceGuid?: string;
}

export class BankAccountPaymentMethodResponse implements IBankAccountPaymentMethodResponse {
    accountNumberLastFourDigits?: string | null;
    accountRoutingLastFourDigits?: string | null;
    bankName?: string | null;

    constructor(data?: IBankAccountPaymentMethodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumberLastFourDigits = _data["accountNumberLastFourDigits"];
            this.accountRoutingLastFourDigits = _data["accountRoutingLastFourDigits"];
            this.bankName = _data["bankName"];
        }
    }

    static fromJS(data: any): BankAccountPaymentMethodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountPaymentMethodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumberLastFourDigits"] = this.accountNumberLastFourDigits;
        data["accountRoutingLastFourDigits"] = this.accountRoutingLastFourDigits;
        data["bankName"] = this.bankName;
        return data;
    }
}

export interface IBankAccountPaymentMethodResponse {
    accountNumberLastFourDigits?: string | null;
    accountRoutingLastFourDigits?: string | null;
    bankName?: string | null;
}

export class BankAccountPaymentRequest implements IBankAccountPaymentRequest {
    opaqueDataValue!: string | null;
    opaqueDataDescriptor!: string | null;
    routingNumberLastFourDigits!: string | null;
    accountNumberLastFourDigits!: string | null;
    nameOnAccount!: string | null;
    accountType!: BankAccountTypeEnum;

    constructor(data?: IBankAccountPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opaqueDataValue = _data["opaqueDataValue"];
            this.opaqueDataDescriptor = _data["opaqueDataDescriptor"];
            this.routingNumberLastFourDigits = _data["routingNumberLastFourDigits"];
            this.accountNumberLastFourDigits = _data["accountNumberLastFourDigits"];
            this.nameOnAccount = _data["nameOnAccount"];
            this.accountType = _data["accountType"];
        }
    }

    static fromJS(data: any): BankAccountPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opaqueDataValue"] = this.opaqueDataValue;
        data["opaqueDataDescriptor"] = this.opaqueDataDescriptor;
        data["routingNumberLastFourDigits"] = this.routingNumberLastFourDigits;
        data["accountNumberLastFourDigits"] = this.accountNumberLastFourDigits;
        data["nameOnAccount"] = this.nameOnAccount;
        data["accountType"] = this.accountType;
        return data;
    }
}

export interface IBankAccountPaymentRequest {
    opaqueDataValue: string | null;
    opaqueDataDescriptor: string | null;
    routingNumberLastFourDigits: string | null;
    accountNumberLastFourDigits: string | null;
    nameOnAccount: string | null;
    accountType: BankAccountTypeEnum;
}

export class BoatEventCommandResult implements IBoatEventCommandResult {
    isCalendarUpdatedImmediately?: boolean;

    constructor(data?: IBoatEventCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCalendarUpdatedImmediately = _data["isCalendarUpdatedImmediately"];
        }
    }

    static fromJS(data: any): BoatEventCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new BoatEventCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCalendarUpdatedImmediately"] = this.isCalendarUpdatedImmediately;
        return data;
    }
}

export interface IBoatEventCommandResult {
    isCalendarUpdatedImmediately?: boolean;
}

export enum BoatEventType {
    NotSet = "NotSet",
    Booking = "Booking",
    Fueling = "Fueling",
    Cleaning = "Cleaning",
    Transporting = "Transporting",
    Maintenance = "Maintenance",
    PersonalUse = "PersonalUse",
}

export enum BoatIssueStatus {
    NotSet = "NotSet",
    Evaluating = "Evaluating",
    PartOrdering = "PartOrdering",
    PartOrdered = "PartOrdered",
    FixScheduled = "FixScheduled",
    Fixed = "Fixed",
}

export enum BoatIssueType {
    NotSet = "NotSet",
    Emergency = "Emergency",
    SafetyIssue = "SafetyIssue",
    Functionality = "Functionality",
    Appearance = "Appearance",
}

export class BoatIssueUser implements IBoatIssueUser {
    readonly guid?: string;
    readonly firstName?: string | null;
    readonly lastName?: string | null;
    readonly middleName?: string | null;
    readonly fullName?: string | null;
    readonly email?: string | null;
    readonly phone?: string | null;
    status?: UserStatus;

    constructor(data?: IBoatIssueUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).firstName = _data["firstName"];
            (<any>this).lastName = _data["lastName"];
            (<any>this).middleName = _data["middleName"];
            (<any>this).fullName = _data["fullName"];
            (<any>this).email = _data["email"];
            (<any>this).phone = _data["phone"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): BoatIssueUser {
        data = typeof data === 'object' ? data : {};
        let result = new BoatIssueUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        return data;
    }
}

export interface IBoatIssueUser {
    guid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
}

export enum BoatOwnerType {
    NotSet = "NotSet",
    Internal = "Internal",
    External = "External",
}

export enum BoatPartCategory {
    NotSet = "NotSet",
    Boat = "Boat",
    Engine = "Engine",
    Generator = "Generator",
}

export enum BoatPartType {
    NotSet = "NotSet",
    PortEngine = "PortEngine",
    StbdEngine = "StbdEngine",
    OilFilter = "OilFilter",
    Oil = "Oil",
    AirFilter = "AirFilter",
    MainFuelFilter = "MainFuelFilter",
    SmallerFuelFilter = "SmallerFuelFilter",
    TransmissionOil = "TransmissionOil",
    SparkPlug = "SparkPlug",
    Zinc = "Zinc",
    FreshWaterPump = "FreshWaterPump",
    Macerator = "Macerator",
    AnchorWinch = "AnchorWinch",
    Batteries = "Batteries",
    Stereo = "Stereo",
    Hardware = "Hardware",
    AirConditioning = "AirConditioning",
    Hydraulic = "Hydraulic",
    MISC = "MISC",
    Hull = "Hull",
    Alternator = "Alternator",
    AlternatorBelt = "AlternatorBelt",
    FuelPump = "FuelPump",
    WaterPumpImpeller = "WaterPumpImpeller",
    CompleteWaterPump = "CompleteWaterPump",
    BeltTensioner = "BeltTensioner",
    GeneratorOilFilter = "GeneratorOilFilter",
    GeneratorOil = "GeneratorOil",
    GeneratorSmallFuelFilter = "GeneratorSmallFuelFilter",
    GeneratorLargeFuelFilter = "GeneratorLargeFuelFilter",
    GeneratorAirFilter = "GeneratorAirFilter",
    GeneratorBelt = "GeneratorBelt",
}

export class BoatPartVendor implements IBoatPartVendor {
    guid?: string;
    name?: string | null;
    corporatePhoneNumber?: string | null;
    email?: string | null;
    note?: string | null;

    constructor(data?: IBoatPartVendor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.corporatePhoneNumber = _data["corporatePhoneNumber"];
            this.email = _data["email"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): BoatPartVendor {
        data = typeof data === 'object' ? data : {};
        let result = new BoatPartVendor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["corporatePhoneNumber"] = this.corporatePhoneNumber;
        data["email"] = this.email;
        data["note"] = this.note;
        return data;
    }
}

export interface IBoatPartVendor {
    guid?: string;
    name?: string | null;
    corporatePhoneNumber?: string | null;
    email?: string | null;
    note?: string | null;
}

export class BoatPictureResultModel implements IBoatPictureResultModel {
    readonly pictureGuid?: string | null;
    readonly host?: string | null;
    bucket?: string | null;
    readonly name?: string | null;
    readonly extension?: string | null;
    readonly height?: number | null;
    readonly width?: number | null;
    readonly size?: number | null;
    sortOrder?: number;
    description?: string | null;

    constructor(data?: IBoatPictureResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).pictureGuid = _data["pictureGuid"];
            (<any>this).host = _data["host"];
            this.bucket = _data["bucket"];
            (<any>this).name = _data["name"];
            (<any>this).extension = _data["extension"];
            (<any>this).height = _data["height"];
            (<any>this).width = _data["width"];
            (<any>this).size = _data["size"];
            this.sortOrder = _data["sortOrder"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BoatPictureResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new BoatPictureResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pictureGuid"] = this.pictureGuid;
        data["host"] = this.host;
        data["bucket"] = this.bucket;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["height"] = this.height;
        data["width"] = this.width;
        data["size"] = this.size;
        data["sortOrder"] = this.sortOrder;
        data["description"] = this.description;
        return data;
    }
}

export interface IBoatPictureResultModel {
    pictureGuid?: string | null;
    host?: string | null;
    bucket?: string | null;
    name?: string | null;
    extension?: string | null;
    height?: number | null;
    width?: number | null;
    size?: number | null;
    sortOrder?: number;
    description?: string | null;
}

export class BoatPictureResultResult implements IBoatPictureResultResult {
    readonly pictureGuid?: string | null;
    readonly host?: string | null;
    bucket?: string | null;
    readonly name?: string | null;
    readonly extension?: string | null;
    readonly height?: number | null;
    readonly width?: number | null;
    readonly size?: number | null;
    sortOrder?: number;
    description?: string | null;

    constructor(data?: IBoatPictureResultResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).pictureGuid = _data["pictureGuid"];
            (<any>this).host = _data["host"];
            this.bucket = _data["bucket"];
            (<any>this).name = _data["name"];
            (<any>this).extension = _data["extension"];
            (<any>this).height = _data["height"];
            (<any>this).width = _data["width"];
            (<any>this).size = _data["size"];
            this.sortOrder = _data["sortOrder"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BoatPictureResultResult {
        data = typeof data === 'object' ? data : {};
        let result = new BoatPictureResultResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pictureGuid"] = this.pictureGuid;
        data["host"] = this.host;
        data["bucket"] = this.bucket;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["height"] = this.height;
        data["width"] = this.width;
        data["size"] = this.size;
        data["sortOrder"] = this.sortOrder;
        data["description"] = this.description;
        return data;
    }
}

export interface IBoatPictureResultResult {
    pictureGuid?: string | null;
    host?: string | null;
    bucket?: string | null;
    name?: string | null;
    extension?: string | null;
    height?: number | null;
    width?: number | null;
    size?: number | null;
    sortOrder?: number;
    description?: string | null;
}

export enum BoatSortOptions {
    Length = "Length",
    DefaultListingTitle = "DefaultListingTitle",
    Status = "Status",
    Owner = "Owner",
    Market = "Market",
    SortPriority = "SortPriority",
    TotalTrips = "TotalTrips",
    TotalRevenue = "TotalRevenue",
}

export class BoatSpecification implements IBoatSpecification {
    yearBuilt?: number | null;
    yearRefit?: number | null;
    length?: number | null;
    engineType?: EngineType;
    fuelCapacity?: number | null;
    fuelConsumption?: number | null;
    sleepCapacity?: number | null;
    passengersCapacity?: number;
    crewCapacity?: number | null;
    dayCapacity?: number | null;
    dayCapacityDescription?: string | null;
    bedCount?: number | null;
    bathroomsCount?: number | null;
    stateroomsCount?: number | null;
    stateroomsDescription?: string | null;
    portOfRegistry?: string | null;
    flag?: string | null;
    includedToys?: string | null;

    constructor(data?: IBoatSpecification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.yearBuilt = _data["yearBuilt"];
            this.yearRefit = _data["yearRefit"];
            this.length = _data["length"];
            this.engineType = _data["engineType"];
            this.fuelCapacity = _data["fuelCapacity"];
            this.fuelConsumption = _data["fuelConsumption"];
            this.sleepCapacity = _data["sleepCapacity"];
            this.passengersCapacity = _data["passengersCapacity"];
            this.crewCapacity = _data["crewCapacity"];
            this.dayCapacity = _data["dayCapacity"];
            this.dayCapacityDescription = _data["dayCapacityDescription"];
            this.bedCount = _data["bedCount"];
            this.bathroomsCount = _data["bathroomsCount"];
            this.stateroomsCount = _data["stateroomsCount"];
            this.stateroomsDescription = _data["stateroomsDescription"];
            this.portOfRegistry = _data["portOfRegistry"];
            this.flag = _data["flag"];
            this.includedToys = _data["includedToys"];
        }
    }

    static fromJS(data: any): BoatSpecification {
        data = typeof data === 'object' ? data : {};
        let result = new BoatSpecification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yearBuilt"] = this.yearBuilt;
        data["yearRefit"] = this.yearRefit;
        data["length"] = this.length;
        data["engineType"] = this.engineType;
        data["fuelCapacity"] = this.fuelCapacity;
        data["fuelConsumption"] = this.fuelConsumption;
        data["sleepCapacity"] = this.sleepCapacity;
        data["passengersCapacity"] = this.passengersCapacity;
        data["crewCapacity"] = this.crewCapacity;
        data["dayCapacity"] = this.dayCapacity;
        data["dayCapacityDescription"] = this.dayCapacityDescription;
        data["bedCount"] = this.bedCount;
        data["bathroomsCount"] = this.bathroomsCount;
        data["stateroomsCount"] = this.stateroomsCount;
        data["stateroomsDescription"] = this.stateroomsDescription;
        data["portOfRegistry"] = this.portOfRegistry;
        data["flag"] = this.flag;
        data["includedToys"] = this.includedToys;
        return data;
    }
}

export interface IBoatSpecification {
    yearBuilt?: number | null;
    yearRefit?: number | null;
    length?: number | null;
    engineType?: EngineType;
    fuelCapacity?: number | null;
    fuelConsumption?: number | null;
    sleepCapacity?: number | null;
    passengersCapacity?: number;
    crewCapacity?: number | null;
    dayCapacity?: number | null;
    dayCapacityDescription?: string | null;
    bedCount?: number | null;
    bathroomsCount?: number | null;
    stateroomsCount?: number | null;
    stateroomsDescription?: string | null;
    portOfRegistry?: string | null;
    flag?: string | null;
    includedToys?: string | null;
}

export enum BoatTuneUpType {
    OilChange = "OilChange",
    WaterPump = "WaterPump",
    SparkPlugs = "SparkPlugs",
    LowerUnit = "LowerUnit",
    Thermostat = "Thermostat",
    Generator = "Generator",
    FuelFilter = "FuelFilter",
    AirFilter = "AirFilter",
    Other = "Other",
}

export class BoatYearStatisticsResult implements IBoatYearStatisticsResult {
    year?: number;
    totalTrips?: number;
    revenue?: number;

    constructor(data?: IBoatYearStatisticsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.totalTrips = _data["totalTrips"];
            this.revenue = _data["revenue"];
        }
    }

    static fromJS(data: any): BoatYearStatisticsResult {
        data = typeof data === 'object' ? data : {};
        let result = new BoatYearStatisticsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["totalTrips"] = this.totalTrips;
        data["revenue"] = this.revenue;
        return data;
    }
}

export interface IBoatYearStatisticsResult {
    year?: number;
    totalTrips?: number;
    revenue?: number;
}

export enum BoatYearsStatisticsSortOptions {
    DefaultListingTitle = "DefaultListingTitle",
}

export class BookingAdditionalFeeItem implements IBookingAdditionalFeeItem {
    readonly guid?: string;
    code?: string | null;
    name?: string | null;
    price?: PricedAmount;
    readonly amount?: number;

    constructor(data?: IBookingAdditionalFeeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.price = _data["price"] ? PricedAmount.fromJS(_data["price"]) : <any>null;
            (<any>this).amount = _data["amount"];
        }
    }

    static fromJS(data: any): BookingAdditionalFeeItem {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAdditionalFeeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["price"] = this.price ? this.price.toJSON() : this.price;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IBookingAdditionalFeeItem {
    guid?: string;
    code?: string | null;
    name?: string | null;
    price?: PricedAmount;
    amount?: number;
}

export class BookingAdditionalFees implements IBookingAdditionalFees {
    readonly items?: BookingAdditionalFeeItem[] | null;
    readonly totalPrice?: number;

    constructor(data?: IBookingAdditionalFees) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(BookingAdditionalFeeItem.fromJS(item));
            }
            (<any>this).totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): BookingAdditionalFees {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAdditionalFees();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IBookingAdditionalFees {
    items?: BookingAdditionalFeeItem[] | null;
    totalPrice?: number;
}

export class BookingAddonDto implements IBookingAddonDto {
    guid?: string;
    addonGuid?: string;
    name!: string | null;
    description?: string | null;
    vendorGuid?: string;
    vendorName?: string | null;
    categoryGuid?: string;
    categoryName?: string | null;
    pricingModel?: PricingModel;
    bookability?: AddonBookability;
    approvalStatus?: BookingAddonStatus;
    quantity?: number;
    days?: number | null;
    unitBasePrice?: number;
    price!: PricedAmount;
    commissionable?: boolean;
    commissionRatePercentage?: number;
    commissionAmount?: number;
    selectedOptionGuid?: string | null;
    selectedOptionName?: string | null;
    note?: string | null;
    declineNote?: string | null;
    requestedAt?: Date | null;
    resolvedAt?: Date | null;
    resolvedByUserGuid?: string | null;
    createdAt?: Date;
    updatedAt?: Date | null;

    constructor(data?: IBookingAddonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.price = new PricedAmount();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.addonGuid = _data["addonGuid"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.vendorGuid = _data["vendorGuid"];
            this.vendorName = _data["vendorName"];
            this.categoryGuid = _data["categoryGuid"];
            this.categoryName = _data["categoryName"];
            this.pricingModel = _data["pricingModel"];
            this.bookability = _data["bookability"];
            this.approvalStatus = _data["approvalStatus"];
            this.quantity = _data["quantity"];
            this.days = _data["days"];
            this.unitBasePrice = _data["unitBasePrice"];
            this.price = _data["price"] ? PricedAmount.fromJS(_data["price"]) : new PricedAmount();
            this.commissionable = _data["commissionable"];
            this.commissionRatePercentage = _data["commissionRatePercentage"];
            this.commissionAmount = _data["commissionAmount"];
            this.selectedOptionGuid = _data["selectedOptionGuid"];
            this.selectedOptionName = _data["selectedOptionName"];
            this.note = _data["note"];
            this.declineNote = _data["declineNote"];
            this.requestedAt = _data["requestedAt"] ? new Date(_data["requestedAt"].toString()) : <any>null;
            this.resolvedAt = _data["resolvedAt"] ? new Date(_data["resolvedAt"].toString()) : <any>null;
            this.resolvedByUserGuid = _data["resolvedByUserGuid"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): BookingAddonDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAddonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["addonGuid"] = this.addonGuid;
        data["name"] = this.name;
        data["description"] = this.description;
        data["vendorGuid"] = this.vendorGuid;
        data["vendorName"] = this.vendorName;
        data["categoryGuid"] = this.categoryGuid;
        data["categoryName"] = this.categoryName;
        data["pricingModel"] = this.pricingModel;
        data["bookability"] = this.bookability;
        data["approvalStatus"] = this.approvalStatus;
        data["quantity"] = this.quantity;
        data["days"] = this.days;
        data["unitBasePrice"] = this.unitBasePrice;
        data["price"] = this.price ? this.price.toJSON() : this.price;
        data["commissionable"] = this.commissionable;
        data["commissionRatePercentage"] = this.commissionRatePercentage;
        data["commissionAmount"] = this.commissionAmount;
        data["selectedOptionGuid"] = this.selectedOptionGuid;
        data["selectedOptionName"] = this.selectedOptionName;
        data["note"] = this.note;
        data["declineNote"] = this.declineNote;
        data["requestedAt"] = this.requestedAt && this.requestedAt.toISOString();
        data["resolvedAt"] = this.resolvedAt && this.resolvedAt.toISOString();
        data["resolvedByUserGuid"] = this.resolvedByUserGuid;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        return data;
    }
}

export interface IBookingAddonDto {
    guid?: string;
    addonGuid?: string;
    name: string | null;
    description?: string | null;
    vendorGuid?: string;
    vendorName?: string | null;
    categoryGuid?: string;
    categoryName?: string | null;
    pricingModel?: PricingModel;
    bookability?: AddonBookability;
    approvalStatus?: BookingAddonStatus;
    quantity?: number;
    days?: number | null;
    unitBasePrice?: number;
    price: PricedAmount;
    commissionable?: boolean;
    commissionRatePercentage?: number;
    commissionAmount?: number;
    selectedOptionGuid?: string | null;
    selectedOptionName?: string | null;
    note?: string | null;
    declineNote?: string | null;
    requestedAt?: Date | null;
    resolvedAt?: Date | null;
    resolvedByUserGuid?: string | null;
    createdAt?: Date;
    updatedAt?: Date | null;
}

export enum BookingAddonStatus {
    NotSet = "NotSet",
    InstantConfirmed = "InstantConfirmed",
    Requested = "Requested",
    Approved = "Approved",
    Declined = "Declined",
}

export enum BookingAddonSummaryStatus {
    NotSet = "NotSet",
    Instant = "Instant",
    Requested = "Requested",
    Resolved = "Resolved",
}

export class BookingAgent implements IBookingAgent {
    readonly guid?: string;
    readonly name?: string | null;
    readonly group?: string | null;
    readonly commissionPercent?: number;

    constructor(data?: IBookingAgent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).name = _data["name"];
            (<any>this).group = _data["group"];
            (<any>this).commissionPercent = _data["commissionPercent"];
        }
    }

    static fromJS(data: any): BookingAgent {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAgent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["group"] = this.group;
        data["commissionPercent"] = this.commissionPercent;
        return data;
    }
}

export interface IBookingAgent {
    guid?: string;
    name?: string | null;
    group?: string | null;
    commissionPercent?: number;
}

export class BookingAppliedCampaign implements IBookingAppliedCampaign {
    campaignCode?: string | null;
    campaignGuid?: string;
    channelGuid?: string;
    appliedDiscountAmount?: number;
    appliedCommisionAmount?: number;

    constructor(data?: IBookingAppliedCampaign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignCode = _data["campaignCode"];
            this.campaignGuid = _data["campaignGuid"];
            this.channelGuid = _data["channelGuid"];
            this.appliedDiscountAmount = _data["appliedDiscountAmount"];
            this.appliedCommisionAmount = _data["appliedCommisionAmount"];
        }
    }

    static fromJS(data: any): BookingAppliedCampaign {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAppliedCampaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignCode"] = this.campaignCode;
        data["campaignGuid"] = this.campaignGuid;
        data["channelGuid"] = this.channelGuid;
        data["appliedDiscountAmount"] = this.appliedDiscountAmount;
        data["appliedCommisionAmount"] = this.appliedCommisionAmount;
        return data;
    }
}

export interface IBookingAppliedCampaign {
    campaignCode?: string | null;
    campaignGuid?: string;
    channelGuid?: string;
    appliedDiscountAmount?: number;
    appliedCommisionAmount?: number;
}

export class BookingAppliedPromoCode implements IBookingAppliedPromoCode {
    promoCodeGuid?: string;
    promoCodeType?: PromoCodeType;
    code?: string | null;
    appliedDiscountAmount?: number;
    fixedDiscountAmount?: number | null;
    percentageRate?: number | null;

    constructor(data?: IBookingAppliedPromoCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promoCodeGuid = _data["promoCodeGuid"];
            this.promoCodeType = _data["promoCodeType"];
            this.code = _data["code"];
            this.appliedDiscountAmount = _data["appliedDiscountAmount"];
            this.fixedDiscountAmount = _data["fixedDiscountAmount"];
            this.percentageRate = _data["percentageRate"];
        }
    }

    static fromJS(data: any): BookingAppliedPromoCode {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAppliedPromoCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promoCodeGuid"] = this.promoCodeGuid;
        data["promoCodeType"] = this.promoCodeType;
        data["code"] = this.code;
        data["appliedDiscountAmount"] = this.appliedDiscountAmount;
        data["fixedDiscountAmount"] = this.fixedDiscountAmount;
        data["percentageRate"] = this.percentageRate;
        return data;
    }
}

export interface IBookingAppliedPromoCode {
    promoCodeGuid?: string;
    promoCodeType?: PromoCodeType;
    code?: string | null;
    appliedDiscountAmount?: number;
    fixedDiscountAmount?: number | null;
    percentageRate?: number | null;
}

export class BookingAttachmentDto implements IBookingAttachmentDto {
    guid!: string;
    alias!: string | null;
    name!: string | null;
    extension!: string | null;
    contentType!: string | null;
    originalFileName!: string | null;
    fileSizeBytes!: number;

    constructor(data?: IBookingAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.alias = _data["alias"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.contentType = _data["contentType"];
            this.originalFileName = _data["originalFileName"];
            this.fileSizeBytes = _data["fileSizeBytes"];
        }
    }

    static fromJS(data: any): BookingAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["alias"] = this.alias;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["contentType"] = this.contentType;
        data["originalFileName"] = this.originalFileName;
        data["fileSizeBytes"] = this.fileSizeBytes;
        return data;
    }
}

export interface IBookingAttachmentDto {
    guid: string;
    alias: string | null;
    name: string | null;
    extension: string | null;
    contentType: string | null;
    originalFileName: string | null;
    fileSizeBytes: number;
}

export class BookingBoat implements IBookingBoat {
    readonly guid?: string;
    readonly defaultListingTitle?: string | null;

    constructor(data?: IBookingBoat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).defaultListingTitle = _data["defaultListingTitle"];
        }
    }

    static fromJS(data: any): BookingBoat {
        data = typeof data === 'object' ? data : {};
        let result = new BookingBoat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["defaultListingTitle"] = this.defaultListingTitle;
        return data;
    }
}

export interface IBookingBoat {
    guid?: string;
    defaultListingTitle?: string | null;
}

export class BookingCancellationDetails implements IBookingCancellationDetails {
    note?: string | null;
    reason?: BookingCancellationReason;
    cancelledBy?: string | null;
    date?: Date;

    constructor(data?: IBookingCancellationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.reason = _data["reason"];
            this.cancelledBy = _data["cancelledBy"];
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): BookingCancellationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BookingCancellationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["reason"] = this.reason;
        data["cancelledBy"] = this.cancelledBy;
        data["date"] = this.date && formatDate(this.date);
        return data;
    }
}

export interface IBookingCancellationDetails {
    note?: string | null;
    reason?: BookingCancellationReason;
    cancelledBy?: string | null;
    date?: Date;
}

export enum BookingCancellationReason {
    NotSet = "NotSet",
    Planning = "Planning",
    Price = "Price",
    Weather = "Weather",
    BoatAvailability = "BoatAvailability",
    TestOrDuplicate = "TestOrDuplicate",
}

export enum BookingChannelType {
    NotSet = "NotSet",
    Referral = "Referral",
    Agent = "Agent",
    Direct = "Direct",
}

export class BookingCheckoutSessionResponse implements IBookingCheckoutSessionResponse {
    start?: Date;
    end?: Date;
    passengers?: number;
    listingTitle?: string | null;

    constructor(data?: IBookingCheckoutSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
            this.passengers = _data["passengers"];
            this.listingTitle = _data["listingTitle"];
        }
    }

    static fromJS(data: any): BookingCheckoutSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BookingCheckoutSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start && this.start.toISOString();
        data["end"] = this.end && this.end.toISOString();
        data["passengers"] = this.passengers;
        data["listingTitle"] = this.listingTitle;
        return data;
    }
}

export interface IBookingCheckoutSessionResponse {
    start?: Date;
    end?: Date;
    passengers?: number;
    listingTitle?: string | null;
}

export class BookingCustomer implements IBookingCustomer {
    readonly guid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
    customerNumber?: number;
    createdAtUtc?: Date;
    infoStatus?: CustomerInfoStatus;
    readonly fullName?: string | null;

    constructor(data?: IBookingCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.customerNumber = _data["customerNumber"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
            this.infoStatus = _data["infoStatus"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): BookingCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new BookingCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["customerNumber"] = this.customerNumber;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        data["infoStatus"] = this.infoStatus;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IBookingCustomer {
    guid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
    customerNumber?: number;
    createdAtUtc?: Date;
    infoStatus?: CustomerInfoStatus;
    fullName?: string | null;
}

export class BookingDayFeeItem implements IBookingDayFeeItem {
    additionalFeeTypeGuid?: string;
    code?: string | null;
    name?: string | null;
    amount?: number;
    defaultTaxes?: TaxLine[] | null;

    constructor(data?: IBookingDayFeeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalFeeTypeGuid = _data["additionalFeeTypeGuid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookingDayFeeItem {
        data = typeof data === 'object' ? data : {};
        let result = new BookingDayFeeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalFeeTypeGuid"] = this.additionalFeeTypeGuid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["amount"] = this.amount;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBookingDayFeeItem {
    additionalFeeTypeGuid?: string;
    code?: string | null;
    name?: string | null;
    amount?: number;
    defaultTaxes?: TaxLine[] | null;
}

export class BookingDayPrice implements IBookingDayPrice {
    date?: Date;
    basePrice?: number;
    feesTotal?: number;
    feeItems?: BookingDayFeeItem[] | null;
    seasonGuid?: string | null;
    seasonName?: string | null;
    seasonColor?: string | null;
    isCustomPrice?: boolean;
    isChargeableDay?: boolean;

    constructor(data?: IBookingDayPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
            this.basePrice = _data["basePrice"];
            this.feesTotal = _data["feesTotal"];
            if (Array.isArray(_data["feeItems"])) {
                this.feeItems = [] as any;
                for (let item of _data["feeItems"])
                    this.feeItems!.push(BookingDayFeeItem.fromJS(item));
            }
            this.seasonGuid = _data["seasonGuid"];
            this.seasonName = _data["seasonName"];
            this.seasonColor = _data["seasonColor"];
            this.isCustomPrice = _data["isCustomPrice"];
            this.isChargeableDay = _data["isChargeableDay"];
        }
    }

    static fromJS(data: any): BookingDayPrice {
        data = typeof data === 'object' ? data : {};
        let result = new BookingDayPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date && formatDate(this.date);
        data["basePrice"] = this.basePrice;
        data["feesTotal"] = this.feesTotal;
        if (Array.isArray(this.feeItems)) {
            data["feeItems"] = [];
            for (let item of this.feeItems)
                data["feeItems"].push(item.toJSON());
        }
        data["seasonGuid"] = this.seasonGuid;
        data["seasonName"] = this.seasonName;
        data["seasonColor"] = this.seasonColor;
        data["isCustomPrice"] = this.isCustomPrice;
        data["isChargeableDay"] = this.isChargeableDay;
        return data;
    }
}

export interface IBookingDayPrice {
    date?: Date;
    basePrice?: number;
    feesTotal?: number;
    feeItems?: BookingDayFeeItem[] | null;
    seasonGuid?: string | null;
    seasonName?: string | null;
    seasonColor?: string | null;
    isCustomPrice?: boolean;
    isChargeableDay?: boolean;
}

export enum BookingItemResultType {
    NotSet = "NotSet",
    BasePrice = "BasePrice",
    Fee = "Fee",
    Addon = "Addon",
}

export enum BookingItemSortOptions {
    NotSet = "NotSet",
    BookingId = "BookingId",
    BookingStartDate = "BookingStartDate",
    CustomerName = "CustomerName",
    Boat = "Boat",
    ItemType = "ItemType",
    ItemName = "ItemName",
    GrossAmount = "GrossAmount",
}

export class BookingLocation implements IBookingLocation {
    readonly guid?: string;
    readonly title?: string | null;
    readonly city?: string | null;
    readonly fullAddress?: string | null;
    readonly shortAddress?: string | null;
    readonly timeZoneInfoId?: string | null;

    constructor(data?: IBookingLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).title = _data["title"];
            (<any>this).city = _data["city"];
            (<any>this).fullAddress = _data["fullAddress"];
            (<any>this).shortAddress = _data["shortAddress"];
            (<any>this).timeZoneInfoId = _data["timeZoneInfoId"];
        }
    }

    static fromJS(data: any): BookingLocation {
        data = typeof data === 'object' ? data : {};
        let result = new BookingLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["city"] = this.city;
        data["fullAddress"] = this.fullAddress;
        data["shortAddress"] = this.shortAddress;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        return data;
    }
}

export interface IBookingLocation {
    guid?: string;
    title?: string | null;
    city?: string | null;
    fullAddress?: string | null;
    shortAddress?: string | null;
    timeZoneInfoId?: string | null;
}

export enum BookingLogsSortOptions {
    CreatedDate = "CreatedDate",
}

export enum BookingMailerNotificationStatus {
    Scheduled = "Scheduled",
    Sent = "Sent",
    Failed = "Failed",
    Signed = "Signed",
    Cancelled = "Cancelled",
    Voided = "Voided",
}

export enum BookingMailerNotificationType {
    Offer = "Offer",
    Contract = "Contract",
    CustomerHandoff = "CustomerHandoff",
    SkipperHandoff = "SkipperHandoff",
    StewardessHandoff = "StewardessHandoff",
    Invoice = "Invoice",
    AmbassadorBookingNotification = "AmbassadorBookingNotification",
    BookingSkipperReminder = "BookingSkipperReminder",
    BookingPromoCodeApplied = "BookingPromoCodeApplied",
    BookingPaidEnquiry = "BookingPaidEnquiry",
    BookingReservationConfirmed = "BookingReservationConfirmed",
    BookingUnpaidEnquiry = "BookingUnpaidEnquiry",
    BookingAddonRequested = "BookingAddonRequested",
    BookingAddonApproved = "BookingAddonApproved",
    BookingAddonDeclined = "BookingAddonDeclined",
    OverbookingNotification = "OverbookingNotification",
    CheckinPersonHandoff = "CheckinPersonHandoff",
    BookingSalesPersonAssignment = "BookingSalesPersonAssignment",
    MultibookingOffer = "MultibookingOffer",
    MultibookingReservationConfirmed = "MultibookingReservationConfirmed",
}

export class BookingNotes implements IBookingNotes {
    note?: string | null;
    toysPromised?: string | null;
    customerGoalsAndAgenda?: string | null;
    tripNotes?: string | null;

    constructor(data?: IBookingNotes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.toysPromised = _data["toysPromised"];
            this.customerGoalsAndAgenda = _data["customerGoalsAndAgenda"];
            this.tripNotes = _data["tripNotes"];
        }
    }

    static fromJS(data: any): BookingNotes {
        data = typeof data === 'object' ? data : {};
        let result = new BookingNotes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["toysPromised"] = this.toysPromised;
        data["customerGoalsAndAgenda"] = this.customerGoalsAndAgenda;
        data["tripNotes"] = this.tripNotes;
        return data;
    }
}

export interface IBookingNotes {
    note?: string | null;
    toysPromised?: string | null;
    customerGoalsAndAgenda?: string | null;
    tripNotes?: string | null;
}

export enum BookingPaymentStatus {
    NotSet = "NotSet",
    Unpaid = "Unpaid",
    PartiallyPaid = "PartiallyPaid",
    Paid = "Paid",
}

export class BookingPriceBreakdown implements IBookingPriceBreakdown {
    pricingMode?: PricingMode;
    dayPrices?: BookingDayPrice[] | null;
    seasonSummaries?: BookingSeasonSummary[] | null;

    constructor(data?: IBookingPriceBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricingMode = _data["pricingMode"];
            if (Array.isArray(_data["dayPrices"])) {
                this.dayPrices = [] as any;
                for (let item of _data["dayPrices"])
                    this.dayPrices!.push(BookingDayPrice.fromJS(item));
            }
            if (Array.isArray(_data["seasonSummaries"])) {
                this.seasonSummaries = [] as any;
                for (let item of _data["seasonSummaries"])
                    this.seasonSummaries!.push(BookingSeasonSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookingPriceBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new BookingPriceBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricingMode"] = this.pricingMode;
        if (Array.isArray(this.dayPrices)) {
            data["dayPrices"] = [];
            for (let item of this.dayPrices)
                data["dayPrices"].push(item.toJSON());
        }
        if (Array.isArray(this.seasonSummaries)) {
            data["seasonSummaries"] = [];
            for (let item of this.seasonSummaries)
                data["seasonSummaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBookingPriceBreakdown {
    pricingMode?: PricingMode;
    dayPrices?: BookingDayPrice[] | null;
    seasonSummaries?: BookingSeasonSummary[] | null;
}

export class BookingSeasonSummary implements IBookingSeasonSummary {
    seasonGuid?: string | null;
    seasonName?: string | null;
    daysCount?: number;
    totalBasePrice?: number;
    totalFees?: number;

    constructor(data?: IBookingSeasonSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonGuid = _data["seasonGuid"];
            this.seasonName = _data["seasonName"];
            this.daysCount = _data["daysCount"];
            this.totalBasePrice = _data["totalBasePrice"];
            this.totalFees = _data["totalFees"];
        }
    }

    static fromJS(data: any): BookingSeasonSummary {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSeasonSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonGuid"] = this.seasonGuid;
        data["seasonName"] = this.seasonName;
        data["daysCount"] = this.daysCount;
        data["totalBasePrice"] = this.totalBasePrice;
        data["totalFees"] = this.totalFees;
        return data;
    }
}

export interface IBookingSeasonSummary {
    seasonGuid?: string | null;
    seasonName?: string | null;
    daysCount?: number;
    totalBasePrice?: number;
    totalFees?: number;
}

export enum BookingSortOptions {
    BookingId = "BookingId",
    ListingTitle = "ListingTitle",
    CustomerName = "CustomerName",
    MarketName = "MarketName",
    Price = "Price",
    BoatName = "BoatName",
    BookedFrom = "BookedFrom",
    BookedTo = "BookedTo",
    CreatedAt = "CreatedAt",
    HasAppliedPromoCode = "HasAppliedPromoCode",
}

export enum BookingSource {
    NotSet = "NotSet",
    Admin = "Admin",
    Widget = "Widget",
    Import = "Import",
}

export class BookingSourceInfo implements IBookingSourceInfo {
    source?: BookingSource;
    widgetDomain?: string | null;

    constructor(data?: IBookingSourceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.widgetDomain = _data["widgetDomain"];
        }
    }

    static fromJS(data: any): BookingSourceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSourceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["widgetDomain"] = this.widgetDomain;
        return data;
    }
}

export interface IBookingSourceInfo {
    source?: BookingSource;
    widgetDomain?: string | null;
}

export enum BookingStatus {
    NotSet = "NotSet",
    Draft = "Draft",
    Enquiry = "Enquiry",
    Offer = "Offer",
    Proforma = "Proforma",
    Reservation = "Reservation",
    Completed = "Completed",
    Declined = "Declined",
    Cancelled = "Cancelled",
    Expired = "Expired",
    Postponed = "Postponed",
}

export class BookingSummaryDto implements IBookingSummaryDto {
    guid!: string;
    bookingNumber!: string | null;
    totalPrice!: number;
    startDate!: Date;
    endDate!: Date;

    constructor(data?: IBookingSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingNumber = _data["bookingNumber"];
            this.totalPrice = _data["totalPrice"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): BookingSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingNumber"] = this.bookingNumber;
        data["totalPrice"] = this.totalPrice;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["endDate"] = this.endDate && formatDate(this.endDate);
        return data;
    }
}

export interface IBookingSummaryDto {
    guid: string;
    bookingNumber: string | null;
    totalPrice: number;
    startDate: Date;
    endDate: Date;
}

export class BookingSummaryRequiredFields implements IBookingSummaryRequiredFields {
    phoneVisible?: boolean;
    phoneRequired?: boolean;
    addressVisible?: boolean;
    addressRequired?: boolean;
    companyVisible?: boolean;
    companyRequired?: boolean;
    taxIdVisible?: boolean;
    taxIdRequired?: boolean;
    billingInfoVisible?: boolean;
    billingInfoRequired?: boolean;
    idPassportNumberVisible?: boolean;
    idPassportNumberRequired?: boolean;

    constructor(data?: IBookingSummaryRequiredFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneVisible = _data["phoneVisible"];
            this.phoneRequired = _data["phoneRequired"];
            this.addressVisible = _data["addressVisible"];
            this.addressRequired = _data["addressRequired"];
            this.companyVisible = _data["companyVisible"];
            this.companyRequired = _data["companyRequired"];
            this.taxIdVisible = _data["taxIdVisible"];
            this.taxIdRequired = _data["taxIdRequired"];
            this.billingInfoVisible = _data["billingInfoVisible"];
            this.billingInfoRequired = _data["billingInfoRequired"];
            this.idPassportNumberVisible = _data["idPassportNumberVisible"];
            this.idPassportNumberRequired = _data["idPassportNumberRequired"];
        }
    }

    static fromJS(data: any): BookingSummaryRequiredFields {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSummaryRequiredFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneVisible"] = this.phoneVisible;
        data["phoneRequired"] = this.phoneRequired;
        data["addressVisible"] = this.addressVisible;
        data["addressRequired"] = this.addressRequired;
        data["companyVisible"] = this.companyVisible;
        data["companyRequired"] = this.companyRequired;
        data["taxIdVisible"] = this.taxIdVisible;
        data["taxIdRequired"] = this.taxIdRequired;
        data["billingInfoVisible"] = this.billingInfoVisible;
        data["billingInfoRequired"] = this.billingInfoRequired;
        data["idPassportNumberVisible"] = this.idPassportNumberVisible;
        data["idPassportNumberRequired"] = this.idPassportNumberRequired;
        return data;
    }
}

export interface IBookingSummaryRequiredFields {
    phoneVisible?: boolean;
    phoneRequired?: boolean;
    addressVisible?: boolean;
    addressRequired?: boolean;
    companyVisible?: boolean;
    companyRequired?: boolean;
    taxIdVisible?: boolean;
    taxIdRequired?: boolean;
    billingInfoVisible?: boolean;
    billingInfoRequired?: boolean;
    idPassportNumberVisible?: boolean;
    idPassportNumberRequired?: boolean;
}

export class BookingSummarySettings implements IBookingSummarySettings {
    hideLocationSection?: boolean;
    fuelNotice?: string | null;
    requiredFields?: BookingSummaryRequiredFields;

    constructor(data?: IBookingSummarySettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hideLocationSection = _data["hideLocationSection"];
            this.fuelNotice = _data["fuelNotice"];
            this.requiredFields = _data["requiredFields"] ? BookingSummaryRequiredFields.fromJS(_data["requiredFields"]) : <any>null;
        }
    }

    static fromJS(data: any): BookingSummarySettings {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSummarySettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hideLocationSection"] = this.hideLocationSection;
        data["fuelNotice"] = this.fuelNotice;
        data["requiredFields"] = this.requiredFields ? this.requiredFields.toJSON() : this.requiredFields;
        return data;
    }
}

export interface IBookingSummarySettings {
    hideLocationSection?: boolean;
    fuelNotice?: string | null;
    requiredFields?: BookingSummaryRequiredFields;
}

export enum BookingType {
    NotSet = "NotSet",
    InstantlyBookable = "InstantlyBookable",
    RequestOnly = "RequestOnly",
}

export class BrokerContactResult implements IBrokerContactResult {
    guid!: string;
    firstName!: string | null;
    lastName!: string | null;
    middleName!: string | null;
    fullName!: string | null;
    email!: string | null;
    phone!: string | null;

    constructor(data?: IBrokerContactResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): BrokerContactResult {
        data = typeof data === 'object' ? data : {};
        let result = new BrokerContactResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IBrokerContactResult {
    guid: string;
    firstName: string | null;
    lastName: string | null;
    middleName: string | null;
    fullName: string | null;
    email: string | null;
    phone: string | null;
}

export class CalculateBookingPriceQuery implements ICalculateBookingPriceQuery {
    date?: Date | null;
    pricingGuid?: string | null;
    readonly hasOverrides?: boolean;

    constructor(data?: ICalculateBookingPriceQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
            this.pricingGuid = _data["pricingGuid"];
            (<any>this).hasOverrides = _data["hasOverrides"];
        }
    }

    static fromJS(data: any): CalculateBookingPriceQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateBookingPriceQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date && formatDate(this.date);
        data["pricingGuid"] = this.pricingGuid;
        data["hasOverrides"] = this.hasOverrides;
        return data;
    }
}

export interface ICalculateBookingPriceQuery {
    date?: Date | null;
    pricingGuid?: string | null;
    hasOverrides?: boolean;
}

export class CalculateBookingPriceQueryResult implements ICalculateBookingPriceQueryResult {
    recalculationBlockedReason?: string | null;
    currentBasePrice?: number;
    currentAdditionalFees?: AdditionalFeeItem[] | null;
    currentTotalPrice?: number;
    basePriceDiscount?: number;
    discountTypeGuid?: string | null;
    recalculatedBasePrice?: number | null;
    recalculatedAdditionalFees?: AdditionalFeeItem[] | null;
    recalculatedTotalPrice?: number | null;
    priceDifference?: number | null;
    priceDifferencePercentage?: number | null;

    constructor(data?: ICalculateBookingPriceQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recalculationBlockedReason = _data["recalculationBlockedReason"];
            this.currentBasePrice = _data["currentBasePrice"];
            if (Array.isArray(_data["currentAdditionalFees"])) {
                this.currentAdditionalFees = [] as any;
                for (let item of _data["currentAdditionalFees"])
                    this.currentAdditionalFees!.push(AdditionalFeeItem.fromJS(item));
            }
            this.currentTotalPrice = _data["currentTotalPrice"];
            this.basePriceDiscount = _data["basePriceDiscount"];
            this.discountTypeGuid = _data["discountTypeGuid"];
            this.recalculatedBasePrice = _data["recalculatedBasePrice"];
            if (Array.isArray(_data["recalculatedAdditionalFees"])) {
                this.recalculatedAdditionalFees = [] as any;
                for (let item of _data["recalculatedAdditionalFees"])
                    this.recalculatedAdditionalFees!.push(AdditionalFeeItem.fromJS(item));
            }
            this.recalculatedTotalPrice = _data["recalculatedTotalPrice"];
            this.priceDifference = _data["priceDifference"];
            this.priceDifferencePercentage = _data["priceDifferencePercentage"];
        }
    }

    static fromJS(data: any): CalculateBookingPriceQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateBookingPriceQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recalculationBlockedReason"] = this.recalculationBlockedReason;
        data["currentBasePrice"] = this.currentBasePrice;
        if (Array.isArray(this.currentAdditionalFees)) {
            data["currentAdditionalFees"] = [];
            for (let item of this.currentAdditionalFees)
                data["currentAdditionalFees"].push(item.toJSON());
        }
        data["currentTotalPrice"] = this.currentTotalPrice;
        data["basePriceDiscount"] = this.basePriceDiscount;
        data["discountTypeGuid"] = this.discountTypeGuid;
        data["recalculatedBasePrice"] = this.recalculatedBasePrice;
        if (Array.isArray(this.recalculatedAdditionalFees)) {
            data["recalculatedAdditionalFees"] = [];
            for (let item of this.recalculatedAdditionalFees)
                data["recalculatedAdditionalFees"].push(item.toJSON());
        }
        data["recalculatedTotalPrice"] = this.recalculatedTotalPrice;
        data["priceDifference"] = this.priceDifference;
        data["priceDifferencePercentage"] = this.priceDifferencePercentage;
        return data;
    }
}

export interface ICalculateBookingPriceQueryResult {
    recalculationBlockedReason?: string | null;
    currentBasePrice?: number;
    currentAdditionalFees?: AdditionalFeeItem[] | null;
    currentTotalPrice?: number;
    basePriceDiscount?: number;
    discountTypeGuid?: string | null;
    recalculatedBasePrice?: number | null;
    recalculatedAdditionalFees?: AdditionalFeeItem[] | null;
    recalculatedTotalPrice?: number | null;
    priceDifference?: number | null;
    priceDifferencePercentage?: number | null;
}

export class CalendarBoat implements ICalendarBoat {
    guid!: string;
    defaultListingTitle!: string | null;
    registeredName!: string | null;
    passengers!: number | null;
    length!: number | null;
    isDeleted!: boolean;
    sortPriority!: number | null;
    isComplete!: boolean;
    bathroomsCount!: number | null;
    crewCapacity!: number | null;
    hasSpecificationFile!: boolean;
    boatPicture?: PictureResultModel;

    constructor(data?: ICalendarBoat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.defaultListingTitle = _data["defaultListingTitle"];
            this.registeredName = _data["registeredName"];
            this.passengers = _data["passengers"];
            this.length = _data["length"];
            this.isDeleted = _data["isDeleted"];
            this.sortPriority = _data["sortPriority"];
            this.isComplete = _data["isComplete"];
            this.bathroomsCount = _data["bathroomsCount"];
            this.crewCapacity = _data["crewCapacity"];
            this.hasSpecificationFile = _data["hasSpecificationFile"];
            this.boatPicture = _data["boatPicture"] ? PictureResultModel.fromJS(_data["boatPicture"]) : <any>null;
        }
    }

    static fromJS(data: any): CalendarBoat {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarBoat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["defaultListingTitle"] = this.defaultListingTitle;
        data["registeredName"] = this.registeredName;
        data["passengers"] = this.passengers;
        data["length"] = this.length;
        data["isDeleted"] = this.isDeleted;
        data["sortPriority"] = this.sortPriority;
        data["isComplete"] = this.isComplete;
        data["bathroomsCount"] = this.bathroomsCount;
        data["crewCapacity"] = this.crewCapacity;
        data["hasSpecificationFile"] = this.hasSpecificationFile;
        data["boatPicture"] = this.boatPicture ? this.boatPicture.toJSON() : this.boatPicture;
        return data;
    }
}

export interface ICalendarBoat {
    guid: string;
    defaultListingTitle: string | null;
    registeredName: string | null;
    passengers: number | null;
    length: number | null;
    isDeleted: boolean;
    sortPriority: number | null;
    isComplete: boolean;
    bathroomsCount: number | null;
    crewCapacity: number | null;
    hasSpecificationFile: boolean;
    boatPicture?: PictureResultModel;
}

export class CalendarBookingContractInfo implements ICalendarBookingContractInfo {
    status?: ContractStatus;
    lastSentAt?: Date | null;
    signedAt?: Date | null;
    isCurrent?: boolean;
    contractId?: string | null;
    recipientEmail?: string | null;

    constructor(data?: ICalendarBookingContractInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.lastSentAt = _data["lastSentAt"] ? new Date(_data["lastSentAt"].toString()) : <any>null;
            this.signedAt = _data["signedAt"] ? new Date(_data["signedAt"].toString()) : <any>null;
            this.isCurrent = _data["isCurrent"];
            this.contractId = _data["contractId"];
            this.recipientEmail = _data["recipientEmail"];
        }
    }

    static fromJS(data: any): CalendarBookingContractInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarBookingContractInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["lastSentAt"] = this.lastSentAt && this.lastSentAt.toISOString();
        data["signedAt"] = this.signedAt && this.signedAt.toISOString();
        data["isCurrent"] = this.isCurrent;
        data["contractId"] = this.contractId;
        data["recipientEmail"] = this.recipientEmail;
        return data;
    }
}

export interface ICalendarBookingContractInfo {
    status?: ContractStatus;
    lastSentAt?: Date | null;
    signedAt?: Date | null;
    isCurrent?: boolean;
    contractId?: string | null;
    recipientEmail?: string | null;
}

export enum CalendarDayAvailability {
    NotSet = "NotSet",
    Available = "Available",
    PartiallyAvailable = "PartiallyAvailable",
    SoldOut = "SoldOut",
}

export class CalendarDayPrice implements ICalendarDayPrice {
    readonly guid?: string;
    basePrice?: number;
    feesTotal?: number;
    seasonGuid?: string | null;
    seasonName?: string | null;
    seasonColor?: string | null;
    isCustomPrice?: boolean;

    constructor(data?: ICalendarDayPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.basePrice = _data["basePrice"];
            this.feesTotal = _data["feesTotal"];
            this.seasonGuid = _data["seasonGuid"];
            this.seasonName = _data["seasonName"];
            this.seasonColor = _data["seasonColor"];
            this.isCustomPrice = _data["isCustomPrice"];
        }
    }

    static fromJS(data: any): CalendarDayPrice {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDayPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["basePrice"] = this.basePrice;
        data["feesTotal"] = this.feesTotal;
        data["seasonGuid"] = this.seasonGuid;
        data["seasonName"] = this.seasonName;
        data["seasonColor"] = this.seasonColor;
        data["isCustomPrice"] = this.isCustomPrice;
        return data;
    }
}

export interface ICalendarDayPrice {
    guid?: string;
    basePrice?: number;
    feesTotal?: number;
    seasonGuid?: string | null;
    seasonName?: string | null;
    seasonColor?: string | null;
    isCustomPrice?: boolean;
}

export class CalendarDayPriceResult implements ICalendarDayPriceResult {
    date!: Date;
    basePrice!: number;
    feesTotal!: number;
    isAvailable!: boolean;
    seasonGuid?: string | null;
    seasonName?: string | null;
    seasonColor?: string | null;
    isCustomPrice?: boolean;

    constructor(data?: ICalendarDayPriceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
            this.basePrice = _data["basePrice"];
            this.feesTotal = _data["feesTotal"];
            this.isAvailable = _data["isAvailable"];
            this.seasonGuid = _data["seasonGuid"];
            this.seasonName = _data["seasonName"];
            this.seasonColor = _data["seasonColor"];
            this.isCustomPrice = _data["isCustomPrice"];
        }
    }

    static fromJS(data: any): CalendarDayPriceResult {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDayPriceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date && formatDate(this.date);
        data["basePrice"] = this.basePrice;
        data["feesTotal"] = this.feesTotal;
        data["isAvailable"] = this.isAvailable;
        data["seasonGuid"] = this.seasonGuid;
        data["seasonName"] = this.seasonName;
        data["seasonColor"] = this.seasonColor;
        data["isCustomPrice"] = this.isCustomPrice;
        return data;
    }
}

export interface ICalendarDayPriceResult {
    date: Date;
    basePrice: number;
    feesTotal: number;
    isAvailable: boolean;
    seasonGuid?: string | null;
    seasonName?: string | null;
    seasonColor?: string | null;
    isCustomPrice?: boolean;
}

export enum CalendarDayPricingsSortOptions {
    LocationTitle = "LocationTitle",
}

export class CalendarDayResult implements ICalendarDayResult {
    day?: Date;
    dayPackagePrices?: DayPackagePrice[] | null;

    constructor(data?: ICalendarDayResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"] ? parseDateOnly(_data["day"].toString()) : <any>null;
            if (Array.isArray(_data["dayPackagePrices"])) {
                this.dayPackagePrices = [] as any;
                for (let item of _data["dayPackagePrices"])
                    this.dayPackagePrices!.push(DayPackagePrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalendarDayResult {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDayResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day && formatDate(this.day);
        if (Array.isArray(this.dayPackagePrices)) {
            data["dayPackagePrices"] = [];
            for (let item of this.dayPackagePrices)
                data["dayPackagePrices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalendarDayResult {
    day?: Date;
    dayPackagePrices?: DayPackagePrice[] | null;
}

export class CalendarListing implements ICalendarListing {
    guid!: string;
    title!: string | null;
    publishStatus!: PublishStatus;
    boatIdentifier!: string | null;
    location?: LocationResult;
    market?: MarketResult;
    defaultSkipper?: UserResult;
    defaultStewardess?: UserResult;
    defaultCheckinPerson?: UserResult;

    constructor(data?: ICalendarListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.publishStatus = _data["publishStatus"];
            this.boatIdentifier = _data["boatIdentifier"];
            this.location = _data["location"] ? LocationResult.fromJS(_data["location"]) : <any>null;
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : <any>null;
            this.defaultSkipper = _data["defaultSkipper"] ? UserResult.fromJS(_data["defaultSkipper"]) : <any>null;
            this.defaultStewardess = _data["defaultStewardess"] ? UserResult.fromJS(_data["defaultStewardess"]) : <any>null;
            this.defaultCheckinPerson = _data["defaultCheckinPerson"] ? UserResult.fromJS(_data["defaultCheckinPerson"]) : <any>null;
        }
    }

    static fromJS(data: any): CalendarListing {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["publishStatus"] = this.publishStatus;
        data["boatIdentifier"] = this.boatIdentifier;
        data["location"] = this.location ? this.location.toJSON() : this.location;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["defaultSkipper"] = this.defaultSkipper ? this.defaultSkipper.toJSON() : this.defaultSkipper;
        data["defaultStewardess"] = this.defaultStewardess ? this.defaultStewardess.toJSON() : this.defaultStewardess;
        data["defaultCheckinPerson"] = this.defaultCheckinPerson ? this.defaultCheckinPerson.toJSON() : this.defaultCheckinPerson;
        return data;
    }
}

export interface ICalendarListing {
    guid: string;
    title: string | null;
    publishStatus: PublishStatus;
    boatIdentifier: string | null;
    location?: LocationResult;
    market?: MarketResult;
    defaultSkipper?: UserResult;
    defaultStewardess?: UserResult;
    defaultCheckinPerson?: UserResult;
}

export enum CampaignComissionType {
    NotSet = "NotSet",
    Fixed = "Fixed",
}

export enum CampaignCommissionPaymentSortOptions {
    BookingId = "BookingId",
    BookingTotalPrice = "BookingTotalPrice",
    BookingStart = "BookingStart",
    CommissionAmount = "CommissionAmount",
    IsPaid = "IsPaid",
    PaidAtUtc = "PaidAtUtc",
    CustomerName = "CustomerName",
}

export class CancelBookingCommand implements ICancelBookingCommand {
    reason?: BookingCancellationReason;
    note?: string | null;

    constructor(data?: ICancelBookingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CancelBookingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelBookingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["note"] = this.note;
        return data;
    }
}

export interface ICancelBookingCommand {
    reason?: BookingCancellationReason;
    note?: string | null;
}

export class CarParkingLocation implements ICarParkingLocation {
    providerScheme?: string | null;
    name?: string | null;
    extension?: string | null;
    contentType?: string | null;
    alias?: string | null;

    constructor(data?: ICarParkingLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerScheme = _data["providerScheme"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.contentType = _data["contentType"];
            this.alias = _data["alias"];
        }
    }

    static fromJS(data: any): CarParkingLocation {
        data = typeof data === 'object' ? data : {};
        let result = new CarParkingLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerScheme"] = this.providerScheme;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["contentType"] = this.contentType;
        data["alias"] = this.alias;
        return data;
    }
}

export interface ICarParkingLocation {
    providerScheme?: string | null;
    name?: string | null;
    extension?: string | null;
    contentType?: string | null;
    alias?: string | null;
}

export class ChangePasswordCommand implements IChangePasswordCommand {
    oldPassword!: string | null;
    newPassword!: string | null;
    confirmNewPassword!: string | null;

    constructor(data?: IChangePasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmNewPassword = _data["confirmNewPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["confirmNewPassword"] = this.confirmNewPassword;
        return data;
    }
}

export interface IChangePasswordCommand {
    oldPassword: string | null;
    newPassword: string | null;
    confirmNewPassword: string | null;
}

export class ChangePasswordFromResetTokenCommand implements IChangePasswordFromResetTokenCommand {
    authenticationUserId!: string | null;
    token!: string | null;
    newPassword!: string | null;
    confirmNewPassword!: string | null;

    constructor(data?: IChangePasswordFromResetTokenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationUserId = _data["authenticationUserId"];
            this.token = _data["token"];
            this.newPassword = _data["newPassword"];
            this.confirmNewPassword = _data["confirmNewPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordFromResetTokenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordFromResetTokenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationUserId"] = this.authenticationUserId;
        data["token"] = this.token;
        data["newPassword"] = this.newPassword;
        data["confirmNewPassword"] = this.confirmNewPassword;
        return data;
    }
}

export interface IChangePasswordFromResetTokenCommand {
    authenticationUserId: string | null;
    token: string | null;
    newPassword: string | null;
    confirmNewPassword: string | null;
}

export class ChannelCampaingsResult implements IChannelCampaingsResult {
    guid?: string;
    name?: string | null;
    isActive?: boolean;
    landingUrl?: string | null;
    clicks?: number;
    conversions?: number;
    rate?: number;
    createdAtUtc?: Date;

    constructor(data?: IChannelCampaingsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.landingUrl = _data["landingUrl"];
            this.clicks = _data["clicks"];
            this.conversions = _data["conversions"];
            this.rate = _data["rate"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ChannelCampaingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelCampaingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["landingUrl"] = this.landingUrl;
        data["clicks"] = this.clicks;
        data["conversions"] = this.conversions;
        data["rate"] = this.rate;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        return data;
    }
}

export interface IChannelCampaingsResult {
    guid?: string;
    name?: string | null;
    isActive?: boolean;
    landingUrl?: string | null;
    clicks?: number;
    conversions?: number;
    rate?: number;
    createdAtUtc?: Date;
}

export enum ChannelSortOptions {
    Name = "Name",
}

export enum ChannelType {
    NotSet = "NotSet",
    Referral = "Referral",
}

export class ChargeBookingWorldPayPaymentCommand implements IChargeBookingWorldPayPaymentCommand {
    bookingGuid!: string;
    paymentMethodGuid!: string;
    amount!: number;
    note?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: IChargeBookingWorldPayPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.paymentMethodGuid = _data["paymentMethodGuid"];
            this.amount = _data["amount"];
            this.note = _data["note"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): ChargeBookingWorldPayPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeBookingWorldPayPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["paymentMethodGuid"] = this.paymentMethodGuid;
        data["amount"] = this.amount;
        data["note"] = this.note;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface IChargeBookingWorldPayPaymentCommand {
    bookingGuid: string;
    paymentMethodGuid: string;
    amount: number;
    note?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class ChargeBookingWorldPayPaymentCommandResult implements IChargeBookingWorldPayPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: WorldPayTransactionStatus;
    paymentStatus?: PaymentStatus;
    tokenId?: string | null;
    isNewPaymentMethod?: boolean;

    constructor(data?: IChargeBookingWorldPayPaymentCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGuid = _data["paymentGuid"];
            this.transactionStatus = _data["transactionStatus"];
            this.paymentStatus = _data["paymentStatus"];
            this.tokenId = _data["tokenId"];
            this.isNewPaymentMethod = _data["isNewPaymentMethod"];
        }
    }

    static fromJS(data: any): ChargeBookingWorldPayPaymentCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeBookingWorldPayPaymentCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGuid"] = this.paymentGuid;
        data["transactionStatus"] = this.transactionStatus;
        data["paymentStatus"] = this.paymentStatus;
        data["tokenId"] = this.tokenId;
        data["isNewPaymentMethod"] = this.isNewPaymentMethod;
        return data;
    }
}

export interface IChargeBookingWorldPayPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: WorldPayTransactionStatus;
    paymentStatus?: PaymentStatus;
    tokenId?: string | null;
    isNewPaymentMethod?: boolean;
}

export class ChargeCustomerBalanceAuthorizeNetPaymentCommand implements IChargeCustomerBalanceAuthorizeNetPaymentCommand {
    customerGuid!: string;
    amount!: number;
    paymentProfileId!: string | null;
    note?: string | null;

    constructor(data?: IChargeCustomerBalanceAuthorizeNetPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerGuid = _data["customerGuid"];
            this.amount = _data["amount"];
            this.paymentProfileId = _data["paymentProfileId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ChargeCustomerBalanceAuthorizeNetPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeCustomerBalanceAuthorizeNetPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerGuid"] = this.customerGuid;
        data["amount"] = this.amount;
        data["paymentProfileId"] = this.paymentProfileId;
        data["note"] = this.note;
        return data;
    }
}

export interface IChargeCustomerBalanceAuthorizeNetPaymentCommand {
    customerGuid: string;
    amount: number;
    paymentProfileId: string | null;
    note?: string | null;
}

export class ChargeCustomerBalanceAuthorizeNetPaymentCommandResult implements IChargeCustomerBalanceAuthorizeNetPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: AuthorizeNetTransactionStatus;
    paymentStatus?: PaymentStatus;

    constructor(data?: IChargeCustomerBalanceAuthorizeNetPaymentCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGuid = _data["paymentGuid"];
            this.transactionStatus = _data["transactionStatus"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): ChargeCustomerBalanceAuthorizeNetPaymentCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeCustomerBalanceAuthorizeNetPaymentCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGuid"] = this.paymentGuid;
        data["transactionStatus"] = this.transactionStatus;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IChargeCustomerBalanceAuthorizeNetPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: AuthorizeNetTransactionStatus;
    paymentStatus?: PaymentStatus;
}

export class ChargeCustomerBalancePaymentCommand implements IChargeCustomerBalancePaymentCommand {
    customerGuid!: string;
    amount!: number;
    paymentMethodId!: string | null;
    note?: string | null;

    constructor(data?: IChargeCustomerBalancePaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerGuid = _data["customerGuid"];
            this.amount = _data["amount"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ChargeCustomerBalancePaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeCustomerBalancePaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerGuid"] = this.customerGuid;
        data["amount"] = this.amount;
        data["paymentMethodId"] = this.paymentMethodId;
        data["note"] = this.note;
        return data;
    }
}

export interface IChargeCustomerBalancePaymentCommand {
    customerGuid: string;
    amount: number;
    paymentMethodId: string | null;
    note?: string | null;
}

export class ChargeCustomerBalanceWorldPayPaymentCommand implements IChargeCustomerBalanceWorldPayPaymentCommand {
    customerGuid!: string;
    amount!: number;
    paymentMethodGuid!: string;
    note?: string | null;

    constructor(data?: IChargeCustomerBalanceWorldPayPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerGuid = _data["customerGuid"];
            this.amount = _data["amount"];
            this.paymentMethodGuid = _data["paymentMethodGuid"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ChargeCustomerBalanceWorldPayPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeCustomerBalanceWorldPayPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerGuid"] = this.customerGuid;
        data["amount"] = this.amount;
        data["paymentMethodGuid"] = this.paymentMethodGuid;
        data["note"] = this.note;
        return data;
    }
}

export interface IChargeCustomerBalanceWorldPayPaymentCommand {
    customerGuid: string;
    amount: number;
    paymentMethodGuid: string;
    note?: string | null;
}

export class ChargeCustomerBalanceWorldPayPaymentCommandResult implements IChargeCustomerBalanceWorldPayPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: WorldPayTransactionStatus;
    paymentStatus?: PaymentStatus;

    constructor(data?: IChargeCustomerBalanceWorldPayPaymentCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGuid = _data["paymentGuid"];
            this.transactionStatus = _data["transactionStatus"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): ChargeCustomerBalanceWorldPayPaymentCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeCustomerBalanceWorldPayPaymentCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGuid"] = this.paymentGuid;
        data["transactionStatus"] = this.transactionStatus;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IChargeCustomerBalanceWorldPayPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: WorldPayTransactionStatus;
    paymentStatus?: PaymentStatus;
}

export class ChargeCustomerBookingAuthorizeNetPaymentCommand implements IChargeCustomerBookingAuthorizeNetPaymentCommand {
    bookingGuid!: string;
    amount!: number;
    paymentProfileId!: string | null;
    note?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: IChargeCustomerBookingAuthorizeNetPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.amount = _data["amount"];
            this.paymentProfileId = _data["paymentProfileId"];
            this.note = _data["note"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): ChargeCustomerBookingAuthorizeNetPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeCustomerBookingAuthorizeNetPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["amount"] = this.amount;
        data["paymentProfileId"] = this.paymentProfileId;
        data["note"] = this.note;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface IChargeCustomerBookingAuthorizeNetPaymentCommand {
    bookingGuid: string;
    amount: number;
    paymentProfileId: string | null;
    note?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class ChargeCustomerBookingAuthorizeNetPaymentCommandResult implements IChargeCustomerBookingAuthorizeNetPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: AuthorizeNetTransactionStatus;
    paymentStatus?: PaymentStatus;

    constructor(data?: IChargeCustomerBookingAuthorizeNetPaymentCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGuid = _data["paymentGuid"];
            this.transactionStatus = _data["transactionStatus"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): ChargeCustomerBookingAuthorizeNetPaymentCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeCustomerBookingAuthorizeNetPaymentCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGuid"] = this.paymentGuid;
        data["transactionStatus"] = this.transactionStatus;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IChargeCustomerBookingAuthorizeNetPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: AuthorizeNetTransactionStatus;
    paymentStatus?: PaymentStatus;
}

export class ChargeCustomerBookingStripePaymentCommand implements IChargeCustomerBookingStripePaymentCommand {
    bookingGuid!: string;
    amount!: number;
    paymentMethodId!: string | null;
    note?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: IChargeCustomerBookingStripePaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.amount = _data["amount"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.note = _data["note"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): ChargeCustomerBookingStripePaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeCustomerBookingStripePaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["amount"] = this.amount;
        data["paymentMethodId"] = this.paymentMethodId;
        data["note"] = this.note;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface IChargeCustomerBookingStripePaymentCommand {
    bookingGuid: string;
    amount: number;
    paymentMethodId: string | null;
    note?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class CheckinPersonAssignedListing implements ICheckinPersonAssignedListing {
    guid?: string;
    title?: string | null;

    constructor(data?: ICheckinPersonAssignedListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CheckinPersonAssignedListing {
        data = typeof data === 'object' ? data : {};
        let result = new CheckinPersonAssignedListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        return data;
    }
}

export interface ICheckinPersonAssignedListing {
    guid?: string;
    title?: string | null;
}

export enum CheckinPersonSortOptions {
    FullName = "FullName",
}

export class CloseSalesLeadCommand implements ICloseSalesLeadCommand {
    closedStatus!: SalesLeadStatus;

    constructor(data?: ICloseSalesLeadCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.closedStatus = _data["closedStatus"];
        }
    }

    static fromJS(data: any): CloseSalesLeadCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CloseSalesLeadCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["closedStatus"] = this.closedStatus;
        return data;
    }
}

export interface ICloseSalesLeadCommand {
    closedStatus: SalesLeadStatus;
}

export class ContractBooking implements IContractBooking {
    guid?: string;
    start?: TimeZoneDateTime;
    end?: TimeZoneDateTime;

    constructor(data?: IContractBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.start = _data["start"] ? TimeZoneDateTime.fromJS(_data["start"]) : <any>null;
            this.end = _data["end"] ? TimeZoneDateTime.fromJS(_data["end"]) : <any>null;
        }
    }

    static fromJS(data: any): ContractBooking {
        data = typeof data === 'object' ? data : {};
        let result = new ContractBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["start"] = this.start ? this.start.toJSON() : this.start;
        data["end"] = this.end ? this.end.toJSON() : this.end;
        return data;
    }
}

export interface IContractBooking {
    guid?: string;
    start?: TimeZoneDateTime;
    end?: TimeZoneDateTime;
}

export class ContractCustomer implements IContractCustomer {
    guid?: string;
    fullName?: string | null;

    constructor(data?: IContractCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): ContractCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new ContractCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IContractCustomer {
    guid?: string;
    fullName?: string | null;
}

export class ContractLocation implements IContractLocation {
    guid?: string;
    fullName?: string | null;

    constructor(data?: IContractLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): ContractLocation {
        data = typeof data === 'object' ? data : {};
        let result = new ContractLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IContractLocation {
    guid?: string;
    fullName?: string | null;
}

export enum ContractProviderType {
    NotSet = "NotSet",
    Docusign = "Docusign",
    ExternalUrl = "ExternalUrl",
}

export class ContractSendInfo implements IContractSendInfo {
    sentAt!: Date;
    recipientEmail!: string | null;

    constructor(data?: IContractSendInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : <any>null;
            this.recipientEmail = _data["recipientEmail"];
        }
    }

    static fromJS(data: any): ContractSendInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSendInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sentAt"] = this.sentAt && this.sentAt.toISOString();
        data["recipientEmail"] = this.recipientEmail;
        return data;
    }
}

export interface IContractSendInfo {
    sentAt: Date;
    recipientEmail: string | null;
}

export class ContractSkipper implements IContractSkipper {
    guid?: string;
    fullName?: string | null;

    constructor(data?: IContractSkipper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): ContractSkipper {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSkipper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IContractSkipper {
    guid?: string;
    fullName?: string | null;
}

export enum ContractStatus {
    Created = "Created",
    Sending = "Sending",
    Sent = "Sent",
    Signed = "Signed",
    Expired = "Expired",
    Voiding = "Voiding",
    Voided = "Voided",
}

export class ContractUser implements IContractUser {
    guid?: string;
    fullName?: string | null;
    email?: string | null;

    constructor(data?: IContractUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ContractUser {
        data = typeof data === 'object' ? data : {};
        let result = new ContractUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        return data;
    }
}

export interface IContractUser {
    guid?: string;
    fullName?: string | null;
    email?: string | null;
}

export class ConversionTrackingDomainConfigDto implements IConversionTrackingDomainConfigDto {
    guid?: string;
    domain!: string | null;
    ga4MeasurementId?: string | null;
    hasGa4ApiSecret?: boolean;
    googleAdsCustomerId?: string | null;
    googleAdsConversionActionId?: string | null;
    hasGoogleAdsRefreshToken?: boolean;
    metaPixelId?: string | null;
    hasMetaAccessToken?: boolean;

    constructor(data?: IConversionTrackingDomainConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.domain = _data["domain"];
            this.ga4MeasurementId = _data["ga4MeasurementId"];
            this.hasGa4ApiSecret = _data["hasGa4ApiSecret"];
            this.googleAdsCustomerId = _data["googleAdsCustomerId"];
            this.googleAdsConversionActionId = _data["googleAdsConversionActionId"];
            this.hasGoogleAdsRefreshToken = _data["hasGoogleAdsRefreshToken"];
            this.metaPixelId = _data["metaPixelId"];
            this.hasMetaAccessToken = _data["hasMetaAccessToken"];
        }
    }

    static fromJS(data: any): ConversionTrackingDomainConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionTrackingDomainConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["domain"] = this.domain;
        data["ga4MeasurementId"] = this.ga4MeasurementId;
        data["hasGa4ApiSecret"] = this.hasGa4ApiSecret;
        data["googleAdsCustomerId"] = this.googleAdsCustomerId;
        data["googleAdsConversionActionId"] = this.googleAdsConversionActionId;
        data["hasGoogleAdsRefreshToken"] = this.hasGoogleAdsRefreshToken;
        data["metaPixelId"] = this.metaPixelId;
        data["hasMetaAccessToken"] = this.hasMetaAccessToken;
        return data;
    }
}

export interface IConversionTrackingDomainConfigDto {
    guid?: string;
    domain: string | null;
    ga4MeasurementId?: string | null;
    hasGa4ApiSecret?: boolean;
    googleAdsCustomerId?: string | null;
    googleAdsConversionActionId?: string | null;
    hasGoogleAdsRefreshToken?: boolean;
    metaPixelId?: string | null;
    hasMetaAccessToken?: boolean;
}

export class ConvertToProformaCommand implements IConvertToProformaCommand {
    availabilityBlockExpiresAtDate?: Date | null;
    availabilityBlockExpiresAtTime?: TimeOnly;

    constructor(data?: IConvertToProformaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availabilityBlockExpiresAtDate = _data["availabilityBlockExpiresAtDate"] ? parseDateOnly(_data["availabilityBlockExpiresAtDate"].toString()) : <any>null;
            this.availabilityBlockExpiresAtTime = _data["availabilityBlockExpiresAtTime"] ? TimeOnly.fromJS(_data["availabilityBlockExpiresAtTime"]) : <any>null;
        }
    }

    static fromJS(data: any): ConvertToProformaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertToProformaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityBlockExpiresAtDate"] = this.availabilityBlockExpiresAtDate && formatDate(this.availabilityBlockExpiresAtDate);
        data["availabilityBlockExpiresAtTime"] = this.availabilityBlockExpiresAtTime ? this.availabilityBlockExpiresAtTime.toJSON() : this.availabilityBlockExpiresAtTime;
        return data;
    }
}

export interface IConvertToProformaCommand {
    availabilityBlockExpiresAtDate?: Date | null;
    availabilityBlockExpiresAtTime?: TimeOnly;
}

export enum CountryEnum {
    USA = "USA",
    CAN = "CAN",
    GBR = "GBR",
    DEU = "DEU",
    FRA = "FRA",
    ESP = "ESP",
    ITA = "ITA",
    NLD = "NLD",
    BEL = "BEL",
    AUT = "AUT",
    CHE = "CHE",
    AUS = "AUS",
    NZL = "NZL",
    JPN = "JPN",
    KOR = "KOR",
    CHN = "CHN",
    IND = "IND",
    BRA = "BRA",
    MEX = "MEX",
    ARG = "ARG",
    CHL = "CHL",
    COL = "COL",
    PER = "PER",
    VEN = "VEN",
    ECU = "ECU",
    URY = "URY",
    PRY = "PRY",
    BOL = "BOL",
    PAN = "PAN",
    CRI = "CRI",
    GTM = "GTM",
    HND = "HND",
    SLV = "SLV",
    NIC = "NIC",
    DOM = "DOM",
    PRI = "PRI",
    CUB = "CUB",
    JAM = "JAM",
    HTI = "HTI",
    BHS = "BHS",
    TTO = "TTO",
    BRB = "BRB",
    GUY = "GUY",
    SUR = "SUR",
    BLZ = "BLZ",
    IRL = "IRL",
    PRT = "PRT",
    GRC = "GRC",
    POL = "POL",
    CZE = "CZE",
    SVK = "SVK",
    HUN = "HUN",
    ROU = "ROU",
    BGR = "BGR",
    HRV = "HRV",
    SVN = "SVN",
    SRB = "SRB",
    BIH = "BIH",
    MKD = "MKD",
    ALB = "ALB",
    MNE = "MNE",
    UKR = "UKR",
    RUS = "RUS",
    BLR = "BLR",
    MDA = "MDA",
    LTU = "LTU",
    LVA = "LVA",
    EST = "EST",
    FIN = "FIN",
    SWE = "SWE",
    NOR = "NOR",
    DNK = "DNK",
    ISL = "ISL",
    LUX = "LUX",
    MCO = "MCO",
    AND = "AND",
    LIE = "LIE",
    SMR = "SMR",
    VAT = "VAT",
    MLT = "MLT",
    CYP = "CYP",
    TUR = "TUR",
    ISR = "ISR",
    SAU = "SAU",
    ARE = "ARE",
    QAT = "QAT",
    KWT = "KWT",
    BHR = "BHR",
    OMN = "OMN",
    JOR = "JOR",
    LBN = "LBN",
    EGY = "EGY",
    ZAF = "ZAF",
    NGA = "NGA",
    KEN = "KEN",
    GHA = "GHA",
    TZA = "TZA",
    UGA = "UGA",
    ETH = "ETH",
    MAR = "MAR",
    DZA = "DZA",
    TUN = "TUN",
    SGP = "SGP",
    MYS = "MYS",
    THA = "THA",
    IDN = "IDN",
    PHL = "PHL",
    VNM = "VNM",
    HKG = "HKG",
    TWN = "TWN",
    PAK = "PAK",
    BGD = "BGD",
    LKA = "LKA",
    NPL = "NPL",
}

export class CreateAdditionalFeeTypeCommand implements ICreateAdditionalFeeTypeCommand {
    code!: string | null;
    name!: string | null;
    isActive!: boolean;
    defaultTaxes?: TaxLine[] | null;

    constructor(data?: ICreateAdditionalFeeTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAdditionalFeeTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAdditionalFeeTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateAdditionalFeeTypeCommand {
    code: string | null;
    name: string | null;
    isActive: boolean;
    defaultTaxes?: TaxLine[] | null;
}

export class CreateAddonCategoryCommand implements ICreateAddonCategoryCommand {
    name!: string | null;
    publishStatus?: PublishStatus;

    constructor(data?: ICreateAddonCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.publishStatus = _data["publishStatus"];
        }
    }

    static fromJS(data: any): CreateAddonCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddonCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["publishStatus"] = this.publishStatus;
        return data;
    }
}

export interface ICreateAddonCategoryCommand {
    name: string | null;
    publishStatus?: PublishStatus;
}

export class CreateAddonCommand implements ICreateAddonCommand {
    name!: string | null;
    description?: string | null;
    categoryGuid!: string;
    vendorGuid!: string;
    pricingModel!: PricingModel;
    basePrice!: number;
    defaultTaxes?: TaxLine[] | null;
    commissionable!: boolean;
    commissionRatePercentage!: number;
    bookability!: AddonBookability;
    maxQuantity?: number | null;
    selectionType?: AddonSelectionType;
    options?: OptionRequest[] | null;
    publishStatus?: PublishStatus;

    constructor(data?: ICreateAddonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.categoryGuid = _data["categoryGuid"];
            this.vendorGuid = _data["vendorGuid"];
            this.pricingModel = _data["pricingModel"];
            this.basePrice = _data["basePrice"];
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
            this.commissionable = _data["commissionable"];
            this.commissionRatePercentage = _data["commissionRatePercentage"];
            this.bookability = _data["bookability"];
            this.maxQuantity = _data["maxQuantity"];
            this.selectionType = _data["selectionType"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(OptionRequest.fromJS(item));
            }
            this.publishStatus = _data["publishStatus"];
        }
    }

    static fromJS(data: any): CreateAddonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["categoryGuid"] = this.categoryGuid;
        data["vendorGuid"] = this.vendorGuid;
        data["pricingModel"] = this.pricingModel;
        data["basePrice"] = this.basePrice;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        data["commissionable"] = this.commissionable;
        data["commissionRatePercentage"] = this.commissionRatePercentage;
        data["bookability"] = this.bookability;
        data["maxQuantity"] = this.maxQuantity;
        data["selectionType"] = this.selectionType;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["publishStatus"] = this.publishStatus;
        return data;
    }
}

export interface ICreateAddonCommand {
    name: string | null;
    description?: string | null;
    categoryGuid: string;
    vendorGuid: string;
    pricingModel: PricingModel;
    basePrice: number;
    defaultTaxes?: TaxLine[] | null;
    commissionable: boolean;
    commissionRatePercentage: number;
    bookability: AddonBookability;
    maxQuantity?: number | null;
    selectionType?: AddonSelectionType;
    options?: OptionRequest[] | null;
    publishStatus?: PublishStatus;
}

export class CreateAgentBillingInfoDto implements ICreateAgentBillingInfoDto {
    companyName?: string | null;
    vatId?: string | null;
    addressLine?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;

    constructor(data?: ICreateAgentBillingInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.vatId = _data["vatId"];
            this.addressLine = _data["addressLine"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): CreateAgentBillingInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgentBillingInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["vatId"] = this.vatId;
        data["addressLine"] = this.addressLine;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        return data;
    }
}

export interface ICreateAgentBillingInfoDto {
    companyName?: string | null;
    vatId?: string | null;
    addressLine?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
}

export class CreateAgentCommand implements ICreateAgentCommand {
    name!: string | null;
    group!: string | null;
    commissionPercent?: number;
    internalOwnerUserGuid!: string;
    billingInfo?: CreateAgentBillingInfoDto;
    brokers?: CreateBrokerDto[] | null;

    constructor(data?: ICreateAgentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.group = _data["group"];
            this.commissionPercent = _data["commissionPercent"];
            this.internalOwnerUserGuid = _data["internalOwnerUserGuid"];
            this.billingInfo = _data["billingInfo"] ? CreateAgentBillingInfoDto.fromJS(_data["billingInfo"]) : <any>null;
            if (Array.isArray(_data["brokers"])) {
                this.brokers = [] as any;
                for (let item of _data["brokers"])
                    this.brokers!.push(CreateBrokerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAgentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["group"] = this.group;
        data["commissionPercent"] = this.commissionPercent;
        data["internalOwnerUserGuid"] = this.internalOwnerUserGuid;
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : this.billingInfo;
        if (Array.isArray(this.brokers)) {
            data["brokers"] = [];
            for (let item of this.brokers)
                data["brokers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateAgentCommand {
    name: string | null;
    group: string | null;
    commissionPercent?: number;
    internalOwnerUserGuid: string;
    billingInfo?: CreateAgentBillingInfoDto;
    brokers?: CreateBrokerDto[] | null;
}

export class CreateAuthenticationUserCommand implements ICreateAuthenticationUserCommand {
    firstName!: string | null;
    lastName!: string | null;
    middleName?: string | null;
    phone?: string | null;
    email!: string | null;
    password!: string | null;

    constructor(data?: ICreateAuthenticationUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.firstName = "David";
            this.lastName = "Baguetta";
            this.email = "propeller.admin@praguelabs.com";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : "David";
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : "Baguetta";
            this.middleName = _data["middleName"];
            this.phone = _data["phone"];
            this.email = _data["email"] !== undefined ? _data["email"] : "propeller.admin@praguelabs.com";
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateAuthenticationUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAuthenticationUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateAuthenticationUserCommand {
    firstName: string | null;
    lastName: string | null;
    middleName?: string | null;
    phone?: string | null;
    email: string | null;
    password: string | null;
}

export class CreateAuthenticationUserResponse implements ICreateAuthenticationUserResponse {
    authenticationUserId?: string | null;

    constructor(data?: ICreateAuthenticationUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationUserId = _data["authenticationUserId"];
        }
    }

    static fromJS(data: any): CreateAuthenticationUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAuthenticationUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationUserId"] = this.authenticationUserId;
        return data;
    }
}

export interface ICreateAuthenticationUserResponse {
    authenticationUserId?: string | null;
}

export class CreateBoatCommand implements ICreateBoatCommand {
    defaultListingTitle!: string | null;
    registeredName!: string | null;
    makeAndModel!: string | null;
    passengersCapacity!: number;

    constructor(data?: ICreateBoatCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultListingTitle = _data["defaultListingTitle"];
            this.registeredName = _data["registeredName"];
            this.makeAndModel = _data["makeAndModel"];
            this.passengersCapacity = _data["passengersCapacity"];
        }
    }

    static fromJS(data: any): CreateBoatCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBoatCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultListingTitle"] = this.defaultListingTitle;
        data["registeredName"] = this.registeredName;
        data["makeAndModel"] = this.makeAndModel;
        data["passengersCapacity"] = this.passengersCapacity;
        return data;
    }
}

export interface ICreateBoatCommand {
    defaultListingTitle: string | null;
    registeredName: string | null;
    makeAndModel: string | null;
    passengersCapacity: number;
}

export class CreateBoatEventCommand implements ICreateBoatEventCommand {
    boatGuid?: string;
    type!: BoatEventType;
    dateFrom!: Date;
    dateTo!: Date;
    isBlockingAvailability!: boolean;
    note?: string | null;
    timeFrom?: TimeOnly;
    timeTo?: TimeOnly;

    constructor(data?: ICreateBoatEventCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boatGuid = _data["boatGuid"];
            this.type = _data["type"];
            this.dateFrom = _data["dateFrom"] ? parseDateOnly(_data["dateFrom"].toString()) : <any>null;
            this.dateTo = _data["dateTo"] ? parseDateOnly(_data["dateTo"].toString()) : <any>null;
            this.isBlockingAvailability = _data["isBlockingAvailability"];
            this.note = _data["note"];
            this.timeFrom = _data["timeFrom"] ? TimeOnly.fromJS(_data["timeFrom"]) : <any>null;
            this.timeTo = _data["timeTo"] ? TimeOnly.fromJS(_data["timeTo"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateBoatEventCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBoatEventCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boatGuid"] = this.boatGuid;
        data["type"] = this.type;
        data["dateFrom"] = this.dateFrom && formatDate(this.dateFrom);
        data["dateTo"] = this.dateTo && formatDate(this.dateTo);
        data["isBlockingAvailability"] = this.isBlockingAvailability;
        data["note"] = this.note;
        data["timeFrom"] = this.timeFrom ? this.timeFrom.toJSON() : this.timeFrom;
        data["timeTo"] = this.timeTo ? this.timeTo.toJSON() : this.timeTo;
        return data;
    }
}

export interface ICreateBoatEventCommand {
    boatGuid?: string;
    type: BoatEventType;
    dateFrom: Date;
    dateTo: Date;
    isBlockingAvailability: boolean;
    note?: string | null;
    timeFrom?: TimeOnly;
    timeTo?: TimeOnly;
}

export class CreateBoatEventCommandResult implements ICreateBoatEventCommandResult {
    guid?: string;
    isCalendarUpdatedImmediately?: boolean;

    constructor(data?: ICreateBoatEventCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.isCalendarUpdatedImmediately = _data["isCalendarUpdatedImmediately"];
        }
    }

    static fromJS(data: any): CreateBoatEventCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBoatEventCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isCalendarUpdatedImmediately"] = this.isCalendarUpdatedImmediately;
        return data;
    }
}

export interface ICreateBoatEventCommandResult {
    guid?: string;
    isCalendarUpdatedImmediately?: boolean;
}

export class CreateBoatIssueCommand implements ICreateBoatIssueCommand {
    title!: string | null;
    responsible!: string | null;
    type!: BoatIssueType;
    status!: BoatIssueStatus;
    notes?: string | null;

    constructor(data?: ICreateBoatIssueCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.responsible = _data["responsible"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateBoatIssueCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBoatIssueCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["responsible"] = this.responsible;
        data["type"] = this.type;
        data["status"] = this.status;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateBoatIssueCommand {
    title: string | null;
    responsible: string | null;
    type: BoatIssueType;
    status: BoatIssueStatus;
    notes?: string | null;
}

export class CreateBoatPartCommand implements ICreateBoatPartCommand {
    name!: string | null;
    number?: string | null;
    vendorGuid?: string | null;
    cost?: number | null;
    note?: string | null;
    type!: BoatPartType;
    manufacturer?: string | null;
    manufacturerPartNumber?: string | null;
    reorderVendorNumber?: string | null;
    reorderUnitSize?: string | null;
    reorderDate?: Date | null;

    constructor(data?: ICreateBoatPartCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.number = _data["number"];
            this.vendorGuid = _data["vendorGuid"];
            this.cost = _data["cost"];
            this.note = _data["note"];
            this.type = _data["type"];
            this.manufacturer = _data["manufacturer"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.reorderVendorNumber = _data["reorderVendorNumber"];
            this.reorderUnitSize = _data["reorderUnitSize"];
            this.reorderDate = _data["reorderDate"] ? new Date(_data["reorderDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): CreateBoatPartCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBoatPartCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["number"] = this.number;
        data["vendorGuid"] = this.vendorGuid;
        data["cost"] = this.cost;
        data["note"] = this.note;
        data["type"] = this.type;
        data["manufacturer"] = this.manufacturer;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["reorderVendorNumber"] = this.reorderVendorNumber;
        data["reorderUnitSize"] = this.reorderUnitSize;
        data["reorderDate"] = this.reorderDate && this.reorderDate.toISOString();
        return data;
    }
}

export interface ICreateBoatPartCommand {
    name: string | null;
    number?: string | null;
    vendorGuid?: string | null;
    cost?: number | null;
    note?: string | null;
    type: BoatPartType;
    manufacturer?: string | null;
    manufacturerPartNumber?: string | null;
    reorderVendorNumber?: string | null;
    reorderUnitSize?: string | null;
    reorderDate?: Date | null;
}

export class CreateBoatTuneUpCommand implements ICreateBoatTuneUpCommand {
    type!: BoatTuneUpType;
    date!: Date;
    notes!: string | null;

    constructor(data?: ICreateBoatTuneUpCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateBoatTuneUpCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBoatTuneUpCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["date"] = this.date && this.date.toISOString();
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateBoatTuneUpCommand {
    type: BoatTuneUpType;
    date: Date;
    notes: string | null;
}

export class CreateBookingAsBrokerCommand implements ICreateBookingAsBrokerCommand {
    customerGuid!: string;
    listingGuid!: string;
    pricingGuid!: string | null;
    startDate!: Date;
    startTime!: TimeOnly;
    endDate?: Date | null;
    endTime?: TimeOnly;
    passengers!: number;
    additionalFees?: AdditionalFeeItemRequest[] | null;
    bookingNotes?: BookingNotes;
    pickUpLocationGuid?: string | null;
    dropOffLocationGuid?: string | null;
    availabilityBlockForOffer?: boolean;
    formLeadGuid?: string | null;

    constructor(data?: ICreateBookingAsBrokerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.startTime = new TimeOnly();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerGuid = _data["customerGuid"];
            this.listingGuid = _data["listingGuid"];
            this.pricingGuid = _data["pricingGuid"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : new TimeOnly();
            this.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? TimeOnly.fromJS(_data["endTime"]) : <any>null;
            this.passengers = _data["passengers"];
            if (Array.isArray(_data["additionalFees"])) {
                this.additionalFees = [] as any;
                for (let item of _data["additionalFees"])
                    this.additionalFees!.push(AdditionalFeeItemRequest.fromJS(item));
            }
            this.bookingNotes = _data["bookingNotes"] ? BookingNotes.fromJS(_data["bookingNotes"]) : <any>null;
            this.pickUpLocationGuid = _data["pickUpLocationGuid"];
            this.dropOffLocationGuid = _data["dropOffLocationGuid"];
            this.availabilityBlockForOffer = _data["availabilityBlockForOffer"];
            this.formLeadGuid = _data["formLeadGuid"];
        }
    }

    static fromJS(data: any): CreateBookingAsBrokerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingAsBrokerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerGuid"] = this.customerGuid;
        data["listingGuid"] = this.listingGuid;
        data["pricingGuid"] = this.pricingGuid;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        data["endDate"] = this.endDate && formatDate(this.endDate);
        data["endTime"] = this.endTime ? this.endTime.toJSON() : this.endTime;
        data["passengers"] = this.passengers;
        if (Array.isArray(this.additionalFees)) {
            data["additionalFees"] = [];
            for (let item of this.additionalFees)
                data["additionalFees"].push(item.toJSON());
        }
        data["bookingNotes"] = this.bookingNotes ? this.bookingNotes.toJSON() : this.bookingNotes;
        data["pickUpLocationGuid"] = this.pickUpLocationGuid;
        data["dropOffLocationGuid"] = this.dropOffLocationGuid;
        data["availabilityBlockForOffer"] = this.availabilityBlockForOffer;
        data["formLeadGuid"] = this.formLeadGuid;
        return data;
    }
}

export interface ICreateBookingAsBrokerCommand {
    customerGuid: string;
    listingGuid: string;
    pricingGuid: string | null;
    startDate: Date;
    startTime: TimeOnly;
    endDate?: Date | null;
    endTime?: TimeOnly;
    passengers: number;
    additionalFees?: AdditionalFeeItemRequest[] | null;
    bookingNotes?: BookingNotes;
    pickUpLocationGuid?: string | null;
    dropOffLocationGuid?: string | null;
    availabilityBlockForOffer?: boolean;
    formLeadGuid?: string | null;
}

export class CreateBookingAuthorizeNetCheckoutSessionCommand implements ICreateBookingAuthorizeNetCheckoutSessionCommand {
    bookingGuid!: string;
    amount!: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: ICreateBookingAuthorizeNetCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): CreateBookingAuthorizeNetCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingAuthorizeNetCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface ICreateBookingAuthorizeNetCheckoutSessionCommand {
    bookingGuid: string;
    amount: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class CreateBookingCommand implements ICreateBookingCommand {
    customerGuid!: string;
    listingGuid!: string;
    skipperGuid?: string | null;
    checkinPersonGuid?: string | null;
    stewardessesGuid?: string[] | null;
    salesPersonGuid?: string | null;
    pricingGuid!: string | null;
    startDate!: Date;
    startTime!: TimeOnly;
    endDate?: Date | null;
    endTime?: TimeOnly;
    passengers!: number;
    basePrice!: number;
    rentalTaxes?: TaxItemRequest[] | null;
    additionalFees?: AdditionalFeeItemRequest[] | null;
    basePriceDiscount?: number;
    discountTypeGuid?: string | null;
    bookingNotes?: BookingNotes;
    pickUpLocationGuid?: string | null;
    dropOffLocationGuid?: string | null;
    availabilityBlockForOffer?: boolean;
    sendOfferNotification?: boolean | null;
    formLeadGuid?: string | null;
    channelTypeOverride?: BookingChannelType;
    agentGuidOverride?: string | null;
    brokerGuidOverride?: string | null;
    directChannelGuidOverride?: string | null;
    proformaAvailabilityBlockExpiresAtDate?: Date | null;
    proformaAvailabilityBlockExpiresAtTime?: TimeOnly;
    commissionPercentage?: number | null;
    currentUserGuid?: string | null;
    prePaymentOverride?: number | null;
    enableOverbooking?: boolean;

    constructor(data?: ICreateBookingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.startTime = new TimeOnly();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerGuid = _data["customerGuid"];
            this.listingGuid = _data["listingGuid"];
            this.skipperGuid = _data["skipperGuid"];
            this.checkinPersonGuid = _data["checkinPersonGuid"];
            if (Array.isArray(_data["stewardessesGuid"])) {
                this.stewardessesGuid = [] as any;
                for (let item of _data["stewardessesGuid"])
                    this.stewardessesGuid!.push(item);
            }
            this.salesPersonGuid = _data["salesPersonGuid"];
            this.pricingGuid = _data["pricingGuid"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : new TimeOnly();
            this.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? TimeOnly.fromJS(_data["endTime"]) : <any>null;
            this.passengers = _data["passengers"];
            this.basePrice = _data["basePrice"];
            if (Array.isArray(_data["rentalTaxes"])) {
                this.rentalTaxes = [] as any;
                for (let item of _data["rentalTaxes"])
                    this.rentalTaxes!.push(TaxItemRequest.fromJS(item));
            }
            if (Array.isArray(_data["additionalFees"])) {
                this.additionalFees = [] as any;
                for (let item of _data["additionalFees"])
                    this.additionalFees!.push(AdditionalFeeItemRequest.fromJS(item));
            }
            this.basePriceDiscount = _data["basePriceDiscount"];
            this.discountTypeGuid = _data["discountTypeGuid"];
            this.bookingNotes = _data["bookingNotes"] ? BookingNotes.fromJS(_data["bookingNotes"]) : <any>null;
            this.pickUpLocationGuid = _data["pickUpLocationGuid"];
            this.dropOffLocationGuid = _data["dropOffLocationGuid"];
            this.availabilityBlockForOffer = _data["availabilityBlockForOffer"];
            this.sendOfferNotification = _data["sendOfferNotification"];
            this.formLeadGuid = _data["formLeadGuid"];
            this.channelTypeOverride = _data["channelTypeOverride"];
            this.agentGuidOverride = _data["agentGuidOverride"];
            this.brokerGuidOverride = _data["brokerGuidOverride"];
            this.directChannelGuidOverride = _data["directChannelGuidOverride"];
            this.proformaAvailabilityBlockExpiresAtDate = _data["proformaAvailabilityBlockExpiresAtDate"] ? parseDateOnly(_data["proformaAvailabilityBlockExpiresAtDate"].toString()) : <any>null;
            this.proformaAvailabilityBlockExpiresAtTime = _data["proformaAvailabilityBlockExpiresAtTime"] ? TimeOnly.fromJS(_data["proformaAvailabilityBlockExpiresAtTime"]) : <any>null;
            this.commissionPercentage = _data["commissionPercentage"];
            this.currentUserGuid = _data["currentUserGuid"];
            this.prePaymentOverride = _data["prePaymentOverride"];
            this.enableOverbooking = _data["enableOverbooking"];
        }
    }

    static fromJS(data: any): CreateBookingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerGuid"] = this.customerGuid;
        data["listingGuid"] = this.listingGuid;
        data["skipperGuid"] = this.skipperGuid;
        data["checkinPersonGuid"] = this.checkinPersonGuid;
        if (Array.isArray(this.stewardessesGuid)) {
            data["stewardessesGuid"] = [];
            for (let item of this.stewardessesGuid)
                data["stewardessesGuid"].push(item);
        }
        data["salesPersonGuid"] = this.salesPersonGuid;
        data["pricingGuid"] = this.pricingGuid;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        data["endDate"] = this.endDate && formatDate(this.endDate);
        data["endTime"] = this.endTime ? this.endTime.toJSON() : this.endTime;
        data["passengers"] = this.passengers;
        data["basePrice"] = this.basePrice;
        if (Array.isArray(this.rentalTaxes)) {
            data["rentalTaxes"] = [];
            for (let item of this.rentalTaxes)
                data["rentalTaxes"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalFees)) {
            data["additionalFees"] = [];
            for (let item of this.additionalFees)
                data["additionalFees"].push(item.toJSON());
        }
        data["basePriceDiscount"] = this.basePriceDiscount;
        data["discountTypeGuid"] = this.discountTypeGuid;
        data["bookingNotes"] = this.bookingNotes ? this.bookingNotes.toJSON() : this.bookingNotes;
        data["pickUpLocationGuid"] = this.pickUpLocationGuid;
        data["dropOffLocationGuid"] = this.dropOffLocationGuid;
        data["availabilityBlockForOffer"] = this.availabilityBlockForOffer;
        data["sendOfferNotification"] = this.sendOfferNotification;
        data["formLeadGuid"] = this.formLeadGuid;
        data["channelTypeOverride"] = this.channelTypeOverride;
        data["agentGuidOverride"] = this.agentGuidOverride;
        data["brokerGuidOverride"] = this.brokerGuidOverride;
        data["directChannelGuidOverride"] = this.directChannelGuidOverride;
        data["proformaAvailabilityBlockExpiresAtDate"] = this.proformaAvailabilityBlockExpiresAtDate && formatDate(this.proformaAvailabilityBlockExpiresAtDate);
        data["proformaAvailabilityBlockExpiresAtTime"] = this.proformaAvailabilityBlockExpiresAtTime ? this.proformaAvailabilityBlockExpiresAtTime.toJSON() : this.proformaAvailabilityBlockExpiresAtTime;
        data["commissionPercentage"] = this.commissionPercentage;
        data["currentUserGuid"] = this.currentUserGuid;
        data["prePaymentOverride"] = this.prePaymentOverride;
        data["enableOverbooking"] = this.enableOverbooking;
        return data;
    }
}

export interface ICreateBookingCommand {
    customerGuid: string;
    listingGuid: string;
    skipperGuid?: string | null;
    checkinPersonGuid?: string | null;
    stewardessesGuid?: string[] | null;
    salesPersonGuid?: string | null;
    pricingGuid: string | null;
    startDate: Date;
    startTime: TimeOnly;
    endDate?: Date | null;
    endTime?: TimeOnly;
    passengers: number;
    basePrice: number;
    rentalTaxes?: TaxItemRequest[] | null;
    additionalFees?: AdditionalFeeItemRequest[] | null;
    basePriceDiscount?: number;
    discountTypeGuid?: string | null;
    bookingNotes?: BookingNotes;
    pickUpLocationGuid?: string | null;
    dropOffLocationGuid?: string | null;
    availabilityBlockForOffer?: boolean;
    sendOfferNotification?: boolean | null;
    formLeadGuid?: string | null;
    channelTypeOverride?: BookingChannelType;
    agentGuidOverride?: string | null;
    brokerGuidOverride?: string | null;
    directChannelGuidOverride?: string | null;
    proformaAvailabilityBlockExpiresAtDate?: Date | null;
    proformaAvailabilityBlockExpiresAtTime?: TimeOnly;
    commissionPercentage?: number | null;
    currentUserGuid?: string | null;
    prePaymentOverride?: number | null;
    enableOverbooking?: boolean;
}

export class CreateBookingInternalNoteCommand implements ICreateBookingInternalNoteCommand {
    bookingGuid!: string;
    note!: string | null;

    constructor(data?: ICreateBookingInternalNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateBookingInternalNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingInternalNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["note"] = this.note;
        return data;
    }
}

export interface ICreateBookingInternalNoteCommand {
    bookingGuid: string;
    note: string | null;
}

export class CreateBookingStripeCheckoutSessionCommand implements ICreateBookingStripeCheckoutSessionCommand {
    bookingGuid!: string;
    amount!: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: ICreateBookingStripeCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): CreateBookingStripeCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingStripeCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface ICreateBookingStripeCheckoutSessionCommand {
    bookingGuid: string;
    amount: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class CreateBookingWorldPayCheckoutSessionCommand implements ICreateBookingWorldPayCheckoutSessionCommand {
    bookingGuid!: string;
    amount!: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: ICreateBookingWorldPayCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): CreateBookingWorldPayCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingWorldPayCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface ICreateBookingWorldPayCheckoutSessionCommand {
    bookingGuid: string;
    amount: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class CreateBookingWorldPayCheckoutSessionCommandResult implements ICreateBookingWorldPayCheckoutSessionCommandResult {
    sessionGuid!: string;
    checkoutSessionUrl!: string | null;
    merchantId!: string | null;
    amount!: number;
    currency!: string | null;

    constructor(data?: ICreateBookingWorldPayCheckoutSessionCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionGuid = _data["sessionGuid"];
            this.checkoutSessionUrl = _data["checkoutSessionUrl"];
            this.merchantId = _data["merchantId"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): CreateBookingWorldPayCheckoutSessionCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBookingWorldPayCheckoutSessionCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionGuid"] = this.sessionGuid;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        data["merchantId"] = this.merchantId;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ICreateBookingWorldPayCheckoutSessionCommandResult {
    sessionGuid: string;
    checkoutSessionUrl: string | null;
    merchantId: string | null;
    amount: number;
    currency: string | null;
}

export class CreateBrokerDto implements ICreateBrokerDto {
    firstName!: string | null;
    lastName!: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;

    constructor(data?: ICreateBrokerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): CreateBrokerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBrokerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface ICreateBrokerDto {
    firstName: string | null;
    lastName: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
}

export class CreateCampaignCommand implements ICreateCampaignCommand {
    name!: string | null;
    commissionAmount!: number;
    newCustomerDiscountAmount!: number;
    expiresAtUtc?: Date | null;
    isActive?: boolean;
    campaignLandingUrlGuid?: string;

    constructor(data?: ICreateCampaignCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.commissionAmount = _data["commissionAmount"];
            this.newCustomerDiscountAmount = _data["newCustomerDiscountAmount"];
            this.expiresAtUtc = _data["expiresAtUtc"] ? new Date(_data["expiresAtUtc"].toString()) : <any>null;
            this.isActive = _data["isActive"];
            this.campaignLandingUrlGuid = _data["campaignLandingUrlGuid"];
        }
    }

    static fromJS(data: any): CreateCampaignCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCampaignCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["commissionAmount"] = this.commissionAmount;
        data["newCustomerDiscountAmount"] = this.newCustomerDiscountAmount;
        data["expiresAtUtc"] = this.expiresAtUtc && this.expiresAtUtc.toISOString();
        data["isActive"] = this.isActive;
        data["campaignLandingUrlGuid"] = this.campaignLandingUrlGuid;
        return data;
    }
}

export interface ICreateCampaignCommand {
    name: string | null;
    commissionAmount: number;
    newCustomerDiscountAmount: number;
    expiresAtUtc?: Date | null;
    isActive?: boolean;
    campaignLandingUrlGuid?: string;
}

export class CreateChannelCommand implements ICreateChannelCommand {
    name!: string | null;
    isActive!: boolean;
    email!: string | null;
    phoneNumber!: string | null;
    notes?: string | null;

    constructor(data?: ICreateChannelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateChannelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChannelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateChannelCommand {
    name: string | null;
    isActive: boolean;
    email: string | null;
    phoneNumber: string | null;
    notes?: string | null;
}

export class CreateCustomerCommand implements ICreateCustomerCommand {
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
    readonly formLeadGuid?: string | null;
    agentGuid?: string | null;
    brokerGuid?: string | null;

    constructor(data?: ICreateCustomerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            (<any>this).formLeadGuid = _data["formLeadGuid"];
            this.agentGuid = _data["agentGuid"];
            this.brokerGuid = _data["brokerGuid"];
        }
    }

    static fromJS(data: any): CreateCustomerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["formLeadGuid"] = this.formLeadGuid;
        data["agentGuid"] = this.agentGuid;
        data["brokerGuid"] = this.brokerGuid;
        return data;
    }
}

export interface ICreateCustomerCommand {
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
    formLeadGuid?: string | null;
    agentGuid?: string | null;
    brokerGuid?: string | null;
}

export class CreateCustomerNoteCommand implements ICreateCustomerNoteCommand {
    customerGuid!: string;
    note!: string | null;

    constructor(data?: ICreateCustomerNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerGuid = _data["customerGuid"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateCustomerNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerGuid"] = this.customerGuid;
        data["note"] = this.note;
        return data;
    }
}

export interface ICreateCustomerNoteCommand {
    customerGuid: string;
    note: string | null;
}

export class CreateDirectChannelCommand implements ICreateDirectChannelCommand {
    name!: string | null;

    constructor(data?: ICreateDirectChannelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateDirectChannelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDirectChannelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateDirectChannelCommand {
    name: string | null;
}

export class CreateDiscountTypeCommand implements ICreateDiscountTypeCommand {
    code!: string | null;
    name!: string | null;

    constructor(data?: ICreateDiscountTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateDiscountTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDiscountTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateDiscountTypeCommand {
    code: string | null;
    name: string | null;
}

export class CreateEmailTemplateCommand implements ICreateEmailTemplateCommand {
    templateType!: EmailTemplateType;
    subject!: string | null;
    preHeader!: string | null;
    additionalHeaderInfo?: string | null;
    sections?: { [key: string]: string; } | null;

    constructor(data?: ICreateEmailTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateType = _data["templateType"];
            this.subject = _data["subject"];
            this.preHeader = _data["preHeader"];
            this.additionalHeaderInfo = _data["additionalHeaderInfo"];
            if (_data["sections"]) {
                this.sections = {} as any;
                for (let key in _data["sections"]) {
                    if (_data["sections"].hasOwnProperty(key))
                        (<any>this.sections)![key] = _data["sections"][key];
                }
            }
        }
    }

    static fromJS(data: any): CreateEmailTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateType"] = this.templateType;
        data["subject"] = this.subject;
        data["preHeader"] = this.preHeader;
        data["additionalHeaderInfo"] = this.additionalHeaderInfo;
        if (this.sections) {
            data["sections"] = {};
            for (let key in this.sections) {
                if (this.sections.hasOwnProperty(key))
                    (<any>data["sections"])[key] = (<any>this.sections)[key];
            }
        }
        return data;
    }
}

export interface ICreateEmailTemplateCommand {
    templateType: EmailTemplateType;
    subject: string | null;
    preHeader: string | null;
    additionalHeaderInfo?: string | null;
    sections?: { [key: string]: string; } | null;
}

export class CreateExternalPaymentMethodCommand implements ICreateExternalPaymentMethodCommand {
    code!: string | null;
    name!: string | null;
    isActive!: boolean;

    constructor(data?: ICreateExternalPaymentMethodCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateExternalPaymentMethodCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExternalPaymentMethodCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ICreateExternalPaymentMethodCommand {
    code: string | null;
    name: string | null;
    isActive: boolean;
}

export class CreateListingCommand implements ICreateListingCommand {
    boatGuid!: string;
    marketGuid!: string;
    defaultPickUpLocationGuid!: string;
    defaultDropOffLocationGuid!: string;
    slipNumber?: string | null;
    notes?: string | null;
    ownerTakeRate!: ListingOwnerTakeRate;
    marketSpecificTitle?: string | null;
    skipperGuid?: string | null;
    stewardessGuid?: string | null;
    checkinPersonGuid?: string | null;
    boatIdentifier?: string | null;

    constructor(data?: ICreateListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ownerTakeRate = new ListingOwnerTakeRate();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boatGuid = _data["boatGuid"];
            this.marketGuid = _data["marketGuid"];
            this.defaultPickUpLocationGuid = _data["defaultPickUpLocationGuid"];
            this.defaultDropOffLocationGuid = _data["defaultDropOffLocationGuid"];
            this.slipNumber = _data["slipNumber"];
            this.notes = _data["notes"];
            this.ownerTakeRate = _data["ownerTakeRate"] ? ListingOwnerTakeRate.fromJS(_data["ownerTakeRate"]) : new ListingOwnerTakeRate();
            this.marketSpecificTitle = _data["marketSpecificTitle"];
            this.skipperGuid = _data["skipperGuid"];
            this.stewardessGuid = _data["stewardessGuid"];
            this.checkinPersonGuid = _data["checkinPersonGuid"];
            this.boatIdentifier = _data["boatIdentifier"];
        }
    }

    static fromJS(data: any): CreateListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boatGuid"] = this.boatGuid;
        data["marketGuid"] = this.marketGuid;
        data["defaultPickUpLocationGuid"] = this.defaultPickUpLocationGuid;
        data["defaultDropOffLocationGuid"] = this.defaultDropOffLocationGuid;
        data["slipNumber"] = this.slipNumber;
        data["notes"] = this.notes;
        data["ownerTakeRate"] = this.ownerTakeRate ? this.ownerTakeRate.toJSON() : this.ownerTakeRate;
        data["marketSpecificTitle"] = this.marketSpecificTitle;
        data["skipperGuid"] = this.skipperGuid;
        data["stewardessGuid"] = this.stewardessGuid;
        data["checkinPersonGuid"] = this.checkinPersonGuid;
        data["boatIdentifier"] = this.boatIdentifier;
        return data;
    }
}

export interface ICreateListingCommand {
    boatGuid: string;
    marketGuid: string;
    defaultPickUpLocationGuid: string;
    defaultDropOffLocationGuid: string;
    slipNumber?: string | null;
    notes?: string | null;
    ownerTakeRate: ListingOwnerTakeRate;
    marketSpecificTitle?: string | null;
    skipperGuid?: string | null;
    stewardessGuid?: string | null;
    checkinPersonGuid?: string | null;
    boatIdentifier?: string | null;
}

export class CreateLocationCommand implements ICreateLocationCommand {
    marketGuid!: string;
    title!: string | null;
    marina?: string | null;
    locationAddress!: LocationAddress;

    constructor(data?: ICreateLocationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.locationAddress = new LocationAddress();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marketGuid = _data["marketGuid"];
            this.title = _data["title"];
            this.marina = _data["marina"];
            this.locationAddress = _data["locationAddress"] ? LocationAddress.fromJS(_data["locationAddress"]) : new LocationAddress();
        }
    }

    static fromJS(data: any): CreateLocationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLocationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketGuid"] = this.marketGuid;
        data["title"] = this.title;
        data["marina"] = this.marina;
        data["locationAddress"] = this.locationAddress ? this.locationAddress.toJSON() : this.locationAddress;
        return data;
    }
}

export interface ICreateLocationCommand {
    marketGuid: string;
    title: string | null;
    marina?: string | null;
    locationAddress: LocationAddress;
}

export class CreateMakeCommand implements ICreateMakeCommand {
    name!: string | null;

    constructor(data?: ICreateMakeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateMakeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMakeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateMakeCommand {
    name: string | null;
}

export class CreateMarketCommand implements ICreateMarketCommand {
    title!: string | null;
    code!: string | null;
    color!: string | null;

    constructor(data?: ICreateMarketCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.code = _data["code"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): CreateMarketCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMarketCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["color"] = this.color;
        return data;
    }
}

export interface ICreateMarketCommand {
    title: string | null;
    code: string | null;
    color: string | null;
}

export class CreateMultibookingAuthorizeNetCheckoutSessionCommand implements ICreateMultibookingAuthorizeNetCheckoutSessionCommand {
    amount!: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: ICreateMultibookingAuthorizeNetCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): CreateMultibookingAuthorizeNetCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultibookingAuthorizeNetCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface ICreateMultibookingAuthorizeNetCheckoutSessionCommand {
    amount: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class CreateMultibookingCommand implements ICreateMultibookingCommand {
    bookingGuids!: string[] | null;

    constructor(data?: ICreateMultibookingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bookingGuids"])) {
                this.bookingGuids = [] as any;
                for (let item of _data["bookingGuids"])
                    this.bookingGuids!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateMultibookingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultibookingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bookingGuids)) {
            data["bookingGuids"] = [];
            for (let item of this.bookingGuids)
                data["bookingGuids"].push(item);
        }
        return data;
    }
}

export interface ICreateMultibookingCommand {
    bookingGuids: string[] | null;
}

export class CreateMultibookingStripeCheckoutSessionCommand implements ICreateMultibookingStripeCheckoutSessionCommand {
    amount!: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: ICreateMultibookingStripeCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): CreateMultibookingStripeCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultibookingStripeCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface ICreateMultibookingStripeCheckoutSessionCommand {
    amount: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class CreateMultibookingStripeCheckoutSessionCommandResult implements ICreateMultibookingStripeCheckoutSessionCommandResult {
    checkoutSessionId?: string | null;
    checkoutSessionUrl?: string | null;

    constructor(data?: ICreateMultibookingStripeCheckoutSessionCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkoutSessionId = _data["checkoutSessionId"];
            this.checkoutSessionUrl = _data["checkoutSessionUrl"];
        }
    }

    static fromJS(data: any): CreateMultibookingStripeCheckoutSessionCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultibookingStripeCheckoutSessionCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkoutSessionId"] = this.checkoutSessionId;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        return data;
    }
}

export interface ICreateMultibookingStripeCheckoutSessionCommandResult {
    checkoutSessionId?: string | null;
    checkoutSessionUrl?: string | null;
}

export class CreateMultibookingWorldPayCheckoutSessionCommand implements ICreateMultibookingWorldPayCheckoutSessionCommand {
    amount!: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;

    constructor(data?: ICreateMultibookingWorldPayCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.chargeOnlineCustomerFeeToCustomer = _data["chargeOnlineCustomerFeeToCustomer"];
        }
    }

    static fromJS(data: any): CreateMultibookingWorldPayCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultibookingWorldPayCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["chargeOnlineCustomerFeeToCustomer"] = this.chargeOnlineCustomerFeeToCustomer;
        return data;
    }
}

export interface ICreateMultibookingWorldPayCheckoutSessionCommand {
    amount: number;
    description?: string | null;
    chargeOnlineCustomerFeeToCustomer?: boolean;
}

export class CreateMultibookingWorldPayCheckoutSessionCommandResult implements ICreateMultibookingWorldPayCheckoutSessionCommandResult {
    sessionGuid!: string;
    checkoutSessionUrl!: string | null;
    merchantId!: string | null;
    amount!: number;
    currency!: string | null;

    constructor(data?: ICreateMultibookingWorldPayCheckoutSessionCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionGuid = _data["sessionGuid"];
            this.checkoutSessionUrl = _data["checkoutSessionUrl"];
            this.merchantId = _data["merchantId"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): CreateMultibookingWorldPayCheckoutSessionCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultibookingWorldPayCheckoutSessionCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionGuid"] = this.sessionGuid;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        data["merchantId"] = this.merchantId;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ICreateMultibookingWorldPayCheckoutSessionCommandResult {
    sessionGuid: string;
    checkoutSessionUrl: string | null;
    merchantId: string | null;
    amount: number;
    currency: string | null;
}

export class CreatePackageCommand implements ICreatePackageCommand {
    name!: string | null;
    marketGuid!: string;
    startTimes!: TimeOnly[] | null;
    duration!: TimeSpan;
    availableDaysOfWeek!: DayOfWeek[] | null;
    isSunsetPackage!: boolean;

    constructor(data?: ICreatePackageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.duration = new TimeSpan();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.marketGuid = _data["marketGuid"];
            if (Array.isArray(_data["startTimes"])) {
                this.startTimes = [] as any;
                for (let item of _data["startTimes"])
                    this.startTimes!.push(TimeOnly.fromJS(item));
            }
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : new TimeSpan();
            if (Array.isArray(_data["availableDaysOfWeek"])) {
                this.availableDaysOfWeek = [] as any;
                for (let item of _data["availableDaysOfWeek"])
                    this.availableDaysOfWeek!.push(item);
            }
            this.isSunsetPackage = _data["isSunsetPackage"];
        }
    }

    static fromJS(data: any): CreatePackageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["marketGuid"] = this.marketGuid;
        if (Array.isArray(this.startTimes)) {
            data["startTimes"] = [];
            for (let item of this.startTimes)
                data["startTimes"].push(item.toJSON());
        }
        data["duration"] = this.duration ? this.duration.toJSON() : this.duration;
        if (Array.isArray(this.availableDaysOfWeek)) {
            data["availableDaysOfWeek"] = [];
            for (let item of this.availableDaysOfWeek)
                data["availableDaysOfWeek"].push(item);
        }
        data["isSunsetPackage"] = this.isSunsetPackage;
        return data;
    }
}

export interface ICreatePackageCommand {
    name: string | null;
    marketGuid: string;
    startTimes: TimeOnly[] | null;
    duration: TimeSpan;
    availableDaysOfWeek: DayOfWeek[] | null;
    isSunsetPackage: boolean;
}

export class CreatePlatformAccountAccessTokenCommand implements ICreatePlatformAccountAccessTokenCommand {
    expiresAt?: Date | null;
    token?: string | null;
    description!: string | null;
    type?: AccessTokenType;

    constructor(data?: ICreatePlatformAccountAccessTokenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>null;
            this.token = _data["token"];
            this.description = _data["description"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CreatePlatformAccountAccessTokenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlatformAccountAccessTokenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiresAt"] = this.expiresAt && this.expiresAt.toISOString();
        data["token"] = this.token;
        data["description"] = this.description;
        data["type"] = this.type;
        return data;
    }
}

export interface ICreatePlatformAccountAccessTokenCommand {
    expiresAt?: Date | null;
    token?: string | null;
    description: string | null;
    type?: AccessTokenType;
}

export class CreatePlatformAccountAccessTokenCommandResult implements ICreatePlatformAccountAccessTokenCommandResult {
    guid?: string;
    token?: string | null;
    expiresAt?: Date | null;
    description?: string | null;
    type?: AccessTokenType;

    constructor(data?: ICreatePlatformAccountAccessTokenCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.token = _data["token"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>null;
            this.description = _data["description"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CreatePlatformAccountAccessTokenCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlatformAccountAccessTokenCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["token"] = this.token;
        data["expiresAt"] = this.expiresAt && this.expiresAt.toISOString();
        data["description"] = this.description;
        data["type"] = this.type;
        return data;
    }
}

export interface ICreatePlatformAccountAccessTokenCommandResult {
    guid?: string;
    token?: string | null;
    expiresAt?: Date | null;
    description?: string | null;
    type?: AccessTokenType;
}

export class CreatePlatformAccountCommand implements ICreatePlatformAccountCommand {
    name!: string | null;
    statementDescriptor?: string | null;
    email!: string | null;
    replyToEmail?: string | null;
    bookingPromotionNotificationEmail?: string | null;
    bookingWeeklyExportEmail?: string | null;
    bookingWeeklyRevenueExportEmail?: string | null;
    newFormLeadNotificationEmail?: string | null;
    bookingConfirmationCcEmails?: string[] | null;
    newFormLeadNotificationCcEmails?: string[] | null;
    phone?: string | null;
    formLeadSenderEmail?: string | null;
    formLeadSenderDisplayName?: string | null;
    twilioPhoneNumber?: string | null;
    timeZoneInfoId!: string | null;
    culture!: string | null;
    currencyRegion!: string | null;
    propellerTakeRatePercentage?: number | null;
    onlineCustomerFeePercentage?: number | null;
    billingInfo?: PlatformAccountBillingInfo;
    contractProvider?: ContractProviderType;
    docusignConfiguration?: PlatformAccountDocusignConfiguration;
    platformAccountStatus?: PlatformAccountStatus;
    bankInfo?: PlatformAccountBankInfo;
    paymentGateway?: PaymentGateway;
    wordlPayMerchantId?: string | null;
    cashPaymentLimitAmount?: number | null;

    constructor(data?: ICreatePlatformAccountCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.statementDescriptor = _data["statementDescriptor"];
            this.email = _data["email"];
            this.replyToEmail = _data["replyToEmail"];
            this.bookingPromotionNotificationEmail = _data["bookingPromotionNotificationEmail"];
            this.bookingWeeklyExportEmail = _data["bookingWeeklyExportEmail"];
            this.bookingWeeklyRevenueExportEmail = _data["bookingWeeklyRevenueExportEmail"];
            this.newFormLeadNotificationEmail = _data["newFormLeadNotificationEmail"];
            if (Array.isArray(_data["bookingConfirmationCcEmails"])) {
                this.bookingConfirmationCcEmails = [] as any;
                for (let item of _data["bookingConfirmationCcEmails"])
                    this.bookingConfirmationCcEmails!.push(item);
            }
            if (Array.isArray(_data["newFormLeadNotificationCcEmails"])) {
                this.newFormLeadNotificationCcEmails = [] as any;
                for (let item of _data["newFormLeadNotificationCcEmails"])
                    this.newFormLeadNotificationCcEmails!.push(item);
            }
            this.phone = _data["phone"];
            this.formLeadSenderEmail = _data["formLeadSenderEmail"];
            this.formLeadSenderDisplayName = _data["formLeadSenderDisplayName"];
            this.twilioPhoneNumber = _data["twilioPhoneNumber"];
            this.timeZoneInfoId = _data["timeZoneInfoId"];
            this.culture = _data["culture"];
            this.currencyRegion = _data["currencyRegion"];
            this.propellerTakeRatePercentage = _data["propellerTakeRatePercentage"];
            this.onlineCustomerFeePercentage = _data["onlineCustomerFeePercentage"];
            this.billingInfo = _data["billingInfo"] ? PlatformAccountBillingInfo.fromJS(_data["billingInfo"]) : <any>null;
            this.contractProvider = _data["contractProvider"];
            this.docusignConfiguration = _data["docusignConfiguration"] ? PlatformAccountDocusignConfiguration.fromJS(_data["docusignConfiguration"]) : <any>null;
            this.platformAccountStatus = _data["platformAccountStatus"];
            this.bankInfo = _data["bankInfo"] ? PlatformAccountBankInfo.fromJS(_data["bankInfo"]) : <any>null;
            this.paymentGateway = _data["paymentGateway"];
            this.wordlPayMerchantId = _data["wordlPayMerchantId"];
            this.cashPaymentLimitAmount = _data["cashPaymentLimitAmount"];
        }
    }

    static fromJS(data: any): CreatePlatformAccountCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlatformAccountCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["statementDescriptor"] = this.statementDescriptor;
        data["email"] = this.email;
        data["replyToEmail"] = this.replyToEmail;
        data["bookingPromotionNotificationEmail"] = this.bookingPromotionNotificationEmail;
        data["bookingWeeklyExportEmail"] = this.bookingWeeklyExportEmail;
        data["bookingWeeklyRevenueExportEmail"] = this.bookingWeeklyRevenueExportEmail;
        data["newFormLeadNotificationEmail"] = this.newFormLeadNotificationEmail;
        if (Array.isArray(this.bookingConfirmationCcEmails)) {
            data["bookingConfirmationCcEmails"] = [];
            for (let item of this.bookingConfirmationCcEmails)
                data["bookingConfirmationCcEmails"].push(item);
        }
        if (Array.isArray(this.newFormLeadNotificationCcEmails)) {
            data["newFormLeadNotificationCcEmails"] = [];
            for (let item of this.newFormLeadNotificationCcEmails)
                data["newFormLeadNotificationCcEmails"].push(item);
        }
        data["phone"] = this.phone;
        data["formLeadSenderEmail"] = this.formLeadSenderEmail;
        data["formLeadSenderDisplayName"] = this.formLeadSenderDisplayName;
        data["twilioPhoneNumber"] = this.twilioPhoneNumber;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        data["culture"] = this.culture;
        data["currencyRegion"] = this.currencyRegion;
        data["propellerTakeRatePercentage"] = this.propellerTakeRatePercentage;
        data["onlineCustomerFeePercentage"] = this.onlineCustomerFeePercentage;
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : this.billingInfo;
        data["contractProvider"] = this.contractProvider;
        data["docusignConfiguration"] = this.docusignConfiguration ? this.docusignConfiguration.toJSON() : this.docusignConfiguration;
        data["platformAccountStatus"] = this.platformAccountStatus;
        data["bankInfo"] = this.bankInfo ? this.bankInfo.toJSON() : this.bankInfo;
        data["paymentGateway"] = this.paymentGateway;
        data["wordlPayMerchantId"] = this.wordlPayMerchantId;
        data["cashPaymentLimitAmount"] = this.cashPaymentLimitAmount;
        return data;
    }
}

export interface ICreatePlatformAccountCommand {
    name: string | null;
    statementDescriptor?: string | null;
    email: string | null;
    replyToEmail?: string | null;
    bookingPromotionNotificationEmail?: string | null;
    bookingWeeklyExportEmail?: string | null;
    bookingWeeklyRevenueExportEmail?: string | null;
    newFormLeadNotificationEmail?: string | null;
    bookingConfirmationCcEmails?: string[] | null;
    newFormLeadNotificationCcEmails?: string[] | null;
    phone?: string | null;
    formLeadSenderEmail?: string | null;
    formLeadSenderDisplayName?: string | null;
    twilioPhoneNumber?: string | null;
    timeZoneInfoId: string | null;
    culture: string | null;
    currencyRegion: string | null;
    propellerTakeRatePercentage?: number | null;
    onlineCustomerFeePercentage?: number | null;
    billingInfo?: PlatformAccountBillingInfo;
    contractProvider?: ContractProviderType;
    docusignConfiguration?: PlatformAccountDocusignConfiguration;
    platformAccountStatus?: PlatformAccountStatus;
    bankInfo?: PlatformAccountBankInfo;
    paymentGateway?: PaymentGateway;
    wordlPayMerchantId?: string | null;
    cashPaymentLimitAmount?: number | null;
}

export class CreatePricingCommand implements ICreatePricingCommand {
    listingGuid!: string;
    packageGuid!: string;
    basePrice!: number;
    includedPassengers!: number;
    extraPassengerPrice!: number;
    extraPassengers!: number;
    additionalFees?: AdditionalFeeItemDto[] | null;

    constructor(data?: ICreatePricingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingGuid = _data["listingGuid"];
            this.packageGuid = _data["packageGuid"];
            this.basePrice = _data["basePrice"];
            this.includedPassengers = _data["includedPassengers"];
            this.extraPassengerPrice = _data["extraPassengerPrice"];
            this.extraPassengers = _data["extraPassengers"];
            if (Array.isArray(_data["additionalFees"])) {
                this.additionalFees = [] as any;
                for (let item of _data["additionalFees"])
                    this.additionalFees!.push(AdditionalFeeItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePricingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePricingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingGuid"] = this.listingGuid;
        data["packageGuid"] = this.packageGuid;
        data["basePrice"] = this.basePrice;
        data["includedPassengers"] = this.includedPassengers;
        data["extraPassengerPrice"] = this.extraPassengerPrice;
        data["extraPassengers"] = this.extraPassengers;
        if (Array.isArray(this.additionalFees)) {
            data["additionalFees"] = [];
            for (let item of this.additionalFees)
                data["additionalFees"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreatePricingCommand {
    listingGuid: string;
    packageGuid: string;
    basePrice: number;
    includedPassengers: number;
    extraPassengerPrice: number;
    extraPassengers: number;
    additionalFees?: AdditionalFeeItemDto[] | null;
}

export class CreateSalesLeadCommand implements ICreateSalesLeadCommand {
    origin!: SalesLeadOrigin;
    firstName!: string | null;
    middleName?: string | null;
    lastName!: string | null;
    email?: string | null;
    phone?: string | null;
    numberOfGuests?: number | null;
    budget?: number | null;
    boatGuid?: string | null;
    message?: string | null;

    constructor(data?: ICreateSalesLeadCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.numberOfGuests = _data["numberOfGuests"];
            this.budget = _data["budget"];
            this.boatGuid = _data["boatGuid"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateSalesLeadCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSalesLeadCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["numberOfGuests"] = this.numberOfGuests;
        data["budget"] = this.budget;
        data["boatGuid"] = this.boatGuid;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateSalesLeadCommand {
    origin: SalesLeadOrigin;
    firstName: string | null;
    middleName?: string | null;
    lastName: string | null;
    email?: string | null;
    phone?: string | null;
    numberOfGuests?: number | null;
    budget?: number | null;
    boatGuid?: string | null;
    message?: string | null;
}

export class CreateSeasonCommand implements ICreateSeasonCommand {
    marketGuid!: string;
    name!: string | null;
    color!: string | null;
    isDefault!: boolean;
    dateRanges!: CreateSeasonDateRangeDto[] | null;

    constructor(data?: ICreateSeasonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marketGuid = _data["marketGuid"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["dateRanges"])) {
                this.dateRanges = [] as any;
                for (let item of _data["dateRanges"])
                    this.dateRanges!.push(CreateSeasonDateRangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateSeasonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSeasonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketGuid"] = this.marketGuid;
        data["name"] = this.name;
        data["color"] = this.color;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.dateRanges)) {
            data["dateRanges"] = [];
            for (let item of this.dateRanges)
                data["dateRanges"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateSeasonCommand {
    marketGuid: string;
    name: string | null;
    color: string | null;
    isDefault: boolean;
    dateRanges: CreateSeasonDateRangeDto[] | null;
}

export class CreateSeasonDateRangeDto implements ICreateSeasonDateRangeDto {
    startDate!: MonthDay;
    endDate!: MonthDay;

    constructor(data?: ICreateSeasonDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.startDate = new MonthDay();
            this.endDate = new MonthDay();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? MonthDay.fromJS(_data["startDate"]) : new MonthDay();
            this.endDate = _data["endDate"] ? MonthDay.fromJS(_data["endDate"]) : new MonthDay();
        }
    }

    static fromJS(data: any): CreateSeasonDateRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSeasonDateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toJSON() : this.startDate;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : this.endDate;
        return data;
    }
}

export interface ICreateSeasonDateRangeDto {
    startDate: MonthDay;
    endDate: MonthDay;
}

export class CreateStickyNoteCommand implements ICreateStickyNoteCommand {
    from!: Date;
    to!: Date;
    title!: string | null;
    description?: string | null;

    constructor(data?: ICreateStickyNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? parseDateOnly(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? parseDateOnly(_data["to"].toString()) : <any>null;
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateStickyNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStickyNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from && formatDate(this.from);
        data["to"] = this.to && formatDate(this.to);
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateStickyNoteCommand {
    from: Date;
    to: Date;
    title: string | null;
    description?: string | null;
}

export class CreateStripeCheckoutSessionCommandResult implements ICreateStripeCheckoutSessionCommandResult {
    checkoutSessionId?: string | null;
    checkoutSessionUrl?: string | null;

    constructor(data?: ICreateStripeCheckoutSessionCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkoutSessionId = _data["checkoutSessionId"];
            this.checkoutSessionUrl = _data["checkoutSessionUrl"];
        }
    }

    static fromJS(data: any): CreateStripeCheckoutSessionCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStripeCheckoutSessionCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkoutSessionId"] = this.checkoutSessionId;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        return data;
    }
}

export interface ICreateStripeCheckoutSessionCommandResult {
    checkoutSessionId?: string | null;
    checkoutSessionUrl?: string | null;
}

export class CreateTopUpBalanceAuthorizeNetCheckoutSessionCommand implements ICreateTopUpBalanceAuthorizeNetCheckoutSessionCommand {
    customerGuid!: string;
    amount!: number;
    note?: string | null;

    constructor(data?: ICreateTopUpBalanceAuthorizeNetCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerGuid = _data["customerGuid"];
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateTopUpBalanceAuthorizeNetCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTopUpBalanceAuthorizeNetCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerGuid"] = this.customerGuid;
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }
}

export interface ICreateTopUpBalanceAuthorizeNetCheckoutSessionCommand {
    customerGuid: string;
    amount: number;
    note?: string | null;
}

export class CreateTopUpBalanceStripeCheckoutSessionCommand implements ICreateTopUpBalanceStripeCheckoutSessionCommand {
    customerGuid!: string;
    amount!: number;
    note?: string | null;

    constructor(data?: ICreateTopUpBalanceStripeCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerGuid = _data["customerGuid"];
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateTopUpBalanceStripeCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTopUpBalanceStripeCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerGuid"] = this.customerGuid;
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }
}

export interface ICreateTopUpBalanceStripeCheckoutSessionCommand {
    customerGuid: string;
    amount: number;
    note?: string | null;
}

export class CreateTopUpBalanceStripeCheckoutSessionCommandResult implements ICreateTopUpBalanceStripeCheckoutSessionCommandResult {
    checkoutSessionId?: string | null;
    checkoutSessionUrl?: string | null;

    constructor(data?: ICreateTopUpBalanceStripeCheckoutSessionCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkoutSessionId = _data["checkoutSessionId"];
            this.checkoutSessionUrl = _data["checkoutSessionUrl"];
        }
    }

    static fromJS(data: any): CreateTopUpBalanceStripeCheckoutSessionCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTopUpBalanceStripeCheckoutSessionCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkoutSessionId"] = this.checkoutSessionId;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        return data;
    }
}

export interface ICreateTopUpBalanceStripeCheckoutSessionCommandResult {
    checkoutSessionId?: string | null;
    checkoutSessionUrl?: string | null;
}

export class CreateTopUpBalanceWorldPayCheckoutSessionCommand implements ICreateTopUpBalanceWorldPayCheckoutSessionCommand {
    customerGuid!: string;
    amount!: number;

    constructor(data?: ICreateTopUpBalanceWorldPayCheckoutSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerGuid = _data["customerGuid"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): CreateTopUpBalanceWorldPayCheckoutSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTopUpBalanceWorldPayCheckoutSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerGuid"] = this.customerGuid;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ICreateTopUpBalanceWorldPayCheckoutSessionCommand {
    customerGuid: string;
    amount: number;
}

export class CreateTopUpBalanceWorldPayCheckoutSessionCommandResult implements ICreateTopUpBalanceWorldPayCheckoutSessionCommandResult {
    sessionGuid!: string;
    checkoutSessionUrl!: string | null;
    merchantId!: string | null;
    amount!: number;
    currency!: string | null;

    constructor(data?: ICreateTopUpBalanceWorldPayCheckoutSessionCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionGuid = _data["sessionGuid"];
            this.checkoutSessionUrl = _data["checkoutSessionUrl"];
            this.merchantId = _data["merchantId"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): CreateTopUpBalanceWorldPayCheckoutSessionCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTopUpBalanceWorldPayCheckoutSessionCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionGuid"] = this.sessionGuid;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        data["merchantId"] = this.merchantId;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ICreateTopUpBalanceWorldPayCheckoutSessionCommandResult {
    sessionGuid: string;
    checkoutSessionUrl: string | null;
    merchantId: string | null;
    amount: number;
    currency: string | null;
}

export class CreateUserCommand implements ICreateUserCommand {
    firstName!: string | null;
    lastName!: string | null;
    middleName?: string | null;
    email!: string | null;
    phone?: string | null;
    roles!: RoleName[] | null;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ICreateUserCommand {
    firstName: string | null;
    lastName: string | null;
    middleName?: string | null;
    email: string | null;
    phone?: string | null;
    roles: RoleName[] | null;
}

export class CreateVendorCommand implements ICreateVendorCommand {
    name!: string | null;
    type!: VendorType;
    area?: string | null;
    corporatePhoneNumber?: string | null;
    email?: string | null;
    contactPerson?: VendorContactPerson;
    notes?: string | null;

    constructor(data?: ICreateVendorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.area = _data["area"];
            this.corporatePhoneNumber = _data["corporatePhoneNumber"];
            this.email = _data["email"];
            this.contactPerson = _data["contactPerson"] ? VendorContactPerson.fromJS(_data["contactPerson"]) : <any>null;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateVendorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVendorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["area"] = this.area;
        data["corporatePhoneNumber"] = this.corporatePhoneNumber;
        data["email"] = this.email;
        data["contactPerson"] = this.contactPerson ? this.contactPerson.toJSON() : this.contactPerson;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateVendorCommand {
    name: string | null;
    type: VendorType;
    area?: string | null;
    corporatePhoneNumber?: string | null;
    email?: string | null;
    contactPerson?: VendorContactPerson;
    notes?: string | null;
}

export class CreateWorldPayMerchantCommand implements ICreateWorldPayMerchantCommand {
    platformAccountGuid!: string;
    businessName!: string | null;
    dbaName?: string | null;
    businessType!: EntityTypeEnum;
    established!: number;
    address1!: string | null;
    address2?: string | null;
    city!: string | null;
    state!: string | null;
    zip!: string | null;
    country!: EntityCountryEnum;
    timezone!: TimezoneEnum;
    phone!: string | null;
    email!: string | null;
    website?: string | null;
    ein!: string | null;
    einType!: EinTypeEnum;
    globalBusinessType!: GlobalBusinessTypeEnum;
    globalBusinessId!: string | null;
    environment!: MerchantEnvironmentEnum;
    mcc!: string | null;
    seasonal?: SeasonalEnum;
    annualCCSales?: number | null;
    avgTicket?: number | null;
    percentEcomm?: number | null;
    chargebackNotificationEmail?: string | null;
    bankAccountNumber!: string | null;
    bankRoutingNumber!: string | null;
    bankAccountType?: AccountMethodEnum;
    principalFirstName!: string | null;
    principalMiddleName?: string | null;
    principalLastName!: string | null;
    principalTitle?: string | null;
    principalSsn!: string | null;
    principalDob!: number;
    principalOwnership?: number;
    principalEmail!: string | null;
    principalPhone!: string | null;
    principalAddress1!: string | null;
    principalCity!: string | null;
    principalState!: string | null;
    principalZip!: string | null;
    principalCountry!: CountryEnum;

    constructor(data?: ICreateWorldPayMerchantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platformAccountGuid = _data["platformAccountGuid"];
            this.businessName = _data["businessName"];
            this.dbaName = _data["dbaName"];
            this.businessType = _data["businessType"];
            this.established = _data["established"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.country = _data["country"];
            this.timezone = _data["timezone"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.ein = _data["ein"];
            this.einType = _data["einType"];
            this.globalBusinessType = _data["globalBusinessType"];
            this.globalBusinessId = _data["globalBusinessId"];
            this.environment = _data["environment"];
            this.mcc = _data["mcc"];
            this.seasonal = _data["seasonal"];
            this.annualCCSales = _data["annualCCSales"];
            this.avgTicket = _data["avgTicket"];
            this.percentEcomm = _data["percentEcomm"];
            this.chargebackNotificationEmail = _data["chargebackNotificationEmail"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.bankRoutingNumber = _data["bankRoutingNumber"];
            this.bankAccountType = _data["bankAccountType"];
            this.principalFirstName = _data["principalFirstName"];
            this.principalMiddleName = _data["principalMiddleName"];
            this.principalLastName = _data["principalLastName"];
            this.principalTitle = _data["principalTitle"];
            this.principalSsn = _data["principalSsn"];
            this.principalDob = _data["principalDob"];
            this.principalOwnership = _data["principalOwnership"];
            this.principalEmail = _data["principalEmail"];
            this.principalPhone = _data["principalPhone"];
            this.principalAddress1 = _data["principalAddress1"];
            this.principalCity = _data["principalCity"];
            this.principalState = _data["principalState"];
            this.principalZip = _data["principalZip"];
            this.principalCountry = _data["principalCountry"];
        }
    }

    static fromJS(data: any): CreateWorldPayMerchantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorldPayMerchantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platformAccountGuid"] = this.platformAccountGuid;
        data["businessName"] = this.businessName;
        data["dbaName"] = this.dbaName;
        data["businessType"] = this.businessType;
        data["established"] = this.established;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["country"] = this.country;
        data["timezone"] = this.timezone;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["ein"] = this.ein;
        data["einType"] = this.einType;
        data["globalBusinessType"] = this.globalBusinessType;
        data["globalBusinessId"] = this.globalBusinessId;
        data["environment"] = this.environment;
        data["mcc"] = this.mcc;
        data["seasonal"] = this.seasonal;
        data["annualCCSales"] = this.annualCCSales;
        data["avgTicket"] = this.avgTicket;
        data["percentEcomm"] = this.percentEcomm;
        data["chargebackNotificationEmail"] = this.chargebackNotificationEmail;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankRoutingNumber"] = this.bankRoutingNumber;
        data["bankAccountType"] = this.bankAccountType;
        data["principalFirstName"] = this.principalFirstName;
        data["principalMiddleName"] = this.principalMiddleName;
        data["principalLastName"] = this.principalLastName;
        data["principalTitle"] = this.principalTitle;
        data["principalSsn"] = this.principalSsn;
        data["principalDob"] = this.principalDob;
        data["principalOwnership"] = this.principalOwnership;
        data["principalEmail"] = this.principalEmail;
        data["principalPhone"] = this.principalPhone;
        data["principalAddress1"] = this.principalAddress1;
        data["principalCity"] = this.principalCity;
        data["principalState"] = this.principalState;
        data["principalZip"] = this.principalZip;
        data["principalCountry"] = this.principalCountry;
        return data;
    }
}

export interface ICreateWorldPayMerchantCommand {
    platformAccountGuid: string;
    businessName: string | null;
    dbaName?: string | null;
    businessType: EntityTypeEnum;
    established: number;
    address1: string | null;
    address2?: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    country: EntityCountryEnum;
    timezone: TimezoneEnum;
    phone: string | null;
    email: string | null;
    website?: string | null;
    ein: string | null;
    einType: EinTypeEnum;
    globalBusinessType: GlobalBusinessTypeEnum;
    globalBusinessId: string | null;
    environment: MerchantEnvironmentEnum;
    mcc: string | null;
    seasonal?: SeasonalEnum;
    annualCCSales?: number | null;
    avgTicket?: number | null;
    percentEcomm?: number | null;
    chargebackNotificationEmail?: string | null;
    bankAccountNumber: string | null;
    bankRoutingNumber: string | null;
    bankAccountType?: AccountMethodEnum;
    principalFirstName: string | null;
    principalMiddleName?: string | null;
    principalLastName: string | null;
    principalTitle?: string | null;
    principalSsn: string | null;
    principalDob: number;
    principalOwnership?: number;
    principalEmail: string | null;
    principalPhone: string | null;
    principalAddress1: string | null;
    principalCity: string | null;
    principalState: string | null;
    principalZip: string | null;
    principalCountry: CountryEnum;
}

export class CreateWorldPayMerchantCommandResult implements ICreateWorldPayMerchantCommandResult {
    merchantId!: string | null;
    entityId?: string | null;
    status!: string | null;

    constructor(data?: ICreateWorldPayMerchantCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            this.entityId = _data["entityId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateWorldPayMerchantCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorldPayMerchantCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        data["entityId"] = this.entityId;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateWorldPayMerchantCommandResult {
    merchantId: string | null;
    entityId?: string | null;
    status: string | null;
}

export class CreditCardPaymentMethodResponse implements ICreditCardPaymentMethodResponse {
    lastFourDigits?: string | null;
    expirationDate?: Date;
    cardType?: string | null;

    constructor(data?: ICreditCardPaymentMethodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastFourDigits = _data["lastFourDigits"];
            this.expirationDate = _data["expirationDate"] ? parseDateOnly(_data["expirationDate"].toString()) : <any>null;
            this.cardType = _data["cardType"];
        }
    }

    static fromJS(data: any): CreditCardPaymentMethodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardPaymentMethodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastFourDigits"] = this.lastFourDigits;
        data["expirationDate"] = this.expirationDate && formatDate(this.expirationDate);
        data["cardType"] = this.cardType;
        return data;
    }
}

export interface ICreditCardPaymentMethodResponse {
    lastFourDigits?: string | null;
    expirationDate?: Date;
    cardType?: string | null;
}

export class CreditCardPaymentRequest implements ICreditCardPaymentRequest {
    cardHolderName!: string | null;
    opaqueDataValue!: string | null;
    opaqueDataDescriptor!: string | null;
    lastFourDigits!: string | null;
    expirationDate!: Date;

    constructor(data?: ICreditCardPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardHolderName = _data["cardHolderName"];
            this.opaqueDataValue = _data["opaqueDataValue"];
            this.opaqueDataDescriptor = _data["opaqueDataDescriptor"];
            this.lastFourDigits = _data["lastFourDigits"];
            this.expirationDate = _data["expirationDate"] ? parseDateOnly(_data["expirationDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): CreditCardPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardHolderName"] = this.cardHolderName;
        data["opaqueDataValue"] = this.opaqueDataValue;
        data["opaqueDataDescriptor"] = this.opaqueDataDescriptor;
        data["lastFourDigits"] = this.lastFourDigits;
        data["expirationDate"] = this.expirationDate && formatDate(this.expirationDate);
        return data;
    }
}

export interface ICreditCardPaymentRequest {
    cardHolderName: string | null;
    opaqueDataValue: string | null;
    opaqueDataDescriptor: string | null;
    lastFourDigits: string | null;
    expirationDate: Date;
}

export class CurrencyFormatResult implements ICurrencyFormatResult {
    code!: string | null;
    symbol!: string | null;
    locale!: string | null;
    decimalPlaces!: number;
    symbolPosition!: string | null;

    constructor(data?: ICurrencyFormatResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.symbol = _data["symbol"];
            this.locale = _data["locale"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.symbolPosition = _data["symbolPosition"];
        }
    }

    static fromJS(data: any): CurrencyFormatResult {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyFormatResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["symbol"] = this.symbol;
        data["locale"] = this.locale;
        data["decimalPlaces"] = this.decimalPlaces;
        data["symbolPosition"] = this.symbolPosition;
        return data;
    }
}

export interface ICurrencyFormatResult {
    code: string | null;
    symbol: string | null;
    locale: string | null;
    decimalPlaces: number;
    symbolPosition: string | null;
}

export class CustomDayPriceDto implements ICustomDayPriceDto {
    date?: Date;
    basePrice?: number;

    constructor(data?: ICustomDayPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
            this.basePrice = _data["basePrice"];
        }
    }

    static fromJS(data: any): CustomDayPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomDayPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date && formatDate(this.date);
        data["basePrice"] = this.basePrice;
        return data;
    }
}

export interface ICustomDayPriceDto {
    date?: Date;
    basePrice?: number;
}

export class CustomerAddress implements ICustomerAddress {
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;

    constructor(data?: ICustomerAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line = _data["line"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): CustomerAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line"] = this.line;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["state"] = this.state;
        return data;
    }
}

export interface ICustomerAddress {
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;
}

export class CustomerBillingInfo implements ICustomerBillingInfo {
    companyName?: string | null;
    taxId?: string | null;
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;

    constructor(data?: ICustomerBillingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.taxId = _data["taxId"];
            this.line = _data["line"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): CustomerBillingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerBillingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["taxId"] = this.taxId;
        data["line"] = this.line;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["state"] = this.state;
        return data;
    }
}

export interface ICustomerBillingInfo {
    companyName?: string | null;
    taxId?: string | null;
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;
}

export enum CustomerBookingHistorySortOptions {
    BookingId = "BookingId",
    ListingTitle = "ListingTitle",
    MarketName = "MarketName",
    SkipperName = "SkipperName",
    From = "From",
    Status = "Status",
    TotalPrice = "TotalPrice",
}

export enum CustomerClass {
    FirstTimer = "FirstTimer",
    RepeatCustomer = "RepeatCustomer",
    Vip = "Vip",
}

export class CustomerConcierge implements ICustomerConcierge {
    name?: string | null;
    email?: string | null;
    phone?: string | null;

    constructor(data?: ICustomerConcierge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): CustomerConcierge {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerConcierge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface ICustomerConcierge {
    name?: string | null;
    email?: string | null;
    phone?: string | null;
}

export enum CustomerInfoStatus {
    NotSet = "NotSet",
    Complete = "Complete",
    Incomplete = "Incomplete",
}

export class CustomerPreferences implements ICustomerPreferences {
    gratuityLevel?: string | null;
    musicPreference?: string | null;
    drinkPreference?: string | null;
    foodPreference?: string | null;
    familyNames?: string | null;
    theyLikeToDo?: string | null;
    miscellaneous?: string | null;
    birthdays?: string | null;
    blacklisted?: boolean;

    constructor(data?: ICustomerPreferences) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gratuityLevel = _data["gratuityLevel"];
            this.musicPreference = _data["musicPreference"];
            this.drinkPreference = _data["drinkPreference"];
            this.foodPreference = _data["foodPreference"];
            this.familyNames = _data["familyNames"];
            this.theyLikeToDo = _data["theyLikeToDo"];
            this.miscellaneous = _data["miscellaneous"];
            this.birthdays = _data["birthdays"];
            this.blacklisted = _data["blacklisted"];
        }
    }

    static fromJS(data: any): CustomerPreferences {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPreferences();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gratuityLevel"] = this.gratuityLevel;
        data["musicPreference"] = this.musicPreference;
        data["drinkPreference"] = this.drinkPreference;
        data["foodPreference"] = this.foodPreference;
        data["familyNames"] = this.familyNames;
        data["theyLikeToDo"] = this.theyLikeToDo;
        data["miscellaneous"] = this.miscellaneous;
        data["birthdays"] = this.birthdays;
        data["blacklisted"] = this.blacklisted;
        return data;
    }
}

export interface ICustomerPreferences {
    gratuityLevel?: string | null;
    musicPreference?: string | null;
    drinkPreference?: string | null;
    foodPreference?: string | null;
    familyNames?: string | null;
    theyLikeToDo?: string | null;
    miscellaneous?: string | null;
    birthdays?: string | null;
    blacklisted?: boolean;
}

export enum CustomerRating {
    None = "None",
    Top5percent = "Top5percent",
    Top10percent = "Top10percent",
    Top20percent = "Top20percent",
    Top30percent = "Top30percent",
    Top40percent = "Top40percent",
    Top50percent = "Top50percent",
    Other = "Other",
}

export enum CustomerRentClass {
    Customer = "Customer",
    Prospect = "Prospect",
    Charterer = "Charterer",
}

export enum CustomerSortOptions {
    FullName = "FullName",
}

export enum CustomerUpcomingBookingsSortOptions {
    BookingId = "BookingId",
    ListingTitle = "ListingTitle",
    MarketName = "MarketName",
    SkipperName = "SkipperName",
    From = "From",
    Status = "Status",
    TotalPrice = "TotalPrice",
}

export class DashboardAddonResult implements IDashboardAddonResult {
    name?: string | null;
    price?: number;

    constructor(data?: IDashboardAddonResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): DashboardAddonResult {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardAddonResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        return data;
    }
}

export interface IDashboardAddonResult {
    name?: string | null;
    price?: number;
}

export class DashboardAvailableBoatResult implements IDashboardAvailableBoatResult {
    boatGuid?: string;
    listingGuid?: string;
    name?: string | null;
    makeAndModel?: string | null;
    photoUrl?: string | null;
    locationName?: string | null;
    availability?: CalendarDayAvailability;
    passengerCapacity?: number | null;
    length?: number | null;
    timeSlots?: DashboardTimeSlotResult[] | null;

    constructor(data?: IDashboardAvailableBoatResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boatGuid = _data["boatGuid"];
            this.listingGuid = _data["listingGuid"];
            this.name = _data["name"];
            this.makeAndModel = _data["makeAndModel"];
            this.photoUrl = _data["photoUrl"];
            this.locationName = _data["locationName"];
            this.availability = _data["availability"];
            this.passengerCapacity = _data["passengerCapacity"];
            this.length = _data["length"];
            if (Array.isArray(_data["timeSlots"])) {
                this.timeSlots = [] as any;
                for (let item of _data["timeSlots"])
                    this.timeSlots!.push(DashboardTimeSlotResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardAvailableBoatResult {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardAvailableBoatResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boatGuid"] = this.boatGuid;
        data["listingGuid"] = this.listingGuid;
        data["name"] = this.name;
        data["makeAndModel"] = this.makeAndModel;
        data["photoUrl"] = this.photoUrl;
        data["locationName"] = this.locationName;
        data["availability"] = this.availability;
        data["passengerCapacity"] = this.passengerCapacity;
        data["length"] = this.length;
        if (Array.isArray(this.timeSlots)) {
            data["timeSlots"] = [];
            for (let item of this.timeSlots)
                data["timeSlots"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardAvailableBoatResult {
    boatGuid?: string;
    listingGuid?: string;
    name?: string | null;
    makeAndModel?: string | null;
    photoUrl?: string | null;
    locationName?: string | null;
    availability?: CalendarDayAvailability;
    passengerCapacity?: number | null;
    length?: number | null;
    timeSlots?: DashboardTimeSlotResult[] | null;
}

export class DashboardAvailableBoatResultPaginatedResult implements IDashboardAvailableBoatResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: DashboardAvailableBoatResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IDashboardAvailableBoatResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DashboardAvailableBoatResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): DashboardAvailableBoatResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardAvailableBoatResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IDashboardAvailableBoatResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: DashboardAvailableBoatResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class DashboardCardResult implements IDashboardCardResult {
    guid?: string;
    customerName?: string | null;
    phone?: string | null;
    boatName?: string | null;
    salesPersonName?: string | null;
    tripDate?: Date | null;
    price?: number | null;
    createdAtUtc?: Date;

    constructor(data?: IDashboardCardResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.customerName = _data["customerName"];
            this.phone = _data["phone"];
            this.boatName = _data["boatName"];
            this.salesPersonName = _data["salesPersonName"];
            this.tripDate = _data["tripDate"] ? new Date(_data["tripDate"].toString()) : <any>null;
            this.price = _data["price"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DashboardCardResult {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardCardResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["customerName"] = this.customerName;
        data["phone"] = this.phone;
        data["boatName"] = this.boatName;
        data["salesPersonName"] = this.salesPersonName;
        data["tripDate"] = this.tripDate && this.tripDate.toISOString();
        data["price"] = this.price;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        return data;
    }
}

export interface IDashboardCardResult {
    guid?: string;
    customerName?: string | null;
    phone?: string | null;
    boatName?: string | null;
    salesPersonName?: string | null;
    tripDate?: Date | null;
    price?: number | null;
    createdAtUtc?: Date;
}

export class DashboardCardResultPaginatedResult implements IDashboardCardResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: DashboardCardResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IDashboardCardResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DashboardCardResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): DashboardCardResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardCardResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IDashboardCardResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: DashboardCardResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class DashboardCustomerPreferencesResult implements IDashboardCustomerPreferencesResult {
    gratuityLevel?: string | null;
    musicPreference?: string | null;
    drinkPreference?: string | null;
    foodPreference?: string | null;
    familyNames?: string | null;
    theyLikeToDo?: string | null;
    miscellaneous?: string | null;
    birthdays?: string | null;

    constructor(data?: IDashboardCustomerPreferencesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gratuityLevel = _data["gratuityLevel"];
            this.musicPreference = _data["musicPreference"];
            this.drinkPreference = _data["drinkPreference"];
            this.foodPreference = _data["foodPreference"];
            this.familyNames = _data["familyNames"];
            this.theyLikeToDo = _data["theyLikeToDo"];
            this.miscellaneous = _data["miscellaneous"];
            this.birthdays = _data["birthdays"];
        }
    }

    static fromJS(data: any): DashboardCustomerPreferencesResult {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardCustomerPreferencesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gratuityLevel"] = this.gratuityLevel;
        data["musicPreference"] = this.musicPreference;
        data["drinkPreference"] = this.drinkPreference;
        data["foodPreference"] = this.foodPreference;
        data["familyNames"] = this.familyNames;
        data["theyLikeToDo"] = this.theyLikeToDo;
        data["miscellaneous"] = this.miscellaneous;
        data["birthdays"] = this.birthdays;
        return data;
    }
}

export interface IDashboardCustomerPreferencesResult {
    gratuityLevel?: string | null;
    musicPreference?: string | null;
    drinkPreference?: string | null;
    foodPreference?: string | null;
    familyNames?: string | null;
    theyLikeToDo?: string | null;
    miscellaneous?: string | null;
    birthdays?: string | null;
}

export class DashboardMyTodoResult implements IDashboardMyTodoResult {
    guid?: string;
    entityType?: HomeDismissalEntityType;
    itemType?: MyTodoTypeFilter;
    customerName?: string | null;
    phone?: string | null;
    boatName?: string | null;
    tripDate?: Date | null;
    price?: number | null;
    createdAtUtc?: Date;
    isDismissed?: boolean;
    dismissedAtUtc?: Date | null;
    salesPersonName?: string | null;
    bookingStatus?: BookingStatus;

    constructor(data?: IDashboardMyTodoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.entityType = _data["entityType"];
            this.itemType = _data["itemType"];
            this.customerName = _data["customerName"];
            this.phone = _data["phone"];
            this.boatName = _data["boatName"];
            this.tripDate = _data["tripDate"] ? new Date(_data["tripDate"].toString()) : <any>null;
            this.price = _data["price"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
            this.isDismissed = _data["isDismissed"];
            this.dismissedAtUtc = _data["dismissedAtUtc"] ? new Date(_data["dismissedAtUtc"].toString()) : <any>null;
            this.salesPersonName = _data["salesPersonName"];
            this.bookingStatus = _data["bookingStatus"];
        }
    }

    static fromJS(data: any): DashboardMyTodoResult {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardMyTodoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["entityType"] = this.entityType;
        data["itemType"] = this.itemType;
        data["customerName"] = this.customerName;
        data["phone"] = this.phone;
        data["boatName"] = this.boatName;
        data["tripDate"] = this.tripDate && this.tripDate.toISOString();
        data["price"] = this.price;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        data["isDismissed"] = this.isDismissed;
        data["dismissedAtUtc"] = this.dismissedAtUtc && this.dismissedAtUtc.toISOString();
        data["salesPersonName"] = this.salesPersonName;
        data["bookingStatus"] = this.bookingStatus;
        return data;
    }
}

export interface IDashboardMyTodoResult {
    guid?: string;
    entityType?: HomeDismissalEntityType;
    itemType?: MyTodoTypeFilter;
    customerName?: string | null;
    phone?: string | null;
    boatName?: string | null;
    tripDate?: Date | null;
    price?: number | null;
    createdAtUtc?: Date;
    isDismissed?: boolean;
    dismissedAtUtc?: Date | null;
    salesPersonName?: string | null;
    bookingStatus?: BookingStatus;
}

export class DashboardMyTodoResultPaginatedResult implements IDashboardMyTodoResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: DashboardMyTodoResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IDashboardMyTodoResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DashboardMyTodoResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): DashboardMyTodoResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardMyTodoResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IDashboardMyTodoResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: DashboardMyTodoResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class DashboardOperationsResult implements IDashboardOperationsResult {
    guid?: string;
    bookingId?: number;
    boatName?: string | null;
    boatMakeAndModel?: string | null;
    boatPhotoUrl?: string | null;
    boatGuid?: string | null;
    customerName?: string | null;
    tripDate?: Date | null;
    captainName?: string | null;
    captainGuid?: string | null;
    locationName?: string | null;
    contractStatus?: ContractStatus;
    totalPrice?: number;
    balanceDue?: number;
    tripNotes?: string | null;
    customerPreferences?: DashboardCustomerPreferencesResult;
    addons?: DashboardAddonResult[] | null;

    constructor(data?: IDashboardOperationsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
            this.boatName = _data["boatName"];
            this.boatMakeAndModel = _data["boatMakeAndModel"];
            this.boatPhotoUrl = _data["boatPhotoUrl"];
            this.boatGuid = _data["boatGuid"];
            this.customerName = _data["customerName"];
            this.tripDate = _data["tripDate"] ? new Date(_data["tripDate"].toString()) : <any>null;
            this.captainName = _data["captainName"];
            this.captainGuid = _data["captainGuid"];
            this.locationName = _data["locationName"];
            this.contractStatus = _data["contractStatus"];
            this.totalPrice = _data["totalPrice"];
            this.balanceDue = _data["balanceDue"];
            this.tripNotes = _data["tripNotes"];
            this.customerPreferences = _data["customerPreferences"] ? DashboardCustomerPreferencesResult.fromJS(_data["customerPreferences"]) : <any>null;
            if (Array.isArray(_data["addons"])) {
                this.addons = [] as any;
                for (let item of _data["addons"])
                    this.addons!.push(DashboardAddonResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardOperationsResult {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOperationsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        data["boatName"] = this.boatName;
        data["boatMakeAndModel"] = this.boatMakeAndModel;
        data["boatPhotoUrl"] = this.boatPhotoUrl;
        data["boatGuid"] = this.boatGuid;
        data["customerName"] = this.customerName;
        data["tripDate"] = this.tripDate && this.tripDate.toISOString();
        data["captainName"] = this.captainName;
        data["captainGuid"] = this.captainGuid;
        data["locationName"] = this.locationName;
        data["contractStatus"] = this.contractStatus;
        data["totalPrice"] = this.totalPrice;
        data["balanceDue"] = this.balanceDue;
        data["tripNotes"] = this.tripNotes;
        data["customerPreferences"] = this.customerPreferences ? this.customerPreferences.toJSON() : this.customerPreferences;
        if (Array.isArray(this.addons)) {
            data["addons"] = [];
            for (let item of this.addons)
                data["addons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardOperationsResult {
    guid?: string;
    bookingId?: number;
    boatName?: string | null;
    boatMakeAndModel?: string | null;
    boatPhotoUrl?: string | null;
    boatGuid?: string | null;
    customerName?: string | null;
    tripDate?: Date | null;
    captainName?: string | null;
    captainGuid?: string | null;
    locationName?: string | null;
    contractStatus?: ContractStatus;
    totalPrice?: number;
    balanceDue?: number;
    tripNotes?: string | null;
    customerPreferences?: DashboardCustomerPreferencesResult;
    addons?: DashboardAddonResult[] | null;
}

export class DashboardOperationsResultPaginatedResult implements IDashboardOperationsResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: DashboardOperationsResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IDashboardOperationsResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DashboardOperationsResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): DashboardOperationsResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOperationsResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IDashboardOperationsResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: DashboardOperationsResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export enum DashboardSourceFilter {
    NotSet = "NotSet",
    All = "All",
    Direct = "Direct",
    Indirect = "Indirect",
}

export class DashboardTimeSlotResult implements IDashboardTimeSlotResult {
    name?: string | null;
    startTime?: TimeOnly;
    duration?: TimeSpan;
    price?: number;
    isBooked?: boolean;

    constructor(data?: IDashboardTimeSlotResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : <any>null;
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : <any>null;
            this.price = _data["price"];
            this.isBooked = _data["isBooked"];
        }
    }

    static fromJS(data: any): DashboardTimeSlotResult {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTimeSlotResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        data["duration"] = this.duration ? this.duration.toJSON() : this.duration;
        data["price"] = this.price;
        data["isBooked"] = this.isBooked;
        return data;
    }
}

export interface IDashboardTimeSlotResult {
    name?: string | null;
    startTime?: TimeOnly;
    duration?: TimeSpan;
    price?: number;
    isBooked?: boolean;
}

export class DateFormatResult implements IDateFormatResult {
    pattern!: string | null;
    locale!: string | null;
    separator!: string | null;

    constructor(data?: IDateFormatResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pattern = _data["pattern"];
            this.locale = _data["locale"];
            this.separator = _data["separator"];
        }
    }

    static fromJS(data: any): DateFormatResult {
        data = typeof data === 'object' ? data : {};
        let result = new DateFormatResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pattern"] = this.pattern;
        data["locale"] = this.locale;
        data["separator"] = this.separator;
        return data;
    }
}

export interface IDateFormatResult {
    pattern: string | null;
    locale: string | null;
    separator: string | null;
}

export class DateRangeDto implements IDateRangeDto {
    startDate?: MonthDay;
    endDate?: MonthDay;

    constructor(data?: IDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? MonthDay.fromJS(_data["startDate"]) : <any>null;
            this.endDate = _data["endDate"] ? MonthDay.fromJS(_data["endDate"]) : <any>null;
        }
    }

    static fromJS(data: any): DateRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toJSON() : this.startDate;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : this.endDate;
        return data;
    }
}

export interface IDateRangeDto {
    startDate?: MonthDay;
    endDate?: MonthDay;
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export class DayPackagePrice implements IDayPackagePrice {
    readonly guid?: string;
    isAvailable?: boolean;
    startTime?: TimeOnly;
    duration?: TimeSpan;
    name?: string | null;
    basePrice?: number;
    additionalFeesTotal?: number;
    pricingGuid?: string;

    constructor(data?: IDayPackagePrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.isAvailable = _data["isAvailable"];
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : <any>null;
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : <any>null;
            this.name = _data["name"];
            this.basePrice = _data["basePrice"];
            this.additionalFeesTotal = _data["additionalFeesTotal"];
            this.pricingGuid = _data["pricingGuid"];
        }
    }

    static fromJS(data: any): DayPackagePrice {
        data = typeof data === 'object' ? data : {};
        let result = new DayPackagePrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isAvailable"] = this.isAvailable;
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        data["duration"] = this.duration ? this.duration.toJSON() : this.duration;
        data["name"] = this.name;
        data["basePrice"] = this.basePrice;
        data["additionalFeesTotal"] = this.additionalFeesTotal;
        data["pricingGuid"] = this.pricingGuid;
        return data;
    }
}

export interface IDayPackagePrice {
    guid?: string;
    isAvailable?: boolean;
    startTime?: TimeOnly;
    duration?: TimeSpan;
    name?: string | null;
    basePrice?: number;
    additionalFeesTotal?: number;
    pricingGuid?: string;
}

export class DayRevenueModel implements IDayRevenueModel {
    dateTime?: Date;
    revenue?: number;

    constructor(data?: IDayRevenueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>null;
            this.revenue = _data["revenue"];
        }
    }

    static fromJS(data: any): DayRevenueModel {
        data = typeof data === 'object' ? data : {};
        let result = new DayRevenueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime && this.dateTime.toISOString();
        data["revenue"] = this.revenue;
        return data;
    }
}

export interface IDayRevenueModel {
    dateTime?: Date;
    revenue?: number;
}

export class DeclineBookingAddonCommand implements IDeclineBookingAddonCommand {
    declineNote?: string | null;

    constructor(data?: IDeclineBookingAddonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.declineNote = _data["declineNote"];
        }
    }

    static fromJS(data: any): DeclineBookingAddonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineBookingAddonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["declineNote"] = this.declineNote;
        return data;
    }
}

export interface IDeclineBookingAddonCommand {
    declineNote?: string | null;
}

export class DeclineBookingCommand implements IDeclineBookingCommand {
    reason?: BookingCancellationReason;
    note?: string | null;

    constructor(data?: IDeclineBookingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): DeclineBookingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineBookingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["note"] = this.note;
        return data;
    }
}

export interface IDeclineBookingCommand {
    reason?: BookingCancellationReason;
    note?: string | null;
}

export class DeleteBoatEventCommand implements IDeleteBoatEventCommand {

    constructor(data?: IDeleteBoatEventCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteBoatEventCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBoatEventCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteBoatEventCommand {
}

export class DeleteListingCommand implements IDeleteListingCommand {
    guid?: string;

    constructor(data?: IDeleteListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): DeleteListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        return data;
    }
}

export interface IDeleteListingCommand {
    guid?: string;
}

export enum DirectChannelSortOptions {
    Name = "Name",
    CreatedAtUtc = "CreatedAtUtc",
}

export class DiscountTypeItem implements IDiscountTypeItem {
    guid?: string;
    code?: string | null;
    name?: string | null;

    constructor(data?: IDiscountTypeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DiscountTypeItem {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountTypeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IDiscountTypeItem {
    guid?: string;
    code?: string | null;
    name?: string | null;
}

export class DismissFromDashboardCommand implements IDismissFromDashboardCommand {
    entityType!: HomeDismissalEntityType;
    entityGuid!: string;

    constructor(data?: IDismissFromDashboardCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.entityGuid = _data["entityGuid"];
        }
    }

    static fromJS(data: any): DismissFromDashboardCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DismissFromDashboardCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["entityGuid"] = this.entityGuid;
        return data;
    }
}

export interface IDismissFromDashboardCommand {
    entityType: HomeDismissalEntityType;
    entityGuid: string;
}

export class DocusignContractSignedRequest implements IDocusignContractSignedRequest {
    event?: string | null;
    apiVersion?: string | null;
    uri?: string | null;
    retryCount?: number;
    configurationId?: number;
    generatedDateTime?: Date;
    data?: EventData;

    constructor(data?: IDocusignContractSignedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"];
            this.apiVersion = _data["apiVersion"];
            this.uri = _data["uri"];
            this.retryCount = _data["retryCount"];
            this.configurationId = _data["configurationId"];
            this.generatedDateTime = _data["generatedDateTime"] ? new Date(_data["generatedDateTime"].toString()) : <any>null;
            this.data = _data["data"] ? EventData.fromJS(_data["data"]) : <any>null;
        }
    }

    static fromJS(data: any): DocusignContractSignedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocusignContractSignedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["apiVersion"] = this.apiVersion;
        data["uri"] = this.uri;
        data["retryCount"] = this.retryCount;
        data["configurationId"] = this.configurationId;
        data["generatedDateTime"] = this.generatedDateTime && this.generatedDateTime.toISOString();
        data["data"] = this.data ? this.data.toJSON() : this.data;
        return data;
    }
}

export interface IDocusignContractSignedRequest {
    event?: string | null;
    apiVersion?: string | null;
    uri?: string | null;
    retryCount?: number;
    configurationId?: number;
    generatedDateTime?: Date;
    data?: EventData;
}

export enum EinTypeEnum {
    SSN = "SSN",
    TIN = "TIN",
    Other = "Other",
}

export enum EmailDeliveryStatus {
    NotSet = "NotSet",
    Pending = "Pending",
    Sent = "Sent",
    Failed = "Failed",
}

export enum EmailTemplateType {
    NotSet = "NotSet",
    BookingReservationConfirmed = "BookingReservationConfirmed",
    CustomerHandoff = "CustomerHandoff",
    SkipperHandoff = "SkipperHandoff",
    StewardessHandoff = "StewardessHandoff",
    BookingOffer = "BookingOffer",
    BookingSkipperReminder = "BookingSkipperReminder",
    AmbassadorBookingNotification = "AmbassadorBookingNotification",
    BookingPromoCodeApplied = "BookingPromoCodeApplied",
    BookingPaidEnquiry = "BookingPaidEnquiry",
    BookingUnpaidEnquiry = "BookingUnpaidEnquiry",
    Welcome = "Welcome",
    NewMagicLink = "NewMagicLink",
    PlatformInvitation = "PlatformInvitation",
    ResetPassword = "ResetPassword",
    BalanceChanged = "BalanceChanged",
    BookingOverviewExport = "BookingOverviewExport",
    BookingWeeklyExport = "BookingWeeklyExport",
    BookingWeeklyRevenueExport = "BookingWeeklyRevenueExport",
    PromoCodeUsage = "PromoCodeUsage",
    NewFormLeadNotification = "NewFormLeadNotification",
    BookingAddonRequested = "BookingAddonRequested",
    BookingAddonApproved = "BookingAddonApproved",
    BookingAddonDeclined = "BookingAddonDeclined",
    OverbookingNotification = "OverbookingNotification",
    LeadMessageReceived = "LeadMessageReceived",
    CheckinPersonHandoff = "CheckinPersonHandoff",
    SalesPersonAssignment = "SalesPersonAssignment",
    MultibookingOffer = "MultibookingOffer",
    MultibookingReservationConfirmed = "MultibookingReservationConfirmed",
    ExistingCustomerBookingVerification = "ExistingCustomerBookingVerification",
}

export enum EngineType {
    Diesel = "Diesel",
    Gasoline = "Gasoline",
    Electric = "Electric",
    Hybrid = "Hybrid",
}

export enum EntityCountryEnum {
    USA = "USA",
    CAN = "CAN",
}

export enum EntityTypeEnum {
    Sole = "Sole",
    Corp = "Corp",
    LLC = "LLC",
    Partner = "Partner",
    Association = "Association",
    NonProfit = "NonProfit",
    Gov = "Gov",
    CCorp = "CCorp",
    SCorp = "SCorp",
}

export class EventData implements IEventData {
    accountId?: string | null;
    userId?: string | null;
    envelopeId?: string | null;

    constructor(data?: IEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.userId = _data["userId"];
            this.envelopeId = _data["envelopeId"];
        }
    }

    static fromJS(data: any): EventData {
        data = typeof data === 'object' ? data : {};
        let result = new EventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["userId"] = this.userId;
        data["envelopeId"] = this.envelopeId;
        return data;
    }
}

export interface IEventData {
    accountId?: string | null;
    userId?: string | null;
    envelopeId?: string | null;
}

export class ExportPayoutsToCnbAchQuery implements IExportPayoutsToCnbAchQuery {
    payoutGuids?: string[] | null;

    constructor(data?: IExportPayoutsToCnbAchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["payoutGuids"])) {
                this.payoutGuids = [] as any;
                for (let item of _data["payoutGuids"])
                    this.payoutGuids!.push(item);
            }
        }
    }

    static fromJS(data: any): ExportPayoutsToCnbAchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPayoutsToCnbAchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payoutGuids)) {
            data["payoutGuids"] = [];
            for (let item of this.payoutGuids)
                data["payoutGuids"].push(item);
        }
        return data;
    }
}

export interface IExportPayoutsToCnbAchQuery {
    payoutGuids?: string[] | null;
}

export class ExternalPaymentInfo implements IExternalPaymentInfo {
    methodGuid?: string;
    methodCode?: string | null;

    constructor(data?: IExternalPaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.methodGuid = _data["methodGuid"];
            this.methodCode = _data["methodCode"];
        }
    }

    static fromJS(data: any): ExternalPaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalPaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["methodGuid"] = this.methodGuid;
        data["methodCode"] = this.methodCode;
        return data;
    }
}

export interface IExternalPaymentInfo {
    methodGuid?: string;
    methodCode?: string | null;
}

export class ExternalPaymentMethodItem implements IExternalPaymentMethodItem {
    guid?: string;
    code?: string | null;
    name?: string | null;
    displayOrder?: number;

    constructor(data?: IExternalPaymentMethodItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): ExternalPaymentMethodItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalPaymentMethodItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IExternalPaymentMethodItem {
    guid?: string;
    code?: string | null;
    name?: string | null;
    displayOrder?: number;
}

export class FeeItemDto implements IFeeItemDto {
    additionalFeeTypeGuid?: string;
    name?: string | null;
    amount?: number;

    constructor(data?: IFeeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalFeeTypeGuid = _data["additionalFeeTypeGuid"];
            this.name = _data["name"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): FeeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalFeeTypeGuid"] = this.additionalFeeTypeGuid;
        data["name"] = this.name;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IFeeItemDto {
    additionalFeeTypeGuid?: string;
    name?: string | null;
    amount?: number;
}

export class GenerateAuthenticationUserJwtFromAuthenticationUserIdCommandResult implements IGenerateAuthenticationUserJwtFromAuthenticationUserIdCommandResult {
    accessToken?: string | null;
    refreshToken?: string | null;

    constructor(data?: IGenerateAuthenticationUserJwtFromAuthenticationUserIdCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): GenerateAuthenticationUserJwtFromAuthenticationUserIdCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateAuthenticationUserJwtFromAuthenticationUserIdCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IGenerateAuthenticationUserJwtFromAuthenticationUserIdCommandResult {
    accessToken?: string | null;
    refreshToken?: string | null;
}

export class GenerateAuthenticationUserJwtFromCredentialsCommand implements IGenerateAuthenticationUserJwtFromCredentialsCommand {
    email!: string | null;
    password!: string | null;

    constructor(data?: IGenerateAuthenticationUserJwtFromCredentialsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.email = "propeller.admin@praguelabs.com";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : "propeller.admin@praguelabs.com";
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): GenerateAuthenticationUserJwtFromCredentialsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateAuthenticationUserJwtFromCredentialsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IGenerateAuthenticationUserJwtFromCredentialsCommand {
    email: string | null;
    password: string | null;
}

export class GenerateAuthenticationUserJwtFromCredentialsCommandResult implements IGenerateAuthenticationUserJwtFromCredentialsCommandResult {
    accessToken?: string | null;
    refreshToken?: string | null;

    constructor(data?: IGenerateAuthenticationUserJwtFromCredentialsCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): GenerateAuthenticationUserJwtFromCredentialsCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateAuthenticationUserJwtFromCredentialsCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IGenerateAuthenticationUserJwtFromCredentialsCommandResult {
    accessToken?: string | null;
    refreshToken?: string | null;
}

export class GenerateAuthenticationUserJwtFromRefreshTokenCommand implements IGenerateAuthenticationUserJwtFromRefreshTokenCommand {
    refreshToken!: string | null;

    constructor(data?: IGenerateAuthenticationUserJwtFromRefreshTokenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): GenerateAuthenticationUserJwtFromRefreshTokenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateAuthenticationUserJwtFromRefreshTokenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IGenerateAuthenticationUserJwtFromRefreshTokenCommand {
    refreshToken: string | null;
}

export class GenerateAuthenticationUserJwtFromRefreshTokenCommandResult implements IGenerateAuthenticationUserJwtFromRefreshTokenCommandResult {
    accessToken?: string | null;
    refreshToken?: string | null;

    constructor(data?: IGenerateAuthenticationUserJwtFromRefreshTokenCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): GenerateAuthenticationUserJwtFromRefreshTokenCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateAuthenticationUserJwtFromRefreshTokenCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IGenerateAuthenticationUserJwtFromRefreshTokenCommandResult {
    accessToken?: string | null;
    refreshToken?: string | null;
}

export class GenerateNachaFileCommand implements IGenerateNachaFileCommand {
    payoutGuids?: string[] | null;

    constructor(data?: IGenerateNachaFileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["payoutGuids"])) {
                this.payoutGuids = [] as any;
                for (let item of _data["payoutGuids"])
                    this.payoutGuids!.push(item);
            }
        }
    }

    static fromJS(data: any): GenerateNachaFileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateNachaFileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payoutGuids)) {
            data["payoutGuids"] = [];
            for (let item of this.payoutGuids)
                data["payoutGuids"].push(item);
        }
        return data;
    }
}

export interface IGenerateNachaFileCommand {
    payoutGuids?: string[] | null;
}

export class GetAdditionalFeeTypeQueryResult implements IGetAdditionalFeeTypeQueryResult {
    guid?: string;
    code?: string | null;
    name?: string | null;
    isActive?: boolean;
    displayOrder?: number;
    defaultTaxes?: TaxLine[] | null;

    constructor(data?: IGetAdditionalFeeTypeQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAdditionalFeeTypeQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdditionalFeeTypeQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAdditionalFeeTypeQueryResult {
    guid?: string;
    code?: string | null;
    name?: string | null;
    isActive?: boolean;
    displayOrder?: number;
    defaultTaxes?: TaxLine[] | null;
}

export class GetAdminCalendarCalculatedPriceQueryResult implements IGetAdminCalendarCalculatedPriceQueryResult {
    listingTitle?: string | null;
    items?: PricingLineItem[] | null;
    chargeableDaysCount?: number;
    readonly totalPrice?: number;

    constructor(data?: IGetAdminCalendarCalculatedPriceQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingTitle = _data["listingTitle"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PricingLineItem.fromJS(item));
            }
            this.chargeableDaysCount = _data["chargeableDaysCount"];
            (<any>this).totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): GetAdminCalendarCalculatedPriceQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdminCalendarCalculatedPriceQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingTitle"] = this.listingTitle;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["chargeableDaysCount"] = this.chargeableDaysCount;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IGetAdminCalendarCalculatedPriceQueryResult {
    listingTitle?: string | null;
    items?: PricingLineItem[] | null;
    chargeableDaysCount?: number;
    totalPrice?: number;
}

export class GetAgentBillingInfoResult implements IGetAgentBillingInfoResult {
    companyName?: string | null;
    vatId?: string | null;
    addressLine?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;

    constructor(data?: IGetAgentBillingInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.vatId = _data["vatId"];
            this.addressLine = _data["addressLine"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): GetAgentBillingInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgentBillingInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["vatId"] = this.vatId;
        data["addressLine"] = this.addressLine;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        return data;
    }
}

export interface IGetAgentBillingInfoResult {
    companyName?: string | null;
    vatId?: string | null;
    addressLine?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
}

export class GetAgentBrokerResult implements IGetAgentBrokerResult {
    guid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    isActive?: boolean;
    totalCommissionIncome?: number;
    bookingsCount?: number;
    createdAtUtc?: Date;

    constructor(data?: IGetAgentBrokerResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.isActive = _data["isActive"];
            this.totalCommissionIncome = _data["totalCommissionIncome"];
            this.bookingsCount = _data["bookingsCount"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetAgentBrokerResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgentBrokerResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["isActive"] = this.isActive;
        data["totalCommissionIncome"] = this.totalCommissionIncome;
        data["bookingsCount"] = this.bookingsCount;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        return data;
    }
}

export interface IGetAgentBrokerResult {
    guid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    isActive?: boolean;
    totalCommissionIncome?: number;
    bookingsCount?: number;
    createdAtUtc?: Date;
}

export class GetAgentInternalOwnerResult implements IGetAgentInternalOwnerResult {
    guid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;

    constructor(data?: IGetAgentInternalOwnerResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): GetAgentInternalOwnerResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgentInternalOwnerResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IGetAgentInternalOwnerResult {
    guid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
}

export class GetAgentQueryResult implements IGetAgentQueryResult {
    guid?: string;
    name?: string | null;
    group?: string | null;
    commissionPercent?: number;
    internalOwner?: GetAgentInternalOwnerResult;
    billingInfo?: GetAgentBillingInfoResult;
    brokers?: GetAgentBrokerResult[] | null;
    totalCommissionIncome?: number;
    bookingsCount?: number;
    createdAtUtc?: Date;

    constructor(data?: IGetAgentQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.group = _data["group"];
            this.commissionPercent = _data["commissionPercent"];
            this.internalOwner = _data["internalOwner"] ? GetAgentInternalOwnerResult.fromJS(_data["internalOwner"]) : <any>null;
            this.billingInfo = _data["billingInfo"] ? GetAgentBillingInfoResult.fromJS(_data["billingInfo"]) : <any>null;
            if (Array.isArray(_data["brokers"])) {
                this.brokers = [] as any;
                for (let item of _data["brokers"])
                    this.brokers!.push(GetAgentBrokerResult.fromJS(item));
            }
            this.totalCommissionIncome = _data["totalCommissionIncome"];
            this.bookingsCount = _data["bookingsCount"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetAgentQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgentQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["group"] = this.group;
        data["commissionPercent"] = this.commissionPercent;
        data["internalOwner"] = this.internalOwner ? this.internalOwner.toJSON() : this.internalOwner;
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : this.billingInfo;
        if (Array.isArray(this.brokers)) {
            data["brokers"] = [];
            for (let item of this.brokers)
                data["brokers"].push(item.toJSON());
        }
        data["totalCommissionIncome"] = this.totalCommissionIncome;
        data["bookingsCount"] = this.bookingsCount;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        return data;
    }
}

export interface IGetAgentQueryResult {
    guid?: string;
    name?: string | null;
    group?: string | null;
    commissionPercent?: number;
    internalOwner?: GetAgentInternalOwnerResult;
    billingInfo?: GetAgentBillingInfoResult;
    brokers?: GetAgentBrokerResult[] | null;
    totalCommissionIncome?: number;
    bookingsCount?: number;
    createdAtUtc?: Date;
}

export class GetAgentsInternalOwnerResult implements IGetAgentsInternalOwnerResult {
    guid?: string;
    fullName?: string | null;

    constructor(data?: IGetAgentsInternalOwnerResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): GetAgentsInternalOwnerResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgentsInternalOwnerResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IGetAgentsInternalOwnerResult {
    guid?: string;
    fullName?: string | null;
}

export class GetAgentsQueryResult implements IGetAgentsQueryResult {
    guid!: string;
    name?: string | null;
    group?: string | null;
    commissionPercent?: number;
    internalOwner?: GetAgentsInternalOwnerResult;
    brokersCount?: number;
    totalCommissionIncome?: number;
    bookingsCount?: number;
    createdAtUtc?: Date;

    constructor(data?: IGetAgentsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.group = _data["group"];
            this.commissionPercent = _data["commissionPercent"];
            this.internalOwner = _data["internalOwner"] ? GetAgentsInternalOwnerResult.fromJS(_data["internalOwner"]) : <any>null;
            this.brokersCount = _data["brokersCount"];
            this.totalCommissionIncome = _data["totalCommissionIncome"];
            this.bookingsCount = _data["bookingsCount"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetAgentsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgentsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["group"] = this.group;
        data["commissionPercent"] = this.commissionPercent;
        data["internalOwner"] = this.internalOwner ? this.internalOwner.toJSON() : this.internalOwner;
        data["brokersCount"] = this.brokersCount;
        data["totalCommissionIncome"] = this.totalCommissionIncome;
        data["bookingsCount"] = this.bookingsCount;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        return data;
    }
}

export interface IGetAgentsQueryResult {
    guid: string;
    name?: string | null;
    group?: string | null;
    commissionPercent?: number;
    internalOwner?: GetAgentsInternalOwnerResult;
    brokersCount?: number;
    totalCommissionIncome?: number;
    bookingsCount?: number;
    createdAtUtc?: Date;
}

export class GetAgentsQueryResultPaginatedResult implements IGetAgentsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetAgentsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetAgentsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAgentsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetAgentsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgentsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetAgentsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetAgentsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetAircallSalesLeadsQueryResult implements IGetAircallSalesLeadsQueryResult {
    guid?: string;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    numberOfGuests?: number | null;
    budget?: number | null;
    departureDate?: Date | null;
    boat?: SalesLeadBoat;
    message?: string | null;
    source?: string | null;
    origin?: SalesLeadOrigin;
    status?: SalesLeadStatus;
    submissionDate?: Date;
    assignedUser?: SalesLeadUser;
    customer?: SalesLeadCustomer;
    isClosed?: boolean;
    closedDate?: Date | null;
    bookings?: SalesLeadBooking[] | null;
    hasUnreadMessages?: boolean;
    aircallData?: AircallDataResult;

    constructor(data?: IGetAircallSalesLeadsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.numberOfGuests = _data["numberOfGuests"];
            this.budget = _data["budget"];
            this.departureDate = _data["departureDate"] ? new Date(_data["departureDate"].toString()) : <any>null;
            this.boat = _data["boat"] ? SalesLeadBoat.fromJS(_data["boat"]) : <any>null;
            this.message = _data["message"];
            this.source = _data["source"];
            this.origin = _data["origin"];
            this.status = _data["status"];
            this.submissionDate = _data["submissionDate"] ? new Date(_data["submissionDate"].toString()) : <any>null;
            this.assignedUser = _data["assignedUser"] ? SalesLeadUser.fromJS(_data["assignedUser"]) : <any>null;
            this.customer = _data["customer"] ? SalesLeadCustomer.fromJS(_data["customer"]) : <any>null;
            this.isClosed = _data["isClosed"];
            this.closedDate = _data["closedDate"] ? new Date(_data["closedDate"].toString()) : <any>null;
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(SalesLeadBooking.fromJS(item));
            }
            this.hasUnreadMessages = _data["hasUnreadMessages"];
            this.aircallData = _data["aircallData"] ? AircallDataResult.fromJS(_data["aircallData"]) : <any>null;
        }
    }

    static fromJS(data: any): GetAircallSalesLeadsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAircallSalesLeadsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["numberOfGuests"] = this.numberOfGuests;
        data["budget"] = this.budget;
        data["departureDate"] = this.departureDate && this.departureDate.toISOString();
        data["boat"] = this.boat ? this.boat.toJSON() : this.boat;
        data["message"] = this.message;
        data["source"] = this.source;
        data["origin"] = this.origin;
        data["status"] = this.status;
        data["submissionDate"] = this.submissionDate && this.submissionDate.toISOString();
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : this.assignedUser;
        data["customer"] = this.customer ? this.customer.toJSON() : this.customer;
        data["isClosed"] = this.isClosed;
        data["closedDate"] = this.closedDate && this.closedDate.toISOString();
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item.toJSON());
        }
        data["hasUnreadMessages"] = this.hasUnreadMessages;
        data["aircallData"] = this.aircallData ? this.aircallData.toJSON() : this.aircallData;
        return data;
    }
}

export interface IGetAircallSalesLeadsQueryResult {
    guid?: string;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    numberOfGuests?: number | null;
    budget?: number | null;
    departureDate?: Date | null;
    boat?: SalesLeadBoat;
    message?: string | null;
    source?: string | null;
    origin?: SalesLeadOrigin;
    status?: SalesLeadStatus;
    submissionDate?: Date;
    assignedUser?: SalesLeadUser;
    customer?: SalesLeadCustomer;
    isClosed?: boolean;
    closedDate?: Date | null;
    bookings?: SalesLeadBooking[] | null;
    hasUnreadMessages?: boolean;
    aircallData?: AircallDataResult;
}

export class GetAircallSalesLeadsQueryResultPaginatedResult implements IGetAircallSalesLeadsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetAircallSalesLeadsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetAircallSalesLeadsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAircallSalesLeadsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetAircallSalesLeadsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAircallSalesLeadsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetAircallSalesLeadsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetAircallSalesLeadsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetAllAdditionalFeeTypesQueryResult implements IGetAllAdditionalFeeTypesQueryResult {
    feeTypes!: AdditionalFeeTypeItem[] | null;

    constructor(data?: IGetAllAdditionalFeeTypesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["feeTypes"])) {
                this.feeTypes = [] as any;
                for (let item of _data["feeTypes"])
                    this.feeTypes!.push(AdditionalFeeTypeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllAdditionalFeeTypesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAdditionalFeeTypesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.feeTypes)) {
            data["feeTypes"] = [];
            for (let item of this.feeTypes)
                data["feeTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllAdditionalFeeTypesQueryResult {
    feeTypes: AdditionalFeeTypeItem[] | null;
}

export class GetAllAddonCategoriesQueryResult implements IGetAllAddonCategoriesQueryResult {
    categories!: AddonCategoryDto[] | null;

    constructor(data?: IGetAllAddonCategoriesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(AddonCategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllAddonCategoriesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAddonCategoriesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllAddonCategoriesQueryResult {
    categories: AddonCategoryDto[] | null;
}

export class GetAllDiscountTypesQuery implements IGetAllDiscountTypesQuery {

    constructor(data?: IGetAllDiscountTypesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllDiscountTypesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDiscountTypesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllDiscountTypesQuery {
}

export class GetAllDiscountTypesQueryResult implements IGetAllDiscountTypesQueryResult {
    discountTypes!: DiscountTypeItem[] | null;

    constructor(data?: IGetAllDiscountTypesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["discountTypes"])) {
                this.discountTypes = [] as any;
                for (let item of _data["discountTypes"])
                    this.discountTypes!.push(DiscountTypeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllDiscountTypesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDiscountTypesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.discountTypes)) {
            data["discountTypes"] = [];
            for (let item of this.discountTypes)
                data["discountTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllDiscountTypesQueryResult {
    discountTypes: DiscountTypeItem[] | null;
}

export class GetAllPaymentsListQueryResult implements IGetAllPaymentsListQueryResult {
    paymentGuid?: string;
    bookingId?: number;
    bookingGuid?: string;
    paymentDate?: Date | null;
    amount?: number;
    provider?: PaymentProvider;
    customerFullName?: string | null;
    listingTitle?: string | null;
    bookingStartDate?: Date;
    status?: PaymentStatus;

    constructor(data?: IGetAllPaymentsListQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGuid = _data["paymentGuid"];
            this.bookingId = _data["bookingId"];
            this.bookingGuid = _data["bookingGuid"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>null;
            this.amount = _data["amount"];
            this.provider = _data["provider"];
            this.customerFullName = _data["customerFullName"];
            this.listingTitle = _data["listingTitle"];
            this.bookingStartDate = _data["bookingStartDate"] ? new Date(_data["bookingStartDate"].toString()) : <any>null;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetAllPaymentsListQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPaymentsListQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGuid"] = this.paymentGuid;
        data["bookingId"] = this.bookingId;
        data["bookingGuid"] = this.bookingGuid;
        data["paymentDate"] = this.paymentDate && this.paymentDate.toISOString();
        data["amount"] = this.amount;
        data["provider"] = this.provider;
        data["customerFullName"] = this.customerFullName;
        data["listingTitle"] = this.listingTitle;
        data["bookingStartDate"] = this.bookingStartDate && this.bookingStartDate.toISOString();
        data["status"] = this.status;
        return data;
    }
}

export interface IGetAllPaymentsListQueryResult {
    paymentGuid?: string;
    bookingId?: number;
    bookingGuid?: string;
    paymentDate?: Date | null;
    amount?: number;
    provider?: PaymentProvider;
    customerFullName?: string | null;
    listingTitle?: string | null;
    bookingStartDate?: Date;
    status?: PaymentStatus;
}

export class GetAllPaymentsListResponse implements IGetAllPaymentsListResponse {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetAllPaymentsListQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;
    cardPaymentsCount?: number;
    externalPaymentsCount?: number;
    totalAmount?: number;

    constructor(data?: IGetAllPaymentsListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllPaymentsListQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
            this.cardPaymentsCount = _data["cardPaymentsCount"];
            this.externalPaymentsCount = _data["externalPaymentsCount"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): GetAllPaymentsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPaymentsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        data["cardPaymentsCount"] = this.cardPaymentsCount;
        data["externalPaymentsCount"] = this.externalPaymentsCount;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IGetAllPaymentsListResponse {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetAllPaymentsListQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
    cardPaymentsCount?: number;
    externalPaymentsCount?: number;
    totalAmount?: number;
}

export class GetAuthorizeNetCheckoutSessionQueryResponse implements IGetAuthorizeNetCheckoutSessionQueryResponse {
    sessionGuid?: string;
    amount?: number;
    currency?: string | null;
    isAvailable?: boolean;
    booking?: BookingCheckoutSessionResponse;
    lineItems?: AuthorizeNetCheckoutSessionLineItem[] | null;

    constructor(data?: IGetAuthorizeNetCheckoutSessionQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionGuid = _data["sessionGuid"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.isAvailable = _data["isAvailable"];
            this.booking = _data["booking"] ? BookingCheckoutSessionResponse.fromJS(_data["booking"]) : <any>null;
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(AuthorizeNetCheckoutSessionLineItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAuthorizeNetCheckoutSessionQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuthorizeNetCheckoutSessionQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionGuid"] = this.sessionGuid;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["isAvailable"] = this.isAvailable;
        data["booking"] = this.booking ? this.booking.toJSON() : this.booking;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAuthorizeNetCheckoutSessionQueryResponse {
    sessionGuid?: string;
    amount?: number;
    currency?: string | null;
    isAvailable?: boolean;
    booking?: BookingCheckoutSessionResponse;
    lineItems?: AuthorizeNetCheckoutSessionLineItem[] | null;
}

export class GetAuthorizeNetPaymentProfilesQueryResult implements IGetAuthorizeNetPaymentProfilesQueryResult {
    readonly paymentProfiles?: AuthorizeNetPaymentProfileResponse[] | null;

    constructor(data?: IGetAuthorizeNetPaymentProfilesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paymentProfiles"])) {
                (<any>this).paymentProfiles = [] as any;
                for (let item of _data["paymentProfiles"])
                    (<any>this).paymentProfiles!.push(AuthorizeNetPaymentProfileResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAuthorizeNetPaymentProfilesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAuthorizeNetPaymentProfilesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paymentProfiles)) {
            data["paymentProfiles"] = [];
            for (let item of this.paymentProfiles)
                data["paymentProfiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAuthorizeNetPaymentProfilesQueryResult {
    paymentProfiles?: AuthorizeNetPaymentProfileResponse[] | null;
}

export class GetAvailabilityDayPricingsQueryResult implements IGetAvailabilityDayPricingsQueryResult {
    guid!: string;
    listing!: CalendarListing;
    boat!: CalendarBoat;
    market!: MarketResult;
    location!: LocationResult;
    dayPackagePrices!: DayPackagePrice[] | null;
    calendarDayPrice?: CalendarDayPrice;
    isAvailable?: boolean | null;
    pricingMode!: PricingMode;

    constructor(data?: IGetAvailabilityDayPricingsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.listing = new CalendarListing();
            this.boat = new CalendarBoat();
            this.market = new MarketResult();
            this.location = new LocationResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.listing = _data["listing"] ? CalendarListing.fromJS(_data["listing"]) : new CalendarListing();
            this.boat = _data["boat"] ? CalendarBoat.fromJS(_data["boat"]) : new CalendarBoat();
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : new MarketResult();
            this.location = _data["location"] ? LocationResult.fromJS(_data["location"]) : new LocationResult();
            if (Array.isArray(_data["dayPackagePrices"])) {
                this.dayPackagePrices = [] as any;
                for (let item of _data["dayPackagePrices"])
                    this.dayPackagePrices!.push(DayPackagePrice.fromJS(item));
            }
            this.calendarDayPrice = _data["calendarDayPrice"] ? CalendarDayPrice.fromJS(_data["calendarDayPrice"]) : <any>null;
            this.isAvailable = _data["isAvailable"];
            this.pricingMode = _data["pricingMode"];
        }
    }

    static fromJS(data: any): GetAvailabilityDayPricingsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailabilityDayPricingsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["listing"] = this.listing ? this.listing.toJSON() : this.listing;
        data["boat"] = this.boat ? this.boat.toJSON() : this.boat;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["location"] = this.location ? this.location.toJSON() : this.location;
        if (Array.isArray(this.dayPackagePrices)) {
            data["dayPackagePrices"] = [];
            for (let item of this.dayPackagePrices)
                data["dayPackagePrices"].push(item.toJSON());
        }
        data["calendarDayPrice"] = this.calendarDayPrice ? this.calendarDayPrice.toJSON() : this.calendarDayPrice;
        data["isAvailable"] = this.isAvailable;
        data["pricingMode"] = this.pricingMode;
        return data;
    }
}

export interface IGetAvailabilityDayPricingsQueryResult {
    guid: string;
    listing: CalendarListing;
    boat: CalendarBoat;
    market: MarketResult;
    location: LocationResult;
    dayPackagePrices: DayPackagePrice[] | null;
    calendarDayPrice?: CalendarDayPrice;
    isAvailable?: boolean | null;
    pricingMode: PricingMode;
}

export class GetAvailabilityDayPricingsQueryResultPaginatedResult implements IGetAvailabilityDayPricingsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetAvailabilityDayPricingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetAvailabilityDayPricingsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAvailabilityDayPricingsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetAvailabilityDayPricingsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailabilityDayPricingsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetAvailabilityDayPricingsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetAvailabilityDayPricingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetAvailablePlatformAccountsForAuthenticationUserQueryResult implements IGetAvailablePlatformAccountsForAuthenticationUserQueryResult {
    platformAccountGuid?: string;
    platformAccountName?: string | null;
    roles?: RoleName[] | null;

    constructor(data?: IGetAvailablePlatformAccountsForAuthenticationUserQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platformAccountGuid = _data["platformAccountGuid"];
            this.platformAccountName = _data["platformAccountName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAvailablePlatformAccountsForAuthenticationUserQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailablePlatformAccountsForAuthenticationUserQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platformAccountGuid"] = this.platformAccountGuid;
        data["platformAccountName"] = this.platformAccountName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IGetAvailablePlatformAccountsForAuthenticationUserQueryResult {
    platformAccountGuid?: string;
    platformAccountName?: string | null;
    roles?: RoleName[] | null;
}

export class GetBoatAllowedAddonsQueryResult implements IGetBoatAllowedAddonsQueryResult {
    allowAllAddons!: boolean;
    allowedAddonGuids!: string[] | null;

    constructor(data?: IGetBoatAllowedAddonsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowAllAddons = _data["allowAllAddons"];
            if (Array.isArray(_data["allowedAddonGuids"])) {
                this.allowedAddonGuids = [] as any;
                for (let item of _data["allowedAddonGuids"])
                    this.allowedAddonGuids!.push(item);
            }
        }
    }

    static fromJS(data: any): GetBoatAllowedAddonsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatAllowedAddonsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowAllAddons"] = this.allowAllAddons;
        if (Array.isArray(this.allowedAddonGuids)) {
            data["allowedAddonGuids"] = [];
            for (let item of this.allowedAddonGuids)
                data["allowedAddonGuids"].push(item);
        }
        return data;
    }
}

export interface IGetBoatAllowedAddonsQueryResult {
    allowAllAddons: boolean;
    allowedAddonGuids: string[] | null;
}

export class GetBoatCalendarDayBookingQueryResultAdditionalFee implements IGetBoatCalendarDayBookingQueryResultAdditionalFee {
    name?: string | null;
    amount?: number;

    constructor(data?: IGetBoatCalendarDayBookingQueryResultAdditionalFee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): GetBoatCalendarDayBookingQueryResultAdditionalFee {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatCalendarDayBookingQueryResultAdditionalFee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IGetBoatCalendarDayBookingQueryResultAdditionalFee {
    name?: string | null;
    amount?: number;
}

export class GetBoatCalendarDayQueryResult implements IGetBoatCalendarDayQueryResult {
    boatGuid?: string;
    date?: Date;
    bookings?: GetBoatCalendarDayQueryResultBooking[] | null;
    unavailabilities?: GetBoatCalendarDayQueryResultUnavailability[] | null;
    issues?: GetBoatCalendarDayQueryResultIssue[] | null;

    constructor(data?: IGetBoatCalendarDayQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boatGuid = _data["boatGuid"];
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(GetBoatCalendarDayQueryResultBooking.fromJS(item));
            }
            if (Array.isArray(_data["unavailabilities"])) {
                this.unavailabilities = [] as any;
                for (let item of _data["unavailabilities"])
                    this.unavailabilities!.push(GetBoatCalendarDayQueryResultUnavailability.fromJS(item));
            }
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(GetBoatCalendarDayQueryResultIssue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBoatCalendarDayQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatCalendarDayQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boatGuid"] = this.boatGuid;
        data["date"] = this.date && formatDate(this.date);
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item.toJSON());
        }
        if (Array.isArray(this.unavailabilities)) {
            data["unavailabilities"] = [];
            for (let item of this.unavailabilities)
                data["unavailabilities"].push(item.toJSON());
        }
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBoatCalendarDayQueryResult {
    boatGuid?: string;
    date?: Date;
    bookings?: GetBoatCalendarDayQueryResultBooking[] | null;
    unavailabilities?: GetBoatCalendarDayQueryResultUnavailability[] | null;
    issues?: GetBoatCalendarDayQueryResultIssue[] | null;
}

export class GetBoatCalendarDayQueryResultBooking implements IGetBoatCalendarDayQueryResultBooking {
    guid?: string;
    bookingId?: number;
    start?: Date;
    end?: Date;
    totalPrice?: number;
    status?: string | null;
    customerFullName?: string | null;
    pricePackageName?: string | null;
    pricePackagePrice?: number | null;
    additionalFees?: GetBoatCalendarDayBookingQueryResultAdditionalFee[] | null;
    proformaExpiresAt?: Date | null;
    isProformaActive?: boolean;
    offerExpiresAt?: Date | null;
    isOfferBlockActive?: boolean;
    conflicts?: GetBoatCalendarQueryResultBookingConflicts[] | null;

    constructor(data?: IGetBoatCalendarDayQueryResultBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
            this.totalPrice = _data["totalPrice"];
            this.status = _data["status"];
            this.customerFullName = _data["customerFullName"];
            this.pricePackageName = _data["pricePackageName"];
            this.pricePackagePrice = _data["pricePackagePrice"];
            if (Array.isArray(_data["additionalFees"])) {
                this.additionalFees = [] as any;
                for (let item of _data["additionalFees"])
                    this.additionalFees!.push(GetBoatCalendarDayBookingQueryResultAdditionalFee.fromJS(item));
            }
            this.proformaExpiresAt = _data["proformaExpiresAt"] ? new Date(_data["proformaExpiresAt"].toString()) : <any>null;
            this.isProformaActive = _data["isProformaActive"];
            this.offerExpiresAt = _data["offerExpiresAt"] ? new Date(_data["offerExpiresAt"].toString()) : <any>null;
            this.isOfferBlockActive = _data["isOfferBlockActive"];
            if (Array.isArray(_data["conflicts"])) {
                this.conflicts = [] as any;
                for (let item of _data["conflicts"])
                    this.conflicts!.push(GetBoatCalendarQueryResultBookingConflicts.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBoatCalendarDayQueryResultBooking {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatCalendarDayQueryResultBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        data["start"] = this.start && this.start.toISOString();
        data["end"] = this.end && this.end.toISOString();
        data["totalPrice"] = this.totalPrice;
        data["status"] = this.status;
        data["customerFullName"] = this.customerFullName;
        data["pricePackageName"] = this.pricePackageName;
        data["pricePackagePrice"] = this.pricePackagePrice;
        if (Array.isArray(this.additionalFees)) {
            data["additionalFees"] = [];
            for (let item of this.additionalFees)
                data["additionalFees"].push(item.toJSON());
        }
        data["proformaExpiresAt"] = this.proformaExpiresAt && this.proformaExpiresAt.toISOString();
        data["isProformaActive"] = this.isProformaActive;
        data["offerExpiresAt"] = this.offerExpiresAt && this.offerExpiresAt.toISOString();
        data["isOfferBlockActive"] = this.isOfferBlockActive;
        if (Array.isArray(this.conflicts)) {
            data["conflicts"] = [];
            for (let item of this.conflicts)
                data["conflicts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBoatCalendarDayQueryResultBooking {
    guid?: string;
    bookingId?: number;
    start?: Date;
    end?: Date;
    totalPrice?: number;
    status?: string | null;
    customerFullName?: string | null;
    pricePackageName?: string | null;
    pricePackagePrice?: number | null;
    additionalFees?: GetBoatCalendarDayBookingQueryResultAdditionalFee[] | null;
    proformaExpiresAt?: Date | null;
    isProformaActive?: boolean;
    offerExpiresAt?: Date | null;
    isOfferBlockActive?: boolean;
    conflicts?: GetBoatCalendarQueryResultBookingConflicts[] | null;
}

export class GetBoatCalendarDayQueryResultIssue implements IGetBoatCalendarDayQueryResultIssue {
    guid?: string;
    title?: string | null;
    type?: string | null;
    status?: string | null;
    createdOn?: Date;
    responsible?: string | null;

    constructor(data?: IGetBoatCalendarDayQueryResultIssue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>null;
            this.responsible = _data["responsible"];
        }
    }

    static fromJS(data: any): GetBoatCalendarDayQueryResultIssue {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatCalendarDayQueryResultIssue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["type"] = this.type;
        data["status"] = this.status;
        data["createdOn"] = this.createdOn && this.createdOn.toISOString();
        data["responsible"] = this.responsible;
        return data;
    }
}

export interface IGetBoatCalendarDayQueryResultIssue {
    guid?: string;
    title?: string | null;
    type?: string | null;
    status?: string | null;
    createdOn?: Date;
    responsible?: string | null;
}

export class GetBoatCalendarDayQueryResultUnavailability implements IGetBoatCalendarDayQueryResultUnavailability {
    guid?: string;
    name?: string | null;
    from?: Date;
    to?: Date;
    bookingGuid?: string | null;
    boatEventGuid?: string | null;
    note?: string | null;

    constructor(data?: IGetBoatCalendarDayQueryResultUnavailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
            this.bookingGuid = _data["bookingGuid"];
            this.boatEventGuid = _data["boatEventGuid"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): GetBoatCalendarDayQueryResultUnavailability {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatCalendarDayQueryResultUnavailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["from"] = this.from && this.from.toISOString();
        data["to"] = this.to && this.to.toISOString();
        data["bookingGuid"] = this.bookingGuid;
        data["boatEventGuid"] = this.boatEventGuid;
        data["note"] = this.note;
        return data;
    }
}

export interface IGetBoatCalendarDayQueryResultUnavailability {
    guid?: string;
    name?: string | null;
    from?: Date;
    to?: Date;
    bookingGuid?: string | null;
    boatEventGuid?: string | null;
    note?: string | null;
}

export class GetBoatCalendarQueryResult implements IGetBoatCalendarQueryResult {
    date?: Date;
    bookings?: GetBoatCalendarQueryResultBooking[] | null;
    unavailabilities?: GetBoatCalendarQueryResultUnavailability[] | null;
    issues?: GetBoatCalendarQueryResultIssue[] | null;

    constructor(data?: IGetBoatCalendarQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(GetBoatCalendarQueryResultBooking.fromJS(item));
            }
            if (Array.isArray(_data["unavailabilities"])) {
                this.unavailabilities = [] as any;
                for (let item of _data["unavailabilities"])
                    this.unavailabilities!.push(GetBoatCalendarQueryResultUnavailability.fromJS(item));
            }
            if (Array.isArray(_data["issues"])) {
                this.issues = [] as any;
                for (let item of _data["issues"])
                    this.issues!.push(GetBoatCalendarQueryResultIssue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBoatCalendarQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatCalendarQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date && formatDate(this.date);
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item.toJSON());
        }
        if (Array.isArray(this.unavailabilities)) {
            data["unavailabilities"] = [];
            for (let item of this.unavailabilities)
                data["unavailabilities"].push(item.toJSON());
        }
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (let item of this.issues)
                data["issues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBoatCalendarQueryResult {
    date?: Date;
    bookings?: GetBoatCalendarQueryResultBooking[] | null;
    unavailabilities?: GetBoatCalendarQueryResultUnavailability[] | null;
    issues?: GetBoatCalendarQueryResultIssue[] | null;
}

export class GetBoatCalendarQueryResultBooking implements IGetBoatCalendarQueryResultBooking {
    guid?: string;
    bookingId?: number;
    start?: Date;
    end?: Date;
    totalPrice?: number;
    status?: string | null;
    proformaExpiresAt?: Date | null;
    isProformaActive?: boolean;
    offerExpiresAt?: Date | null;
    isOfferBlockActive?: boolean;
    conflicts?: GetBoatCalendarQueryResultBookingConflicts[] | null;

    constructor(data?: IGetBoatCalendarQueryResultBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
            this.totalPrice = _data["totalPrice"];
            this.status = _data["status"];
            this.proformaExpiresAt = _data["proformaExpiresAt"] ? new Date(_data["proformaExpiresAt"].toString()) : <any>null;
            this.isProformaActive = _data["isProformaActive"];
            this.offerExpiresAt = _data["offerExpiresAt"] ? new Date(_data["offerExpiresAt"].toString()) : <any>null;
            this.isOfferBlockActive = _data["isOfferBlockActive"];
            if (Array.isArray(_data["conflicts"])) {
                this.conflicts = [] as any;
                for (let item of _data["conflicts"])
                    this.conflicts!.push(GetBoatCalendarQueryResultBookingConflicts.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBoatCalendarQueryResultBooking {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatCalendarQueryResultBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        data["start"] = this.start && this.start.toISOString();
        data["end"] = this.end && this.end.toISOString();
        data["totalPrice"] = this.totalPrice;
        data["status"] = this.status;
        data["proformaExpiresAt"] = this.proformaExpiresAt && this.proformaExpiresAt.toISOString();
        data["isProformaActive"] = this.isProformaActive;
        data["offerExpiresAt"] = this.offerExpiresAt && this.offerExpiresAt.toISOString();
        data["isOfferBlockActive"] = this.isOfferBlockActive;
        if (Array.isArray(this.conflicts)) {
            data["conflicts"] = [];
            for (let item of this.conflicts)
                data["conflicts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBoatCalendarQueryResultBooking {
    guid?: string;
    bookingId?: number;
    start?: Date;
    end?: Date;
    totalPrice?: number;
    status?: string | null;
    proformaExpiresAt?: Date | null;
    isProformaActive?: boolean;
    offerExpiresAt?: Date | null;
    isOfferBlockActive?: boolean;
    conflicts?: GetBoatCalendarQueryResultBookingConflicts[] | null;
}

export class GetBoatCalendarQueryResultBookingConflicts implements IGetBoatCalendarQueryResultBookingConflicts {
    bookingGuid?: string;
    bookingId?: number;

    constructor(data?: IGetBoatCalendarQueryResultBookingConflicts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.bookingId = _data["bookingId"];
        }
    }

    static fromJS(data: any): GetBoatCalendarQueryResultBookingConflicts {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatCalendarQueryResultBookingConflicts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["bookingId"] = this.bookingId;
        return data;
    }
}

export interface IGetBoatCalendarQueryResultBookingConflicts {
    bookingGuid?: string;
    bookingId?: number;
}

export class GetBoatCalendarQueryResultIssue implements IGetBoatCalendarQueryResultIssue {
    guid?: string;
    title?: string | null;
    type?: string | null;
    status?: string | null;
    createdOn?: Date;
    responsible?: string | null;

    constructor(data?: IGetBoatCalendarQueryResultIssue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>null;
            this.responsible = _data["responsible"];
        }
    }

    static fromJS(data: any): GetBoatCalendarQueryResultIssue {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatCalendarQueryResultIssue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["type"] = this.type;
        data["status"] = this.status;
        data["createdOn"] = this.createdOn && this.createdOn.toISOString();
        data["responsible"] = this.responsible;
        return data;
    }
}

export interface IGetBoatCalendarQueryResultIssue {
    guid?: string;
    title?: string | null;
    type?: string | null;
    status?: string | null;
    createdOn?: Date;
    responsible?: string | null;
}

export class GetBoatCalendarQueryResultUnavailability implements IGetBoatCalendarQueryResultUnavailability {
    guid?: string;
    name?: string | null;
    from?: Date;
    to?: Date;
    bookingGuid?: string | null;
    boatEventGuid?: string | null;

    constructor(data?: IGetBoatCalendarQueryResultUnavailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
            this.bookingGuid = _data["bookingGuid"];
            this.boatEventGuid = _data["boatEventGuid"];
        }
    }

    static fromJS(data: any): GetBoatCalendarQueryResultUnavailability {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatCalendarQueryResultUnavailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["from"] = this.from && this.from.toISOString();
        data["to"] = this.to && this.to.toISOString();
        data["bookingGuid"] = this.bookingGuid;
        data["boatEventGuid"] = this.boatEventGuid;
        return data;
    }
}

export interface IGetBoatCalendarQueryResultUnavailability {
    guid?: string;
    name?: string | null;
    from?: Date;
    to?: Date;
    bookingGuid?: string | null;
    boatEventGuid?: string | null;
}

export class GetBoatEventQueryResult implements IGetBoatEventQueryResult {
    guid!: string;
    type!: BoatEventType;
    from!: Date;
    to!: Date;
    isBlocking!: boolean;
    note!: string | null;

    constructor(data?: IGetBoatEventQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.type = _data["type"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
            this.isBlocking = _data["isBlocking"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): GetBoatEventQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatEventQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["type"] = this.type;
        data["from"] = this.from && this.from.toISOString();
        data["to"] = this.to && this.to.toISOString();
        data["isBlocking"] = this.isBlocking;
        data["note"] = this.note;
        return data;
    }
}

export interface IGetBoatEventQueryResult {
    guid: string;
    type: BoatEventType;
    from: Date;
    to: Date;
    isBlocking: boolean;
    note: string | null;
}

export class GetBoatIssuesQueryResult implements IGetBoatIssuesQueryResult {
    guid?: string;
    title?: string | null;
    createdOn?: Date;
    createdBy?: BoatIssueUser;
    responsible?: string | null;
    type?: BoatIssueType;
    status?: BoatIssueStatus;
    fixDate?: Date | null;
    notes?: string | null;

    constructor(data?: IGetBoatIssuesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>null;
            this.createdBy = _data["createdBy"] ? BoatIssueUser.fromJS(_data["createdBy"]) : <any>null;
            this.responsible = _data["responsible"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.fixDate = _data["fixDate"] ? new Date(_data["fixDate"].toString()) : <any>null;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): GetBoatIssuesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatIssuesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["createdOn"] = this.createdOn && this.createdOn.toISOString();
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : this.createdBy;
        data["responsible"] = this.responsible;
        data["type"] = this.type;
        data["status"] = this.status;
        data["fixDate"] = this.fixDate && this.fixDate.toISOString();
        data["notes"] = this.notes;
        return data;
    }
}

export interface IGetBoatIssuesQueryResult {
    guid?: string;
    title?: string | null;
    createdOn?: Date;
    createdBy?: BoatIssueUser;
    responsible?: string | null;
    type?: BoatIssueType;
    status?: BoatIssueStatus;
    fixDate?: Date | null;
    notes?: string | null;
}

export class GetBoatIssuesQueryResultPaginatedResult implements IGetBoatIssuesQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBoatIssuesQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetBoatIssuesQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBoatIssuesQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetBoatIssuesQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatIssuesQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetBoatIssuesQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBoatIssuesQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetBoatPartsQueryResult implements IGetBoatPartsQueryResult {
    guid?: string;
    name?: string | null;
    number?: string | null;
    vendor?: BoatPartVendor;
    cost?: number | null;
    note?: string | null;
    type?: BoatPartType;
    category?: BoatPartCategory;
    manufacturer?: string | null;
    manufacturerPartNumber?: string | null;
    reorderVendorNumber?: string | null;
    reorderUnitSize?: string | null;
    reorderDate?: Date | null;
    createdBy?: string | null;
    createdByUserName?: string | null;

    constructor(data?: IGetBoatPartsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.vendor = _data["vendor"] ? BoatPartVendor.fromJS(_data["vendor"]) : <any>null;
            this.cost = _data["cost"];
            this.note = _data["note"];
            this.type = _data["type"];
            this.category = _data["category"];
            this.manufacturer = _data["manufacturer"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.reorderVendorNumber = _data["reorderVendorNumber"];
            this.reorderUnitSize = _data["reorderUnitSize"];
            this.reorderDate = _data["reorderDate"] ? new Date(_data["reorderDate"].toString()) : <any>null;
            this.createdBy = _data["createdBy"];
            this.createdByUserName = _data["createdByUserName"];
        }
    }

    static fromJS(data: any): GetBoatPartsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatPartsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["number"] = this.number;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : this.vendor;
        data["cost"] = this.cost;
        data["note"] = this.note;
        data["type"] = this.type;
        data["category"] = this.category;
        data["manufacturer"] = this.manufacturer;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["reorderVendorNumber"] = this.reorderVendorNumber;
        data["reorderUnitSize"] = this.reorderUnitSize;
        data["reorderDate"] = this.reorderDate && this.reorderDate.toISOString();
        data["createdBy"] = this.createdBy;
        data["createdByUserName"] = this.createdByUserName;
        return data;
    }
}

export interface IGetBoatPartsQueryResult {
    guid?: string;
    name?: string | null;
    number?: string | null;
    vendor?: BoatPartVendor;
    cost?: number | null;
    note?: string | null;
    type?: BoatPartType;
    category?: BoatPartCategory;
    manufacturer?: string | null;
    manufacturerPartNumber?: string | null;
    reorderVendorNumber?: string | null;
    reorderUnitSize?: string | null;
    reorderDate?: Date | null;
    createdBy?: string | null;
    createdByUserName?: string | null;
}

export class GetBoatPartsQueryResultPaginatedResult implements IGetBoatPartsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBoatPartsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetBoatPartsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBoatPartsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetBoatPartsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatPartsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetBoatPartsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBoatPartsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetBoatPerformanceQueryResult implements IGetBoatPerformanceQueryResult {
    bookedDays?: number;
    emptyDays?: number;
    occupancyRate?: number;
    issues?: number;
    earnings?: number;

    constructor(data?: IGetBoatPerformanceQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookedDays = _data["bookedDays"];
            this.emptyDays = _data["emptyDays"];
            this.occupancyRate = _data["occupancyRate"];
            this.issues = _data["issues"];
            this.earnings = _data["earnings"];
        }
    }

    static fromJS(data: any): GetBoatPerformanceQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatPerformanceQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookedDays"] = this.bookedDays;
        data["emptyDays"] = this.emptyDays;
        data["occupancyRate"] = this.occupancyRate;
        data["issues"] = this.issues;
        data["earnings"] = this.earnings;
        return data;
    }
}

export interface IGetBoatPerformanceQueryResult {
    bookedDays?: number;
    emptyDays?: number;
    occupancyRate?: number;
    issues?: number;
    earnings?: number;
}

export class GetBoatPricingsCalendarQueryResult implements IGetBoatPricingsCalendarQueryResult {
    listingGuid?: string;
    listingTitle?: string | null;
    days?: CalendarDayResult[] | null;

    constructor(data?: IGetBoatPricingsCalendarQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingGuid = _data["listingGuid"];
            this.listingTitle = _data["listingTitle"];
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(CalendarDayResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBoatPricingsCalendarQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatPricingsCalendarQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingGuid"] = this.listingGuid;
        data["listingTitle"] = this.listingTitle;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBoatPricingsCalendarQueryResult {
    listingGuid?: string;
    listingTitle?: string | null;
    days?: CalendarDayResult[] | null;
}

export class GetBoatQueryResult implements IGetBoatQueryResult {
    guid?: string;
    defaultListingTitle?: string | null;
    registeredName?: string | null;
    makeAndModel?: string | null;
    description?: string | null;
    sortPriority?: number | null;
    ownerType?: BoatOwnerType;
    isComplete?: boolean;
    owner?: UserResult;
    specification?: BoatSpecification;
    pictures?: BoatPictureResultResult[] | null;
    listings?: GetBoatQueryResultListing[] | null;
    isDeleted?: boolean;
    hasSpecificationFile?: boolean;
    specificationFileOriginalName?: string | null;
    specificationFileSizeBytes?: number | null;

    constructor(data?: IGetBoatQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.defaultListingTitle = _data["defaultListingTitle"];
            this.registeredName = _data["registeredName"];
            this.makeAndModel = _data["makeAndModel"];
            this.description = _data["description"];
            this.sortPriority = _data["sortPriority"];
            this.ownerType = _data["ownerType"];
            this.isComplete = _data["isComplete"];
            this.owner = _data["owner"] ? UserResult.fromJS(_data["owner"]) : <any>null;
            this.specification = _data["specification"] ? BoatSpecification.fromJS(_data["specification"]) : <any>null;
            if (Array.isArray(_data["pictures"])) {
                this.pictures = [] as any;
                for (let item of _data["pictures"])
                    this.pictures!.push(BoatPictureResultResult.fromJS(item));
            }
            if (Array.isArray(_data["listings"])) {
                this.listings = [] as any;
                for (let item of _data["listings"])
                    this.listings!.push(GetBoatQueryResultListing.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.hasSpecificationFile = _data["hasSpecificationFile"];
            this.specificationFileOriginalName = _data["specificationFileOriginalName"];
            this.specificationFileSizeBytes = _data["specificationFileSizeBytes"];
        }
    }

    static fromJS(data: any): GetBoatQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["defaultListingTitle"] = this.defaultListingTitle;
        data["registeredName"] = this.registeredName;
        data["makeAndModel"] = this.makeAndModel;
        data["description"] = this.description;
        data["sortPriority"] = this.sortPriority;
        data["ownerType"] = this.ownerType;
        data["isComplete"] = this.isComplete;
        data["owner"] = this.owner ? this.owner.toJSON() : this.owner;
        data["specification"] = this.specification ? this.specification.toJSON() : this.specification;
        if (Array.isArray(this.pictures)) {
            data["pictures"] = [];
            for (let item of this.pictures)
                data["pictures"].push(item.toJSON());
        }
        if (Array.isArray(this.listings)) {
            data["listings"] = [];
            for (let item of this.listings)
                data["listings"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["hasSpecificationFile"] = this.hasSpecificationFile;
        data["specificationFileOriginalName"] = this.specificationFileOriginalName;
        data["specificationFileSizeBytes"] = this.specificationFileSizeBytes;
        return data;
    }
}

export interface IGetBoatQueryResult {
    guid?: string;
    defaultListingTitle?: string | null;
    registeredName?: string | null;
    makeAndModel?: string | null;
    description?: string | null;
    sortPriority?: number | null;
    ownerType?: BoatOwnerType;
    isComplete?: boolean;
    owner?: UserResult;
    specification?: BoatSpecification;
    pictures?: BoatPictureResultResult[] | null;
    listings?: GetBoatQueryResultListing[] | null;
    isDeleted?: boolean;
    hasSpecificationFile?: boolean;
    specificationFileOriginalName?: string | null;
    specificationFileSizeBytes?: number | null;
}

export class GetBoatQueryResultListing implements IGetBoatQueryResultListing {
    guid!: string;
    marketGuid!: string;
    marketCode!: string | null;
    marketTitle!: string | null;
    locationTitle!: string | null;
    marketSpecificTitle!: string | null;
    publishStatus!: PublishStatus;
    defaultSkipper!: UserResult;
    pricingMode!: PricingMode;

    constructor(data?: IGetBoatQueryResultListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.defaultSkipper = new UserResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.marketGuid = _data["marketGuid"];
            this.marketCode = _data["marketCode"];
            this.marketTitle = _data["marketTitle"];
            this.locationTitle = _data["locationTitle"];
            this.marketSpecificTitle = _data["marketSpecificTitle"];
            this.publishStatus = _data["publishStatus"];
            this.defaultSkipper = _data["defaultSkipper"] ? UserResult.fromJS(_data["defaultSkipper"]) : new UserResult();
            this.pricingMode = _data["pricingMode"];
        }
    }

    static fromJS(data: any): GetBoatQueryResultListing {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatQueryResultListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["marketGuid"] = this.marketGuid;
        data["marketCode"] = this.marketCode;
        data["marketTitle"] = this.marketTitle;
        data["locationTitle"] = this.locationTitle;
        data["marketSpecificTitle"] = this.marketSpecificTitle;
        data["publishStatus"] = this.publishStatus;
        data["defaultSkipper"] = this.defaultSkipper ? this.defaultSkipper.toJSON() : this.defaultSkipper;
        data["pricingMode"] = this.pricingMode;
        return data;
    }
}

export interface IGetBoatQueryResultListing {
    guid: string;
    marketGuid: string;
    marketCode: string | null;
    marketTitle: string | null;
    locationTitle: string | null;
    marketSpecificTitle: string | null;
    publishStatus: PublishStatus;
    defaultSkipper: UserResult;
    pricingMode: PricingMode;
}

export class GetBoatTuneUpsQueryResult implements IGetBoatTuneUpsQueryResult {
    guid?: string;
    type?: BoatTuneUpType;
    date?: Date;
    notes?: string | null;

    constructor(data?: IGetBoatTuneUpsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.type = _data["type"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): GetBoatTuneUpsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatTuneUpsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["type"] = this.type;
        data["date"] = this.date && this.date.toISOString();
        data["notes"] = this.notes;
        return data;
    }
}

export interface IGetBoatTuneUpsQueryResult {
    guid?: string;
    type?: BoatTuneUpType;
    date?: Date;
    notes?: string | null;
}

export class GetBoatTuneUpsQueryResultPaginatedResult implements IGetBoatTuneUpsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBoatTuneUpsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetBoatTuneUpsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBoatTuneUpsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetBoatTuneUpsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatTuneUpsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetBoatTuneUpsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBoatTuneUpsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetBoatsByLocationQueryResult implements IGetBoatsByLocationQueryResult {
    guid!: string;
    registeredName!: string | null;
    makeAndModel!: string | null;
    listings!: GetBoatsByLocationQueryResultListing[] | null;

    constructor(data?: IGetBoatsByLocationQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.registeredName = _data["registeredName"];
            this.makeAndModel = _data["makeAndModel"];
            if (Array.isArray(_data["listings"])) {
                this.listings = [] as any;
                for (let item of _data["listings"])
                    this.listings!.push(GetBoatsByLocationQueryResultListing.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBoatsByLocationQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatsByLocationQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["registeredName"] = this.registeredName;
        data["makeAndModel"] = this.makeAndModel;
        if (Array.isArray(this.listings)) {
            data["listings"] = [];
            for (let item of this.listings)
                data["listings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBoatsByLocationQueryResult {
    guid: string;
    registeredName: string | null;
    makeAndModel: string | null;
    listings: GetBoatsByLocationQueryResultListing[] | null;
}

export class GetBoatsByLocationQueryResultListing implements IGetBoatsByLocationQueryResultListing {
    title!: string | null;
    publishStatus!: PublishStatus;
    boatIdentifier!: string | null;
    location!: LocationResult;
    market!: MarketResult;
    defaultSkipper!: UserResult;
    defaultStewardess!: UserResult;

    constructor(data?: IGetBoatsByLocationQueryResultListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.location = new LocationResult();
            this.market = new MarketResult();
            this.defaultSkipper = new UserResult();
            this.defaultStewardess = new UserResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.publishStatus = _data["publishStatus"];
            this.boatIdentifier = _data["boatIdentifier"];
            this.location = _data["location"] ? LocationResult.fromJS(_data["location"]) : new LocationResult();
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : new MarketResult();
            this.defaultSkipper = _data["defaultSkipper"] ? UserResult.fromJS(_data["defaultSkipper"]) : new UserResult();
            this.defaultStewardess = _data["defaultStewardess"] ? UserResult.fromJS(_data["defaultStewardess"]) : new UserResult();
        }
    }

    static fromJS(data: any): GetBoatsByLocationQueryResultListing {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatsByLocationQueryResultListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["publishStatus"] = this.publishStatus;
        data["boatIdentifier"] = this.boatIdentifier;
        data["location"] = this.location ? this.location.toJSON() : this.location;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["defaultSkipper"] = this.defaultSkipper ? this.defaultSkipper.toJSON() : this.defaultSkipper;
        data["defaultStewardess"] = this.defaultStewardess ? this.defaultStewardess.toJSON() : this.defaultStewardess;
        return data;
    }
}

export interface IGetBoatsByLocationQueryResultListing {
    title: string | null;
    publishStatus: PublishStatus;
    boatIdentifier: string | null;
    location: LocationResult;
    market: MarketResult;
    defaultSkipper: UserResult;
    defaultStewardess: UserResult;
}

export class GetBoatsByLocationQueryResultPaginatedResult implements IGetBoatsByLocationQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBoatsByLocationQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetBoatsByLocationQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBoatsByLocationQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetBoatsByLocationQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatsByLocationQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetBoatsByLocationQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBoatsByLocationQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetBoatsQueryResult implements IGetBoatsQueryResult {
    guid?: string;
    length?: number | null;
    defaultListingTitle?: string | null;
    sortPriority?: number | null;
    isComplete?: boolean;
    totalTrips?: number | null;
    totalRevenue?: number | null;
    areAllOwnerTakeRatesSet?: boolean;
    owner?: UserResult;
    markets?: MarketResult[] | null;
    boatPicture?: BoatPictureResultModel;

    constructor(data?: IGetBoatsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.length = _data["length"];
            this.defaultListingTitle = _data["defaultListingTitle"];
            this.sortPriority = _data["sortPriority"];
            this.isComplete = _data["isComplete"];
            this.totalTrips = _data["totalTrips"];
            this.totalRevenue = _data["totalRevenue"];
            this.areAllOwnerTakeRatesSet = _data["areAllOwnerTakeRatesSet"];
            this.owner = _data["owner"] ? UserResult.fromJS(_data["owner"]) : <any>null;
            if (Array.isArray(_data["markets"])) {
                this.markets = [] as any;
                for (let item of _data["markets"])
                    this.markets!.push(MarketResult.fromJS(item));
            }
            this.boatPicture = _data["boatPicture"] ? BoatPictureResultModel.fromJS(_data["boatPicture"]) : <any>null;
        }
    }

    static fromJS(data: any): GetBoatsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["length"] = this.length;
        data["defaultListingTitle"] = this.defaultListingTitle;
        data["sortPriority"] = this.sortPriority;
        data["isComplete"] = this.isComplete;
        data["totalTrips"] = this.totalTrips;
        data["totalRevenue"] = this.totalRevenue;
        data["areAllOwnerTakeRatesSet"] = this.areAllOwnerTakeRatesSet;
        data["owner"] = this.owner ? this.owner.toJSON() : this.owner;
        if (Array.isArray(this.markets)) {
            data["markets"] = [];
            for (let item of this.markets)
                data["markets"].push(item.toJSON());
        }
        data["boatPicture"] = this.boatPicture ? this.boatPicture.toJSON() : this.boatPicture;
        return data;
    }
}

export interface IGetBoatsQueryResult {
    guid?: string;
    length?: number | null;
    defaultListingTitle?: string | null;
    sortPriority?: number | null;
    isComplete?: boolean;
    totalTrips?: number | null;
    totalRevenue?: number | null;
    areAllOwnerTakeRatesSet?: boolean;
    owner?: UserResult;
    markets?: MarketResult[] | null;
    boatPicture?: BoatPictureResultModel;
}

export class GetBoatsQueryResultPaginatedResult implements IGetBoatsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBoatsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetBoatsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBoatsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetBoatsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetBoatsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBoatsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetBoatsYearsStatisticsQueryResult implements IGetBoatsYearsStatisticsQueryResult {
    guid?: string;
    defaultListingTitle?: string | null;
    owner?: UserResult;
    totalRevenue?: number | null;
    totalTrips?: number | null;
    statistics?: BoatYearStatisticsResult[] | null;

    constructor(data?: IGetBoatsYearsStatisticsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.defaultListingTitle = _data["defaultListingTitle"];
            this.owner = _data["owner"] ? UserResult.fromJS(_data["owner"]) : <any>null;
            this.totalRevenue = _data["totalRevenue"];
            this.totalTrips = _data["totalTrips"];
            if (Array.isArray(_data["statistics"])) {
                this.statistics = [] as any;
                for (let item of _data["statistics"])
                    this.statistics!.push(BoatYearStatisticsResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBoatsYearsStatisticsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatsYearsStatisticsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["defaultListingTitle"] = this.defaultListingTitle;
        data["owner"] = this.owner ? this.owner.toJSON() : this.owner;
        data["totalRevenue"] = this.totalRevenue;
        data["totalTrips"] = this.totalTrips;
        if (Array.isArray(this.statistics)) {
            data["statistics"] = [];
            for (let item of this.statistics)
                data["statistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBoatsYearsStatisticsQueryResult {
    guid?: string;
    defaultListingTitle?: string | null;
    owner?: UserResult;
    totalRevenue?: number | null;
    totalTrips?: number | null;
    statistics?: BoatYearStatisticsResult[] | null;
}

export class GetBoatsYearsStatisticsQueryResultPaginatedResult implements IGetBoatsYearsStatisticsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBoatsYearsStatisticsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetBoatsYearsStatisticsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBoatsYearsStatisticsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetBoatsYearsStatisticsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBoatsYearsStatisticsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetBoatsYearsStatisticsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBoatsYearsStatisticsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetBookingCustomerQueryResult implements IGetBookingCustomerQueryResult {
    guid?: string;
    address?: CustomerAddress;
    billingInfo?: CustomerBillingInfo;
    customerPreferences?: CustomerPreferences;
    concierge?: CustomerConcierge;
    customerClass?: CustomerClass;
    isBlocked?: boolean;
    isDeleted?: boolean;
    customerNumber?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    idPassportNumber?: string | null;
    markets?: MarketResult[] | null;

    constructor(data?: IGetBookingCustomerQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.address = _data["address"] ? CustomerAddress.fromJS(_data["address"]) : <any>null;
            this.billingInfo = _data["billingInfo"] ? CustomerBillingInfo.fromJS(_data["billingInfo"]) : <any>null;
            this.customerPreferences = _data["customerPreferences"] ? CustomerPreferences.fromJS(_data["customerPreferences"]) : <any>null;
            this.concierge = _data["concierge"] ? CustomerConcierge.fromJS(_data["concierge"]) : <any>null;
            this.customerClass = _data["customerClass"];
            this.isBlocked = _data["isBlocked"];
            this.isDeleted = _data["isDeleted"];
            this.customerNumber = _data["customerNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.idPassportNumber = _data["idPassportNumber"];
            if (Array.isArray(_data["markets"])) {
                this.markets = [] as any;
                for (let item of _data["markets"])
                    this.markets!.push(MarketResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBookingCustomerQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingCustomerQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["address"] = this.address ? this.address.toJSON() : this.address;
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : this.billingInfo;
        data["customerPreferences"] = this.customerPreferences ? this.customerPreferences.toJSON() : this.customerPreferences;
        data["concierge"] = this.concierge ? this.concierge.toJSON() : this.concierge;
        data["customerClass"] = this.customerClass;
        data["isBlocked"] = this.isBlocked;
        data["isDeleted"] = this.isDeleted;
        data["customerNumber"] = this.customerNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["idPassportNumber"] = this.idPassportNumber;
        if (Array.isArray(this.markets)) {
            data["markets"] = [];
            for (let item of this.markets)
                data["markets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBookingCustomerQueryResult {
    guid?: string;
    address?: CustomerAddress;
    billingInfo?: CustomerBillingInfo;
    customerPreferences?: CustomerPreferences;
    concierge?: CustomerConcierge;
    customerClass?: CustomerClass;
    isBlocked?: boolean;
    isDeleted?: boolean;
    customerNumber?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    idPassportNumber?: string | null;
    markets?: MarketResult[] | null;
}

export class GetBookingInternalNotesQueryResult implements IGetBookingInternalNotesQueryResult {
    guid?: string;
    createdByUser?: UserResult;
    note?: string | null;
    createdAt?: Date;

    constructor(data?: IGetBookingInternalNotesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.createdByUser = _data["createdByUser"] ? UserResult.fromJS(_data["createdByUser"]) : <any>null;
            this.note = _data["note"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetBookingInternalNotesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingInternalNotesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : this.createdByUser;
        data["note"] = this.note;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        return data;
    }
}

export interface IGetBookingInternalNotesQueryResult {
    guid?: string;
    createdByUser?: UserResult;
    note?: string | null;
    createdAt?: Date;
}

export class GetBookingItemsQueryResult implements IGetBookingItemsQueryResult {
    bookingGuid?: string;
    bookingId?: number;
    bookingStartDate?: Date;
    customerName?: string | null;
    boat?: string | null;
    itemType?: BookingItemResultType;
    itemName?: string | null;
    grossAmount?: number;
    currency?: string | null;

    constructor(data?: IGetBookingItemsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.bookingId = _data["bookingId"];
            this.bookingStartDate = _data["bookingStartDate"] ? new Date(_data["bookingStartDate"].toString()) : <any>null;
            this.customerName = _data["customerName"];
            this.boat = _data["boat"];
            this.itemType = _data["itemType"];
            this.itemName = _data["itemName"];
            this.grossAmount = _data["grossAmount"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): GetBookingItemsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingItemsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["bookingId"] = this.bookingId;
        data["bookingStartDate"] = this.bookingStartDate && this.bookingStartDate.toISOString();
        data["customerName"] = this.customerName;
        data["boat"] = this.boat;
        data["itemType"] = this.itemType;
        data["itemName"] = this.itemName;
        data["grossAmount"] = this.grossAmount;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IGetBookingItemsQueryResult {
    bookingGuid?: string;
    bookingId?: number;
    bookingStartDate?: Date;
    customerName?: string | null;
    boat?: string | null;
    itemType?: BookingItemResultType;
    itemName?: string | null;
    grossAmount?: number;
    currency?: string | null;
}

export class GetBookingItemsQueryResultPaginatedResult implements IGetBookingItemsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBookingItemsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetBookingItemsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBookingItemsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetBookingItemsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingItemsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetBookingItemsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBookingItemsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetBookingLogsQueryResult implements IGetBookingLogsQueryResult {
    guid?: string;
    createdDate?: Date;
    eventName?: string | null;
    value?: any | null;
    createdByUser?: GetBookingLogsUser;

    constructor(data?: IGetBookingLogsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.eventName = _data["eventName"];
            this.value = _data["value"];
            this.createdByUser = _data["createdByUser"] ? GetBookingLogsUser.fromJS(_data["createdByUser"]) : <any>null;
        }
    }

    static fromJS(data: any): GetBookingLogsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingLogsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["createdDate"] = this.createdDate && this.createdDate.toISOString();
        data["eventName"] = this.eventName;
        data["value"] = this.value;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : this.createdByUser;
        return data;
    }
}

export interface IGetBookingLogsQueryResult {
    guid?: string;
    createdDate?: Date;
    eventName?: string | null;
    value?: any | null;
    createdByUser?: GetBookingLogsUser;
}

export class GetBookingLogsQueryResultPaginatedResult implements IGetBookingLogsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBookingLogsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetBookingLogsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBookingLogsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetBookingLogsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingLogsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetBookingLogsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBookingLogsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetBookingLogsUser implements IGetBookingLogsUser {
    guid?: string;
    fullName?: string | null;

    constructor(data?: IGetBookingLogsUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): GetBookingLogsUser {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingLogsUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IGetBookingLogsUser {
    guid?: string;
    fullName?: string | null;
}

export class GetBookingMailerNotificationsQueryResult implements IGetBookingMailerNotificationsQueryResult {
    guid?: string;
    type?: BookingMailerNotificationType;
    status?: BookingMailerNotificationStatus;
    createdAt?: Date;
    notificationContent?: string | null;
    triggeredBy?: UserResult;
    contractGuid?: string | null;
    recipients?: string[] | null;
    ccEmails?: string[] | null;
    additionalMessage?: string | null;
    contractId?: string | null;
    contractSignedAt?: Date | null;
    contractRecipientEmail?: string | null;

    constructor(data?: IGetBookingMailerNotificationsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.notificationContent = _data["notificationContent"];
            this.triggeredBy = _data["triggeredBy"] ? UserResult.fromJS(_data["triggeredBy"]) : <any>null;
            this.contractGuid = _data["contractGuid"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            if (Array.isArray(_data["ccEmails"])) {
                this.ccEmails = [] as any;
                for (let item of _data["ccEmails"])
                    this.ccEmails!.push(item);
            }
            this.additionalMessage = _data["additionalMessage"];
            this.contractId = _data["contractId"];
            this.contractSignedAt = _data["contractSignedAt"] ? new Date(_data["contractSignedAt"].toString()) : <any>null;
            this.contractRecipientEmail = _data["contractRecipientEmail"];
        }
    }

    static fromJS(data: any): GetBookingMailerNotificationsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingMailerNotificationsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["type"] = this.type;
        data["status"] = this.status;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["notificationContent"] = this.notificationContent;
        data["triggeredBy"] = this.triggeredBy ? this.triggeredBy.toJSON() : this.triggeredBy;
        data["contractGuid"] = this.contractGuid;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        if (Array.isArray(this.ccEmails)) {
            data["ccEmails"] = [];
            for (let item of this.ccEmails)
                data["ccEmails"].push(item);
        }
        data["additionalMessage"] = this.additionalMessage;
        data["contractId"] = this.contractId;
        data["contractSignedAt"] = this.contractSignedAt && this.contractSignedAt.toISOString();
        data["contractRecipientEmail"] = this.contractRecipientEmail;
        return data;
    }
}

export interface IGetBookingMailerNotificationsQueryResult {
    guid?: string;
    type?: BookingMailerNotificationType;
    status?: BookingMailerNotificationStatus;
    createdAt?: Date;
    notificationContent?: string | null;
    triggeredBy?: UserResult;
    contractGuid?: string | null;
    recipients?: string[] | null;
    ccEmails?: string[] | null;
    additionalMessage?: string | null;
    contractId?: string | null;
    contractSignedAt?: Date | null;
    contractRecipientEmail?: string | null;
}

export class GetBookingMailerNotificationsQueryResultPaginatedResult implements IGetBookingMailerNotificationsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBookingMailerNotificationsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetBookingMailerNotificationsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBookingMailerNotificationsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetBookingMailerNotificationsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingMailerNotificationsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetBookingMailerNotificationsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBookingMailerNotificationsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetBookingMailersQueryResult implements IGetBookingMailersQueryResult {
    guid!: string;
    mailerName!: string | null;
    triggeredByGuid?: string | null;
    triggeredByName?: string | null;
    status!: RunnerJobStatus;
    date!: Date;

    constructor(data?: IGetBookingMailersQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.mailerName = _data["mailerName"];
            this.triggeredByGuid = _data["triggeredByGuid"];
            this.triggeredByName = _data["triggeredByName"];
            this.status = _data["status"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetBookingMailersQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingMailersQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["mailerName"] = this.mailerName;
        data["triggeredByGuid"] = this.triggeredByGuid;
        data["triggeredByName"] = this.triggeredByName;
        data["status"] = this.status;
        data["date"] = this.date && this.date.toISOString();
        return data;
    }
}

export interface IGetBookingMailersQueryResult {
    guid: string;
    mailerName: string | null;
    triggeredByGuid?: string | null;
    triggeredByName?: string | null;
    status: RunnerJobStatus;
    date: Date;
}

export class GetBookingQueryResult implements IGetBookingQueryResult {
    bookingId?: number;
    aliasId?: number | null;
    multibookingGuid?: string | null;
    multibookingId?: number | null;
    formattedMultibookingId?: string | null;
    status?: BookingStatus;
    expiredFrom?: BookingStatus;
    customer?: BookingCustomer;
    hasAuthenticationUser?: boolean;
    listingTitle?: string | null;
    from?: Date;
    to?: Date;
    startDate?: Date;
    startTime?: TimeOnly;
    endDate?: Date;
    endTime?: TimeOnly;
    passengers?: number;
    listing?: GetBookingQueryResultListing;
    pricingTemplateGuid?: string | null;
    bookingConflicts?: GetBookingQueryResultBookingConflict[] | null;
    pickupLocation?: LocationResult;
    dropOffLocation?: LocationResult;
    contractStatus?: ContractStatus;
    contractLastSentAt?: Date | null;
    contractSignedAt?: Date | null;
    skipper?: UserResult;
    checkinPerson?: UserResult;
    salesPerson?: GetBookingQueryResultSalesPerson;
    createdBy?: UserResult;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    stewardess?: UserResult[] | null;
    bookingNotes?: BookingNotes;
    superchatUrl?: string | null;
    basePrice?: number;
    rentalPrice?: PricedAmount;
    discountedRentalNetAmount?: number;
    discountedRentalTaxAmount?: number;
    discountedRentalGrossAmount?: number;
    paymentStatus?: BookingPaymentStatus;
    additionalFees?: BookingAdditionalFees;
    totalOnlineCustomerFeeAmount?: number;
    basePriceDiscount?: number;
    discountTypeGuid?: string | null;
    boatOwnerTakeRateAmount?: number | null;
    appliedPromoCode?: BookingAppliedPromoCode;
    appliedCampaign?: BookingAppliedCampaign;
    commissionPercentage?: number;
    commissionAmount?: number;
    priceBreakdown?: BookingPriceBreakdown;
    ownerGuid?: string | null;
    pickupAddress?: OrderingLocationAddress;
    dropOffAddress?: OrderingLocationAddress;
    totalPrice?: number;
    netTotalAmount?: number;
    taxTotalAmount?: number;
    grossTotalAmount?: number;
    totalPaid?: number;
    totalPriceWithCustomerFee?: number;
    outstandingBalanceWithCustomerFee?: number;
    totalOnlineCustomerFeeWithRemaining?: number;
    remainingCustomerFee?: number;
    remainingToPay?: number;
    cancellationDetails?: BookingCancellationDetails;
    packageName?: string | null;
    boatPicture?: BoatPictureResultResult;
    bookingSourceInfo?: BookingSourceInfo;
    hasBoatSpecificationFile?: boolean;
    channelType?: BookingChannelType;
    agent?: BookingAgent;
    brokerGuid?: string | null;
    brokerContact?: BrokerContactResult;
    directChannelGuid?: string | null;
    isAvailableForReservation?: boolean;
    isOfferExpired?: boolean;
    isProformaExpired?: boolean;
    canRecalculatePrice?: boolean;
    proformaAvailabilityBlockExpiresAt?: Date | null;
    offerAvailabilityBlockExpiresAt?: Date | null;
    timeZoneInfoId?: string | null;
    culture?: string | null;
    currency?: string | null;
    cashPaymentLimitAmount?: number | null;
    requestApproved?: boolean | null;
    canProcessPayment?: boolean;
    requiredPrePaymentPercentage?: number | null;
    isPrePaymentOverridden?: boolean;
    prePayment?: PrePaymentInfo;
    marketplaceSessionId?: string | null;
    addons?: BookingAddonDto[] | null;

    constructor(data?: IGetBookingQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"];
            this.aliasId = _data["aliasId"];
            this.multibookingGuid = _data["multibookingGuid"];
            this.multibookingId = _data["multibookingId"];
            this.formattedMultibookingId = _data["formattedMultibookingId"];
            this.status = _data["status"];
            this.expiredFrom = _data["expiredFrom"];
            this.customer = _data["customer"] ? BookingCustomer.fromJS(_data["customer"]) : <any>null;
            this.hasAuthenticationUser = _data["hasAuthenticationUser"];
            this.listingTitle = _data["listingTitle"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : <any>null;
            this.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? TimeOnly.fromJS(_data["endTime"]) : <any>null;
            this.passengers = _data["passengers"];
            this.listing = _data["listing"] ? GetBookingQueryResultListing.fromJS(_data["listing"]) : <any>null;
            this.pricingTemplateGuid = _data["pricingTemplateGuid"];
            if (Array.isArray(_data["bookingConflicts"])) {
                this.bookingConflicts = [] as any;
                for (let item of _data["bookingConflicts"])
                    this.bookingConflicts!.push(GetBookingQueryResultBookingConflict.fromJS(item));
            }
            this.pickupLocation = _data["pickupLocation"] ? LocationResult.fromJS(_data["pickupLocation"]) : <any>null;
            this.dropOffLocation = _data["dropOffLocation"] ? LocationResult.fromJS(_data["dropOffLocation"]) : <any>null;
            this.contractStatus = _data["contractStatus"];
            this.contractLastSentAt = _data["contractLastSentAt"] ? new Date(_data["contractLastSentAt"].toString()) : <any>null;
            this.contractSignedAt = _data["contractSignedAt"] ? new Date(_data["contractSignedAt"].toString()) : <any>null;
            this.skipper = _data["skipper"] ? UserResult.fromJS(_data["skipper"]) : <any>null;
            this.checkinPerson = _data["checkinPerson"] ? UserResult.fromJS(_data["checkinPerson"]) : <any>null;
            this.salesPerson = _data["salesPerson"] ? GetBookingQueryResultSalesPerson.fromJS(_data["salesPerson"]) : <any>null;
            this.createdBy = _data["createdBy"] ? UserResult.fromJS(_data["createdBy"]) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            if (Array.isArray(_data["stewardess"])) {
                this.stewardess = [] as any;
                for (let item of _data["stewardess"])
                    this.stewardess!.push(UserResult.fromJS(item));
            }
            this.bookingNotes = _data["bookingNotes"] ? BookingNotes.fromJS(_data["bookingNotes"]) : <any>null;
            this.superchatUrl = _data["superchatUrl"];
            this.basePrice = _data["basePrice"];
            this.rentalPrice = _data["rentalPrice"] ? PricedAmount.fromJS(_data["rentalPrice"]) : <any>null;
            this.discountedRentalNetAmount = _data["discountedRentalNetAmount"];
            this.discountedRentalTaxAmount = _data["discountedRentalTaxAmount"];
            this.discountedRentalGrossAmount = _data["discountedRentalGrossAmount"];
            this.paymentStatus = _data["paymentStatus"];
            this.additionalFees = _data["additionalFees"] ? BookingAdditionalFees.fromJS(_data["additionalFees"]) : <any>null;
            this.totalOnlineCustomerFeeAmount = _data["totalOnlineCustomerFeeAmount"];
            this.basePriceDiscount = _data["basePriceDiscount"];
            this.discountTypeGuid = _data["discountTypeGuid"];
            this.boatOwnerTakeRateAmount = _data["boatOwnerTakeRateAmount"];
            this.appliedPromoCode = _data["appliedPromoCode"] ? BookingAppliedPromoCode.fromJS(_data["appliedPromoCode"]) : <any>null;
            this.appliedCampaign = _data["appliedCampaign"] ? BookingAppliedCampaign.fromJS(_data["appliedCampaign"]) : <any>null;
            this.commissionPercentage = _data["commissionPercentage"];
            this.commissionAmount = _data["commissionAmount"];
            this.priceBreakdown = _data["priceBreakdown"] ? BookingPriceBreakdown.fromJS(_data["priceBreakdown"]) : <any>null;
            this.ownerGuid = _data["ownerGuid"];
            this.pickupAddress = _data["pickupAddress"] ? OrderingLocationAddress.fromJS(_data["pickupAddress"]) : <any>null;
            this.dropOffAddress = _data["dropOffAddress"] ? OrderingLocationAddress.fromJS(_data["dropOffAddress"]) : <any>null;
            this.totalPrice = _data["totalPrice"];
            this.netTotalAmount = _data["netTotalAmount"];
            this.taxTotalAmount = _data["taxTotalAmount"];
            this.grossTotalAmount = _data["grossTotalAmount"];
            this.totalPaid = _data["totalPaid"];
            this.totalPriceWithCustomerFee = _data["totalPriceWithCustomerFee"];
            this.outstandingBalanceWithCustomerFee = _data["outstandingBalanceWithCustomerFee"];
            this.totalOnlineCustomerFeeWithRemaining = _data["totalOnlineCustomerFeeWithRemaining"];
            this.remainingCustomerFee = _data["remainingCustomerFee"];
            this.remainingToPay = _data["remainingToPay"];
            this.cancellationDetails = _data["cancellationDetails"] ? BookingCancellationDetails.fromJS(_data["cancellationDetails"]) : <any>null;
            this.packageName = _data["packageName"];
            this.boatPicture = _data["boatPicture"] ? BoatPictureResultResult.fromJS(_data["boatPicture"]) : <any>null;
            this.bookingSourceInfo = _data["bookingSourceInfo"] ? BookingSourceInfo.fromJS(_data["bookingSourceInfo"]) : <any>null;
            this.hasBoatSpecificationFile = _data["hasBoatSpecificationFile"];
            this.channelType = _data["channelType"];
            this.agent = _data["agent"] ? BookingAgent.fromJS(_data["agent"]) : <any>null;
            this.brokerGuid = _data["brokerGuid"];
            this.brokerContact = _data["brokerContact"] ? BrokerContactResult.fromJS(_data["brokerContact"]) : <any>null;
            this.directChannelGuid = _data["directChannelGuid"];
            this.isAvailableForReservation = _data["isAvailableForReservation"];
            this.isOfferExpired = _data["isOfferExpired"];
            this.isProformaExpired = _data["isProformaExpired"];
            this.canRecalculatePrice = _data["canRecalculatePrice"];
            this.proformaAvailabilityBlockExpiresAt = _data["proformaAvailabilityBlockExpiresAt"] ? new Date(_data["proformaAvailabilityBlockExpiresAt"].toString()) : <any>null;
            this.offerAvailabilityBlockExpiresAt = _data["offerAvailabilityBlockExpiresAt"] ? new Date(_data["offerAvailabilityBlockExpiresAt"].toString()) : <any>null;
            this.timeZoneInfoId = _data["timeZoneInfoId"];
            this.culture = _data["culture"];
            this.currency = _data["currency"];
            this.cashPaymentLimitAmount = _data["cashPaymentLimitAmount"];
            this.requestApproved = _data["requestApproved"];
            this.canProcessPayment = _data["canProcessPayment"];
            this.requiredPrePaymentPercentage = _data["requiredPrePaymentPercentage"];
            this.isPrePaymentOverridden = _data["isPrePaymentOverridden"];
            this.prePayment = _data["prePayment"] ? PrePaymentInfo.fromJS(_data["prePayment"]) : <any>null;
            this.marketplaceSessionId = _data["marketplaceSessionId"];
            if (Array.isArray(_data["addons"])) {
                this.addons = [] as any;
                for (let item of _data["addons"])
                    this.addons!.push(BookingAddonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBookingQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        data["aliasId"] = this.aliasId;
        data["multibookingGuid"] = this.multibookingGuid;
        data["multibookingId"] = this.multibookingId;
        data["formattedMultibookingId"] = this.formattedMultibookingId;
        data["status"] = this.status;
        data["expiredFrom"] = this.expiredFrom;
        data["customer"] = this.customer ? this.customer.toJSON() : this.customer;
        data["hasAuthenticationUser"] = this.hasAuthenticationUser;
        data["listingTitle"] = this.listingTitle;
        data["from"] = this.from && this.from.toISOString();
        data["to"] = this.to && this.to.toISOString();
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        data["endDate"] = this.endDate && formatDate(this.endDate);
        data["endTime"] = this.endTime ? this.endTime.toJSON() : this.endTime;
        data["passengers"] = this.passengers;
        data["listing"] = this.listing ? this.listing.toJSON() : this.listing;
        data["pricingTemplateGuid"] = this.pricingTemplateGuid;
        if (Array.isArray(this.bookingConflicts)) {
            data["bookingConflicts"] = [];
            for (let item of this.bookingConflicts)
                data["bookingConflicts"].push(item.toJSON());
        }
        data["pickupLocation"] = this.pickupLocation ? this.pickupLocation.toJSON() : this.pickupLocation;
        data["dropOffLocation"] = this.dropOffLocation ? this.dropOffLocation.toJSON() : this.dropOffLocation;
        data["contractStatus"] = this.contractStatus;
        data["contractLastSentAt"] = this.contractLastSentAt && this.contractLastSentAt.toISOString();
        data["contractSignedAt"] = this.contractSignedAt && this.contractSignedAt.toISOString();
        data["skipper"] = this.skipper ? this.skipper.toJSON() : this.skipper;
        data["checkinPerson"] = this.checkinPerson ? this.checkinPerson.toJSON() : this.checkinPerson;
        data["salesPerson"] = this.salesPerson ? this.salesPerson.toJSON() : this.salesPerson;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : this.createdBy;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        if (Array.isArray(this.stewardess)) {
            data["stewardess"] = [];
            for (let item of this.stewardess)
                data["stewardess"].push(item.toJSON());
        }
        data["bookingNotes"] = this.bookingNotes ? this.bookingNotes.toJSON() : this.bookingNotes;
        data["superchatUrl"] = this.superchatUrl;
        data["basePrice"] = this.basePrice;
        data["rentalPrice"] = this.rentalPrice ? this.rentalPrice.toJSON() : this.rentalPrice;
        data["discountedRentalNetAmount"] = this.discountedRentalNetAmount;
        data["discountedRentalTaxAmount"] = this.discountedRentalTaxAmount;
        data["discountedRentalGrossAmount"] = this.discountedRentalGrossAmount;
        data["paymentStatus"] = this.paymentStatus;
        data["additionalFees"] = this.additionalFees ? this.additionalFees.toJSON() : this.additionalFees;
        data["totalOnlineCustomerFeeAmount"] = this.totalOnlineCustomerFeeAmount;
        data["basePriceDiscount"] = this.basePriceDiscount;
        data["discountTypeGuid"] = this.discountTypeGuid;
        data["boatOwnerTakeRateAmount"] = this.boatOwnerTakeRateAmount;
        data["appliedPromoCode"] = this.appliedPromoCode ? this.appliedPromoCode.toJSON() : this.appliedPromoCode;
        data["appliedCampaign"] = this.appliedCampaign ? this.appliedCampaign.toJSON() : this.appliedCampaign;
        data["commissionPercentage"] = this.commissionPercentage;
        data["commissionAmount"] = this.commissionAmount;
        data["priceBreakdown"] = this.priceBreakdown ? this.priceBreakdown.toJSON() : this.priceBreakdown;
        data["ownerGuid"] = this.ownerGuid;
        data["pickupAddress"] = this.pickupAddress ? this.pickupAddress.toJSON() : this.pickupAddress;
        data["dropOffAddress"] = this.dropOffAddress ? this.dropOffAddress.toJSON() : this.dropOffAddress;
        data["totalPrice"] = this.totalPrice;
        data["netTotalAmount"] = this.netTotalAmount;
        data["taxTotalAmount"] = this.taxTotalAmount;
        data["grossTotalAmount"] = this.grossTotalAmount;
        data["totalPaid"] = this.totalPaid;
        data["totalPriceWithCustomerFee"] = this.totalPriceWithCustomerFee;
        data["outstandingBalanceWithCustomerFee"] = this.outstandingBalanceWithCustomerFee;
        data["totalOnlineCustomerFeeWithRemaining"] = this.totalOnlineCustomerFeeWithRemaining;
        data["remainingCustomerFee"] = this.remainingCustomerFee;
        data["remainingToPay"] = this.remainingToPay;
        data["cancellationDetails"] = this.cancellationDetails ? this.cancellationDetails.toJSON() : this.cancellationDetails;
        data["packageName"] = this.packageName;
        data["boatPicture"] = this.boatPicture ? this.boatPicture.toJSON() : this.boatPicture;
        data["bookingSourceInfo"] = this.bookingSourceInfo ? this.bookingSourceInfo.toJSON() : this.bookingSourceInfo;
        data["hasBoatSpecificationFile"] = this.hasBoatSpecificationFile;
        data["channelType"] = this.channelType;
        data["agent"] = this.agent ? this.agent.toJSON() : this.agent;
        data["brokerGuid"] = this.brokerGuid;
        data["brokerContact"] = this.brokerContact ? this.brokerContact.toJSON() : this.brokerContact;
        data["directChannelGuid"] = this.directChannelGuid;
        data["isAvailableForReservation"] = this.isAvailableForReservation;
        data["isOfferExpired"] = this.isOfferExpired;
        data["isProformaExpired"] = this.isProformaExpired;
        data["canRecalculatePrice"] = this.canRecalculatePrice;
        data["proformaAvailabilityBlockExpiresAt"] = this.proformaAvailabilityBlockExpiresAt && this.proformaAvailabilityBlockExpiresAt.toISOString();
        data["offerAvailabilityBlockExpiresAt"] = this.offerAvailabilityBlockExpiresAt && this.offerAvailabilityBlockExpiresAt.toISOString();
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        data["culture"] = this.culture;
        data["currency"] = this.currency;
        data["cashPaymentLimitAmount"] = this.cashPaymentLimitAmount;
        data["requestApproved"] = this.requestApproved;
        data["canProcessPayment"] = this.canProcessPayment;
        data["requiredPrePaymentPercentage"] = this.requiredPrePaymentPercentage;
        data["isPrePaymentOverridden"] = this.isPrePaymentOverridden;
        data["prePayment"] = this.prePayment ? this.prePayment.toJSON() : this.prePayment;
        data["marketplaceSessionId"] = this.marketplaceSessionId;
        if (Array.isArray(this.addons)) {
            data["addons"] = [];
            for (let item of this.addons)
                data["addons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBookingQueryResult {
    bookingId?: number;
    aliasId?: number | null;
    multibookingGuid?: string | null;
    multibookingId?: number | null;
    formattedMultibookingId?: string | null;
    status?: BookingStatus;
    expiredFrom?: BookingStatus;
    customer?: BookingCustomer;
    hasAuthenticationUser?: boolean;
    listingTitle?: string | null;
    from?: Date;
    to?: Date;
    startDate?: Date;
    startTime?: TimeOnly;
    endDate?: Date;
    endTime?: TimeOnly;
    passengers?: number;
    listing?: GetBookingQueryResultListing;
    pricingTemplateGuid?: string | null;
    bookingConflicts?: GetBookingQueryResultBookingConflict[] | null;
    pickupLocation?: LocationResult;
    dropOffLocation?: LocationResult;
    contractStatus?: ContractStatus;
    contractLastSentAt?: Date | null;
    contractSignedAt?: Date | null;
    skipper?: UserResult;
    checkinPerson?: UserResult;
    salesPerson?: GetBookingQueryResultSalesPerson;
    createdBy?: UserResult;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    stewardess?: UserResult[] | null;
    bookingNotes?: BookingNotes;
    superchatUrl?: string | null;
    basePrice?: number;
    rentalPrice?: PricedAmount;
    discountedRentalNetAmount?: number;
    discountedRentalTaxAmount?: number;
    discountedRentalGrossAmount?: number;
    paymentStatus?: BookingPaymentStatus;
    additionalFees?: BookingAdditionalFees;
    totalOnlineCustomerFeeAmount?: number;
    basePriceDiscount?: number;
    discountTypeGuid?: string | null;
    boatOwnerTakeRateAmount?: number | null;
    appliedPromoCode?: BookingAppliedPromoCode;
    appliedCampaign?: BookingAppliedCampaign;
    commissionPercentage?: number;
    commissionAmount?: number;
    priceBreakdown?: BookingPriceBreakdown;
    ownerGuid?: string | null;
    pickupAddress?: OrderingLocationAddress;
    dropOffAddress?: OrderingLocationAddress;
    totalPrice?: number;
    netTotalAmount?: number;
    taxTotalAmount?: number;
    grossTotalAmount?: number;
    totalPaid?: number;
    totalPriceWithCustomerFee?: number;
    outstandingBalanceWithCustomerFee?: number;
    totalOnlineCustomerFeeWithRemaining?: number;
    remainingCustomerFee?: number;
    remainingToPay?: number;
    cancellationDetails?: BookingCancellationDetails;
    packageName?: string | null;
    boatPicture?: BoatPictureResultResult;
    bookingSourceInfo?: BookingSourceInfo;
    hasBoatSpecificationFile?: boolean;
    channelType?: BookingChannelType;
    agent?: BookingAgent;
    brokerGuid?: string | null;
    brokerContact?: BrokerContactResult;
    directChannelGuid?: string | null;
    isAvailableForReservation?: boolean;
    isOfferExpired?: boolean;
    isProformaExpired?: boolean;
    canRecalculatePrice?: boolean;
    proformaAvailabilityBlockExpiresAt?: Date | null;
    offerAvailabilityBlockExpiresAt?: Date | null;
    timeZoneInfoId?: string | null;
    culture?: string | null;
    currency?: string | null;
    cashPaymentLimitAmount?: number | null;
    requestApproved?: boolean | null;
    canProcessPayment?: boolean;
    requiredPrePaymentPercentage?: number | null;
    isPrePaymentOverridden?: boolean;
    prePayment?: PrePaymentInfo;
    marketplaceSessionId?: string | null;
    addons?: BookingAddonDto[] | null;
}

export class GetBookingQueryResultBookingConflict implements IGetBookingQueryResultBookingConflict {
    guid!: string;
    bookingId!: number;

    constructor(data?: IGetBookingQueryResultBookingConflict) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
        }
    }

    static fromJS(data: any): GetBookingQueryResultBookingConflict {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingQueryResultBookingConflict();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        return data;
    }
}

export interface IGetBookingQueryResultBookingConflict {
    guid: string;
    bookingId: number;
}

export class GetBookingQueryResultListing implements IGetBookingQueryResultListing {
    guid?: string;
    boatGuid?: string;
    title?: string | null;
    publishStatus?: PublishStatus;
    boatIdentifier?: string | null;
    market?: MarketResult;
    location?: LocationResult;
    defaultSkipper?: UserResult;
    defaultStewardess?: UserResult;

    constructor(data?: IGetBookingQueryResultListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.boatGuid = _data["boatGuid"];
            this.title = _data["title"];
            this.publishStatus = _data["publishStatus"];
            this.boatIdentifier = _data["boatIdentifier"];
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : <any>null;
            this.location = _data["location"] ? LocationResult.fromJS(_data["location"]) : <any>null;
            this.defaultSkipper = _data["defaultSkipper"] ? UserResult.fromJS(_data["defaultSkipper"]) : <any>null;
            this.defaultStewardess = _data["defaultStewardess"] ? UserResult.fromJS(_data["defaultStewardess"]) : <any>null;
        }
    }

    static fromJS(data: any): GetBookingQueryResultListing {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingQueryResultListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["boatGuid"] = this.boatGuid;
        data["title"] = this.title;
        data["publishStatus"] = this.publishStatus;
        data["boatIdentifier"] = this.boatIdentifier;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["location"] = this.location ? this.location.toJSON() : this.location;
        data["defaultSkipper"] = this.defaultSkipper ? this.defaultSkipper.toJSON() : this.defaultSkipper;
        data["defaultStewardess"] = this.defaultStewardess ? this.defaultStewardess.toJSON() : this.defaultStewardess;
        return data;
    }
}

export interface IGetBookingQueryResultListing {
    guid?: string;
    boatGuid?: string;
    title?: string | null;
    publishStatus?: PublishStatus;
    boatIdentifier?: string | null;
    market?: MarketResult;
    location?: LocationResult;
    defaultSkipper?: UserResult;
    defaultStewardess?: UserResult;
}

export class GetBookingQueryResultSalesPerson implements IGetBookingQueryResultSalesPerson {
    fullName!: string | null;
    guid!: string;
    userGuid!: string;

    constructor(data?: IGetBookingQueryResultSalesPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.guid = _data["guid"];
            this.userGuid = _data["userGuid"];
        }
    }

    static fromJS(data: any): GetBookingQueryResultSalesPerson {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingQueryResultSalesPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["guid"] = this.guid;
        data["userGuid"] = this.userGuid;
        return data;
    }
}

export interface IGetBookingQueryResultSalesPerson {
    fullName: string | null;
    guid: string;
    userGuid: string;
}

export class GetBookingWidgetDomainsQueryResult implements IGetBookingWidgetDomainsQueryResult {
    guid?: string;
    domain?: string | null;
    createdAtUtc?: Date;

    constructor(data?: IGetBookingWidgetDomainsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.domain = _data["domain"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetBookingWidgetDomainsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingWidgetDomainsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["domain"] = this.domain;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        return data;
    }
}

export interface IGetBookingWidgetDomainsQueryResult {
    guid?: string;
    domain?: string | null;
    createdAtUtc?: Date;
}

export class GetBookingWidgetDomainsQueryResultPaginatedResult implements IGetBookingWidgetDomainsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBookingWidgetDomainsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetBookingWidgetDomainsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBookingWidgetDomainsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetBookingWidgetDomainsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingWidgetDomainsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetBookingWidgetDomainsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBookingWidgetDomainsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetBookingsForAvailabilityBookedSlotsQueryResult implements IGetBookingsForAvailabilityBookedSlotsQueryResult {
    guid!: string;
    bookingId!: number;
    from!: Date;
    to!: Date;
    customer!: BookingCustomer;
    skipper!: UserResult;
    totalPrice!: number;
    paymentStatus!: BookingPaymentStatus;
    notes!: BookingNotes;
    listing!: GetBookingsForAvailabilityBookedSlotsQueryResultListing;

    constructor(data?: IGetBookingsForAvailabilityBookedSlotsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customer = new BookingCustomer();
            this.skipper = new UserResult();
            this.notes = new BookingNotes();
            this.listing = new GetBookingsForAvailabilityBookedSlotsQueryResultListing();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
            this.customer = _data["customer"] ? BookingCustomer.fromJS(_data["customer"]) : new BookingCustomer();
            this.skipper = _data["skipper"] ? UserResult.fromJS(_data["skipper"]) : new UserResult();
            this.totalPrice = _data["totalPrice"];
            this.paymentStatus = _data["paymentStatus"];
            this.notes = _data["notes"] ? BookingNotes.fromJS(_data["notes"]) : new BookingNotes();
            this.listing = _data["listing"] ? GetBookingsForAvailabilityBookedSlotsQueryResultListing.fromJS(_data["listing"]) : new GetBookingsForAvailabilityBookedSlotsQueryResultListing();
        }
    }

    static fromJS(data: any): GetBookingsForAvailabilityBookedSlotsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingsForAvailabilityBookedSlotsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        data["from"] = this.from && this.from.toISOString();
        data["to"] = this.to && this.to.toISOString();
        data["customer"] = this.customer ? this.customer.toJSON() : this.customer;
        data["skipper"] = this.skipper ? this.skipper.toJSON() : this.skipper;
        data["totalPrice"] = this.totalPrice;
        data["paymentStatus"] = this.paymentStatus;
        data["notes"] = this.notes ? this.notes.toJSON() : this.notes;
        data["listing"] = this.listing ? this.listing.toJSON() : this.listing;
        return data;
    }
}

export interface IGetBookingsForAvailabilityBookedSlotsQueryResult {
    guid: string;
    bookingId: number;
    from: Date;
    to: Date;
    customer: BookingCustomer;
    skipper: UserResult;
    totalPrice: number;
    paymentStatus: BookingPaymentStatus;
    notes: BookingNotes;
    listing: GetBookingsForAvailabilityBookedSlotsQueryResultListing;
}

export class GetBookingsForAvailabilityBookedSlotsQueryResultListing implements IGetBookingsForAvailabilityBookedSlotsQueryResultListing {
    guid!: string;
    title!: string | null;
    publishStatus!: PublishStatus;
    boatIdentifier!: string | null;
    market!: MarketResult;
    location!: LocationResult;
    defaultSkipper!: UserResult;
    defaultStewardess!: UserResult;
    defaultCheckinPerson!: UserResult;

    constructor(data?: IGetBookingsForAvailabilityBookedSlotsQueryResultListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.market = new MarketResult();
            this.location = new LocationResult();
            this.defaultSkipper = new UserResult();
            this.defaultStewardess = new UserResult();
            this.defaultCheckinPerson = new UserResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.publishStatus = _data["publishStatus"];
            this.boatIdentifier = _data["boatIdentifier"];
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : new MarketResult();
            this.location = _data["location"] ? LocationResult.fromJS(_data["location"]) : new LocationResult();
            this.defaultSkipper = _data["defaultSkipper"] ? UserResult.fromJS(_data["defaultSkipper"]) : new UserResult();
            this.defaultStewardess = _data["defaultStewardess"] ? UserResult.fromJS(_data["defaultStewardess"]) : new UserResult();
            this.defaultCheckinPerson = _data["defaultCheckinPerson"] ? UserResult.fromJS(_data["defaultCheckinPerson"]) : new UserResult();
        }
    }

    static fromJS(data: any): GetBookingsForAvailabilityBookedSlotsQueryResultListing {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingsForAvailabilityBookedSlotsQueryResultListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["publishStatus"] = this.publishStatus;
        data["boatIdentifier"] = this.boatIdentifier;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["location"] = this.location ? this.location.toJSON() : this.location;
        data["defaultSkipper"] = this.defaultSkipper ? this.defaultSkipper.toJSON() : this.defaultSkipper;
        data["defaultStewardess"] = this.defaultStewardess ? this.defaultStewardess.toJSON() : this.defaultStewardess;
        data["defaultCheckinPerson"] = this.defaultCheckinPerson ? this.defaultCheckinPerson.toJSON() : this.defaultCheckinPerson;
        return data;
    }
}

export interface IGetBookingsForAvailabilityBookedSlotsQueryResultListing {
    guid: string;
    title: string | null;
    publishStatus: PublishStatus;
    boatIdentifier: string | null;
    market: MarketResult;
    location: LocationResult;
    defaultSkipper: UserResult;
    defaultStewardess: UserResult;
    defaultCheckinPerson: UserResult;
}

export class GetBookingsForAvailabilityBookedSlotsQueryResultPaginatedResult implements IGetBookingsForAvailabilityBookedSlotsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBookingsForAvailabilityBookedSlotsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetBookingsForAvailabilityBookedSlotsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBookingsForAvailabilityBookedSlotsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetBookingsForAvailabilityBookedSlotsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingsForAvailabilityBookedSlotsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetBookingsForAvailabilityBookedSlotsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBookingsForAvailabilityBookedSlotsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetBookingsQueryResult implements IGetBookingsQueryResult {
    guid?: string;
    bookingId?: number;
    aliasId?: number | null;
    multibookingGuid?: string | null;
    multibookingId?: number | null;
    formattedMultibookingId?: string | null;
    customer?: BookingCustomer;
    totalPrice?: number;
    status?: BookingStatus;
    paymentStatus?: BookingPaymentStatus;
    from?: Date;
    to?: Date;
    boat?: BookingBoat;
    contractStatus?: ContractStatus;
    contractLastSentAt?: Date | null;
    contractSignedAt?: Date | null;
    handoffSentAt?: Date | null;
    offerSentAt?: Date | null;
    pickupLocation?: BookingLocation;
    dropOffLocation?: BookingLocation;
    createdBy?: UserResult;
    listing?: GetBookingsQueryResultListing;
    skipper?: UserResult;
    checkinPerson?: UserResult;
    stewardesses?: UserResult[] | null;
    createdAtUtc?: Date;
    createdAt?: Date;
    updatedAt?: Date | null;
    cancellationDetails?: BookingCancellationDetails;
    promoCode?: string | null;
    basePriceDiscount?: number;
    discountTypeGuid?: string | null;
    sourceInfo?: BookingSourceInfo;
    addonStatus?: BookingAddonSummaryStatus;
    pendingAddonRequestCount?: number;

    constructor(data?: IGetBookingsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
            this.aliasId = _data["aliasId"];
            this.multibookingGuid = _data["multibookingGuid"];
            this.multibookingId = _data["multibookingId"];
            this.formattedMultibookingId = _data["formattedMultibookingId"];
            this.customer = _data["customer"] ? BookingCustomer.fromJS(_data["customer"]) : <any>null;
            this.totalPrice = _data["totalPrice"];
            this.status = _data["status"];
            this.paymentStatus = _data["paymentStatus"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
            this.boat = _data["boat"] ? BookingBoat.fromJS(_data["boat"]) : <any>null;
            this.contractStatus = _data["contractStatus"];
            this.contractLastSentAt = _data["contractLastSentAt"] ? new Date(_data["contractLastSentAt"].toString()) : <any>null;
            this.contractSignedAt = _data["contractSignedAt"] ? new Date(_data["contractSignedAt"].toString()) : <any>null;
            this.handoffSentAt = _data["handoffSentAt"] ? new Date(_data["handoffSentAt"].toString()) : <any>null;
            this.offerSentAt = _data["offerSentAt"] ? new Date(_data["offerSentAt"].toString()) : <any>null;
            this.pickupLocation = _data["pickupLocation"] ? BookingLocation.fromJS(_data["pickupLocation"]) : <any>null;
            this.dropOffLocation = _data["dropOffLocation"] ? BookingLocation.fromJS(_data["dropOffLocation"]) : <any>null;
            this.createdBy = _data["createdBy"] ? UserResult.fromJS(_data["createdBy"]) : <any>null;
            this.listing = _data["listing"] ? GetBookingsQueryResultListing.fromJS(_data["listing"]) : <any>null;
            this.skipper = _data["skipper"] ? UserResult.fromJS(_data["skipper"]) : <any>null;
            this.checkinPerson = _data["checkinPerson"] ? UserResult.fromJS(_data["checkinPerson"]) : <any>null;
            if (Array.isArray(_data["stewardesses"])) {
                this.stewardesses = [] as any;
                for (let item of _data["stewardesses"])
                    this.stewardesses!.push(UserResult.fromJS(item));
            }
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.cancellationDetails = _data["cancellationDetails"] ? BookingCancellationDetails.fromJS(_data["cancellationDetails"]) : <any>null;
            this.promoCode = _data["promoCode"];
            this.basePriceDiscount = _data["basePriceDiscount"];
            this.discountTypeGuid = _data["discountTypeGuid"];
            this.sourceInfo = _data["sourceInfo"] ? BookingSourceInfo.fromJS(_data["sourceInfo"]) : <any>null;
            this.addonStatus = _data["addonStatus"];
            this.pendingAddonRequestCount = _data["pendingAddonRequestCount"];
        }
    }

    static fromJS(data: any): GetBookingsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        data["aliasId"] = this.aliasId;
        data["multibookingGuid"] = this.multibookingGuid;
        data["multibookingId"] = this.multibookingId;
        data["formattedMultibookingId"] = this.formattedMultibookingId;
        data["customer"] = this.customer ? this.customer.toJSON() : this.customer;
        data["totalPrice"] = this.totalPrice;
        data["status"] = this.status;
        data["paymentStatus"] = this.paymentStatus;
        data["from"] = this.from && this.from.toISOString();
        data["to"] = this.to && this.to.toISOString();
        data["boat"] = this.boat ? this.boat.toJSON() : this.boat;
        data["contractStatus"] = this.contractStatus;
        data["contractLastSentAt"] = this.contractLastSentAt && this.contractLastSentAt.toISOString();
        data["contractSignedAt"] = this.contractSignedAt && this.contractSignedAt.toISOString();
        data["handoffSentAt"] = this.handoffSentAt && this.handoffSentAt.toISOString();
        data["offerSentAt"] = this.offerSentAt && this.offerSentAt.toISOString();
        data["pickupLocation"] = this.pickupLocation ? this.pickupLocation.toJSON() : this.pickupLocation;
        data["dropOffLocation"] = this.dropOffLocation ? this.dropOffLocation.toJSON() : this.dropOffLocation;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : this.createdBy;
        data["listing"] = this.listing ? this.listing.toJSON() : this.listing;
        data["skipper"] = this.skipper ? this.skipper.toJSON() : this.skipper;
        data["checkinPerson"] = this.checkinPerson ? this.checkinPerson.toJSON() : this.checkinPerson;
        if (Array.isArray(this.stewardesses)) {
            data["stewardesses"] = [];
            for (let item of this.stewardesses)
                data["stewardesses"].push(item.toJSON());
        }
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        data["cancellationDetails"] = this.cancellationDetails ? this.cancellationDetails.toJSON() : this.cancellationDetails;
        data["promoCode"] = this.promoCode;
        data["basePriceDiscount"] = this.basePriceDiscount;
        data["discountTypeGuid"] = this.discountTypeGuid;
        data["sourceInfo"] = this.sourceInfo ? this.sourceInfo.toJSON() : this.sourceInfo;
        data["addonStatus"] = this.addonStatus;
        data["pendingAddonRequestCount"] = this.pendingAddonRequestCount;
        return data;
    }
}

export interface IGetBookingsQueryResult {
    guid?: string;
    bookingId?: number;
    aliasId?: number | null;
    multibookingGuid?: string | null;
    multibookingId?: number | null;
    formattedMultibookingId?: string | null;
    customer?: BookingCustomer;
    totalPrice?: number;
    status?: BookingStatus;
    paymentStatus?: BookingPaymentStatus;
    from?: Date;
    to?: Date;
    boat?: BookingBoat;
    contractStatus?: ContractStatus;
    contractLastSentAt?: Date | null;
    contractSignedAt?: Date | null;
    handoffSentAt?: Date | null;
    offerSentAt?: Date | null;
    pickupLocation?: BookingLocation;
    dropOffLocation?: BookingLocation;
    createdBy?: UserResult;
    listing?: GetBookingsQueryResultListing;
    skipper?: UserResult;
    checkinPerson?: UserResult;
    stewardesses?: UserResult[] | null;
    createdAtUtc?: Date;
    createdAt?: Date;
    updatedAt?: Date | null;
    cancellationDetails?: BookingCancellationDetails;
    promoCode?: string | null;
    basePriceDiscount?: number;
    discountTypeGuid?: string | null;
    sourceInfo?: BookingSourceInfo;
    addonStatus?: BookingAddonSummaryStatus;
    pendingAddonRequestCount?: number;
}

export class GetBookingsQueryResultListing implements IGetBookingsQueryResultListing {
    guid?: string;
    title?: string | null;
    boatIdentifier?: string | null;
    marketGuid?: string;
    marketCode?: string | null;
    marketTitle?: string | null;

    constructor(data?: IGetBookingsQueryResultListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.boatIdentifier = _data["boatIdentifier"];
            this.marketGuid = _data["marketGuid"];
            this.marketCode = _data["marketCode"];
            this.marketTitle = _data["marketTitle"];
        }
    }

    static fromJS(data: any): GetBookingsQueryResultListing {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingsQueryResultListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["boatIdentifier"] = this.boatIdentifier;
        data["marketGuid"] = this.marketGuid;
        data["marketCode"] = this.marketCode;
        data["marketTitle"] = this.marketTitle;
        return data;
    }
}

export interface IGetBookingsQueryResultListing {
    guid?: string;
    title?: string | null;
    boatIdentifier?: string | null;
    marketGuid?: string;
    marketCode?: string | null;
    marketTitle?: string | null;
}

export class GetBookingsQueryResultPaginatedResult implements IGetBookingsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetBookingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetBookingsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBookingsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetBookingsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookingsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetBookingsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetBookingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetCalendarBookingsQueryResult implements IGetCalendarBookingsQueryResult {
    guid!: string;
    bookingId!: number;
    totalPrice!: number;
    customer!: BookingCustomer;
    status!: BookingStatus;
    paymentStatus!: BookingPaymentStatus;
    createdBy!: UserResult;
    createdAt!: Date;
    from!: Date;
    to!: Date;
    pickupLocation!: LocationResult;
    dropOffLocation!: LocationResult;
    bookingNotes!: BookingNotes;
    listing!: GetCalendarBookingsQueryResultListing;
    skipper!: UserResult;
    checkinPerson!: UserResult;
    contract!: CalendarBookingContractInfo;
    stewardesses!: UserResult[] | null;
    bookingSourceInfo!: BookingSourceInfo;
    bookingConflicts!: GetCalendarBookingsQueryResultBookingConflicts[] | null;

    constructor(data?: IGetCalendarBookingsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customer = new BookingCustomer();
            this.createdBy = new UserResult();
            this.pickupLocation = new LocationResult();
            this.dropOffLocation = new LocationResult();
            this.bookingNotes = new BookingNotes();
            this.listing = new GetCalendarBookingsQueryResultListing();
            this.skipper = new UserResult();
            this.checkinPerson = new UserResult();
            this.contract = new CalendarBookingContractInfo();
            this.bookingSourceInfo = new BookingSourceInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
            this.totalPrice = _data["totalPrice"];
            this.customer = _data["customer"] ? BookingCustomer.fromJS(_data["customer"]) : new BookingCustomer();
            this.status = _data["status"];
            this.paymentStatus = _data["paymentStatus"];
            this.createdBy = _data["createdBy"] ? UserResult.fromJS(_data["createdBy"]) : new UserResult();
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
            this.pickupLocation = _data["pickupLocation"] ? LocationResult.fromJS(_data["pickupLocation"]) : new LocationResult();
            this.dropOffLocation = _data["dropOffLocation"] ? LocationResult.fromJS(_data["dropOffLocation"]) : new LocationResult();
            this.bookingNotes = _data["bookingNotes"] ? BookingNotes.fromJS(_data["bookingNotes"]) : new BookingNotes();
            this.listing = _data["listing"] ? GetCalendarBookingsQueryResultListing.fromJS(_data["listing"]) : new GetCalendarBookingsQueryResultListing();
            this.skipper = _data["skipper"] ? UserResult.fromJS(_data["skipper"]) : new UserResult();
            this.checkinPerson = _data["checkinPerson"] ? UserResult.fromJS(_data["checkinPerson"]) : new UserResult();
            this.contract = _data["contract"] ? CalendarBookingContractInfo.fromJS(_data["contract"]) : new CalendarBookingContractInfo();
            if (Array.isArray(_data["stewardesses"])) {
                this.stewardesses = [] as any;
                for (let item of _data["stewardesses"])
                    this.stewardesses!.push(UserResult.fromJS(item));
            }
            this.bookingSourceInfo = _data["bookingSourceInfo"] ? BookingSourceInfo.fromJS(_data["bookingSourceInfo"]) : new BookingSourceInfo();
            if (Array.isArray(_data["bookingConflicts"])) {
                this.bookingConflicts = [] as any;
                for (let item of _data["bookingConflicts"])
                    this.bookingConflicts!.push(GetCalendarBookingsQueryResultBookingConflicts.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCalendarBookingsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarBookingsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        data["totalPrice"] = this.totalPrice;
        data["customer"] = this.customer ? this.customer.toJSON() : this.customer;
        data["status"] = this.status;
        data["paymentStatus"] = this.paymentStatus;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : this.createdBy;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["from"] = this.from && this.from.toISOString();
        data["to"] = this.to && this.to.toISOString();
        data["pickupLocation"] = this.pickupLocation ? this.pickupLocation.toJSON() : this.pickupLocation;
        data["dropOffLocation"] = this.dropOffLocation ? this.dropOffLocation.toJSON() : this.dropOffLocation;
        data["bookingNotes"] = this.bookingNotes ? this.bookingNotes.toJSON() : this.bookingNotes;
        data["listing"] = this.listing ? this.listing.toJSON() : this.listing;
        data["skipper"] = this.skipper ? this.skipper.toJSON() : this.skipper;
        data["checkinPerson"] = this.checkinPerson ? this.checkinPerson.toJSON() : this.checkinPerson;
        data["contract"] = this.contract ? this.contract.toJSON() : this.contract;
        if (Array.isArray(this.stewardesses)) {
            data["stewardesses"] = [];
            for (let item of this.stewardesses)
                data["stewardesses"].push(item.toJSON());
        }
        data["bookingSourceInfo"] = this.bookingSourceInfo ? this.bookingSourceInfo.toJSON() : this.bookingSourceInfo;
        if (Array.isArray(this.bookingConflicts)) {
            data["bookingConflicts"] = [];
            for (let item of this.bookingConflicts)
                data["bookingConflicts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCalendarBookingsQueryResult {
    guid: string;
    bookingId: number;
    totalPrice: number;
    customer: BookingCustomer;
    status: BookingStatus;
    paymentStatus: BookingPaymentStatus;
    createdBy: UserResult;
    createdAt: Date;
    from: Date;
    to: Date;
    pickupLocation: LocationResult;
    dropOffLocation: LocationResult;
    bookingNotes: BookingNotes;
    listing: GetCalendarBookingsQueryResultListing;
    skipper: UserResult;
    checkinPerson: UserResult;
    contract: CalendarBookingContractInfo;
    stewardesses: UserResult[] | null;
    bookingSourceInfo: BookingSourceInfo;
    bookingConflicts: GetCalendarBookingsQueryResultBookingConflicts[] | null;
}

export class GetCalendarBookingsQueryResultBookingConflicts implements IGetCalendarBookingsQueryResultBookingConflicts {
    guid?: string;
    bookingId?: number;

    constructor(data?: IGetCalendarBookingsQueryResultBookingConflicts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
        }
    }

    static fromJS(data: any): GetCalendarBookingsQueryResultBookingConflicts {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarBookingsQueryResultBookingConflicts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        return data;
    }
}

export interface IGetCalendarBookingsQueryResultBookingConflicts {
    guid?: string;
    bookingId?: number;
}

export class GetCalendarBookingsQueryResultListing implements IGetCalendarBookingsQueryResultListing {
    title!: string | null;
    publishStatus!: PublishStatus;
    boatIdentifier!: string | null;
    market!: MarketResult;
    location!: LocationResult;
    defaultSkipper!: UserResult;
    defaultStewardess!: UserResult;

    constructor(data?: IGetCalendarBookingsQueryResultListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.market = new MarketResult();
            this.location = new LocationResult();
            this.defaultSkipper = new UserResult();
            this.defaultStewardess = new UserResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.publishStatus = _data["publishStatus"];
            this.boatIdentifier = _data["boatIdentifier"];
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : new MarketResult();
            this.location = _data["location"] ? LocationResult.fromJS(_data["location"]) : new LocationResult();
            this.defaultSkipper = _data["defaultSkipper"] ? UserResult.fromJS(_data["defaultSkipper"]) : new UserResult();
            this.defaultStewardess = _data["defaultStewardess"] ? UserResult.fromJS(_data["defaultStewardess"]) : new UserResult();
        }
    }

    static fromJS(data: any): GetCalendarBookingsQueryResultListing {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarBookingsQueryResultListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["publishStatus"] = this.publishStatus;
        data["boatIdentifier"] = this.boatIdentifier;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["location"] = this.location ? this.location.toJSON() : this.location;
        data["defaultSkipper"] = this.defaultSkipper ? this.defaultSkipper.toJSON() : this.defaultSkipper;
        data["defaultStewardess"] = this.defaultStewardess ? this.defaultStewardess.toJSON() : this.defaultStewardess;
        return data;
    }
}

export interface IGetCalendarBookingsQueryResultListing {
    title: string | null;
    publishStatus: PublishStatus;
    boatIdentifier: string | null;
    market: MarketResult;
    location: LocationResult;
    defaultSkipper: UserResult;
    defaultStewardess: UserResult;
}

export class GetCalendarDayPricingsQueryResult implements IGetCalendarDayPricingsQueryResult {
    listingTitle?: string | null;
    dayPackagePrices?: DayPackagePrice[] | null;

    constructor(data?: IGetCalendarDayPricingsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingTitle = _data["listingTitle"];
            if (Array.isArray(_data["dayPackagePrices"])) {
                this.dayPackagePrices = [] as any;
                for (let item of _data["dayPackagePrices"])
                    this.dayPackagePrices!.push(DayPackagePrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCalendarDayPricingsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarDayPricingsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingTitle"] = this.listingTitle;
        if (Array.isArray(this.dayPackagePrices)) {
            data["dayPackagePrices"] = [];
            for (let item of this.dayPackagePrices)
                data["dayPackagePrices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCalendarDayPricingsQueryResult {
    listingTitle?: string | null;
    dayPackagePrices?: DayPackagePrice[] | null;
}

export class GetCalendarDaysQueryResult implements IGetCalendarDaysQueryResult {
    day?: Date;
    availability?: CalendarDayAvailability;

    constructor(data?: IGetCalendarDaysQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"] ? parseDateOnly(_data["day"].toString()) : <any>null;
            this.availability = _data["availability"];
        }
    }

    static fromJS(data: any): GetCalendarDaysQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarDaysQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day && formatDate(this.day);
        data["availability"] = this.availability;
        return data;
    }
}

export interface IGetCalendarDaysQueryResult {
    day?: Date;
    availability?: CalendarDayAvailability;
}

export class GetCalendarPricingQueryResult implements IGetCalendarPricingQueryResult {
    calendarPricingGuid?: string | null;
    listingGuid?: string;
    seasonPrices?: SeasonPriceDto[] | null;
    customDayPrices?: CustomDayPriceDto[] | null;
    seasonFees?: SeasonFeesDto[] | null;

    constructor(data?: IGetCalendarPricingQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calendarPricingGuid = _data["calendarPricingGuid"];
            this.listingGuid = _data["listingGuid"];
            if (Array.isArray(_data["seasonPrices"])) {
                this.seasonPrices = [] as any;
                for (let item of _data["seasonPrices"])
                    this.seasonPrices!.push(SeasonPriceDto.fromJS(item));
            }
            if (Array.isArray(_data["customDayPrices"])) {
                this.customDayPrices = [] as any;
                for (let item of _data["customDayPrices"])
                    this.customDayPrices!.push(CustomDayPriceDto.fromJS(item));
            }
            if (Array.isArray(_data["seasonFees"])) {
                this.seasonFees = [] as any;
                for (let item of _data["seasonFees"])
                    this.seasonFees!.push(SeasonFeesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCalendarPricingQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarPricingQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarPricingGuid"] = this.calendarPricingGuid;
        data["listingGuid"] = this.listingGuid;
        if (Array.isArray(this.seasonPrices)) {
            data["seasonPrices"] = [];
            for (let item of this.seasonPrices)
                data["seasonPrices"].push(item.toJSON());
        }
        if (Array.isArray(this.customDayPrices)) {
            data["customDayPrices"] = [];
            for (let item of this.customDayPrices)
                data["customDayPrices"].push(item.toJSON());
        }
        if (Array.isArray(this.seasonFees)) {
            data["seasonFees"] = [];
            for (let item of this.seasonFees)
                data["seasonFees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCalendarPricingQueryResult {
    calendarPricingGuid?: string | null;
    listingGuid?: string;
    seasonPrices?: SeasonPriceDto[] | null;
    customDayPrices?: CustomDayPriceDto[] | null;
    seasonFees?: SeasonFeesDto[] | null;
}

export class GetCalendarRecalculationStatusQueryResult implements IGetCalendarRecalculationStatusQueryResult {
    marketGuid?: string;
    state?: RecalculationState;
    startedAt?: Date | null;
    completedAt?: Date | null;
    errorMessage?: string | null;
    totalListings?: number | null;
    processedListings?: number | null;
    progressPercent?: number | null;
    listingStatuses?: ListingRecalculationStatusDto[] | null;

    constructor(data?: IGetCalendarRecalculationStatusQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marketGuid = _data["marketGuid"];
            this.state = _data["state"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>null;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>null;
            this.errorMessage = _data["errorMessage"];
            this.totalListings = _data["totalListings"];
            this.processedListings = _data["processedListings"];
            this.progressPercent = _data["progressPercent"];
            if (Array.isArray(_data["listingStatuses"])) {
                this.listingStatuses = [] as any;
                for (let item of _data["listingStatuses"])
                    this.listingStatuses!.push(ListingRecalculationStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCalendarRecalculationStatusQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarRecalculationStatusQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketGuid"] = this.marketGuid;
        data["state"] = this.state;
        data["startedAt"] = this.startedAt && this.startedAt.toISOString();
        data["completedAt"] = this.completedAt && this.completedAt.toISOString();
        data["errorMessage"] = this.errorMessage;
        data["totalListings"] = this.totalListings;
        data["processedListings"] = this.processedListings;
        data["progressPercent"] = this.progressPercent;
        if (Array.isArray(this.listingStatuses)) {
            data["listingStatuses"] = [];
            for (let item of this.listingStatuses)
                data["listingStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCalendarRecalculationStatusQueryResult {
    marketGuid?: string;
    state?: RecalculationState;
    startedAt?: Date | null;
    completedAt?: Date | null;
    errorMessage?: string | null;
    totalListings?: number | null;
    processedListings?: number | null;
    progressPercent?: number | null;
    listingStatuses?: ListingRecalculationStatusDto[] | null;
}

export class GetCampaignCommissionPayoutTotalsQueryResult implements IGetCampaignCommissionPayoutTotalsQueryResult {
    totalAmount?: number;

    constructor(data?: IGetCampaignCommissionPayoutTotalsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): GetCampaignCommissionPayoutTotalsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignCommissionPayoutTotalsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IGetCampaignCommissionPayoutTotalsQueryResult {
    totalAmount?: number;
}

export class GetCampaignCommissionPayoutsQueryResult implements IGetCampaignCommissionPayoutsQueryResult {
    guid?: string;
    bookingId!: number;
    bookingGuid!: string;
    bookingTotalPrice!: number;
    bookingStart!: Date;
    commissionAmount!: number;
    customerDiscountAmount!: number;
    commissionType!: CampaignComissionType;
    isPaid!: boolean;
    paidAt?: Date | null;
    customerName!: string | null;
    customerEmail!: string | null;

    constructor(data?: IGetCampaignCommissionPayoutsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
            this.bookingGuid = _data["bookingGuid"];
            this.bookingTotalPrice = _data["bookingTotalPrice"];
            this.bookingStart = _data["bookingStart"] ? new Date(_data["bookingStart"].toString()) : <any>null;
            this.commissionAmount = _data["commissionAmount"];
            this.customerDiscountAmount = _data["customerDiscountAmount"];
            this.commissionType = _data["commissionType"];
            this.isPaid = _data["isPaid"];
            this.paidAt = _data["paidAt"] ? new Date(_data["paidAt"].toString()) : <any>null;
            this.customerName = _data["customerName"];
            this.customerEmail = _data["customerEmail"];
        }
    }

    static fromJS(data: any): GetCampaignCommissionPayoutsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignCommissionPayoutsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        data["bookingGuid"] = this.bookingGuid;
        data["bookingTotalPrice"] = this.bookingTotalPrice;
        data["bookingStart"] = this.bookingStart && this.bookingStart.toISOString();
        data["commissionAmount"] = this.commissionAmount;
        data["customerDiscountAmount"] = this.customerDiscountAmount;
        data["commissionType"] = this.commissionType;
        data["isPaid"] = this.isPaid;
        data["paidAt"] = this.paidAt && this.paidAt.toISOString();
        data["customerName"] = this.customerName;
        data["customerEmail"] = this.customerEmail;
        return data;
    }
}

export interface IGetCampaignCommissionPayoutsQueryResult {
    guid?: string;
    bookingId: number;
    bookingGuid: string;
    bookingTotalPrice: number;
    bookingStart: Date;
    commissionAmount: number;
    customerDiscountAmount: number;
    commissionType: CampaignComissionType;
    isPaid: boolean;
    paidAt?: Date | null;
    customerName: string | null;
    customerEmail: string | null;
}

export class GetCampaignCommissionPayoutsQueryResultPaginatedResult implements IGetCampaignCommissionPayoutsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetCampaignCommissionPayoutsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetCampaignCommissionPayoutsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCampaignCommissionPayoutsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetCampaignCommissionPayoutsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignCommissionPayoutsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetCampaignCommissionPayoutsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetCampaignCommissionPayoutsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetCampaignUrlsQueryResult implements IGetCampaignUrlsQueryResult {
    guid?: string;
    url?: string | null;
    description?: string | null;
    createdAtUtc?: Date;

    constructor(data?: IGetCampaignUrlsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetCampaignUrlsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignUrlsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["url"] = this.url;
        data["description"] = this.description;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        return data;
    }
}

export interface IGetCampaignUrlsQueryResult {
    guid?: string;
    url?: string | null;
    description?: string | null;
    createdAtUtc?: Date;
}

export class GetChannelsQueryResult implements IGetChannelsQueryResult {
    guid?: string;
    name?: string | null;
    type?: ChannelType;
    isActive?: boolean;
    email?: string | null;
    phoneNumber?: string | null;
    notes?: string | null;
    clicks?: number;
    conversions?: number;
    rate?: number;
    revenue?: number;
    cost?: number;
    campaigns?: ChannelCampaingsResult[] | null;

    constructor(data?: IGetChannelsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.isActive = _data["isActive"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.notes = _data["notes"];
            this.clicks = _data["clicks"];
            this.conversions = _data["conversions"];
            this.rate = _data["rate"];
            this.revenue = _data["revenue"];
            this.cost = _data["cost"];
            if (Array.isArray(_data["campaigns"])) {
                this.campaigns = [] as any;
                for (let item of _data["campaigns"])
                    this.campaigns!.push(ChannelCampaingsResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetChannelsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetChannelsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["type"] = this.type;
        data["isActive"] = this.isActive;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["notes"] = this.notes;
        data["clicks"] = this.clicks;
        data["conversions"] = this.conversions;
        data["rate"] = this.rate;
        data["revenue"] = this.revenue;
        data["cost"] = this.cost;
        if (Array.isArray(this.campaigns)) {
            data["campaigns"] = [];
            for (let item of this.campaigns)
                data["campaigns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetChannelsQueryResult {
    guid?: string;
    name?: string | null;
    type?: ChannelType;
    isActive?: boolean;
    email?: string | null;
    phoneNumber?: string | null;
    notes?: string | null;
    clicks?: number;
    conversions?: number;
    rate?: number;
    revenue?: number;
    cost?: number;
    campaigns?: ChannelCampaingsResult[] | null;
}

export class GetChannelsQueryResultPaginatedResult implements IGetChannelsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetChannelsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetChannelsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetChannelsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetChannelsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetChannelsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetChannelsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetChannelsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetCheckinPersonQueryResult implements IGetCheckinPersonQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;

    constructor(data?: IGetCheckinPersonQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.isDisabled = _data["isDisabled"];
            this.userGuid = _data["userGuid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetCheckinPersonQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCheckinPersonQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isDisabled"] = this.isDisabled;
        data["userGuid"] = this.userGuid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetCheckinPersonQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
}

export class GetCheckinPersonsQueryResult implements IGetCheckinPersonsQueryResult {
    guid!: string;
    isDisabled?: boolean;
    userGuid!: string;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
    assignedListings?: CheckinPersonAssignedListing[] | null;

    constructor(data?: IGetCheckinPersonsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.isDisabled = _data["isDisabled"];
            this.userGuid = _data["userGuid"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            if (Array.isArray(_data["assignedListings"])) {
                this.assignedListings = [] as any;
                for (let item of _data["assignedListings"])
                    this.assignedListings!.push(CheckinPersonAssignedListing.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCheckinPersonsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCheckinPersonsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isDisabled"] = this.isDisabled;
        data["userGuid"] = this.userGuid;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        if (Array.isArray(this.assignedListings)) {
            data["assignedListings"] = [];
            for (let item of this.assignedListings)
                data["assignedListings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCheckinPersonsQueryResult {
    guid: string;
    isDisabled?: boolean;
    userGuid: string;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
    assignedListings?: CheckinPersonAssignedListing[] | null;
}

export class GetCheckinPersonsQueryResultPaginatedResult implements IGetCheckinPersonsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetCheckinPersonsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetCheckinPersonsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCheckinPersonsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetCheckinPersonsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCheckinPersonsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetCheckinPersonsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetCheckinPersonsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetContractsByBookingGuidQueryResult implements IGetContractsByBookingGuidQueryResult {
    guid?: string;
    contractId?: string | null;
    recipientEmail?: string | null;
    recipientName?: string | null;
    createdAt?: Date;
    sentBy?: ContractUser;
    lastSentAt?: Date | null;
    signedAt?: Date | null;
    status?: ContractStatus;
    isCurrent?: boolean;
    providerType?: ContractProviderType;
    booking?: ContractBooking;
    customer?: ContractCustomer;
    skipper?: ContractSkipper;
    pickupLocation?: ContractLocation;
    dropoffLocation?: ContractLocation;
    sendInfos?: ContractSendInfo[] | null;

    constructor(data?: IGetContractsByBookingGuidQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.contractId = _data["contractId"];
            this.recipientEmail = _data["recipientEmail"];
            this.recipientName = _data["recipientName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.sentBy = _data["sentBy"] ? ContractUser.fromJS(_data["sentBy"]) : <any>null;
            this.lastSentAt = _data["lastSentAt"] ? new Date(_data["lastSentAt"].toString()) : <any>null;
            this.signedAt = _data["signedAt"] ? new Date(_data["signedAt"].toString()) : <any>null;
            this.status = _data["status"];
            this.isCurrent = _data["isCurrent"];
            this.providerType = _data["providerType"];
            this.booking = _data["booking"] ? ContractBooking.fromJS(_data["booking"]) : <any>null;
            this.customer = _data["customer"] ? ContractCustomer.fromJS(_data["customer"]) : <any>null;
            this.skipper = _data["skipper"] ? ContractSkipper.fromJS(_data["skipper"]) : <any>null;
            this.pickupLocation = _data["pickupLocation"] ? ContractLocation.fromJS(_data["pickupLocation"]) : <any>null;
            this.dropoffLocation = _data["dropoffLocation"] ? ContractLocation.fromJS(_data["dropoffLocation"]) : <any>null;
            if (Array.isArray(_data["sendInfos"])) {
                this.sendInfos = [] as any;
                for (let item of _data["sendInfos"])
                    this.sendInfos!.push(ContractSendInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetContractsByBookingGuidQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetContractsByBookingGuidQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["contractId"] = this.contractId;
        data["recipientEmail"] = this.recipientEmail;
        data["recipientName"] = this.recipientName;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["sentBy"] = this.sentBy ? this.sentBy.toJSON() : this.sentBy;
        data["lastSentAt"] = this.lastSentAt && this.lastSentAt.toISOString();
        data["signedAt"] = this.signedAt && this.signedAt.toISOString();
        data["status"] = this.status;
        data["isCurrent"] = this.isCurrent;
        data["providerType"] = this.providerType;
        data["booking"] = this.booking ? this.booking.toJSON() : this.booking;
        data["customer"] = this.customer ? this.customer.toJSON() : this.customer;
        data["skipper"] = this.skipper ? this.skipper.toJSON() : this.skipper;
        data["pickupLocation"] = this.pickupLocation ? this.pickupLocation.toJSON() : this.pickupLocation;
        data["dropoffLocation"] = this.dropoffLocation ? this.dropoffLocation.toJSON() : this.dropoffLocation;
        if (Array.isArray(this.sendInfos)) {
            data["sendInfos"] = [];
            for (let item of this.sendInfos)
                data["sendInfos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetContractsByBookingGuidQueryResult {
    guid?: string;
    contractId?: string | null;
    recipientEmail?: string | null;
    recipientName?: string | null;
    createdAt?: Date;
    sentBy?: ContractUser;
    lastSentAt?: Date | null;
    signedAt?: Date | null;
    status?: ContractStatus;
    isCurrent?: boolean;
    providerType?: ContractProviderType;
    booking?: ContractBooking;
    customer?: ContractCustomer;
    skipper?: ContractSkipper;
    pickupLocation?: ContractLocation;
    dropoffLocation?: ContractLocation;
    sendInfos?: ContractSendInfo[] | null;
}

export class GetContractsByBookingGuidQueryResultPaginatedResult implements IGetContractsByBookingGuidQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetContractsByBookingGuidQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetContractsByBookingGuidQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetContractsByBookingGuidQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetContractsByBookingGuidQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetContractsByBookingGuidQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetContractsByBookingGuidQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetContractsByBookingGuidQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetCustomerBalanceActivitiesResult implements IGetCustomerBalanceActivitiesResult {
    guid?: string;
    paidOn?: Date;
    createdAt?: Date;
    type?: BalanceAccountActivityType;
    amount?: number;
    createdByFullName?: string | null;
    target?: BalanceAccountOwnerType;
    movementType?: BalanceActivityMovementType;
    bookingId?: number | null;
    bookingGuid?: string | null;
    bookingStartDateTime?: Date | null;
    balanceAfter?: number;
    note?: string | null;
    paymentGuid?: string | null;
    provider?: PaymentProvider;
    externalPaymentMethodGuid?: string | null;
    externalPaymentMethodCode?: string | null;
    stripePaymentMethodType?: string | null;

    constructor(data?: IGetCustomerBalanceActivitiesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.paidOn = _data["paidOn"] ? new Date(_data["paidOn"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.type = _data["type"];
            this.amount = _data["amount"];
            this.createdByFullName = _data["createdByFullName"];
            this.target = _data["target"];
            this.movementType = _data["movementType"];
            this.bookingId = _data["bookingId"];
            this.bookingGuid = _data["bookingGuid"];
            this.bookingStartDateTime = _data["bookingStartDateTime"] ? new Date(_data["bookingStartDateTime"].toString()) : <any>null;
            this.balanceAfter = _data["balanceAfter"];
            this.note = _data["note"];
            this.paymentGuid = _data["paymentGuid"];
            this.provider = _data["provider"];
            this.externalPaymentMethodGuid = _data["externalPaymentMethodGuid"];
            this.externalPaymentMethodCode = _data["externalPaymentMethodCode"];
            this.stripePaymentMethodType = _data["stripePaymentMethodType"];
        }
    }

    static fromJS(data: any): GetCustomerBalanceActivitiesResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerBalanceActivitiesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["paidOn"] = this.paidOn && this.paidOn.toISOString();
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["type"] = this.type;
        data["amount"] = this.amount;
        data["createdByFullName"] = this.createdByFullName;
        data["target"] = this.target;
        data["movementType"] = this.movementType;
        data["bookingId"] = this.bookingId;
        data["bookingGuid"] = this.bookingGuid;
        data["bookingStartDateTime"] = this.bookingStartDateTime && this.bookingStartDateTime.toISOString();
        data["balanceAfter"] = this.balanceAfter;
        data["note"] = this.note;
        data["paymentGuid"] = this.paymentGuid;
        data["provider"] = this.provider;
        data["externalPaymentMethodGuid"] = this.externalPaymentMethodGuid;
        data["externalPaymentMethodCode"] = this.externalPaymentMethodCode;
        data["stripePaymentMethodType"] = this.stripePaymentMethodType;
        return data;
    }
}

export interface IGetCustomerBalanceActivitiesResult {
    guid?: string;
    paidOn?: Date;
    createdAt?: Date;
    type?: BalanceAccountActivityType;
    amount?: number;
    createdByFullName?: string | null;
    target?: BalanceAccountOwnerType;
    movementType?: BalanceActivityMovementType;
    bookingId?: number | null;
    bookingGuid?: string | null;
    bookingStartDateTime?: Date | null;
    balanceAfter?: number;
    note?: string | null;
    paymentGuid?: string | null;
    provider?: PaymentProvider;
    externalPaymentMethodGuid?: string | null;
    externalPaymentMethodCode?: string | null;
    stripePaymentMethodType?: string | null;
}

export class GetCustomerBalanceActivitiesResultPaginatedResult implements IGetCustomerBalanceActivitiesResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetCustomerBalanceActivitiesResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetCustomerBalanceActivitiesResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCustomerBalanceActivitiesResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetCustomerBalanceActivitiesResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerBalanceActivitiesResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetCustomerBalanceActivitiesResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetCustomerBalanceActivitiesResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetCustomerBalanceQueryResult implements IGetCustomerBalanceQueryResult {
    balance?: number;

    constructor(data?: IGetCustomerBalanceQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balance = _data["balance"];
        }
    }

    static fromJS(data: any): GetCustomerBalanceQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerBalanceQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        return data;
    }
}

export interface IGetCustomerBalanceQueryResult {
    balance?: number;
}

export class GetCustomerBookingHistoryQueryResult implements IGetCustomerBookingHistoryQueryResult {
    guid!: string;
    bookingId!: number;
    totalPrice!: number;
    from!: Date;
    to!: Date;
    status!: BookingStatus;
    boat!: GetCustomerBookingHistoryQueryResultBoat;
    listing!: GetCustomerBookingHistoryQueryResultListing;
    skipper!: UserResult;
    multibookingGuid!: string | null;

    constructor(data?: IGetCustomerBookingHistoryQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boat = new GetCustomerBookingHistoryQueryResultBoat();
            this.listing = new GetCustomerBookingHistoryQueryResultListing();
            this.skipper = new UserResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
            this.totalPrice = _data["totalPrice"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
            this.status = _data["status"];
            this.boat = _data["boat"] ? GetCustomerBookingHistoryQueryResultBoat.fromJS(_data["boat"]) : new GetCustomerBookingHistoryQueryResultBoat();
            this.listing = _data["listing"] ? GetCustomerBookingHistoryQueryResultListing.fromJS(_data["listing"]) : new GetCustomerBookingHistoryQueryResultListing();
            this.skipper = _data["skipper"] ? UserResult.fromJS(_data["skipper"]) : new UserResult();
            this.multibookingGuid = _data["multibookingGuid"];
        }
    }

    static fromJS(data: any): GetCustomerBookingHistoryQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerBookingHistoryQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        data["totalPrice"] = this.totalPrice;
        data["from"] = this.from && this.from.toISOString();
        data["to"] = this.to && this.to.toISOString();
        data["status"] = this.status;
        data["boat"] = this.boat ? this.boat.toJSON() : this.boat;
        data["listing"] = this.listing ? this.listing.toJSON() : this.listing;
        data["skipper"] = this.skipper ? this.skipper.toJSON() : this.skipper;
        data["multibookingGuid"] = this.multibookingGuid;
        return data;
    }
}

export interface IGetCustomerBookingHistoryQueryResult {
    guid: string;
    bookingId: number;
    totalPrice: number;
    from: Date;
    to: Date;
    status: BookingStatus;
    boat: GetCustomerBookingHistoryQueryResultBoat;
    listing: GetCustomerBookingHistoryQueryResultListing;
    skipper: UserResult;
    multibookingGuid: string | null;
}

export class GetCustomerBookingHistoryQueryResultBoat implements IGetCustomerBookingHistoryQueryResultBoat {
    guid!: string;
    defaultListingTitle!: string | null;
    registeredName!: string | null;
    passengers!: number | null;
    length!: number | null;
    isDeleted!: boolean;
    sortPriority!: number | null;
    isComplete!: boolean;
    bathroomsCount!: number | null;
    crewCapacity!: number | null;
    boatOwner!: UserResult;

    constructor(data?: IGetCustomerBookingHistoryQueryResultBoat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boatOwner = new UserResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.defaultListingTitle = _data["defaultListingTitle"];
            this.registeredName = _data["registeredName"];
            this.passengers = _data["passengers"];
            this.length = _data["length"];
            this.isDeleted = _data["isDeleted"];
            this.sortPriority = _data["sortPriority"];
            this.isComplete = _data["isComplete"];
            this.bathroomsCount = _data["bathroomsCount"];
            this.crewCapacity = _data["crewCapacity"];
            this.boatOwner = _data["boatOwner"] ? UserResult.fromJS(_data["boatOwner"]) : new UserResult();
        }
    }

    static fromJS(data: any): GetCustomerBookingHistoryQueryResultBoat {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerBookingHistoryQueryResultBoat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["defaultListingTitle"] = this.defaultListingTitle;
        data["registeredName"] = this.registeredName;
        data["passengers"] = this.passengers;
        data["length"] = this.length;
        data["isDeleted"] = this.isDeleted;
        data["sortPriority"] = this.sortPriority;
        data["isComplete"] = this.isComplete;
        data["bathroomsCount"] = this.bathroomsCount;
        data["crewCapacity"] = this.crewCapacity;
        data["boatOwner"] = this.boatOwner ? this.boatOwner.toJSON() : this.boatOwner;
        return data;
    }
}

export interface IGetCustomerBookingHistoryQueryResultBoat {
    guid: string;
    defaultListingTitle: string | null;
    registeredName: string | null;
    passengers: number | null;
    length: number | null;
    isDeleted: boolean;
    sortPriority: number | null;
    isComplete: boolean;
    bathroomsCount: number | null;
    crewCapacity: number | null;
    boatOwner: UserResult;
}

export class GetCustomerBookingHistoryQueryResultListing implements IGetCustomerBookingHistoryQueryResultListing {
    title!: string | null;
    publishStatus!: PublishStatus;
    boatIdentifier!: string | null;
    market!: MarketResult;
    location!: LocationResult;
    defaultSkipper!: UserResult;
    defaultStewardess!: UserResult;

    constructor(data?: IGetCustomerBookingHistoryQueryResultListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.market = new MarketResult();
            this.location = new LocationResult();
            this.defaultSkipper = new UserResult();
            this.defaultStewardess = new UserResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.publishStatus = _data["publishStatus"];
            this.boatIdentifier = _data["boatIdentifier"];
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : new MarketResult();
            this.location = _data["location"] ? LocationResult.fromJS(_data["location"]) : new LocationResult();
            this.defaultSkipper = _data["defaultSkipper"] ? UserResult.fromJS(_data["defaultSkipper"]) : new UserResult();
            this.defaultStewardess = _data["defaultStewardess"] ? UserResult.fromJS(_data["defaultStewardess"]) : new UserResult();
        }
    }

    static fromJS(data: any): GetCustomerBookingHistoryQueryResultListing {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerBookingHistoryQueryResultListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["publishStatus"] = this.publishStatus;
        data["boatIdentifier"] = this.boatIdentifier;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["location"] = this.location ? this.location.toJSON() : this.location;
        data["defaultSkipper"] = this.defaultSkipper ? this.defaultSkipper.toJSON() : this.defaultSkipper;
        data["defaultStewardess"] = this.defaultStewardess ? this.defaultStewardess.toJSON() : this.defaultStewardess;
        return data;
    }
}

export interface IGetCustomerBookingHistoryQueryResultListing {
    title: string | null;
    publishStatus: PublishStatus;
    boatIdentifier: string | null;
    market: MarketResult;
    location: LocationResult;
    defaultSkipper: UserResult;
    defaultStewardess: UserResult;
}

export class GetCustomerBookingHistoryQueryResultPaginatedResult implements IGetCustomerBookingHistoryQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetCustomerBookingHistoryQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetCustomerBookingHistoryQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCustomerBookingHistoryQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetCustomerBookingHistoryQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerBookingHistoryQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetCustomerBookingHistoryQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetCustomerBookingHistoryQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetCustomerNotesQueryResult implements IGetCustomerNotesQueryResult {
    guid?: string;
    createdByUser?: UserResult;
    note?: string | null;
    createdAt?: Date;

    constructor(data?: IGetCustomerNotesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.createdByUser = _data["createdByUser"] ? UserResult.fromJS(_data["createdByUser"]) : <any>null;
            this.note = _data["note"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetCustomerNotesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerNotesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : this.createdByUser;
        data["note"] = this.note;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        return data;
    }
}

export interface IGetCustomerNotesQueryResult {
    guid?: string;
    createdByUser?: UserResult;
    note?: string | null;
    createdAt?: Date;
}

export class GetCustomerNotesQueryResultPaginatedResult implements IGetCustomerNotesQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetCustomerNotesQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetCustomerNotesQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCustomerNotesQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetCustomerNotesQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerNotesQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetCustomerNotesQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetCustomerNotesQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetCustomerQueryResult implements IGetCustomerQueryResult {
    guid?: string;
    address?: CustomerAddress;
    billingInfo?: CustomerBillingInfo;
    customerPreferences?: CustomerPreferences;
    concierge?: CustomerConcierge;
    customerClass?: CustomerClass;
    isBlocked?: boolean;
    isDeleted?: boolean;
    customerNumber?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    idPassportNumber?: string | null;
    infoStatus?: CustomerInfoStatus;
    rentClass?: CustomerRentClass;
    agentGuid?: string | null;
    brokerGuid?: string | null;
    markets?: MarketResult[] | null;

    constructor(data?: IGetCustomerQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.address = _data["address"] ? CustomerAddress.fromJS(_data["address"]) : <any>null;
            this.billingInfo = _data["billingInfo"] ? CustomerBillingInfo.fromJS(_data["billingInfo"]) : <any>null;
            this.customerPreferences = _data["customerPreferences"] ? CustomerPreferences.fromJS(_data["customerPreferences"]) : <any>null;
            this.concierge = _data["concierge"] ? CustomerConcierge.fromJS(_data["concierge"]) : <any>null;
            this.customerClass = _data["customerClass"];
            this.isBlocked = _data["isBlocked"];
            this.isDeleted = _data["isDeleted"];
            this.customerNumber = _data["customerNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.idPassportNumber = _data["idPassportNumber"];
            this.infoStatus = _data["infoStatus"];
            this.rentClass = _data["rentClass"];
            this.agentGuid = _data["agentGuid"];
            this.brokerGuid = _data["brokerGuid"];
            if (Array.isArray(_data["markets"])) {
                this.markets = [] as any;
                for (let item of _data["markets"])
                    this.markets!.push(MarketResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCustomerQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["address"] = this.address ? this.address.toJSON() : this.address;
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : this.billingInfo;
        data["customerPreferences"] = this.customerPreferences ? this.customerPreferences.toJSON() : this.customerPreferences;
        data["concierge"] = this.concierge ? this.concierge.toJSON() : this.concierge;
        data["customerClass"] = this.customerClass;
        data["isBlocked"] = this.isBlocked;
        data["isDeleted"] = this.isDeleted;
        data["customerNumber"] = this.customerNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["idPassportNumber"] = this.idPassportNumber;
        data["infoStatus"] = this.infoStatus;
        data["rentClass"] = this.rentClass;
        data["agentGuid"] = this.agentGuid;
        data["brokerGuid"] = this.brokerGuid;
        if (Array.isArray(this.markets)) {
            data["markets"] = [];
            for (let item of this.markets)
                data["markets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCustomerQueryResult {
    guid?: string;
    address?: CustomerAddress;
    billingInfo?: CustomerBillingInfo;
    customerPreferences?: CustomerPreferences;
    concierge?: CustomerConcierge;
    customerClass?: CustomerClass;
    isBlocked?: boolean;
    isDeleted?: boolean;
    customerNumber?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    idPassportNumber?: string | null;
    infoStatus?: CustomerInfoStatus;
    rentClass?: CustomerRentClass;
    agentGuid?: string | null;
    brokerGuid?: string | null;
    markets?: MarketResult[] | null;
}

export class GetCustomerStatisticsQueryResult implements IGetCustomerStatisticsQueryResult {
    totalSpent?: number;
    averageSpent?: number;
    ratingPosition?: number | null;
    totalCustomers?: number;
    rating?: CustomerRating;
    totalBookings?: number;
    lastTripStartDate?: Date | null;
    nextBookingStartDate?: Date | null;
    pastBookings?: number;

    constructor(data?: IGetCustomerStatisticsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalSpent = _data["totalSpent"];
            this.averageSpent = _data["averageSpent"];
            this.ratingPosition = _data["ratingPosition"];
            this.totalCustomers = _data["totalCustomers"];
            this.rating = _data["rating"];
            this.totalBookings = _data["totalBookings"];
            this.lastTripStartDate = _data["lastTripStartDate"] ? parseDateOnly(_data["lastTripStartDate"].toString()) : <any>null;
            this.nextBookingStartDate = _data["nextBookingStartDate"] ? parseDateOnly(_data["nextBookingStartDate"].toString()) : <any>null;
            this.pastBookings = _data["pastBookings"];
        }
    }

    static fromJS(data: any): GetCustomerStatisticsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerStatisticsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSpent"] = this.totalSpent;
        data["averageSpent"] = this.averageSpent;
        data["ratingPosition"] = this.ratingPosition;
        data["totalCustomers"] = this.totalCustomers;
        data["rating"] = this.rating;
        data["totalBookings"] = this.totalBookings;
        data["lastTripStartDate"] = this.lastTripStartDate && formatDate(this.lastTripStartDate);
        data["nextBookingStartDate"] = this.nextBookingStartDate && formatDate(this.nextBookingStartDate);
        data["pastBookings"] = this.pastBookings;
        return data;
    }
}

export interface IGetCustomerStatisticsQueryResult {
    totalSpent?: number;
    averageSpent?: number;
    ratingPosition?: number | null;
    totalCustomers?: number;
    rating?: CustomerRating;
    totalBookings?: number;
    lastTripStartDate?: Date | null;
    nextBookingStartDate?: Date | null;
    pastBookings?: number;
}

export class GetCustomerUpcomingBookingsQueryResult implements IGetCustomerUpcomingBookingsQueryResult {
    guid!: string;
    bookingId!: number;
    totalPrice!: number;
    from!: Date;
    to!: Date;
    status!: BookingStatus;
    boat!: GetCustomerUpcomingBookingsQueryResultBoat;
    listing!: GetCustomerUpcomingBookingsQueryResultListing;
    skipper!: UserResult;
    multibookingGuid!: string | null;

    constructor(data?: IGetCustomerUpcomingBookingsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boat = new GetCustomerUpcomingBookingsQueryResultBoat();
            this.listing = new GetCustomerUpcomingBookingsQueryResultListing();
            this.skipper = new UserResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
            this.totalPrice = _data["totalPrice"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
            this.status = _data["status"];
            this.boat = _data["boat"] ? GetCustomerUpcomingBookingsQueryResultBoat.fromJS(_data["boat"]) : new GetCustomerUpcomingBookingsQueryResultBoat();
            this.listing = _data["listing"] ? GetCustomerUpcomingBookingsQueryResultListing.fromJS(_data["listing"]) : new GetCustomerUpcomingBookingsQueryResultListing();
            this.skipper = _data["skipper"] ? UserResult.fromJS(_data["skipper"]) : new UserResult();
            this.multibookingGuid = _data["multibookingGuid"];
        }
    }

    static fromJS(data: any): GetCustomerUpcomingBookingsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerUpcomingBookingsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        data["totalPrice"] = this.totalPrice;
        data["from"] = this.from && this.from.toISOString();
        data["to"] = this.to && this.to.toISOString();
        data["status"] = this.status;
        data["boat"] = this.boat ? this.boat.toJSON() : this.boat;
        data["listing"] = this.listing ? this.listing.toJSON() : this.listing;
        data["skipper"] = this.skipper ? this.skipper.toJSON() : this.skipper;
        data["multibookingGuid"] = this.multibookingGuid;
        return data;
    }
}

export interface IGetCustomerUpcomingBookingsQueryResult {
    guid: string;
    bookingId: number;
    totalPrice: number;
    from: Date;
    to: Date;
    status: BookingStatus;
    boat: GetCustomerUpcomingBookingsQueryResultBoat;
    listing: GetCustomerUpcomingBookingsQueryResultListing;
    skipper: UserResult;
    multibookingGuid: string | null;
}

export class GetCustomerUpcomingBookingsQueryResultBoat implements IGetCustomerUpcomingBookingsQueryResultBoat {
    guid!: string;
    defaultListingTitle!: string | null;
    registeredName!: string | null;
    passengers!: number | null;
    length!: number | null;
    isDeleted!: boolean;
    sortPriority!: number | null;
    isComplete!: boolean;
    bathroomsCount!: number | null;
    crewCapacity!: number | null;
    boatOwner!: UserResult;

    constructor(data?: IGetCustomerUpcomingBookingsQueryResultBoat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boatOwner = new UserResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.defaultListingTitle = _data["defaultListingTitle"];
            this.registeredName = _data["registeredName"];
            this.passengers = _data["passengers"];
            this.length = _data["length"];
            this.isDeleted = _data["isDeleted"];
            this.sortPriority = _data["sortPriority"];
            this.isComplete = _data["isComplete"];
            this.bathroomsCount = _data["bathroomsCount"];
            this.crewCapacity = _data["crewCapacity"];
            this.boatOwner = _data["boatOwner"] ? UserResult.fromJS(_data["boatOwner"]) : new UserResult();
        }
    }

    static fromJS(data: any): GetCustomerUpcomingBookingsQueryResultBoat {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerUpcomingBookingsQueryResultBoat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["defaultListingTitle"] = this.defaultListingTitle;
        data["registeredName"] = this.registeredName;
        data["passengers"] = this.passengers;
        data["length"] = this.length;
        data["isDeleted"] = this.isDeleted;
        data["sortPriority"] = this.sortPriority;
        data["isComplete"] = this.isComplete;
        data["bathroomsCount"] = this.bathroomsCount;
        data["crewCapacity"] = this.crewCapacity;
        data["boatOwner"] = this.boatOwner ? this.boatOwner.toJSON() : this.boatOwner;
        return data;
    }
}

export interface IGetCustomerUpcomingBookingsQueryResultBoat {
    guid: string;
    defaultListingTitle: string | null;
    registeredName: string | null;
    passengers: number | null;
    length: number | null;
    isDeleted: boolean;
    sortPriority: number | null;
    isComplete: boolean;
    bathroomsCount: number | null;
    crewCapacity: number | null;
    boatOwner: UserResult;
}

export class GetCustomerUpcomingBookingsQueryResultListing implements IGetCustomerUpcomingBookingsQueryResultListing {
    title!: string | null;
    publishStatus!: PublishStatus;
    boatIdentifier!: string | null;
    market!: MarketResult;
    location!: LocationResult;
    defaultSkipper!: UserResult;
    defaultStewardess!: UserResult;

    constructor(data?: IGetCustomerUpcomingBookingsQueryResultListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.market = new MarketResult();
            this.location = new LocationResult();
            this.defaultSkipper = new UserResult();
            this.defaultStewardess = new UserResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.publishStatus = _data["publishStatus"];
            this.boatIdentifier = _data["boatIdentifier"];
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : new MarketResult();
            this.location = _data["location"] ? LocationResult.fromJS(_data["location"]) : new LocationResult();
            this.defaultSkipper = _data["defaultSkipper"] ? UserResult.fromJS(_data["defaultSkipper"]) : new UserResult();
            this.defaultStewardess = _data["defaultStewardess"] ? UserResult.fromJS(_data["defaultStewardess"]) : new UserResult();
        }
    }

    static fromJS(data: any): GetCustomerUpcomingBookingsQueryResultListing {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerUpcomingBookingsQueryResultListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["publishStatus"] = this.publishStatus;
        data["boatIdentifier"] = this.boatIdentifier;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["location"] = this.location ? this.location.toJSON() : this.location;
        data["defaultSkipper"] = this.defaultSkipper ? this.defaultSkipper.toJSON() : this.defaultSkipper;
        data["defaultStewardess"] = this.defaultStewardess ? this.defaultStewardess.toJSON() : this.defaultStewardess;
        return data;
    }
}

export interface IGetCustomerUpcomingBookingsQueryResultListing {
    title: string | null;
    publishStatus: PublishStatus;
    boatIdentifier: string | null;
    market: MarketResult;
    location: LocationResult;
    defaultSkipper: UserResult;
    defaultStewardess: UserResult;
}

export class GetCustomerUpcomingBookingsQueryResultPaginatedResult implements IGetCustomerUpcomingBookingsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetCustomerUpcomingBookingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetCustomerUpcomingBookingsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCustomerUpcomingBookingsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetCustomerUpcomingBookingsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerUpcomingBookingsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetCustomerUpcomingBookingsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetCustomerUpcomingBookingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetCustomersQueryResult implements IGetCustomersQueryResult {
    customerNumber?: number;
    guid?: string;
    fullName?: string | null;
    readonly email?: string | null;
    readonly phone?: string | null;
    readonly totalSpent?: number | null;
    readonly bookingEnquiries?: number | null;
    readonly bookingOffers?: number | null;
    readonly reservedBookings?: number | null;
    readonly cancelledBookings?: number | null;
    readonly declinedBookings?: number | null;
    readonly totalBookings?: number | null;
    createdAt?: Date;
    infoStatus?: CustomerInfoStatus;
    agentGuid?: string | null;
    brokerGuid?: string | null;

    constructor(data?: IGetCustomersQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerNumber = _data["customerNumber"];
            this.guid = _data["guid"];
            this.fullName = _data["fullName"];
            (<any>this).email = _data["email"];
            (<any>this).phone = _data["phone"];
            (<any>this).totalSpent = _data["totalSpent"];
            (<any>this).bookingEnquiries = _data["bookingEnquiries"];
            (<any>this).bookingOffers = _data["bookingOffers"];
            (<any>this).reservedBookings = _data["reservedBookings"];
            (<any>this).cancelledBookings = _data["cancelledBookings"];
            (<any>this).declinedBookings = _data["declinedBookings"];
            (<any>this).totalBookings = _data["totalBookings"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.infoStatus = _data["infoStatus"];
            this.agentGuid = _data["agentGuid"];
            this.brokerGuid = _data["brokerGuid"];
        }
    }

    static fromJS(data: any): GetCustomersQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomersQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerNumber"] = this.customerNumber;
        data["guid"] = this.guid;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["totalSpent"] = this.totalSpent;
        data["bookingEnquiries"] = this.bookingEnquiries;
        data["bookingOffers"] = this.bookingOffers;
        data["reservedBookings"] = this.reservedBookings;
        data["cancelledBookings"] = this.cancelledBookings;
        data["declinedBookings"] = this.declinedBookings;
        data["totalBookings"] = this.totalBookings;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["infoStatus"] = this.infoStatus;
        data["agentGuid"] = this.agentGuid;
        data["brokerGuid"] = this.brokerGuid;
        return data;
    }
}

export interface IGetCustomersQueryResult {
    customerNumber?: number;
    guid?: string;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    totalSpent?: number | null;
    bookingEnquiries?: number | null;
    bookingOffers?: number | null;
    reservedBookings?: number | null;
    cancelledBookings?: number | null;
    declinedBookings?: number | null;
    totalBookings?: number | null;
    createdAt?: Date;
    infoStatus?: CustomerInfoStatus;
    agentGuid?: string | null;
    brokerGuid?: string | null;
}

export class GetCustomersQueryResultPaginatedResult implements IGetCustomersQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetCustomersQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetCustomersQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCustomersQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetCustomersQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomersQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetCustomersQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetCustomersQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetCustomersStatisticsQueryResult implements IGetCustomersStatisticsQueryResult {
    totalCustomers?: number;
    havePaidMoney?: number;
    zeroTransactions?: number;
    totalBookings?: number;
    futureBookings?: number;
    pastBookings?: number;

    constructor(data?: IGetCustomersStatisticsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCustomers = _data["totalCustomers"];
            this.havePaidMoney = _data["havePaidMoney"];
            this.zeroTransactions = _data["zeroTransactions"];
            this.totalBookings = _data["totalBookings"];
            this.futureBookings = _data["futureBookings"];
            this.pastBookings = _data["pastBookings"];
        }
    }

    static fromJS(data: any): GetCustomersStatisticsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomersStatisticsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCustomers"] = this.totalCustomers;
        data["havePaidMoney"] = this.havePaidMoney;
        data["zeroTransactions"] = this.zeroTransactions;
        data["totalBookings"] = this.totalBookings;
        data["futureBookings"] = this.futureBookings;
        data["pastBookings"] = this.pastBookings;
        return data;
    }
}

export interface IGetCustomersStatisticsQueryResult {
    totalCustomers?: number;
    havePaidMoney?: number;
    zeroTransactions?: number;
    totalBookings?: number;
    futureBookings?: number;
    pastBookings?: number;
}

export class GetDirectChannelQueryResult implements IGetDirectChannelQueryResult {
    guid?: string;
    name?: string | null;
    createdAtUtc?: Date;

    constructor(data?: IGetDirectChannelQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetDirectChannelQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetDirectChannelQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        return data;
    }
}

export interface IGetDirectChannelQueryResult {
    guid?: string;
    name?: string | null;
    createdAtUtc?: Date;
}

export class GetDirectChannelsQueryResult implements IGetDirectChannelsQueryResult {
    guid?: string;
    name?: string | null;
    createdAtUtc?: Date;
    createdAtLocal?: Date;

    constructor(data?: IGetDirectChannelsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
            this.createdAtLocal = _data["createdAtLocal"] ? new Date(_data["createdAtLocal"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetDirectChannelsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetDirectChannelsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        data["createdAtLocal"] = this.createdAtLocal && this.createdAtLocal.toISOString();
        return data;
    }
}

export interface IGetDirectChannelsQueryResult {
    guid?: string;
    name?: string | null;
    createdAtUtc?: Date;
    createdAtLocal?: Date;
}

export class GetDirectChannelsQueryResultPaginatedResult implements IGetDirectChannelsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetDirectChannelsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetDirectChannelsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetDirectChannelsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetDirectChannelsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetDirectChannelsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetDirectChannelsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetDirectChannelsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetEmailTemplateQueryResult implements IGetEmailTemplateQueryResult {
    preHeader?: string | null;
    guid!: string;
    platformAccountGuid!: string;
    templateType!: EmailTemplateType;
    subject!: string | null;
    additionalHeaderInfo?: string | null;
    sections!: { [key: string]: string; } | null;
    isActive!: boolean;
    isEnabled!: boolean;
    createdAt!: Date;
    updatedAt!: Date;
    emailCCs!: string[] | null;

    constructor(data?: IGetEmailTemplateQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preHeader = _data["preHeader"];
            this.guid = _data["guid"];
            this.platformAccountGuid = _data["platformAccountGuid"];
            this.templateType = _data["templateType"];
            this.subject = _data["subject"];
            this.additionalHeaderInfo = _data["additionalHeaderInfo"];
            if (_data["sections"]) {
                this.sections = {} as any;
                for (let key in _data["sections"]) {
                    if (_data["sections"].hasOwnProperty(key))
                        (<any>this.sections)![key] = _data["sections"][key];
                }
            }
            this.isActive = _data["isActive"];
            this.isEnabled = _data["isEnabled"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            if (Array.isArray(_data["emailCCs"])) {
                this.emailCCs = [] as any;
                for (let item of _data["emailCCs"])
                    this.emailCCs!.push(item);
            }
        }
    }

    static fromJS(data: any): GetEmailTemplateQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailTemplateQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preHeader"] = this.preHeader;
        data["guid"] = this.guid;
        data["platformAccountGuid"] = this.platformAccountGuid;
        data["templateType"] = this.templateType;
        data["subject"] = this.subject;
        data["additionalHeaderInfo"] = this.additionalHeaderInfo;
        if (this.sections) {
            data["sections"] = {};
            for (let key in this.sections) {
                if (this.sections.hasOwnProperty(key))
                    (<any>data["sections"])[key] = (<any>this.sections)[key];
            }
        }
        data["isActive"] = this.isActive;
        data["isEnabled"] = this.isEnabled;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        if (Array.isArray(this.emailCCs)) {
            data["emailCCs"] = [];
            for (let item of this.emailCCs)
                data["emailCCs"].push(item);
        }
        return data;
    }
}

export interface IGetEmailTemplateQueryResult {
    preHeader?: string | null;
    guid: string;
    platformAccountGuid: string;
    templateType: EmailTemplateType;
    subject: string | null;
    additionalHeaderInfo?: string | null;
    sections: { [key: string]: string; } | null;
    isActive: boolean;
    isEnabled: boolean;
    createdAt: Date;
    updatedAt: Date;
    emailCCs: string[] | null;
}

export class GetEmailTemplatesQueryResult implements IGetEmailTemplatesQueryResult {
    guid!: string;
    preHeader!: string | null;
    templateType!: EmailTemplateType;
    subject!: string | null;
    additionalHeaderInfo!: string | null;
    sections!: { [key: string]: string; } | null;
    isActive!: boolean;
    isEnabled!: boolean;
    createdAt!: Date;
    updatedAt!: Date;
    emailCCs!: string[] | null;

    constructor(data?: IGetEmailTemplatesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.preHeader = _data["preHeader"];
            this.templateType = _data["templateType"];
            this.subject = _data["subject"];
            this.additionalHeaderInfo = _data["additionalHeaderInfo"];
            if (_data["sections"]) {
                this.sections = {} as any;
                for (let key in _data["sections"]) {
                    if (_data["sections"].hasOwnProperty(key))
                        (<any>this.sections)![key] = _data["sections"][key];
                }
            }
            this.isActive = _data["isActive"];
            this.isEnabled = _data["isEnabled"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            if (Array.isArray(_data["emailCCs"])) {
                this.emailCCs = [] as any;
                for (let item of _data["emailCCs"])
                    this.emailCCs!.push(item);
            }
        }
    }

    static fromJS(data: any): GetEmailTemplatesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailTemplatesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["preHeader"] = this.preHeader;
        data["templateType"] = this.templateType;
        data["subject"] = this.subject;
        data["additionalHeaderInfo"] = this.additionalHeaderInfo;
        if (this.sections) {
            data["sections"] = {};
            for (let key in this.sections) {
                if (this.sections.hasOwnProperty(key))
                    (<any>data["sections"])[key] = (<any>this.sections)[key];
            }
        }
        data["isActive"] = this.isActive;
        data["isEnabled"] = this.isEnabled;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["updatedAt"] = this.updatedAt && this.updatedAt.toISOString();
        if (Array.isArray(this.emailCCs)) {
            data["emailCCs"] = [];
            for (let item of this.emailCCs)
                data["emailCCs"].push(item);
        }
        return data;
    }
}

export interface IGetEmailTemplatesQueryResult {
    guid: string;
    preHeader: string | null;
    templateType: EmailTemplateType;
    subject: string | null;
    additionalHeaderInfo: string | null;
    sections: { [key: string]: string; } | null;
    isActive: boolean;
    isEnabled: boolean;
    createdAt: Date;
    updatedAt: Date;
    emailCCs: string[] | null;
}

export class GetExternalPaymentMethodsQuery implements IGetExternalPaymentMethodsQuery {

    constructor(data?: IGetExternalPaymentMethodsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetExternalPaymentMethodsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetExternalPaymentMethodsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetExternalPaymentMethodsQuery {
}

export class GetExternalPaymentMethodsQueryResult implements IGetExternalPaymentMethodsQueryResult {
    paymentMethods!: ExternalPaymentMethodItem[] | null;

    constructor(data?: IGetExternalPaymentMethodsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paymentMethods"])) {
                this.paymentMethods = [] as any;
                for (let item of _data["paymentMethods"])
                    this.paymentMethods!.push(ExternalPaymentMethodItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetExternalPaymentMethodsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetExternalPaymentMethodsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paymentMethods)) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetExternalPaymentMethodsQueryResult {
    paymentMethods: ExternalPaymentMethodItem[] | null;
}

export class GetGoogleAdsAuthUrlQueryResult implements IGetGoogleAdsAuthUrlQueryResult {
    authUrl!: string | null;

    constructor(data?: IGetGoogleAdsAuthUrlQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authUrl = _data["authUrl"];
        }
    }

    static fromJS(data: any): GetGoogleAdsAuthUrlQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetGoogleAdsAuthUrlQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authUrl"] = this.authUrl;
        return data;
    }
}

export interface IGetGoogleAdsAuthUrlQueryResult {
    authUrl: string | null;
}

export class GetHandoffsQueryResult implements IGetHandoffsQueryResult {
    guid!: string;
    sentAt!: Date;
    bookingGuid!: string;
    type!: HandoffType;
    customerMailerJobStatus?: BookingMailerNotificationStatus;
    stewardessMailerJobStatus?: BookingMailerNotificationStatus;
    skipperMailerJobStatus?: BookingMailerNotificationStatus;
    createdBy?: UserResult;

    constructor(data?: IGetHandoffsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : <any>null;
            this.bookingGuid = _data["bookingGuid"];
            this.type = _data["type"];
            this.customerMailerJobStatus = _data["customerMailerJobStatus"];
            this.stewardessMailerJobStatus = _data["stewardessMailerJobStatus"];
            this.skipperMailerJobStatus = _data["skipperMailerJobStatus"];
            this.createdBy = _data["createdBy"] ? UserResult.fromJS(_data["createdBy"]) : <any>null;
        }
    }

    static fromJS(data: any): GetHandoffsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetHandoffsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["sentAt"] = this.sentAt && this.sentAt.toISOString();
        data["bookingGuid"] = this.bookingGuid;
        data["type"] = this.type;
        data["customerMailerJobStatus"] = this.customerMailerJobStatus;
        data["stewardessMailerJobStatus"] = this.stewardessMailerJobStatus;
        data["skipperMailerJobStatus"] = this.skipperMailerJobStatus;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : this.createdBy;
        return data;
    }
}

export interface IGetHandoffsQueryResult {
    guid: string;
    sentAt: Date;
    bookingGuid: string;
    type: HandoffType;
    customerMailerJobStatus?: BookingMailerNotificationStatus;
    stewardessMailerJobStatus?: BookingMailerNotificationStatus;
    skipperMailerJobStatus?: BookingMailerNotificationStatus;
    createdBy?: UserResult;
}

export class GetHandoffsQueryResultPaginatedResult implements IGetHandoffsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetHandoffsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetHandoffsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetHandoffsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetHandoffsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetHandoffsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetHandoffsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetHandoffsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetListingQueryResult implements IGetListingQueryResult {
    guid?: string;
    marketSpecificTitle?: string | null;
    boat?: ListingBoatResult;
    market?: MarketResult;
    publishStatus?: PublishStatus;
    pickUpLocation?: LocationResult;
    dropOffLocation?: LocationResult;
    slipNumber?: string | null;
    notes?: string | null;
    skipper?: UserResult;
    stewardess?: UserResult;
    checkinPerson?: UserResult;
    ownerTakeRate?: ListingOwnerTakeRate;
    boatIdentifier?: string | null;
    bookingType?: BookingType;

    constructor(data?: IGetListingQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.marketSpecificTitle = _data["marketSpecificTitle"];
            this.boat = _data["boat"] ? ListingBoatResult.fromJS(_data["boat"]) : <any>null;
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : <any>null;
            this.publishStatus = _data["publishStatus"];
            this.pickUpLocation = _data["pickUpLocation"] ? LocationResult.fromJS(_data["pickUpLocation"]) : <any>null;
            this.dropOffLocation = _data["dropOffLocation"] ? LocationResult.fromJS(_data["dropOffLocation"]) : <any>null;
            this.slipNumber = _data["slipNumber"];
            this.notes = _data["notes"];
            this.skipper = _data["skipper"] ? UserResult.fromJS(_data["skipper"]) : <any>null;
            this.stewardess = _data["stewardess"] ? UserResult.fromJS(_data["stewardess"]) : <any>null;
            this.checkinPerson = _data["checkinPerson"] ? UserResult.fromJS(_data["checkinPerson"]) : <any>null;
            this.ownerTakeRate = _data["ownerTakeRate"] ? ListingOwnerTakeRate.fromJS(_data["ownerTakeRate"]) : <any>null;
            this.boatIdentifier = _data["boatIdentifier"];
            this.bookingType = _data["bookingType"];
        }
    }

    static fromJS(data: any): GetListingQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetListingQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["marketSpecificTitle"] = this.marketSpecificTitle;
        data["boat"] = this.boat ? this.boat.toJSON() : this.boat;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["publishStatus"] = this.publishStatus;
        data["pickUpLocation"] = this.pickUpLocation ? this.pickUpLocation.toJSON() : this.pickUpLocation;
        data["dropOffLocation"] = this.dropOffLocation ? this.dropOffLocation.toJSON() : this.dropOffLocation;
        data["slipNumber"] = this.slipNumber;
        data["notes"] = this.notes;
        data["skipper"] = this.skipper ? this.skipper.toJSON() : this.skipper;
        data["stewardess"] = this.stewardess ? this.stewardess.toJSON() : this.stewardess;
        data["checkinPerson"] = this.checkinPerson ? this.checkinPerson.toJSON() : this.checkinPerson;
        data["ownerTakeRate"] = this.ownerTakeRate ? this.ownerTakeRate.toJSON() : this.ownerTakeRate;
        data["boatIdentifier"] = this.boatIdentifier;
        data["bookingType"] = this.bookingType;
        return data;
    }
}

export interface IGetListingQueryResult {
    guid?: string;
    marketSpecificTitle?: string | null;
    boat?: ListingBoatResult;
    market?: MarketResult;
    publishStatus?: PublishStatus;
    pickUpLocation?: LocationResult;
    dropOffLocation?: LocationResult;
    slipNumber?: string | null;
    notes?: string | null;
    skipper?: UserResult;
    stewardess?: UserResult;
    checkinPerson?: UserResult;
    ownerTakeRate?: ListingOwnerTakeRate;
    boatIdentifier?: string | null;
    bookingType?: BookingType;
}

export class GetListingsForBookingQueryResult implements IGetListingsForBookingQueryResult {
    guid?: string;
    title?: string | null;
    publishStatus?: PublishStatus;
    market?: MarketResult;
    boatIdentifier?: string | null;

    constructor(data?: IGetListingsForBookingQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.publishStatus = _data["publishStatus"];
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : <any>null;
            this.boatIdentifier = _data["boatIdentifier"];
        }
    }

    static fromJS(data: any): GetListingsForBookingQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetListingsForBookingQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["publishStatus"] = this.publishStatus;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["boatIdentifier"] = this.boatIdentifier;
        return data;
    }
}

export interface IGetListingsForBookingQueryResult {
    guid?: string;
    title?: string | null;
    publishStatus?: PublishStatus;
    market?: MarketResult;
    boatIdentifier?: string | null;
}

export class GetListingsQueryResult implements IGetListingsQueryResult {
    guid!: string;
    boat!: ListingBoatResult;
    title!: string | null;
    publishStatus!: PublishStatus;
    market!: MarketResult;
    pickupLocationGuid!: string;
    pickupLocationTitle!: string | null;
    boatIdentifier!: string | null;
    ownerTakeRate!: ListingOwnerTakeRate;
    defaultSkipper!: UserResult;
    defaultStewardess!: UserResult;
    defaultCheckinPerson!: UserResult;
    owner!: UserResult;
    boatPicture!: ListingBoatPictureResultModel;

    constructor(data?: IGetListingsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boat = new ListingBoatResult();
            this.market = new MarketResult();
            this.ownerTakeRate = new ListingOwnerTakeRate();
            this.defaultSkipper = new UserResult();
            this.defaultStewardess = new UserResult();
            this.defaultCheckinPerson = new UserResult();
            this.owner = new UserResult();
            this.boatPicture = new ListingBoatPictureResultModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.boat = _data["boat"] ? ListingBoatResult.fromJS(_data["boat"]) : new ListingBoatResult();
            this.title = _data["title"];
            this.publishStatus = _data["publishStatus"];
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : new MarketResult();
            this.pickupLocationGuid = _data["pickupLocationGuid"];
            this.pickupLocationTitle = _data["pickupLocationTitle"];
            this.boatIdentifier = _data["boatIdentifier"];
            this.ownerTakeRate = _data["ownerTakeRate"] ? ListingOwnerTakeRate.fromJS(_data["ownerTakeRate"]) : new ListingOwnerTakeRate();
            this.defaultSkipper = _data["defaultSkipper"] ? UserResult.fromJS(_data["defaultSkipper"]) : new UserResult();
            this.defaultStewardess = _data["defaultStewardess"] ? UserResult.fromJS(_data["defaultStewardess"]) : new UserResult();
            this.defaultCheckinPerson = _data["defaultCheckinPerson"] ? UserResult.fromJS(_data["defaultCheckinPerson"]) : new UserResult();
            this.owner = _data["owner"] ? UserResult.fromJS(_data["owner"]) : new UserResult();
            this.boatPicture = _data["boatPicture"] ? ListingBoatPictureResultModel.fromJS(_data["boatPicture"]) : new ListingBoatPictureResultModel();
        }
    }

    static fromJS(data: any): GetListingsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetListingsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["boat"] = this.boat ? this.boat.toJSON() : this.boat;
        data["title"] = this.title;
        data["publishStatus"] = this.publishStatus;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["pickupLocationGuid"] = this.pickupLocationGuid;
        data["pickupLocationTitle"] = this.pickupLocationTitle;
        data["boatIdentifier"] = this.boatIdentifier;
        data["ownerTakeRate"] = this.ownerTakeRate ? this.ownerTakeRate.toJSON() : this.ownerTakeRate;
        data["defaultSkipper"] = this.defaultSkipper ? this.defaultSkipper.toJSON() : this.defaultSkipper;
        data["defaultStewardess"] = this.defaultStewardess ? this.defaultStewardess.toJSON() : this.defaultStewardess;
        data["defaultCheckinPerson"] = this.defaultCheckinPerson ? this.defaultCheckinPerson.toJSON() : this.defaultCheckinPerson;
        data["owner"] = this.owner ? this.owner.toJSON() : this.owner;
        data["boatPicture"] = this.boatPicture ? this.boatPicture.toJSON() : this.boatPicture;
        return data;
    }
}

export interface IGetListingsQueryResult {
    guid: string;
    boat: ListingBoatResult;
    title: string | null;
    publishStatus: PublishStatus;
    market: MarketResult;
    pickupLocationGuid: string;
    pickupLocationTitle: string | null;
    boatIdentifier: string | null;
    ownerTakeRate: ListingOwnerTakeRate;
    defaultSkipper: UserResult;
    defaultStewardess: UserResult;
    defaultCheckinPerson: UserResult;
    owner: UserResult;
    boatPicture: ListingBoatPictureResultModel;
}

export class GetListingsQueryResultPaginatedResult implements IGetListingsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetListingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetListingsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetListingsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetListingsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetListingsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetListingsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetListingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetLocationQueryResult implements IGetLocationQueryResult {
    guid?: string;
    title?: string | null;
    market?: MarketResult;
    address?: LocationAddress;
    dock?: string | null;
    pickupInstructions?: string | null;
    parkingNotes?: string | null;
    marina?: string | null;
    carParkingLocation?: CarParkingLocation;
    mapToMarina?: MapToMarina;
    isActive?: boolean;

    constructor(data?: IGetLocationQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : <any>null;
            this.address = _data["address"] ? LocationAddress.fromJS(_data["address"]) : <any>null;
            this.dock = _data["dock"];
            this.pickupInstructions = _data["pickupInstructions"];
            this.parkingNotes = _data["parkingNotes"];
            this.marina = _data["marina"];
            this.carParkingLocation = _data["carParkingLocation"] ? CarParkingLocation.fromJS(_data["carParkingLocation"]) : <any>null;
            this.mapToMarina = _data["mapToMarina"] ? MapToMarina.fromJS(_data["mapToMarina"]) : <any>null;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GetLocationQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["address"] = this.address ? this.address.toJSON() : this.address;
        data["dock"] = this.dock;
        data["pickupInstructions"] = this.pickupInstructions;
        data["parkingNotes"] = this.parkingNotes;
        data["marina"] = this.marina;
        data["carParkingLocation"] = this.carParkingLocation ? this.carParkingLocation.toJSON() : this.carParkingLocation;
        data["mapToMarina"] = this.mapToMarina ? this.mapToMarina.toJSON() : this.mapToMarina;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGetLocationQueryResult {
    guid?: string;
    title?: string | null;
    market?: MarketResult;
    address?: LocationAddress;
    dock?: string | null;
    pickupInstructions?: string | null;
    parkingNotes?: string | null;
    marina?: string | null;
    carParkingLocation?: CarParkingLocation;
    mapToMarina?: MapToMarina;
    isActive?: boolean;
}

export class GetLocationsQueryResult implements IGetLocationsQueryResult {
    guid?: string;
    title?: string | null;
    market?: MarketResult;
    marina?: string | null;
    dock?: string | null;
    pickupInstructions?: string | null;
    parkingNotes?: string | null;
    address?: LocationAddress;
    carParkingLocation?: CarParkingLocation;
    mapToMarina?: MapToMarina;
    isActive?: boolean;

    constructor(data?: IGetLocationsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : <any>null;
            this.marina = _data["marina"];
            this.dock = _data["dock"];
            this.pickupInstructions = _data["pickupInstructions"];
            this.parkingNotes = _data["parkingNotes"];
            this.address = _data["address"] ? LocationAddress.fromJS(_data["address"]) : <any>null;
            this.carParkingLocation = _data["carParkingLocation"] ? CarParkingLocation.fromJS(_data["carParkingLocation"]) : <any>null;
            this.mapToMarina = _data["mapToMarina"] ? MapToMarina.fromJS(_data["mapToMarina"]) : <any>null;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GetLocationsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["marina"] = this.marina;
        data["dock"] = this.dock;
        data["pickupInstructions"] = this.pickupInstructions;
        data["parkingNotes"] = this.parkingNotes;
        data["address"] = this.address ? this.address.toJSON() : this.address;
        data["carParkingLocation"] = this.carParkingLocation ? this.carParkingLocation.toJSON() : this.carParkingLocation;
        data["mapToMarina"] = this.mapToMarina ? this.mapToMarina.toJSON() : this.mapToMarina;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGetLocationsQueryResult {
    guid?: string;
    title?: string | null;
    market?: MarketResult;
    marina?: string | null;
    dock?: string | null;
    pickupInstructions?: string | null;
    parkingNotes?: string | null;
    address?: LocationAddress;
    carParkingLocation?: CarParkingLocation;
    mapToMarina?: MapToMarina;
    isActive?: boolean;
}

export class GetLocationsQueryResultPaginatedResult implements IGetLocationsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetLocationsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetLocationsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLocationsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetLocationsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetLocationsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetLocationsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetMakeQueryResult implements IGetMakeQueryResult {
    guid?: string;
    name?: string | null;
    isDeleted?: boolean;

    constructor(data?: IGetMakeQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): GetMakeQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMakeQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IGetMakeQueryResult {
    guid?: string;
    name?: string | null;
    isDeleted?: boolean;
}

export class GetMakesQueryResult implements IGetMakesQueryResult {
    guid?: string;
    name?: string | null;
    isDeleted?: boolean;

    constructor(data?: IGetMakesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): GetMakesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMakesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IGetMakesQueryResult {
    guid?: string;
    name?: string | null;
    isDeleted?: boolean;
}

export class GetMakesQueryResultPaginatedResult implements IGetMakesQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetMakesQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetMakesQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMakesQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetMakesQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMakesQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetMakesQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetMakesQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetMarketQueryResult implements IGetMarketQueryResult {
    guid?: string;
    title?: string | null;
    code?: string | null;
    color?: string | null;

    constructor(data?: IGetMarketQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.code = _data["code"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): GetMarketQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["code"] = this.code;
        data["color"] = this.color;
        return data;
    }
}

export interface IGetMarketQueryResult {
    guid?: string;
    title?: string | null;
    code?: string | null;
    color?: string | null;
}

export class GetMarketplaceCalendarPricingQueryResult implements IGetMarketplaceCalendarPricingQueryResult {
    listingTitle!: string | null;
    pricingMode!: PricingMode;
    dayPrices!: CalendarDayPriceResult[] | null;

    constructor(data?: IGetMarketplaceCalendarPricingQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingTitle = _data["listingTitle"];
            this.pricingMode = _data["pricingMode"];
            if (Array.isArray(_data["dayPrices"])) {
                this.dayPrices = [] as any;
                for (let item of _data["dayPrices"])
                    this.dayPrices!.push(CalendarDayPriceResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMarketplaceCalendarPricingQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketplaceCalendarPricingQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingTitle"] = this.listingTitle;
        data["pricingMode"] = this.pricingMode;
        if (Array.isArray(this.dayPrices)) {
            data["dayPrices"] = [];
            for (let item of this.dayPrices)
                data["dayPrices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMarketplaceCalendarPricingQueryResult {
    listingTitle: string | null;
    pricingMode: PricingMode;
    dayPrices: CalendarDayPriceResult[] | null;
}

export class GetMarketsQueryResult implements IGetMarketsQueryResult {
    guid?: string;
    title?: string | null;
    code?: string | null;
    color?: string | null;
    pricingMode?: PricingMode;

    constructor(data?: IGetMarketsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.code = _data["code"];
            this.color = _data["color"];
            this.pricingMode = _data["pricingMode"];
        }
    }

    static fromJS(data: any): GetMarketsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["code"] = this.code;
        data["color"] = this.color;
        data["pricingMode"] = this.pricingMode;
        return data;
    }
}

export interface IGetMarketsQueryResult {
    guid?: string;
    title?: string | null;
    code?: string | null;
    color?: string | null;
    pricingMode?: PricingMode;
}

export class GetMarketsQueryResultPaginatedResult implements IGetMarketsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetMarketsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetMarketsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMarketsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetMarketsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMarketsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetMarketsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetMarketsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetMultibookingBookingSummary implements IGetMultibookingBookingSummary {
    guid?: string;
    bookingId?: number;
    status?: BookingStatus;
    paymentStatus?: BookingPaymentStatus;
    listingTitle?: string | null;
    boatName?: string | null;
    from?: Date;
    to?: Date;
    totalPrice?: number;
    totalPaid?: number;

    constructor(data?: IGetMultibookingBookingSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.bookingId = _data["bookingId"];
            this.status = _data["status"];
            this.paymentStatus = _data["paymentStatus"];
            this.listingTitle = _data["listingTitle"];
            this.boatName = _data["boatName"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>null;
            this.totalPrice = _data["totalPrice"];
            this.totalPaid = _data["totalPaid"];
        }
    }

    static fromJS(data: any): GetMultibookingBookingSummary {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultibookingBookingSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["bookingId"] = this.bookingId;
        data["status"] = this.status;
        data["paymentStatus"] = this.paymentStatus;
        data["listingTitle"] = this.listingTitle;
        data["boatName"] = this.boatName;
        data["from"] = this.from && this.from.toISOString();
        data["to"] = this.to && this.to.toISOString();
        data["totalPrice"] = this.totalPrice;
        data["totalPaid"] = this.totalPaid;
        return data;
    }
}

export interface IGetMultibookingBookingSummary {
    guid?: string;
    bookingId?: number;
    status?: BookingStatus;
    paymentStatus?: BookingPaymentStatus;
    listingTitle?: string | null;
    boatName?: string | null;
    from?: Date;
    to?: Date;
    totalPrice?: number;
    totalPaid?: number;
}

export class GetMultibookingPaymentsQueryResult implements IGetMultibookingPaymentsQueryResult {
    guid?: string;
    paidOn?: Date | null;
    createdAt?: Date;
    amount?: number;
    status?: PaymentStatus;
    note?: string | null;
    provider?: PaymentProvider;
    bookingGuid?: string | null;
    bookingId?: number | null;
    multibookingGuid?: string | null;
    externalPaymentInfo?: ExternalPaymentInfo;
    stripePaymentInfo?: StripePaymentInfo;
    authorizeNetPaymentInfo?: AuthorizeNetPaymentProfileInfo;
    worldPayPaymentInfo?: WorldPayPaymentInfo;
    balancePaymentInfo?: BalancePaymentInfo;
    onlineCustomerFee?: OnlineCustomerFee;
    propellerTakeRate?: PropellerTakeRate;
    isMultibookingPayment?: boolean;
    createdBy?: PaymentUser;

    constructor(data?: IGetMultibookingPaymentsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.paidOn = _data["paidOn"] ? new Date(_data["paidOn"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.amount = _data["amount"];
            this.status = _data["status"];
            this.note = _data["note"];
            this.provider = _data["provider"];
            this.bookingGuid = _data["bookingGuid"];
            this.bookingId = _data["bookingId"];
            this.multibookingGuid = _data["multibookingGuid"];
            this.externalPaymentInfo = _data["externalPaymentInfo"] ? ExternalPaymentInfo.fromJS(_data["externalPaymentInfo"]) : <any>null;
            this.stripePaymentInfo = _data["stripePaymentInfo"] ? StripePaymentInfo.fromJS(_data["stripePaymentInfo"]) : <any>null;
            this.authorizeNetPaymentInfo = _data["authorizeNetPaymentInfo"] ? AuthorizeNetPaymentProfileInfo.fromJS(_data["authorizeNetPaymentInfo"]) : <any>null;
            this.worldPayPaymentInfo = _data["worldPayPaymentInfo"] ? WorldPayPaymentInfo.fromJS(_data["worldPayPaymentInfo"]) : <any>null;
            this.balancePaymentInfo = _data["balancePaymentInfo"] ? BalancePaymentInfo.fromJS(_data["balancePaymentInfo"]) : <any>null;
            this.onlineCustomerFee = _data["onlineCustomerFee"] ? OnlineCustomerFee.fromJS(_data["onlineCustomerFee"]) : <any>null;
            this.propellerTakeRate = _data["propellerTakeRate"] ? PropellerTakeRate.fromJS(_data["propellerTakeRate"]) : <any>null;
            this.isMultibookingPayment = _data["isMultibookingPayment"];
            this.createdBy = _data["createdBy"] ? PaymentUser.fromJS(_data["createdBy"]) : <any>null;
        }
    }

    static fromJS(data: any): GetMultibookingPaymentsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultibookingPaymentsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["paidOn"] = this.paidOn && this.paidOn.toISOString();
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["amount"] = this.amount;
        data["status"] = this.status;
        data["note"] = this.note;
        data["provider"] = this.provider;
        data["bookingGuid"] = this.bookingGuid;
        data["bookingId"] = this.bookingId;
        data["multibookingGuid"] = this.multibookingGuid;
        data["externalPaymentInfo"] = this.externalPaymentInfo ? this.externalPaymentInfo.toJSON() : this.externalPaymentInfo;
        data["stripePaymentInfo"] = this.stripePaymentInfo ? this.stripePaymentInfo.toJSON() : this.stripePaymentInfo;
        data["authorizeNetPaymentInfo"] = this.authorizeNetPaymentInfo ? this.authorizeNetPaymentInfo.toJSON() : this.authorizeNetPaymentInfo;
        data["worldPayPaymentInfo"] = this.worldPayPaymentInfo ? this.worldPayPaymentInfo.toJSON() : this.worldPayPaymentInfo;
        data["balancePaymentInfo"] = this.balancePaymentInfo ? this.balancePaymentInfo.toJSON() : this.balancePaymentInfo;
        data["onlineCustomerFee"] = this.onlineCustomerFee ? this.onlineCustomerFee.toJSON() : this.onlineCustomerFee;
        data["propellerTakeRate"] = this.propellerTakeRate ? this.propellerTakeRate.toJSON() : this.propellerTakeRate;
        data["isMultibookingPayment"] = this.isMultibookingPayment;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : this.createdBy;
        return data;
    }
}

export interface IGetMultibookingPaymentsQueryResult {
    guid?: string;
    paidOn?: Date | null;
    createdAt?: Date;
    amount?: number;
    status?: PaymentStatus;
    note?: string | null;
    provider?: PaymentProvider;
    bookingGuid?: string | null;
    bookingId?: number | null;
    multibookingGuid?: string | null;
    externalPaymentInfo?: ExternalPaymentInfo;
    stripePaymentInfo?: StripePaymentInfo;
    authorizeNetPaymentInfo?: AuthorizeNetPaymentProfileInfo;
    worldPayPaymentInfo?: WorldPayPaymentInfo;
    balancePaymentInfo?: BalancePaymentInfo;
    onlineCustomerFee?: OnlineCustomerFee;
    propellerTakeRate?: PropellerTakeRate;
    isMultibookingPayment?: boolean;
    createdBy?: PaymentUser;
}

export class GetMultibookingQueryResult implements IGetMultibookingQueryResult {
    guid?: string;
    multibookingId?: number;
    formattedMultibookingId?: string | null;
    customerGuid?: string;
    createdAt?: Date;
    bookings?: GetMultibookingBookingSummary[] | null;
    totalPrice?: number;
    totalPaid?: number;
    remainingToPay?: number;

    constructor(data?: IGetMultibookingQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.multibookingId = _data["multibookingId"];
            this.formattedMultibookingId = _data["formattedMultibookingId"];
            this.customerGuid = _data["customerGuid"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(GetMultibookingBookingSummary.fromJS(item));
            }
            this.totalPrice = _data["totalPrice"];
            this.totalPaid = _data["totalPaid"];
            this.remainingToPay = _data["remainingToPay"];
        }
    }

    static fromJS(data: any): GetMultibookingQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultibookingQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["multibookingId"] = this.multibookingId;
        data["formattedMultibookingId"] = this.formattedMultibookingId;
        data["customerGuid"] = this.customerGuid;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item.toJSON());
        }
        data["totalPrice"] = this.totalPrice;
        data["totalPaid"] = this.totalPaid;
        data["remainingToPay"] = this.remainingToPay;
        return data;
    }
}

export interface IGetMultibookingQueryResult {
    guid?: string;
    multibookingId?: number;
    formattedMultibookingId?: string | null;
    customerGuid?: string;
    createdAt?: Date;
    bookings?: GetMultibookingBookingSummary[] | null;
    totalPrice?: number;
    totalPaid?: number;
    remainingToPay?: number;
}

export class GetMultibookingsQueryResult implements IGetMultibookingsQueryResult {
    guid?: string;
    multibookingId?: number;
    formattedMultibookingId?: string | null;
    customerGuid?: string;
    createdAt?: Date;
    bookingCount?: number;
    totalPrice?: number;
    totalPaid?: number;

    constructor(data?: IGetMultibookingsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.multibookingId = _data["multibookingId"];
            this.formattedMultibookingId = _data["formattedMultibookingId"];
            this.customerGuid = _data["customerGuid"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.bookingCount = _data["bookingCount"];
            this.totalPrice = _data["totalPrice"];
            this.totalPaid = _data["totalPaid"];
        }
    }

    static fromJS(data: any): GetMultibookingsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultibookingsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["multibookingId"] = this.multibookingId;
        data["formattedMultibookingId"] = this.formattedMultibookingId;
        data["customerGuid"] = this.customerGuid;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["bookingCount"] = this.bookingCount;
        data["totalPrice"] = this.totalPrice;
        data["totalPaid"] = this.totalPaid;
        return data;
    }
}

export interface IGetMultibookingsQueryResult {
    guid?: string;
    multibookingId?: number;
    formattedMultibookingId?: string | null;
    customerGuid?: string;
    createdAt?: Date;
    bookingCount?: number;
    totalPrice?: number;
    totalPaid?: number;
}

export class GetMultibookingsQueryResultPaginatedResult implements IGetMultibookingsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetMultibookingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetMultibookingsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMultibookingsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetMultibookingsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultibookingsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetMultibookingsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetMultibookingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetOperatorBalanceActivitiesResult implements IGetOperatorBalanceActivitiesResult {
    guid?: string;
    paidOn?: Date;
    createdAt?: Date;
    type?: BalanceAccountActivityType;
    amount?: number;
    createdByFullName?: string | null;
    target?: BalanceAccountOwnerType;
    movementType?: BalanceActivityMovementType;
    bookingId?: number | null;
    bookingGuid?: string | null;
    balanceAfter?: number;
    note?: string | null;
    paymentGuid?: string | null;

    constructor(data?: IGetOperatorBalanceActivitiesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.paidOn = _data["paidOn"] ? new Date(_data["paidOn"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.type = _data["type"];
            this.amount = _data["amount"];
            this.createdByFullName = _data["createdByFullName"];
            this.target = _data["target"];
            this.movementType = _data["movementType"];
            this.bookingId = _data["bookingId"];
            this.bookingGuid = _data["bookingGuid"];
            this.balanceAfter = _data["balanceAfter"];
            this.note = _data["note"];
            this.paymentGuid = _data["paymentGuid"];
        }
    }

    static fromJS(data: any): GetOperatorBalanceActivitiesResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetOperatorBalanceActivitiesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["paidOn"] = this.paidOn && this.paidOn.toISOString();
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["type"] = this.type;
        data["amount"] = this.amount;
        data["createdByFullName"] = this.createdByFullName;
        data["target"] = this.target;
        data["movementType"] = this.movementType;
        data["bookingId"] = this.bookingId;
        data["bookingGuid"] = this.bookingGuid;
        data["balanceAfter"] = this.balanceAfter;
        data["note"] = this.note;
        data["paymentGuid"] = this.paymentGuid;
        return data;
    }
}

export interface IGetOperatorBalanceActivitiesResult {
    guid?: string;
    paidOn?: Date;
    createdAt?: Date;
    type?: BalanceAccountActivityType;
    amount?: number;
    createdByFullName?: string | null;
    target?: BalanceAccountOwnerType;
    movementType?: BalanceActivityMovementType;
    bookingId?: number | null;
    bookingGuid?: string | null;
    balanceAfter?: number;
    note?: string | null;
    paymentGuid?: string | null;
}

export class GetOperatorBalanceActivitiesResultPaginatedResult implements IGetOperatorBalanceActivitiesResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetOperatorBalanceActivitiesResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetOperatorBalanceActivitiesResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOperatorBalanceActivitiesResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetOperatorBalanceActivitiesResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetOperatorBalanceActivitiesResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetOperatorBalanceActivitiesResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetOperatorBalanceActivitiesResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetOperatorBalanceSummaryQueryResult implements IGetOperatorBalanceSummaryQueryResult {
    currentBalance?: number;

    constructor(data?: IGetOperatorBalanceSummaryQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentBalance = _data["currentBalance"];
        }
    }

    static fromJS(data: any): GetOperatorBalanceSummaryQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetOperatorBalanceSummaryQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentBalance"] = this.currentBalance;
        return data;
    }
}

export interface IGetOperatorBalanceSummaryQueryResult {
    currentBalance?: number;
}

export class GetOperatorPayoutsResult implements IGetOperatorPayoutsResult {
    payoutGuid?: string;
    paymentGuid?: string;
    bookingId?: number | null;
    bookingGuid?: string | null;
    bookingCreatedAt?: Date | null;
    payoutAmount?: number;
    paymentAmount?: number;
    customerFullName?: string | null;
    status?: OperatorPayoutStatus;
    type?: OperatorPayoutType;
    createdAt?: Date;
    payoutDate?: Date | null;
    paymentPaidOn?: Date | null;
    paymentMethod?: string | null;

    constructor(data?: IGetOperatorPayoutsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payoutGuid = _data["payoutGuid"];
            this.paymentGuid = _data["paymentGuid"];
            this.bookingId = _data["bookingId"];
            this.bookingGuid = _data["bookingGuid"];
            this.bookingCreatedAt = _data["bookingCreatedAt"] ? new Date(_data["bookingCreatedAt"].toString()) : <any>null;
            this.payoutAmount = _data["payoutAmount"];
            this.paymentAmount = _data["paymentAmount"];
            this.customerFullName = _data["customerFullName"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.payoutDate = _data["payoutDate"] ? new Date(_data["payoutDate"].toString()) : <any>null;
            this.paymentPaidOn = _data["paymentPaidOn"] ? new Date(_data["paymentPaidOn"].toString()) : <any>null;
            this.paymentMethod = _data["paymentMethod"];
        }
    }

    static fromJS(data: any): GetOperatorPayoutsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetOperatorPayoutsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payoutGuid"] = this.payoutGuid;
        data["paymentGuid"] = this.paymentGuid;
        data["bookingId"] = this.bookingId;
        data["bookingGuid"] = this.bookingGuid;
        data["bookingCreatedAt"] = this.bookingCreatedAt && this.bookingCreatedAt.toISOString();
        data["payoutAmount"] = this.payoutAmount;
        data["paymentAmount"] = this.paymentAmount;
        data["customerFullName"] = this.customerFullName;
        data["status"] = this.status;
        data["type"] = this.type;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["payoutDate"] = this.payoutDate && this.payoutDate.toISOString();
        data["paymentPaidOn"] = this.paymentPaidOn && this.paymentPaidOn.toISOString();
        data["paymentMethod"] = this.paymentMethod;
        return data;
    }
}

export interface IGetOperatorPayoutsResult {
    payoutGuid?: string;
    paymentGuid?: string;
    bookingId?: number | null;
    bookingGuid?: string | null;
    bookingCreatedAt?: Date | null;
    payoutAmount?: number;
    paymentAmount?: number;
    customerFullName?: string | null;
    status?: OperatorPayoutStatus;
    type?: OperatorPayoutType;
    createdAt?: Date;
    payoutDate?: Date | null;
    paymentPaidOn?: Date | null;
    paymentMethod?: string | null;
}

export class GetOperatorPayoutsResultPaginatedResult implements IGetOperatorPayoutsResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetOperatorPayoutsResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetOperatorPayoutsResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOperatorPayoutsResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetOperatorPayoutsResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetOperatorPayoutsResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetOperatorPayoutsResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetOperatorPayoutsResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetOperatorPayoutsSummaryQueryResult implements IGetOperatorPayoutsSummaryQueryResult {
    totalAvailableForPayout?: number;
    totalPaidOut?: number;
    collectedFeesSum?: number;

    constructor(data?: IGetOperatorPayoutsSummaryQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAvailableForPayout = _data["totalAvailableForPayout"];
            this.totalPaidOut = _data["totalPaidOut"];
            this.collectedFeesSum = _data["collectedFeesSum"];
        }
    }

    static fromJS(data: any): GetOperatorPayoutsSummaryQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetOperatorPayoutsSummaryQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAvailableForPayout"] = this.totalAvailableForPayout;
        data["totalPaidOut"] = this.totalPaidOut;
        data["collectedFeesSum"] = this.collectedFeesSum;
        return data;
    }
}

export interface IGetOperatorPayoutsSummaryQueryResult {
    totalAvailableForPayout?: number;
    totalPaidOut?: number;
    collectedFeesSum?: number;
}

export class GetOwnerQueryResult implements IGetOwnerQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;

    constructor(data?: IGetOwnerQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.isDisabled = _data["isDisabled"];
            this.userGuid = _data["userGuid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): GetOwnerQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetOwnerQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isDisabled"] = this.isDisabled;
        data["userGuid"] = this.userGuid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IGetOwnerQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
}

export class GetOwnersQueryResult implements IGetOwnersQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    gmv?: number;

    constructor(data?: IGetOwnersQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.isDisabled = _data["isDisabled"];
            this.userGuid = _data["userGuid"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.gmv = _data["gmv"];
        }
    }

    static fromJS(data: any): GetOwnersQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetOwnersQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isDisabled"] = this.isDisabled;
        data["userGuid"] = this.userGuid;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["gmv"] = this.gmv;
        return data;
    }
}

export interface IGetOwnersQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    gmv?: number;
}

export class GetOwnersQueryResultPaginatedResult implements IGetOwnersQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetOwnersQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetOwnersQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOwnersQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetOwnersQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetOwnersQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetOwnersQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetOwnersQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetPackageQueryResult implements IGetPackageQueryResult {
    guid?: string;
    name?: string | null;
    duration?: TimeSpan;
    startTimes?: TimeOnly[] | null;
    market?: MarketResult;
    availableDaysOfWeek?: DayOfWeek[] | null;
    isSunset?: boolean;

    constructor(data?: IGetPackageQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : <any>null;
            if (Array.isArray(_data["startTimes"])) {
                this.startTimes = [] as any;
                for (let item of _data["startTimes"])
                    this.startTimes!.push(TimeOnly.fromJS(item));
            }
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : <any>null;
            if (Array.isArray(_data["availableDaysOfWeek"])) {
                this.availableDaysOfWeek = [] as any;
                for (let item of _data["availableDaysOfWeek"])
                    this.availableDaysOfWeek!.push(item);
            }
            this.isSunset = _data["isSunset"];
        }
    }

    static fromJS(data: any): GetPackageQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackageQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["duration"] = this.duration ? this.duration.toJSON() : this.duration;
        if (Array.isArray(this.startTimes)) {
            data["startTimes"] = [];
            for (let item of this.startTimes)
                data["startTimes"].push(item.toJSON());
        }
        data["market"] = this.market ? this.market.toJSON() : this.market;
        if (Array.isArray(this.availableDaysOfWeek)) {
            data["availableDaysOfWeek"] = [];
            for (let item of this.availableDaysOfWeek)
                data["availableDaysOfWeek"].push(item);
        }
        data["isSunset"] = this.isSunset;
        return data;
    }
}

export interface IGetPackageQueryResult {
    guid?: string;
    name?: string | null;
    duration?: TimeSpan;
    startTimes?: TimeOnly[] | null;
    market?: MarketResult;
    availableDaysOfWeek?: DayOfWeek[] | null;
    isSunset?: boolean;
}

export class GetPackagesQueryResult implements IGetPackagesQueryResult {
    guid?: string;
    name?: string | null;
    market?: MarketResult;
    startTimes?: TimeOnly[] | null;
    duration?: TimeSpan;
    numberOfBoats?: number;
    isSunset?: boolean;

    constructor(data?: IGetPackagesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : <any>null;
            if (Array.isArray(_data["startTimes"])) {
                this.startTimes = [] as any;
                for (let item of _data["startTimes"])
                    this.startTimes!.push(TimeOnly.fromJS(item));
            }
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : <any>null;
            this.numberOfBoats = _data["numberOfBoats"];
            this.isSunset = _data["isSunset"];
        }
    }

    static fromJS(data: any): GetPackagesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackagesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        if (Array.isArray(this.startTimes)) {
            data["startTimes"] = [];
            for (let item of this.startTimes)
                data["startTimes"].push(item.toJSON());
        }
        data["duration"] = this.duration ? this.duration.toJSON() : this.duration;
        data["numberOfBoats"] = this.numberOfBoats;
        data["isSunset"] = this.isSunset;
        return data;
    }
}

export interface IGetPackagesQueryResult {
    guid?: string;
    name?: string | null;
    market?: MarketResult;
    startTimes?: TimeOnly[] | null;
    duration?: TimeSpan;
    numberOfBoats?: number;
    isSunset?: boolean;
}

export class GetPackagesQueryResultPaginatedResult implements IGetPackagesQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetPackagesQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetPackagesQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPackagesQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetPackagesQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPackagesQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetPackagesQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetPackagesQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetPaymentQueryResult implements IGetPaymentQueryResult {
    guid?: string;
    createdAt?: Date;
    amount?: number;
    currency?: string | null;
    note?: string | null;
    status?: PaymentStatus;
    provider?: PaymentProvider;
    externalPaymentInfo?: ExternalPaymentInfo;
    stripePaymentInfo?: StripePaymentInfo;
    authorizeNetPaymentInfo?: AuthorizeNetPaymentInfo;

    constructor(data?: IGetPaymentQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.note = _data["note"];
            this.status = _data["status"];
            this.provider = _data["provider"];
            this.externalPaymentInfo = _data["externalPaymentInfo"] ? ExternalPaymentInfo.fromJS(_data["externalPaymentInfo"]) : <any>null;
            this.stripePaymentInfo = _data["stripePaymentInfo"] ? StripePaymentInfo.fromJS(_data["stripePaymentInfo"]) : <any>null;
            this.authorizeNetPaymentInfo = _data["authorizeNetPaymentInfo"] ? AuthorizeNetPaymentInfo.fromJS(_data["authorizeNetPaymentInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): GetPaymentQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["note"] = this.note;
        data["status"] = this.status;
        data["provider"] = this.provider;
        data["externalPaymentInfo"] = this.externalPaymentInfo ? this.externalPaymentInfo.toJSON() : this.externalPaymentInfo;
        data["stripePaymentInfo"] = this.stripePaymentInfo ? this.stripePaymentInfo.toJSON() : this.stripePaymentInfo;
        data["authorizeNetPaymentInfo"] = this.authorizeNetPaymentInfo ? this.authorizeNetPaymentInfo.toJSON() : this.authorizeNetPaymentInfo;
        return data;
    }
}

export interface IGetPaymentQueryResult {
    guid?: string;
    createdAt?: Date;
    amount?: number;
    currency?: string | null;
    note?: string | null;
    status?: PaymentStatus;
    provider?: PaymentProvider;
    externalPaymentInfo?: ExternalPaymentInfo;
    stripePaymentInfo?: StripePaymentInfo;
    authorizeNetPaymentInfo?: AuthorizeNetPaymentInfo;
}

export class GetPaymentsFeesSummaryQueryResult implements IGetPaymentsFeesSummaryQueryResult {
    feesSum?: number;
    feesCount?: number;
    averagePerFee?: number;

    constructor(data?: IGetPaymentsFeesSummaryQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feesSum = _data["feesSum"];
            this.feesCount = _data["feesCount"];
            this.averagePerFee = _data["averagePerFee"];
        }
    }

    static fromJS(data: any): GetPaymentsFeesSummaryQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentsFeesSummaryQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feesSum"] = this.feesSum;
        data["feesCount"] = this.feesCount;
        data["averagePerFee"] = this.averagePerFee;
        return data;
    }
}

export interface IGetPaymentsFeesSummaryQueryResult {
    feesSum?: number;
    feesCount?: number;
    averagePerFee?: number;
}

export class GetPaymentsQueryResult implements IGetPaymentsQueryResult {
    guid?: string;
    paidOn?: Date | null;
    createdAt?: Date;
    amount?: number;
    status?: PaymentStatus;
    note?: string | null;
    provider?: PaymentProvider;
    externalPaymentInfo?: ExternalPaymentInfo;
    stripePaymentInfo?: StripePaymentInfo;
    authorizeNetPaymentInfo?: AuthorizeNetPaymentProfileInfo;
    worldPayPaymentInfo?: WorldPayPaymentInfo;
    balancePaymentInfo?: BalancePaymentInfo;
    onlineCustomerFee?: OnlineCustomerFee;
    propellerTakeRate?: PropellerTakeRate;
    createdBy?: UserResult;
    isVoided?: boolean;
    voidedReason?: string | null;
    voidedBy?: UserResult;
    voidedAt?: Date | null;

    constructor(data?: IGetPaymentsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.paidOn = _data["paidOn"] ? new Date(_data["paidOn"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.amount = _data["amount"];
            this.status = _data["status"];
            this.note = _data["note"];
            this.provider = _data["provider"];
            this.externalPaymentInfo = _data["externalPaymentInfo"] ? ExternalPaymentInfo.fromJS(_data["externalPaymentInfo"]) : <any>null;
            this.stripePaymentInfo = _data["stripePaymentInfo"] ? StripePaymentInfo.fromJS(_data["stripePaymentInfo"]) : <any>null;
            this.authorizeNetPaymentInfo = _data["authorizeNetPaymentInfo"] ? AuthorizeNetPaymentProfileInfo.fromJS(_data["authorizeNetPaymentInfo"]) : <any>null;
            this.worldPayPaymentInfo = _data["worldPayPaymentInfo"] ? WorldPayPaymentInfo.fromJS(_data["worldPayPaymentInfo"]) : <any>null;
            this.balancePaymentInfo = _data["balancePaymentInfo"] ? BalancePaymentInfo.fromJS(_data["balancePaymentInfo"]) : <any>null;
            this.onlineCustomerFee = _data["onlineCustomerFee"] ? OnlineCustomerFee.fromJS(_data["onlineCustomerFee"]) : <any>null;
            this.propellerTakeRate = _data["propellerTakeRate"] ? PropellerTakeRate.fromJS(_data["propellerTakeRate"]) : <any>null;
            this.createdBy = _data["createdBy"] ? UserResult.fromJS(_data["createdBy"]) : <any>null;
            this.isVoided = _data["isVoided"];
            this.voidedReason = _data["voidedReason"];
            this.voidedBy = _data["voidedBy"] ? UserResult.fromJS(_data["voidedBy"]) : <any>null;
            this.voidedAt = _data["voidedAt"] ? new Date(_data["voidedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetPaymentsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["paidOn"] = this.paidOn && this.paidOn.toISOString();
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["amount"] = this.amount;
        data["status"] = this.status;
        data["note"] = this.note;
        data["provider"] = this.provider;
        data["externalPaymentInfo"] = this.externalPaymentInfo ? this.externalPaymentInfo.toJSON() : this.externalPaymentInfo;
        data["stripePaymentInfo"] = this.stripePaymentInfo ? this.stripePaymentInfo.toJSON() : this.stripePaymentInfo;
        data["authorizeNetPaymentInfo"] = this.authorizeNetPaymentInfo ? this.authorizeNetPaymentInfo.toJSON() : this.authorizeNetPaymentInfo;
        data["worldPayPaymentInfo"] = this.worldPayPaymentInfo ? this.worldPayPaymentInfo.toJSON() : this.worldPayPaymentInfo;
        data["balancePaymentInfo"] = this.balancePaymentInfo ? this.balancePaymentInfo.toJSON() : this.balancePaymentInfo;
        data["onlineCustomerFee"] = this.onlineCustomerFee ? this.onlineCustomerFee.toJSON() : this.onlineCustomerFee;
        data["propellerTakeRate"] = this.propellerTakeRate ? this.propellerTakeRate.toJSON() : this.propellerTakeRate;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : this.createdBy;
        data["isVoided"] = this.isVoided;
        data["voidedReason"] = this.voidedReason;
        data["voidedBy"] = this.voidedBy ? this.voidedBy.toJSON() : this.voidedBy;
        data["voidedAt"] = this.voidedAt && this.voidedAt.toISOString();
        return data;
    }
}

export interface IGetPaymentsQueryResult {
    guid?: string;
    paidOn?: Date | null;
    createdAt?: Date;
    amount?: number;
    status?: PaymentStatus;
    note?: string | null;
    provider?: PaymentProvider;
    externalPaymentInfo?: ExternalPaymentInfo;
    stripePaymentInfo?: StripePaymentInfo;
    authorizeNetPaymentInfo?: AuthorizeNetPaymentProfileInfo;
    worldPayPaymentInfo?: WorldPayPaymentInfo;
    balancePaymentInfo?: BalancePaymentInfo;
    onlineCustomerFee?: OnlineCustomerFee;
    propellerTakeRate?: PropellerTakeRate;
    createdBy?: UserResult;
    isVoided?: boolean;
    voidedReason?: string | null;
    voidedBy?: UserResult;
    voidedAt?: Date | null;
}

export class GetPaymentsQueryResultPaginatedResult implements IGetPaymentsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetPaymentsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetPaymentsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPaymentsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetPaymentsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetPaymentsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetPaymentsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetPaymentsWithFeesQueryResult implements IGetPaymentsWithFeesQueryResult {
    guid?: string;
    paidOn?: Date | null;
    createdAt?: Date;
    feeAmount?: number;
    feePercentage?: number;
    note?: string | null;
    bookingId?: number;
    bookingGuid?: string;
    customerFullName?: string | null;
    bookingTotalPrice?: number;
    paymentAmount?: number;
    provider?: PaymentProvider;
    stripePaymentInfo?: StripePaymentInfo;
    paymentFeeType?: PaymentFeeType;

    constructor(data?: IGetPaymentsWithFeesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.paidOn = _data["paidOn"] ? new Date(_data["paidOn"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.feeAmount = _data["feeAmount"];
            this.feePercentage = _data["feePercentage"];
            this.note = _data["note"];
            this.bookingId = _data["bookingId"];
            this.bookingGuid = _data["bookingGuid"];
            this.customerFullName = _data["customerFullName"];
            this.bookingTotalPrice = _data["bookingTotalPrice"];
            this.paymentAmount = _data["paymentAmount"];
            this.provider = _data["provider"];
            this.stripePaymentInfo = _data["stripePaymentInfo"] ? StripePaymentInfo.fromJS(_data["stripePaymentInfo"]) : <any>null;
            this.paymentFeeType = _data["paymentFeeType"];
        }
    }

    static fromJS(data: any): GetPaymentsWithFeesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentsWithFeesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["paidOn"] = this.paidOn && this.paidOn.toISOString();
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["feeAmount"] = this.feeAmount;
        data["feePercentage"] = this.feePercentage;
        data["note"] = this.note;
        data["bookingId"] = this.bookingId;
        data["bookingGuid"] = this.bookingGuid;
        data["customerFullName"] = this.customerFullName;
        data["bookingTotalPrice"] = this.bookingTotalPrice;
        data["paymentAmount"] = this.paymentAmount;
        data["provider"] = this.provider;
        data["stripePaymentInfo"] = this.stripePaymentInfo ? this.stripePaymentInfo.toJSON() : this.stripePaymentInfo;
        data["paymentFeeType"] = this.paymentFeeType;
        return data;
    }
}

export interface IGetPaymentsWithFeesQueryResult {
    guid?: string;
    paidOn?: Date | null;
    createdAt?: Date;
    feeAmount?: number;
    feePercentage?: number;
    note?: string | null;
    bookingId?: number;
    bookingGuid?: string;
    customerFullName?: string | null;
    bookingTotalPrice?: number;
    paymentAmount?: number;
    provider?: PaymentProvider;
    stripePaymentInfo?: StripePaymentInfo;
    paymentFeeType?: PaymentFeeType;
}

export class GetPaymentsWithFeesQueryResultPaginatedResult implements IGetPaymentsWithFeesQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetPaymentsWithFeesQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetPaymentsWithFeesQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPaymentsWithFeesQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetPaymentsWithFeesQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentsWithFeesQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetPaymentsWithFeesQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetPaymentsWithFeesQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetPerformanceQueryResult implements IGetPerformanceQueryResult {
    date?: Date;
    revenue?: number;
    revenueYtd?: number;
    reservationCount?: number;
    reservationCountYtd?: number;
    readonly averagePerReservation?: number;
    newCustomers?: number;
    repeatCustomers?: number;

    constructor(data?: IGetPerformanceQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
            this.revenue = _data["revenue"];
            this.revenueYtd = _data["revenueYtd"];
            this.reservationCount = _data["reservationCount"];
            this.reservationCountYtd = _data["reservationCountYtd"];
            (<any>this).averagePerReservation = _data["averagePerReservation"];
            this.newCustomers = _data["newCustomers"];
            this.repeatCustomers = _data["repeatCustomers"];
        }
    }

    static fromJS(data: any): GetPerformanceQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPerformanceQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date && formatDate(this.date);
        data["revenue"] = this.revenue;
        data["revenueYtd"] = this.revenueYtd;
        data["reservationCount"] = this.reservationCount;
        data["reservationCountYtd"] = this.reservationCountYtd;
        data["averagePerReservation"] = this.averagePerReservation;
        data["newCustomers"] = this.newCustomers;
        data["repeatCustomers"] = this.repeatCustomers;
        return data;
    }
}

export interface IGetPerformanceQueryResult {
    date?: Date;
    revenue?: number;
    revenueYtd?: number;
    reservationCount?: number;
    reservationCountYtd?: number;
    averagePerReservation?: number;
    newCustomers?: number;
    repeatCustomers?: number;
}

export class GetPlatformAccountAccessTokensQueryResult implements IGetPlatformAccountAccessTokensQueryResult {
    guid?: string;
    token?: string | null;
    description?: string | null;
    expiresAt?: Date | null;
    type?: AccessTokenType;

    constructor(data?: IGetPlatformAccountAccessTokensQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.token = _data["token"];
            this.description = _data["description"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>null;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetPlatformAccountAccessTokensQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlatformAccountAccessTokensQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["token"] = this.token;
        data["description"] = this.description;
        data["expiresAt"] = this.expiresAt && this.expiresAt.toISOString();
        data["type"] = this.type;
        return data;
    }
}

export interface IGetPlatformAccountAccessTokensQueryResult {
    guid?: string;
    token?: string | null;
    description?: string | null;
    expiresAt?: Date | null;
    type?: AccessTokenType;
}

export class GetPlatformAccountPrePaymentSettingsQueryResult implements IGetPlatformAccountPrePaymentSettingsQueryResult {
    defaultPercentage?: number;
    conditionType?: PrePaymentConditionType;
    thresholdDays?: number | null;

    constructor(data?: IGetPlatformAccountPrePaymentSettingsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultPercentage = _data["defaultPercentage"];
            this.conditionType = _data["conditionType"];
            this.thresholdDays = _data["thresholdDays"];
        }
    }

    static fromJS(data: any): GetPlatformAccountPrePaymentSettingsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlatformAccountPrePaymentSettingsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultPercentage"] = this.defaultPercentage;
        data["conditionType"] = this.conditionType;
        data["thresholdDays"] = this.thresholdDays;
        return data;
    }
}

export interface IGetPlatformAccountPrePaymentSettingsQueryResult {
    defaultPercentage?: number;
    conditionType?: PrePaymentConditionType;
    thresholdDays?: number | null;
}

export class GetPlatformAccountQueryResult implements IGetPlatformAccountQueryResult {
    guid?: string;
    name?: string | null;
    email?: string | null;
    phone?: string | null;
    logoUrl?: string | null;
    logoStyle?: string | null;
    status?: PlatformAccountStatus;
    isDeleted?: boolean;
    timeZoneInfoId?: string | null;
    culture?: string | null;
    country?: string | null;
    currency?: string | null;
    onlineCustomerFeePercentage?: number;
    propellerTakeRatePercentage?: number;
    operatorProcessingFeeSharePercentage?: number | null;
    billingInfo?: PlatformAccountBillingInfo;
    newFormLeadNotificationEmail?: string | null;
    worldPayMerchantId?: string | null;
    stripeConnectedAccountId?: string | null;
    paymentGateway?: PaymentGateway;
    cashPaymentLimitAmount?: number | null;
    contractProviderType?: ContractProviderType;
    taxType?: TaxType;
    defaultTaxes?: TaxLine[] | null;
    onlineCustomerFeeTaxes?: TaxLine[] | null;
    formLeadSenderEmail?: string | null;
    formLeadSenderDisplayName?: string | null;
    twilioPhoneNumber?: string | null;
    settings?: PlatformAccountSettings;
    locale?: LocaleSettingsResult;
    aircallApiId?: string | null;
    hasAircallApiToken?: boolean;
    conversionTrackingConfigs?: ConversionTrackingDomainConfigDto[] | null;
    externalContractUrlTemplate?: string | null;
    bookingWebhookUrl?: string | null;
    hasBookingWebhookApiToken?: boolean;

    constructor(data?: IGetPlatformAccountQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.logoUrl = _data["logoUrl"];
            this.logoStyle = _data["logoStyle"];
            this.status = _data["status"];
            this.isDeleted = _data["isDeleted"];
            this.timeZoneInfoId = _data["timeZoneInfoId"];
            this.culture = _data["culture"];
            this.country = _data["country"];
            this.currency = _data["currency"];
            this.onlineCustomerFeePercentage = _data["onlineCustomerFeePercentage"];
            this.propellerTakeRatePercentage = _data["propellerTakeRatePercentage"];
            this.operatorProcessingFeeSharePercentage = _data["operatorProcessingFeeSharePercentage"];
            this.billingInfo = _data["billingInfo"] ? PlatformAccountBillingInfo.fromJS(_data["billingInfo"]) : <any>null;
            this.newFormLeadNotificationEmail = _data["newFormLeadNotificationEmail"];
            this.worldPayMerchantId = _data["worldPayMerchantId"];
            this.stripeConnectedAccountId = _data["stripeConnectedAccountId"];
            this.paymentGateway = _data["paymentGateway"];
            this.cashPaymentLimitAmount = _data["cashPaymentLimitAmount"];
            this.contractProviderType = _data["contractProviderType"];
            this.taxType = _data["taxType"];
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
            if (Array.isArray(_data["onlineCustomerFeeTaxes"])) {
                this.onlineCustomerFeeTaxes = [] as any;
                for (let item of _data["onlineCustomerFeeTaxes"])
                    this.onlineCustomerFeeTaxes!.push(TaxLine.fromJS(item));
            }
            this.formLeadSenderEmail = _data["formLeadSenderEmail"];
            this.formLeadSenderDisplayName = _data["formLeadSenderDisplayName"];
            this.twilioPhoneNumber = _data["twilioPhoneNumber"];
            this.settings = _data["settings"] ? PlatformAccountSettings.fromJS(_data["settings"]) : <any>null;
            this.locale = _data["locale"] ? LocaleSettingsResult.fromJS(_data["locale"]) : <any>null;
            this.aircallApiId = _data["aircallApiId"];
            this.hasAircallApiToken = _data["hasAircallApiToken"];
            if (Array.isArray(_data["conversionTrackingConfigs"])) {
                this.conversionTrackingConfigs = [] as any;
                for (let item of _data["conversionTrackingConfigs"])
                    this.conversionTrackingConfigs!.push(ConversionTrackingDomainConfigDto.fromJS(item));
            }
            this.externalContractUrlTemplate = _data["externalContractUrlTemplate"];
            this.bookingWebhookUrl = _data["bookingWebhookUrl"];
            this.hasBookingWebhookApiToken = _data["hasBookingWebhookApiToken"];
        }
    }

    static fromJS(data: any): GetPlatformAccountQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlatformAccountQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["logoUrl"] = this.logoUrl;
        data["logoStyle"] = this.logoStyle;
        data["status"] = this.status;
        data["isDeleted"] = this.isDeleted;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        data["culture"] = this.culture;
        data["country"] = this.country;
        data["currency"] = this.currency;
        data["onlineCustomerFeePercentage"] = this.onlineCustomerFeePercentage;
        data["propellerTakeRatePercentage"] = this.propellerTakeRatePercentage;
        data["operatorProcessingFeeSharePercentage"] = this.operatorProcessingFeeSharePercentage;
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : this.billingInfo;
        data["newFormLeadNotificationEmail"] = this.newFormLeadNotificationEmail;
        data["worldPayMerchantId"] = this.worldPayMerchantId;
        data["stripeConnectedAccountId"] = this.stripeConnectedAccountId;
        data["paymentGateway"] = this.paymentGateway;
        data["cashPaymentLimitAmount"] = this.cashPaymentLimitAmount;
        data["contractProviderType"] = this.contractProviderType;
        data["taxType"] = this.taxType;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        if (Array.isArray(this.onlineCustomerFeeTaxes)) {
            data["onlineCustomerFeeTaxes"] = [];
            for (let item of this.onlineCustomerFeeTaxes)
                data["onlineCustomerFeeTaxes"].push(item.toJSON());
        }
        data["formLeadSenderEmail"] = this.formLeadSenderEmail;
        data["formLeadSenderDisplayName"] = this.formLeadSenderDisplayName;
        data["twilioPhoneNumber"] = this.twilioPhoneNumber;
        data["settings"] = this.settings ? this.settings.toJSON() : this.settings;
        data["locale"] = this.locale ? this.locale.toJSON() : this.locale;
        data["aircallApiId"] = this.aircallApiId;
        data["hasAircallApiToken"] = this.hasAircallApiToken;
        if (Array.isArray(this.conversionTrackingConfigs)) {
            data["conversionTrackingConfigs"] = [];
            for (let item of this.conversionTrackingConfigs)
                data["conversionTrackingConfigs"].push(item.toJSON());
        }
        data["externalContractUrlTemplate"] = this.externalContractUrlTemplate;
        data["bookingWebhookUrl"] = this.bookingWebhookUrl;
        data["hasBookingWebhookApiToken"] = this.hasBookingWebhookApiToken;
        return data;
    }
}

export interface IGetPlatformAccountQueryResult {
    guid?: string;
    name?: string | null;
    email?: string | null;
    phone?: string | null;
    logoUrl?: string | null;
    logoStyle?: string | null;
    status?: PlatformAccountStatus;
    isDeleted?: boolean;
    timeZoneInfoId?: string | null;
    culture?: string | null;
    country?: string | null;
    currency?: string | null;
    onlineCustomerFeePercentage?: number;
    propellerTakeRatePercentage?: number;
    operatorProcessingFeeSharePercentage?: number | null;
    billingInfo?: PlatformAccountBillingInfo;
    newFormLeadNotificationEmail?: string | null;
    worldPayMerchantId?: string | null;
    stripeConnectedAccountId?: string | null;
    paymentGateway?: PaymentGateway;
    cashPaymentLimitAmount?: number | null;
    contractProviderType?: ContractProviderType;
    taxType?: TaxType;
    defaultTaxes?: TaxLine[] | null;
    onlineCustomerFeeTaxes?: TaxLine[] | null;
    formLeadSenderEmail?: string | null;
    formLeadSenderDisplayName?: string | null;
    twilioPhoneNumber?: string | null;
    settings?: PlatformAccountSettings;
    locale?: LocaleSettingsResult;
    aircallApiId?: string | null;
    hasAircallApiToken?: boolean;
    conversionTrackingConfigs?: ConversionTrackingDomainConfigDto[] | null;
    externalContractUrlTemplate?: string | null;
    bookingWebhookUrl?: string | null;
    hasBookingWebhookApiToken?: boolean;
}

export class GetPlatformAccountSettingsQueryResult implements IGetPlatformAccountSettingsQueryResult {
    name?: string | null;
    settings?: PlatformAccountSettings;
    measurementSystem?: MeasurementSystem;
    conversionTrackingEnabled?: boolean;
    locale?: LocaleSettingsResult;
    phone?: string | null;

    constructor(data?: IGetPlatformAccountSettingsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.settings = _data["settings"] ? PlatformAccountSettings.fromJS(_data["settings"]) : <any>null;
            this.measurementSystem = _data["measurementSystem"];
            this.conversionTrackingEnabled = _data["conversionTrackingEnabled"];
            this.locale = _data["locale"] ? LocaleSettingsResult.fromJS(_data["locale"]) : <any>null;
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): GetPlatformAccountSettingsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlatformAccountSettingsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["settings"] = this.settings ? this.settings.toJSON() : this.settings;
        data["measurementSystem"] = this.measurementSystem;
        data["conversionTrackingEnabled"] = this.conversionTrackingEnabled;
        data["locale"] = this.locale ? this.locale.toJSON() : this.locale;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IGetPlatformAccountSettingsQueryResult {
    name?: string | null;
    settings?: PlatformAccountSettings;
    measurementSystem?: MeasurementSystem;
    conversionTrackingEnabled?: boolean;
    locale?: LocaleSettingsResult;
    phone?: string | null;
}

export class GetPlatformAccountsQueryResult implements IGetPlatformAccountsQueryResult {
    guid?: string;
    name?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: PlatformAccountStatus;
    isDeleted?: boolean;
    paymentGateway?: PaymentGateway;

    constructor(data?: IGetPlatformAccountsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            this.isDeleted = _data["isDeleted"];
            this.paymentGateway = _data["paymentGateway"];
        }
    }

    static fromJS(data: any): GetPlatformAccountsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlatformAccountsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["isDeleted"] = this.isDeleted;
        data["paymentGateway"] = this.paymentGateway;
        return data;
    }
}

export interface IGetPlatformAccountsQueryResult {
    guid?: string;
    name?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: PlatformAccountStatus;
    isDeleted?: boolean;
    paymentGateway?: PaymentGateway;
}

export class GetPlatformAccountsQueryResultPaginatedResult implements IGetPlatformAccountsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetPlatformAccountsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetPlatformAccountsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPlatformAccountsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetPlatformAccountsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlatformAccountsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetPlatformAccountsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetPlatformAccountsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetPricingModeInfoQueryResult implements IGetPricingModeInfoQueryResult {
    hasPackagesPricingMode?: boolean;
    hasCalendarPricingMode?: boolean;

    constructor(data?: IGetPricingModeInfoQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasPackagesPricingMode = _data["hasPackagesPricingMode"];
            this.hasCalendarPricingMode = _data["hasCalendarPricingMode"];
        }
    }

    static fromJS(data: any): GetPricingModeInfoQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricingModeInfoQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasPackagesPricingMode"] = this.hasPackagesPricingMode;
        data["hasCalendarPricingMode"] = this.hasCalendarPricingMode;
        return data;
    }
}

export interface IGetPricingModeInfoQueryResult {
    hasPackagesPricingMode?: boolean;
    hasCalendarPricingMode?: boolean;
}

export class GetPricingQueryResult implements IGetPricingQueryResult {
    guid?: string;
    boatGuid?: string;
    listingTitle?: string | null;
    package?: PricingPackage;
    basePrice?: number;
    extraPassengerPrice?: number;
    extraPassengers?: number;
    includedPassengers?: number;
    additionalFees?: PricingAdditionalFeeRecord[] | null;
    sortOrder?: number | null;

    constructor(data?: IGetPricingQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.boatGuid = _data["boatGuid"];
            this.listingTitle = _data["listingTitle"];
            this.package = _data["package"] ? PricingPackage.fromJS(_data["package"]) : <any>null;
            this.basePrice = _data["basePrice"];
            this.extraPassengerPrice = _data["extraPassengerPrice"];
            this.extraPassengers = _data["extraPassengers"];
            this.includedPassengers = _data["includedPassengers"];
            if (Array.isArray(_data["additionalFees"])) {
                this.additionalFees = [] as any;
                for (let item of _data["additionalFees"])
                    this.additionalFees!.push(PricingAdditionalFeeRecord.fromJS(item));
            }
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): GetPricingQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricingQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["boatGuid"] = this.boatGuid;
        data["listingTitle"] = this.listingTitle;
        data["package"] = this.package ? this.package.toJSON() : this.package;
        data["basePrice"] = this.basePrice;
        data["extraPassengerPrice"] = this.extraPassengerPrice;
        data["extraPassengers"] = this.extraPassengers;
        data["includedPassengers"] = this.includedPassengers;
        if (Array.isArray(this.additionalFees)) {
            data["additionalFees"] = [];
            for (let item of this.additionalFees)
                data["additionalFees"].push(item.toJSON());
        }
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IGetPricingQueryResult {
    guid?: string;
    boatGuid?: string;
    listingTitle?: string | null;
    package?: PricingPackage;
    basePrice?: number;
    extraPassengerPrice?: number;
    extraPassengers?: number;
    includedPassengers?: number;
    additionalFees?: PricingAdditionalFeeRecord[] | null;
    sortOrder?: number | null;
}

export class GetPricingsQueryResult implements IGetPricingsQueryResult {
    guid?: string;
    name?: string | null;
    duration?: TimeSpan;
    startTimes?: TimeOnly[] | null;
    listingTitle?: string | null;
    boatGuid?: string;
    market?: MarketResult;
    basePrice?: number;
    additionalFees?: PricingAdditionalFeeRecord[] | null;
    totalPrice?: number;
    pricingPackageGuid?: string;
    sortOrder?: number | null;
    isDefault?: boolean;

    constructor(data?: IGetPricingsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : <any>null;
            if (Array.isArray(_data["startTimes"])) {
                this.startTimes = [] as any;
                for (let item of _data["startTimes"])
                    this.startTimes!.push(TimeOnly.fromJS(item));
            }
            this.listingTitle = _data["listingTitle"];
            this.boatGuid = _data["boatGuid"];
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : <any>null;
            this.basePrice = _data["basePrice"];
            if (Array.isArray(_data["additionalFees"])) {
                this.additionalFees = [] as any;
                for (let item of _data["additionalFees"])
                    this.additionalFees!.push(PricingAdditionalFeeRecord.fromJS(item));
            }
            this.totalPrice = _data["totalPrice"];
            this.pricingPackageGuid = _data["pricingPackageGuid"];
            this.sortOrder = _data["sortOrder"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): GetPricingsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricingsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["duration"] = this.duration ? this.duration.toJSON() : this.duration;
        if (Array.isArray(this.startTimes)) {
            data["startTimes"] = [];
            for (let item of this.startTimes)
                data["startTimes"].push(item.toJSON());
        }
        data["listingTitle"] = this.listingTitle;
        data["boatGuid"] = this.boatGuid;
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["basePrice"] = this.basePrice;
        if (Array.isArray(this.additionalFees)) {
            data["additionalFees"] = [];
            for (let item of this.additionalFees)
                data["additionalFees"].push(item.toJSON());
        }
        data["totalPrice"] = this.totalPrice;
        data["pricingPackageGuid"] = this.pricingPackageGuid;
        data["sortOrder"] = this.sortOrder;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IGetPricingsQueryResult {
    guid?: string;
    name?: string | null;
    duration?: TimeSpan;
    startTimes?: TimeOnly[] | null;
    listingTitle?: string | null;
    boatGuid?: string;
    market?: MarketResult;
    basePrice?: number;
    additionalFees?: PricingAdditionalFeeRecord[] | null;
    totalPrice?: number;
    pricingPackageGuid?: string;
    sortOrder?: number | null;
    isDefault?: boolean;
}

export class GetPricingsQueryResultPaginatedResult implements IGetPricingsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetPricingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetPricingsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPricingsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetPricingsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricingsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetPricingsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetPricingsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetProspectsQueryResult implements IGetProspectsQueryResult {
    guid?: string;
    fullName?: string | null;
    customerNumber?: string | null;
    email?: string | null;
    phone?: string | null;
    customerMarkets?: MarketResult[] | null;
    lastEnquiryBoatGuid?: string;
    lastEnquiryListingTitle?: string | null;
    lastEnquiryStartDateLocal?: Date;
    lastEnquiryEndDateLocal?: Date;
    lastEnquiryCreatedAtUtc?: Date;
    lastEnquiryBasePrice?: number;
    bookingEnquiries?: number;
    totalEnquiriesBasePrice?: number;

    constructor(data?: IGetProspectsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.fullName = _data["fullName"];
            this.customerNumber = _data["customerNumber"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["customerMarkets"])) {
                this.customerMarkets = [] as any;
                for (let item of _data["customerMarkets"])
                    this.customerMarkets!.push(MarketResult.fromJS(item));
            }
            this.lastEnquiryBoatGuid = _data["lastEnquiryBoatGuid"];
            this.lastEnquiryListingTitle = _data["lastEnquiryListingTitle"];
            this.lastEnquiryStartDateLocal = _data["lastEnquiryStartDateLocal"] ? new Date(_data["lastEnquiryStartDateLocal"].toString()) : <any>null;
            this.lastEnquiryEndDateLocal = _data["lastEnquiryEndDateLocal"] ? new Date(_data["lastEnquiryEndDateLocal"].toString()) : <any>null;
            this.lastEnquiryCreatedAtUtc = _data["lastEnquiryCreatedAtUtc"] ? new Date(_data["lastEnquiryCreatedAtUtc"].toString()) : <any>null;
            this.lastEnquiryBasePrice = _data["lastEnquiryBasePrice"];
            this.bookingEnquiries = _data["bookingEnquiries"];
            this.totalEnquiriesBasePrice = _data["totalEnquiriesBasePrice"];
        }
    }

    static fromJS(data: any): GetProspectsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetProspectsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["fullName"] = this.fullName;
        data["customerNumber"] = this.customerNumber;
        data["email"] = this.email;
        data["phone"] = this.phone;
        if (Array.isArray(this.customerMarkets)) {
            data["customerMarkets"] = [];
            for (let item of this.customerMarkets)
                data["customerMarkets"].push(item.toJSON());
        }
        data["lastEnquiryBoatGuid"] = this.lastEnquiryBoatGuid;
        data["lastEnquiryListingTitle"] = this.lastEnquiryListingTitle;
        data["lastEnquiryStartDateLocal"] = this.lastEnquiryStartDateLocal && this.lastEnquiryStartDateLocal.toISOString();
        data["lastEnquiryEndDateLocal"] = this.lastEnquiryEndDateLocal && this.lastEnquiryEndDateLocal.toISOString();
        data["lastEnquiryCreatedAtUtc"] = this.lastEnquiryCreatedAtUtc && this.lastEnquiryCreatedAtUtc.toISOString();
        data["lastEnquiryBasePrice"] = this.lastEnquiryBasePrice;
        data["bookingEnquiries"] = this.bookingEnquiries;
        data["totalEnquiriesBasePrice"] = this.totalEnquiriesBasePrice;
        return data;
    }
}

export interface IGetProspectsQueryResult {
    guid?: string;
    fullName?: string | null;
    customerNumber?: string | null;
    email?: string | null;
    phone?: string | null;
    customerMarkets?: MarketResult[] | null;
    lastEnquiryBoatGuid?: string;
    lastEnquiryListingTitle?: string | null;
    lastEnquiryStartDateLocal?: Date;
    lastEnquiryEndDateLocal?: Date;
    lastEnquiryCreatedAtUtc?: Date;
    lastEnquiryBasePrice?: number;
    bookingEnquiries?: number;
    totalEnquiriesBasePrice?: number;
}

export class GetProspectsQueryResultPaginatedResult implements IGetProspectsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetProspectsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetProspectsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetProspectsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetProspectsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetProspectsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetProspectsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetProspectsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetProspectsStatisticsQueryResult implements IGetProspectsStatisticsQueryResult {
    prospectsWithEnquiries?: number;
    enquiries?: number;
    totalAmountOfEnquiries?: number;

    constructor(data?: IGetProspectsStatisticsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectsWithEnquiries = _data["prospectsWithEnquiries"];
            this.enquiries = _data["enquiries"];
            this.totalAmountOfEnquiries = _data["totalAmountOfEnquiries"];
        }
    }

    static fromJS(data: any): GetProspectsStatisticsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetProspectsStatisticsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectsWithEnquiries"] = this.prospectsWithEnquiries;
        data["enquiries"] = this.enquiries;
        data["totalAmountOfEnquiries"] = this.totalAmountOfEnquiries;
        return data;
    }
}

export interface IGetProspectsStatisticsQueryResult {
    prospectsWithEnquiries?: number;
    enquiries?: number;
    totalAmountOfEnquiries?: number;
}

export class GetPublicPlatformAccountQueryResult implements IGetPublicPlatformAccountQueryResult {
    guid?: string;
    name?: string | null;
    email?: string | null;
    timeZoneInfoId?: string | null;
    culture?: string | null;
    currency?: string | null;
    currencySymbol?: string | null;
    status?: PlatformAccountStatus;
    logoUrl?: string | null;
    taxType?: TaxType;
    settings?: PlatformAccountSettings;
    defaultTaxes?: TaxLine[] | null;
    onlineCustomerFeePercentage?: number;
    paymentGateway?: PaymentGateway;
    externalContractUrlTemplate?: string | null;
    locale?: LocaleSettingsResult;

    constructor(data?: IGetPublicPlatformAccountQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.timeZoneInfoId = _data["timeZoneInfoId"];
            this.culture = _data["culture"];
            this.currency = _data["currency"];
            this.currencySymbol = _data["currencySymbol"];
            this.status = _data["status"];
            this.logoUrl = _data["logoUrl"];
            this.taxType = _data["taxType"];
            this.settings = _data["settings"] ? PlatformAccountSettings.fromJS(_data["settings"]) : <any>null;
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
            this.onlineCustomerFeePercentage = _data["onlineCustomerFeePercentage"];
            this.paymentGateway = _data["paymentGateway"];
            this.externalContractUrlTemplate = _data["externalContractUrlTemplate"];
            this.locale = _data["locale"] ? LocaleSettingsResult.fromJS(_data["locale"]) : <any>null;
        }
    }

    static fromJS(data: any): GetPublicPlatformAccountQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicPlatformAccountQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["email"] = this.email;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        data["culture"] = this.culture;
        data["currency"] = this.currency;
        data["currencySymbol"] = this.currencySymbol;
        data["status"] = this.status;
        data["logoUrl"] = this.logoUrl;
        data["taxType"] = this.taxType;
        data["settings"] = this.settings ? this.settings.toJSON() : this.settings;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        data["onlineCustomerFeePercentage"] = this.onlineCustomerFeePercentage;
        data["paymentGateway"] = this.paymentGateway;
        data["externalContractUrlTemplate"] = this.externalContractUrlTemplate;
        data["locale"] = this.locale ? this.locale.toJSON() : this.locale;
        return data;
    }
}

export interface IGetPublicPlatformAccountQueryResult {
    guid?: string;
    name?: string | null;
    email?: string | null;
    timeZoneInfoId?: string | null;
    culture?: string | null;
    currency?: string | null;
    currencySymbol?: string | null;
    status?: PlatformAccountStatus;
    logoUrl?: string | null;
    taxType?: TaxType;
    settings?: PlatformAccountSettings;
    defaultTaxes?: TaxLine[] | null;
    onlineCustomerFeePercentage?: number;
    paymentGateway?: PaymentGateway;
    externalContractUrlTemplate?: string | null;
    locale?: LocaleSettingsResult;
}

export class GetRentersQueryResult implements IGetRentersQueryResult {
    guid?: string;
    fullName?: string | null;
    customerNumber?: string | null;
    email?: string | null;
    phone?: string | null;
    customerMarkets?: GetRentersQueryResultMarkets[] | null;
    rating?: CustomerRating;
    ratingPosition?: number | null;
    totalSpent?: number;
    averageSpent?: number;
    futureBookings?: number;
    pastBookings?: number;
    bookingEnquiries?: number;
    bookingOffers?: number;
    reservedBookings?: number;
    cancelledBookings?: number;
    declinedBookings?: number;
    totalBookings?: number;
    lastBooking?: Date | null;
    createdAt?: Date;

    constructor(data?: IGetRentersQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.fullName = _data["fullName"];
            this.customerNumber = _data["customerNumber"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["customerMarkets"])) {
                this.customerMarkets = [] as any;
                for (let item of _data["customerMarkets"])
                    this.customerMarkets!.push(GetRentersQueryResultMarkets.fromJS(item));
            }
            this.rating = _data["rating"];
            this.ratingPosition = _data["ratingPosition"];
            this.totalSpent = _data["totalSpent"];
            this.averageSpent = _data["averageSpent"];
            this.futureBookings = _data["futureBookings"];
            this.pastBookings = _data["pastBookings"];
            this.bookingEnquiries = _data["bookingEnquiries"];
            this.bookingOffers = _data["bookingOffers"];
            this.reservedBookings = _data["reservedBookings"];
            this.cancelledBookings = _data["cancelledBookings"];
            this.declinedBookings = _data["declinedBookings"];
            this.totalBookings = _data["totalBookings"];
            this.lastBooking = _data["lastBooking"] ? parseDateOnly(_data["lastBooking"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetRentersQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetRentersQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["fullName"] = this.fullName;
        data["customerNumber"] = this.customerNumber;
        data["email"] = this.email;
        data["phone"] = this.phone;
        if (Array.isArray(this.customerMarkets)) {
            data["customerMarkets"] = [];
            for (let item of this.customerMarkets)
                data["customerMarkets"].push(item.toJSON());
        }
        data["rating"] = this.rating;
        data["ratingPosition"] = this.ratingPosition;
        data["totalSpent"] = this.totalSpent;
        data["averageSpent"] = this.averageSpent;
        data["futureBookings"] = this.futureBookings;
        data["pastBookings"] = this.pastBookings;
        data["bookingEnquiries"] = this.bookingEnquiries;
        data["bookingOffers"] = this.bookingOffers;
        data["reservedBookings"] = this.reservedBookings;
        data["cancelledBookings"] = this.cancelledBookings;
        data["declinedBookings"] = this.declinedBookings;
        data["totalBookings"] = this.totalBookings;
        data["lastBooking"] = this.lastBooking && formatDate(this.lastBooking);
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        return data;
    }
}

export interface IGetRentersQueryResult {
    guid?: string;
    fullName?: string | null;
    customerNumber?: string | null;
    email?: string | null;
    phone?: string | null;
    customerMarkets?: GetRentersQueryResultMarkets[] | null;
    rating?: CustomerRating;
    ratingPosition?: number | null;
    totalSpent?: number;
    averageSpent?: number;
    futureBookings?: number;
    pastBookings?: number;
    bookingEnquiries?: number;
    bookingOffers?: number;
    reservedBookings?: number;
    cancelledBookings?: number;
    declinedBookings?: number;
    totalBookings?: number;
    lastBooking?: Date | null;
    createdAt?: Date;
}

export class GetRentersQueryResultMarkets implements IGetRentersQueryResultMarkets {
    guid?: string;
    title?: string | null;
    code?: string | null;

    constructor(data?: IGetRentersQueryResultMarkets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): GetRentersQueryResultMarkets {
        data = typeof data === 'object' ? data : {};
        let result = new GetRentersQueryResultMarkets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["code"] = this.code;
        return data;
    }
}

export interface IGetRentersQueryResultMarkets {
    guid?: string;
    title?: string | null;
    code?: string | null;
}

export class GetRentersQueryResultPaginatedResult implements IGetRentersQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetRentersQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetRentersQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetRentersQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetRentersQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetRentersQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetRentersQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetRentersQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetRevenueByPaymentMethodQueryResult implements IGetRevenueByPaymentMethodQueryResult {
    currency?: string | null;
    totalRevenue?: number;
    revenuesByPaymentMethod?: RevenueByPaymentMethodModel[] | null;

    constructor(data?: IGetRevenueByPaymentMethodQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            this.totalRevenue = _data["totalRevenue"];
            if (Array.isArray(_data["revenuesByPaymentMethod"])) {
                this.revenuesByPaymentMethod = [] as any;
                for (let item of _data["revenuesByPaymentMethod"])
                    this.revenuesByPaymentMethod!.push(RevenueByPaymentMethodModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRevenueByPaymentMethodQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetRevenueByPaymentMethodQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["totalRevenue"] = this.totalRevenue;
        if (Array.isArray(this.revenuesByPaymentMethod)) {
            data["revenuesByPaymentMethod"] = [];
            for (let item of this.revenuesByPaymentMethod)
                data["revenuesByPaymentMethod"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRevenueByPaymentMethodQueryResult {
    currency?: string | null;
    totalRevenue?: number;
    revenuesByPaymentMethod?: RevenueByPaymentMethodModel[] | null;
}

export class GetRevenueQueryResult implements IGetRevenueQueryResult {
    granularity?: RevenueGranularity;
    currency?: string | null;
    totalRevenue?: number;
    items?: DayRevenueModel[] | null;

    constructor(data?: IGetRevenueQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.granularity = _data["granularity"];
            this.currency = _data["currency"];
            this.totalRevenue = _data["totalRevenue"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DayRevenueModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRevenueQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetRevenueQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["granularity"] = this.granularity;
        data["currency"] = this.currency;
        data["totalRevenue"] = this.totalRevenue;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRevenueQueryResult {
    granularity?: RevenueGranularity;
    currency?: string | null;
    totalRevenue?: number;
    items?: DayRevenueModel[] | null;
}

export class GetSalesLeadDetailQueryResult implements IGetSalesLeadDetailQueryResult {
    guid!: string;
    status!: SalesLeadStatus;
    origin!: SalesLeadOrigin;
    name!: string | null;
    email!: string | null;
    phone!: string | null;
    numberOfGuests!: number | null;
    budget!: number | null;
    departureDate!: Date | null;
    boat!: SalesLeadBoat;
    message!: string | null;
    source!: string | null;
    submissionDateUtc!: Date;
    assigneeGuid!: string | null;
    assigneeName!: string | null;
    customerGuid!: string | null;
    customerNumber!: number | null;
    isClosed!: boolean;
    closedDateUtc!: Date | null;
    notes!: SalesLeadNote[] | null;
    acceptedSmsConsent!: boolean | null;
    salesLeadBookings!: SalesLeadBooking[] | null;
    customerHistoricalBookings!: BookingSummaryDto[] | null;
    customerUpcomingBookings!: BookingSummaryDto[] | null;
    aircallData!: SalesLeadDetailAircallDataResult;

    constructor(data?: IGetSalesLeadDetailQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boat = new SalesLeadBoat();
            this.aircallData = new SalesLeadDetailAircallDataResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.status = _data["status"];
            this.origin = _data["origin"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.numberOfGuests = _data["numberOfGuests"];
            this.budget = _data["budget"];
            this.departureDate = _data["departureDate"] ? new Date(_data["departureDate"].toString()) : <any>null;
            this.boat = _data["boat"] ? SalesLeadBoat.fromJS(_data["boat"]) : new SalesLeadBoat();
            this.message = _data["message"];
            this.source = _data["source"];
            this.submissionDateUtc = _data["submissionDateUtc"] ? new Date(_data["submissionDateUtc"].toString()) : <any>null;
            this.assigneeGuid = _data["assigneeGuid"];
            this.assigneeName = _data["assigneeName"];
            this.customerGuid = _data["customerGuid"];
            this.customerNumber = _data["customerNumber"];
            this.isClosed = _data["isClosed"];
            this.closedDateUtc = _data["closedDateUtc"] ? new Date(_data["closedDateUtc"].toString()) : <any>null;
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(SalesLeadNote.fromJS(item));
            }
            this.acceptedSmsConsent = _data["acceptedSmsConsent"];
            if (Array.isArray(_data["salesLeadBookings"])) {
                this.salesLeadBookings = [] as any;
                for (let item of _data["salesLeadBookings"])
                    this.salesLeadBookings!.push(SalesLeadBooking.fromJS(item));
            }
            if (Array.isArray(_data["customerHistoricalBookings"])) {
                this.customerHistoricalBookings = [] as any;
                for (let item of _data["customerHistoricalBookings"])
                    this.customerHistoricalBookings!.push(BookingSummaryDto.fromJS(item));
            }
            if (Array.isArray(_data["customerUpcomingBookings"])) {
                this.customerUpcomingBookings = [] as any;
                for (let item of _data["customerUpcomingBookings"])
                    this.customerUpcomingBookings!.push(BookingSummaryDto.fromJS(item));
            }
            this.aircallData = _data["aircallData"] ? SalesLeadDetailAircallDataResult.fromJS(_data["aircallData"]) : new SalesLeadDetailAircallDataResult();
        }
    }

    static fromJS(data: any): GetSalesLeadDetailQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesLeadDetailQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["status"] = this.status;
        data["origin"] = this.origin;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["numberOfGuests"] = this.numberOfGuests;
        data["budget"] = this.budget;
        data["departureDate"] = this.departureDate && this.departureDate.toISOString();
        data["boat"] = this.boat ? this.boat.toJSON() : this.boat;
        data["message"] = this.message;
        data["source"] = this.source;
        data["submissionDateUtc"] = this.submissionDateUtc && this.submissionDateUtc.toISOString();
        data["assigneeGuid"] = this.assigneeGuid;
        data["assigneeName"] = this.assigneeName;
        data["customerGuid"] = this.customerGuid;
        data["customerNumber"] = this.customerNumber;
        data["isClosed"] = this.isClosed;
        data["closedDateUtc"] = this.closedDateUtc && this.closedDateUtc.toISOString();
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["acceptedSmsConsent"] = this.acceptedSmsConsent;
        if (Array.isArray(this.salesLeadBookings)) {
            data["salesLeadBookings"] = [];
            for (let item of this.salesLeadBookings)
                data["salesLeadBookings"].push(item.toJSON());
        }
        if (Array.isArray(this.customerHistoricalBookings)) {
            data["customerHistoricalBookings"] = [];
            for (let item of this.customerHistoricalBookings)
                data["customerHistoricalBookings"].push(item.toJSON());
        }
        if (Array.isArray(this.customerUpcomingBookings)) {
            data["customerUpcomingBookings"] = [];
            for (let item of this.customerUpcomingBookings)
                data["customerUpcomingBookings"].push(item.toJSON());
        }
        data["aircallData"] = this.aircallData ? this.aircallData.toJSON() : this.aircallData;
        return data;
    }
}

export interface IGetSalesLeadDetailQueryResult {
    guid: string;
    status: SalesLeadStatus;
    origin: SalesLeadOrigin;
    name: string | null;
    email: string | null;
    phone: string | null;
    numberOfGuests: number | null;
    budget: number | null;
    departureDate: Date | null;
    boat: SalesLeadBoat;
    message: string | null;
    source: string | null;
    submissionDateUtc: Date;
    assigneeGuid: string | null;
    assigneeName: string | null;
    customerGuid: string | null;
    customerNumber: number | null;
    isClosed: boolean;
    closedDateUtc: Date | null;
    notes: SalesLeadNote[] | null;
    acceptedSmsConsent: boolean | null;
    salesLeadBookings: SalesLeadBooking[] | null;
    customerHistoricalBookings: BookingSummaryDto[] | null;
    customerUpcomingBookings: BookingSummaryDto[] | null;
    aircallData: SalesLeadDetailAircallDataResult;
}

export class GetSalesLeadMessagesQueryResult implements IGetSalesLeadMessagesQueryResult {
    messages!: SalesLeadMessageDto[] | null;
    totalCount!: number;
    unreadCount!: number;

    constructor(data?: IGetSalesLeadMessagesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(SalesLeadMessageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.unreadCount = _data["unreadCount"];
        }
    }

    static fromJS(data: any): GetSalesLeadMessagesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesLeadMessagesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["unreadCount"] = this.unreadCount;
        return data;
    }
}

export interface IGetSalesLeadMessagesQueryResult {
    messages: SalesLeadMessageDto[] | null;
    totalCount: number;
    unreadCount: number;
}

export class GetSalesLeadStatisticsQueryResult implements IGetSalesLeadStatisticsQueryResult {
    totalLeads!: number;
    leadsInPeriod!: number;
    unassignedCount!: number;
    leadsByStatus!: { [key: string]: number; } | null;
    leadsWithUnreadByStatus!: { [key: string]: number; } | null;
    leadsByOwner!: SalesLeadOwnerStatistic[] | null;
    totalEarnings?: number | null;
    earningsInPeriod?: number | null;

    constructor(data?: IGetSalesLeadStatisticsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalLeads = _data["totalLeads"];
            this.leadsInPeriod = _data["leadsInPeriod"];
            this.unassignedCount = _data["unassignedCount"];
            if (_data["leadsByStatus"]) {
                this.leadsByStatus = {} as any;
                for (let key in _data["leadsByStatus"]) {
                    if (_data["leadsByStatus"].hasOwnProperty(key))
                        (<any>this.leadsByStatus)![key] = _data["leadsByStatus"][key];
                }
            }
            if (_data["leadsWithUnreadByStatus"]) {
                this.leadsWithUnreadByStatus = {} as any;
                for (let key in _data["leadsWithUnreadByStatus"]) {
                    if (_data["leadsWithUnreadByStatus"].hasOwnProperty(key))
                        (<any>this.leadsWithUnreadByStatus)![key] = _data["leadsWithUnreadByStatus"][key];
                }
            }
            if (Array.isArray(_data["leadsByOwner"])) {
                this.leadsByOwner = [] as any;
                for (let item of _data["leadsByOwner"])
                    this.leadsByOwner!.push(SalesLeadOwnerStatistic.fromJS(item));
            }
            this.totalEarnings = _data["totalEarnings"];
            this.earningsInPeriod = _data["earningsInPeriod"];
        }
    }

    static fromJS(data: any): GetSalesLeadStatisticsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesLeadStatisticsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalLeads"] = this.totalLeads;
        data["leadsInPeriod"] = this.leadsInPeriod;
        data["unassignedCount"] = this.unassignedCount;
        if (this.leadsByStatus) {
            data["leadsByStatus"] = {};
            for (let key in this.leadsByStatus) {
                if (this.leadsByStatus.hasOwnProperty(key))
                    (<any>data["leadsByStatus"])[key] = (<any>this.leadsByStatus)[key];
            }
        }
        if (this.leadsWithUnreadByStatus) {
            data["leadsWithUnreadByStatus"] = {};
            for (let key in this.leadsWithUnreadByStatus) {
                if (this.leadsWithUnreadByStatus.hasOwnProperty(key))
                    (<any>data["leadsWithUnreadByStatus"])[key] = (<any>this.leadsWithUnreadByStatus)[key];
            }
        }
        if (Array.isArray(this.leadsByOwner)) {
            data["leadsByOwner"] = [];
            for (let item of this.leadsByOwner)
                data["leadsByOwner"].push(item.toJSON());
        }
        data["totalEarnings"] = this.totalEarnings;
        data["earningsInPeriod"] = this.earningsInPeriod;
        return data;
    }
}

export interface IGetSalesLeadStatisticsQueryResult {
    totalLeads: number;
    leadsInPeriod: number;
    unassignedCount: number;
    leadsByStatus: { [key: string]: number; } | null;
    leadsWithUnreadByStatus: { [key: string]: number; } | null;
    leadsByOwner: SalesLeadOwnerStatistic[] | null;
    totalEarnings?: number | null;
    earningsInPeriod?: number | null;
}

export class GetSalesLeadsQueryResult implements IGetSalesLeadsQueryResult {
    guid?: string;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    numberOfGuests?: number | null;
    budget?: number | null;
    departureDate?: Date | null;
    boat?: SalesLeadBoat;
    message?: string | null;
    source?: string | null;
    origin?: SalesLeadOrigin;
    status?: SalesLeadStatus;
    submissionDate?: Date;
    assignedUser?: SalesLeadUser;
    customer?: SalesLeadCustomer;
    isClosed?: boolean;
    closedDate?: Date | null;
    bookings?: SalesLeadBooking[] | null;
    hasUnreadMessages?: boolean;

    constructor(data?: IGetSalesLeadsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.numberOfGuests = _data["numberOfGuests"];
            this.budget = _data["budget"];
            this.departureDate = _data["departureDate"] ? new Date(_data["departureDate"].toString()) : <any>null;
            this.boat = _data["boat"] ? SalesLeadBoat.fromJS(_data["boat"]) : <any>null;
            this.message = _data["message"];
            this.source = _data["source"];
            this.origin = _data["origin"];
            this.status = _data["status"];
            this.submissionDate = _data["submissionDate"] ? new Date(_data["submissionDate"].toString()) : <any>null;
            this.assignedUser = _data["assignedUser"] ? SalesLeadUser.fromJS(_data["assignedUser"]) : <any>null;
            this.customer = _data["customer"] ? SalesLeadCustomer.fromJS(_data["customer"]) : <any>null;
            this.isClosed = _data["isClosed"];
            this.closedDate = _data["closedDate"] ? new Date(_data["closedDate"].toString()) : <any>null;
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(SalesLeadBooking.fromJS(item));
            }
            this.hasUnreadMessages = _data["hasUnreadMessages"];
        }
    }

    static fromJS(data: any): GetSalesLeadsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesLeadsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["numberOfGuests"] = this.numberOfGuests;
        data["budget"] = this.budget;
        data["departureDate"] = this.departureDate && this.departureDate.toISOString();
        data["boat"] = this.boat ? this.boat.toJSON() : this.boat;
        data["message"] = this.message;
        data["source"] = this.source;
        data["origin"] = this.origin;
        data["status"] = this.status;
        data["submissionDate"] = this.submissionDate && this.submissionDate.toISOString();
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : this.assignedUser;
        data["customer"] = this.customer ? this.customer.toJSON() : this.customer;
        data["isClosed"] = this.isClosed;
        data["closedDate"] = this.closedDate && this.closedDate.toISOString();
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item.toJSON());
        }
        data["hasUnreadMessages"] = this.hasUnreadMessages;
        return data;
    }
}

export interface IGetSalesLeadsQueryResult {
    guid?: string;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    numberOfGuests?: number | null;
    budget?: number | null;
    departureDate?: Date | null;
    boat?: SalesLeadBoat;
    message?: string | null;
    source?: string | null;
    origin?: SalesLeadOrigin;
    status?: SalesLeadStatus;
    submissionDate?: Date;
    assignedUser?: SalesLeadUser;
    customer?: SalesLeadCustomer;
    isClosed?: boolean;
    closedDate?: Date | null;
    bookings?: SalesLeadBooking[] | null;
    hasUnreadMessages?: boolean;
}

export class GetSalesLeadsQueryResultPaginatedResult implements IGetSalesLeadsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetSalesLeadsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetSalesLeadsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSalesLeadsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetSalesLeadsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesLeadsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetSalesLeadsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetSalesLeadsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetSalesPersonQueryResult implements IGetSalesPersonQueryResult {
    guid?: string;
    isInactive?: boolean;
    userGuid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;

    constructor(data?: IGetSalesPersonQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.isInactive = _data["isInactive"];
            this.userGuid = _data["userGuid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): GetSalesPersonQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesPersonQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isInactive"] = this.isInactive;
        data["userGuid"] = this.userGuid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IGetSalesPersonQueryResult {
    guid?: string;
    isInactive?: boolean;
    userGuid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
}

export class GetSalesPersonsQueryResult implements IGetSalesPersonsQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;

    constructor(data?: IGetSalesPersonsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.isDisabled = _data["isDisabled"];
            this.userGuid = _data["userGuid"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): GetSalesPersonsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesPersonsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isDisabled"] = this.isDisabled;
        data["userGuid"] = this.userGuid;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IGetSalesPersonsQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
}

export class GetSalesPersonsQueryResultPaginatedResult implements IGetSalesPersonsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetSalesPersonsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetSalesPersonsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSalesPersonsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetSalesPersonsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesPersonsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetSalesPersonsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetSalesPersonsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetSeasonQueryResult implements IGetSeasonQueryResult {
    guid?: string;
    marketGuid?: string;
    name?: string | null;
    color?: string | null;
    isDefault?: boolean;
    dateRanges?: DateRangeDto[] | null;

    constructor(data?: IGetSeasonQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.marketGuid = _data["marketGuid"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["dateRanges"])) {
                this.dateRanges = [] as any;
                for (let item of _data["dateRanges"])
                    this.dateRanges!.push(DateRangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSeasonQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeasonQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["marketGuid"] = this.marketGuid;
        data["name"] = this.name;
        data["color"] = this.color;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.dateRanges)) {
            data["dateRanges"] = [];
            for (let item of this.dateRanges)
                data["dateRanges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSeasonQueryResult {
    guid?: string;
    marketGuid?: string;
    name?: string | null;
    color?: string | null;
    isDefault?: boolean;
    dateRanges?: DateRangeDto[] | null;
}

export class GetSeasonsQueryResult implements IGetSeasonsQueryResult {
    guid?: string;
    marketGuid?: string;
    name?: string | null;
    color?: string | null;
    isDefault?: boolean;
    dateRanges?: DateRangeDto[] | null;

    constructor(data?: IGetSeasonsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.marketGuid = _data["marketGuid"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["dateRanges"])) {
                this.dateRanges = [] as any;
                for (let item of _data["dateRanges"])
                    this.dateRanges!.push(DateRangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSeasonsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeasonsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["marketGuid"] = this.marketGuid;
        data["name"] = this.name;
        data["color"] = this.color;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.dateRanges)) {
            data["dateRanges"] = [];
            for (let item of this.dateRanges)
                data["dateRanges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSeasonsQueryResult {
    guid?: string;
    marketGuid?: string;
    name?: string | null;
    color?: string | null;
    isDefault?: boolean;
    dateRanges?: DateRangeDto[] | null;
}

export class GetSkipperQueryResult implements IGetSkipperQueryResult {
    guid?: string;
    isDisabled?: boolean;
    isAlternative?: boolean;
    userGuid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;

    constructor(data?: IGetSkipperQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.isDisabled = _data["isDisabled"];
            this.isAlternative = _data["isAlternative"];
            this.userGuid = _data["userGuid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetSkipperQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSkipperQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isDisabled"] = this.isDisabled;
        data["isAlternative"] = this.isAlternative;
        data["userGuid"] = this.userGuid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetSkipperQueryResult {
    guid?: string;
    isDisabled?: boolean;
    isAlternative?: boolean;
    userGuid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
}

export class GetSkippersQueryResult implements IGetSkippersQueryResult {
    guid?: string;
    isDisabled?: boolean;
    isAlternative?: boolean;
    userGuid?: string;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
    assignedListings?: SkipperAssignedListing[] | null;

    constructor(data?: IGetSkippersQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.isDisabled = _data["isDisabled"];
            this.isAlternative = _data["isAlternative"];
            this.userGuid = _data["userGuid"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            if (Array.isArray(_data["assignedListings"])) {
                this.assignedListings = [] as any;
                for (let item of _data["assignedListings"])
                    this.assignedListings!.push(SkipperAssignedListing.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSkippersQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSkippersQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isDisabled"] = this.isDisabled;
        data["isAlternative"] = this.isAlternative;
        data["userGuid"] = this.userGuid;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        if (Array.isArray(this.assignedListings)) {
            data["assignedListings"] = [];
            for (let item of this.assignedListings)
                data["assignedListings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSkippersQueryResult {
    guid?: string;
    isDisabled?: boolean;
    isAlternative?: boolean;
    userGuid?: string;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
    assignedListings?: SkipperAssignedListing[] | null;
}

export class GetSkippersQueryResultPaginatedResult implements IGetSkippersQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetSkippersQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetSkippersQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSkippersQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetSkippersQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSkippersQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetSkippersQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetSkippersQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetStewardessQueryResult implements IGetStewardessQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;

    constructor(data?: IGetStewardessQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.isDisabled = _data["isDisabled"];
            this.userGuid = _data["userGuid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): GetStewardessQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetStewardessQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isDisabled"] = this.isDisabled;
        data["userGuid"] = this.userGuid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IGetStewardessQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
}

export class GetStewardessesQueryResult implements IGetStewardessesQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
    assignedListings?: StewardessAssignedListing[] | null;

    constructor(data?: IGetStewardessesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.isDisabled = _data["isDisabled"];
            this.userGuid = _data["userGuid"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            if (Array.isArray(_data["assignedListings"])) {
                this.assignedListings = [] as any;
                for (let item of _data["assignedListings"])
                    this.assignedListings!.push(StewardessAssignedListing.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStewardessesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetStewardessesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isDisabled"] = this.isDisabled;
        data["userGuid"] = this.userGuid;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        if (Array.isArray(this.assignedListings)) {
            data["assignedListings"] = [];
            for (let item of this.assignedListings)
                data["assignedListings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStewardessesQueryResult {
    guid?: string;
    isDisabled?: boolean;
    userGuid?: string;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
    assignedListings?: StewardessAssignedListing[] | null;
}

export class GetStewardessesQueryResultPaginatedResult implements IGetStewardessesQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetStewardessesQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetStewardessesQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetStewardessesQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetStewardessesQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetStewardessesQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetStewardessesQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetStewardessesQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetStickyNotesQueryResult implements IGetStickyNotesQueryResult {
    guid?: string;
    from?: Date;
    to?: Date;
    title?: string | null;
    description?: string | null;
    createdByUserName?: string | null;

    constructor(data?: IGetStickyNotesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.from = _data["from"] ? parseDateOnly(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? parseDateOnly(_data["to"].toString()) : <any>null;
            this.title = _data["title"];
            this.description = _data["description"];
            this.createdByUserName = _data["createdByUserName"];
        }
    }

    static fromJS(data: any): GetStickyNotesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetStickyNotesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["from"] = this.from && formatDate(this.from);
        data["to"] = this.to && formatDate(this.to);
        data["title"] = this.title;
        data["description"] = this.description;
        data["createdByUserName"] = this.createdByUserName;
        return data;
    }
}

export interface IGetStickyNotesQueryResult {
    guid?: string;
    from?: Date;
    to?: Date;
    title?: string | null;
    description?: string | null;
    createdByUserName?: string | null;
}

export class GetUncoveredDatesQueryResult implements IGetUncoveredDatesQueryResult {
    uncoveredRanges?: UncoveredDateRangeDto[] | null;
    hasDefaultSeason?: boolean;

    constructor(data?: IGetUncoveredDatesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uncoveredRanges"])) {
                this.uncoveredRanges = [] as any;
                for (let item of _data["uncoveredRanges"])
                    this.uncoveredRanges!.push(UncoveredDateRangeDto.fromJS(item));
            }
            this.hasDefaultSeason = _data["hasDefaultSeason"];
        }
    }

    static fromJS(data: any): GetUncoveredDatesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUncoveredDatesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uncoveredRanges)) {
            data["uncoveredRanges"] = [];
            for (let item of this.uncoveredRanges)
                data["uncoveredRanges"].push(item.toJSON());
        }
        data["hasDefaultSeason"] = this.hasDefaultSeason;
        return data;
    }
}

export interface IGetUncoveredDatesQueryResult {
    uncoveredRanges?: UncoveredDateRangeDto[] | null;
    hasDefaultSeason?: boolean;
}

export class GetUserQueryResult implements IGetUserQueryResult {
    guid?: string;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    address?: UserAddress;
    billingInfo?: UserBillingInfo;
    status?: UserStatus;
    profilePictureResult?: PictureResultModel;
    isDeleted?: boolean;
    roles?: RoleName[] | null;
    brokerAgentGuid?: string | null;
    brokerGuid?: string | null;
    policies?: PolicyKeyValue[] | null;

    constructor(data?: IGetUserQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.address = _data["address"] ? UserAddress.fromJS(_data["address"]) : <any>null;
            this.billingInfo = _data["billingInfo"] ? UserBillingInfo.fromJS(_data["billingInfo"]) : <any>null;
            this.status = _data["status"];
            this.profilePictureResult = _data["profilePictureResult"] ? PictureResultModel.fromJS(_data["profilePictureResult"]) : <any>null;
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.brokerAgentGuid = _data["brokerAgentGuid"];
            this.brokerGuid = _data["brokerGuid"];
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(PolicyKeyValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["address"] = this.address ? this.address.toJSON() : this.address;
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : this.billingInfo;
        data["status"] = this.status;
        data["profilePictureResult"] = this.profilePictureResult ? this.profilePictureResult.toJSON() : this.profilePictureResult;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["brokerAgentGuid"] = this.brokerAgentGuid;
        data["brokerGuid"] = this.brokerGuid;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserQueryResult {
    guid?: string;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    address?: UserAddress;
    billingInfo?: UserBillingInfo;
    status?: UserStatus;
    profilePictureResult?: PictureResultModel;
    isDeleted?: boolean;
    roles?: RoleName[] | null;
    brokerAgentGuid?: string | null;
    brokerGuid?: string | null;
    policies?: PolicyKeyValue[] | null;
}

export class GetUsersQueryResult implements IGetUsersQueryResult {
    guid?: string;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
    isDeleted?: boolean;
    roles?: RoleName[] | null;

    constructor(data?: IGetUsersQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUsersQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IGetUsersQueryResult {
    guid?: string;
    fullName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
    isDeleted?: boolean;
    roles?: RoleName[] | null;
}

export class GetUsersQueryResultPaginatedResult implements IGetUsersQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetUsersQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetUsersQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetUsersQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetUsersQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetUsersQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetUsersQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetVendorsQueryResult implements IGetVendorsQueryResult {
    guid?: string;
    name?: string | null;
    type?: VendorType;
    area?: string | null;
    corporatePhoneNumber?: string | null;
    email?: string | null;
    notes?: string | null;
    contactPerson?: VendorContactPerson;
    createdAtUtc?: Date;

    constructor(data?: IGetVendorsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.area = _data["area"];
            this.corporatePhoneNumber = _data["corporatePhoneNumber"];
            this.email = _data["email"];
            this.notes = _data["notes"];
            this.contactPerson = _data["contactPerson"] ? VendorContactPerson.fromJS(_data["contactPerson"]) : <any>null;
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetVendorsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetVendorsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["type"] = this.type;
        data["area"] = this.area;
        data["corporatePhoneNumber"] = this.corporatePhoneNumber;
        data["email"] = this.email;
        data["notes"] = this.notes;
        data["contactPerson"] = this.contactPerson ? this.contactPerson.toJSON() : this.contactPerson;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        return data;
    }
}

export interface IGetVendorsQueryResult {
    guid?: string;
    name?: string | null;
    type?: VendorType;
    area?: string | null;
    corporatePhoneNumber?: string | null;
    email?: string | null;
    notes?: string | null;
    contactPerson?: VendorContactPerson;
    createdAtUtc?: Date;
}

export class GetVendorsQueryResultPaginatedResult implements IGetVendorsQueryResultPaginatedResult {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: GetVendorsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IGetVendorsQueryResultPaginatedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetVendorsQueryResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetVendorsQueryResultPaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetVendorsQueryResultPaginatedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetVendorsQueryResultPaginatedResult {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: GetVendorsQueryResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class GetWorldPayCheckoutSessionQueryResponse implements IGetWorldPayCheckoutSessionQueryResponse {
    sessionGuid?: string;
    amount?: number;
    currency?: string | null;
    description?: string | null;
    isAvailable?: boolean;
    merchantId?: string | null;
    booking?: WorldPayBookingCheckoutSessionResponse;
    lineItems?: WorldPayCheckoutSessionLineItem[] | null;

    constructor(data?: IGetWorldPayCheckoutSessionQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionGuid = _data["sessionGuid"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.description = _data["description"];
            this.isAvailable = _data["isAvailable"];
            this.merchantId = _data["merchantId"];
            this.booking = _data["booking"] ? WorldPayBookingCheckoutSessionResponse.fromJS(_data["booking"]) : <any>null;
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(WorldPayCheckoutSessionLineItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWorldPayCheckoutSessionQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorldPayCheckoutSessionQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionGuid"] = this.sessionGuid;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["description"] = this.description;
        data["isAvailable"] = this.isAvailable;
        data["merchantId"] = this.merchantId;
        data["booking"] = this.booking ? this.booking.toJSON() : this.booking;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWorldPayCheckoutSessionQueryResponse {
    sessionGuid?: string;
    amount?: number;
    currency?: string | null;
    description?: string | null;
    isAvailable?: boolean;
    merchantId?: string | null;
    booking?: WorldPayBookingCheckoutSessionResponse;
    lineItems?: WorldPayCheckoutSessionLineItem[] | null;
}

export class GetWorldPayCustomerIdQueryResult implements IGetWorldPayCustomerIdQueryResult {
    worldPayCustomerId?: string | null;

    constructor(data?: IGetWorldPayCustomerIdQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.worldPayCustomerId = _data["worldPayCustomerId"];
        }
    }

    static fromJS(data: any): GetWorldPayCustomerIdQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorldPayCustomerIdQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["worldPayCustomerId"] = this.worldPayCustomerId;
        return data;
    }
}

export interface IGetWorldPayCustomerIdQueryResult {
    worldPayCustomerId?: string | null;
}

export class GetWorldPayMerchantQueryResult implements IGetWorldPayMerchantQueryResult {
    merchantId!: string | null;
    entityId?: string | null;
    status!: string | null;
    dbaName?: string | null;
    created?: Date | null;
    onboardingStatus?: string | null;
    isLive?: boolean | null;
    canProcess?: boolean | null;

    constructor(data?: IGetWorldPayMerchantQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.merchantId = _data["merchantId"];
            this.entityId = _data["entityId"];
            this.status = _data["status"];
            this.dbaName = _data["dbaName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>null;
            this.onboardingStatus = _data["onboardingStatus"];
            this.isLive = _data["isLive"];
            this.canProcess = _data["canProcess"];
        }
    }

    static fromJS(data: any): GetWorldPayMerchantQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorldPayMerchantQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["merchantId"] = this.merchantId;
        data["entityId"] = this.entityId;
        data["status"] = this.status;
        data["dbaName"] = this.dbaName;
        data["created"] = this.created && this.created.toISOString();
        data["onboardingStatus"] = this.onboardingStatus;
        data["isLive"] = this.isLive;
        data["canProcess"] = this.canProcess;
        return data;
    }
}

export interface IGetWorldPayMerchantQueryResult {
    merchantId: string | null;
    entityId?: string | null;
    status: string | null;
    dbaName?: string | null;
    created?: Date | null;
    onboardingStatus?: string | null;
    isLive?: boolean | null;
    canProcess?: boolean | null;
}

export class GetWorldPayPaymentMethodsQueryResult implements IGetWorldPayPaymentMethodsQueryResult {
    paymentMethods?: WorldPayPaymentMethodResponse[] | null;

    constructor(data?: IGetWorldPayPaymentMethodsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paymentMethods"])) {
                this.paymentMethods = [] as any;
                for (let item of _data["paymentMethods"])
                    this.paymentMethods!.push(WorldPayPaymentMethodResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWorldPayPaymentMethodsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorldPayPaymentMethodsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paymentMethods)) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetWorldPayPaymentMethodsQueryResult {
    paymentMethods?: WorldPayPaymentMethodResponse[] | null;
}

export enum GlobalBusinessTypeEnum {
    SSN = "SSN",
    TIN = "TIN",
    Other = "Other",
    CD = "CD",
    AB = "AB",
    BC = "BC",
    MB = "MB",
    NB = "NB",
    NL = "NL",
    NT = "NT",
    NS = "NS",
    NU = "NU",
    ON = "ON",
    PE = "PE",
    QC = "QC",
    SK = "SK",
    YT = "YT",
}

export enum HandoffType {
    Email = "Email",
    Message = "Message",
}

export enum HomeDismissalEntityType {
    NotSet = "NotSet",
    SalesLead = "SalesLead",
    Booking = "Booking",
}

export class InviteUserToPlatformCommand implements IInviteUserToPlatformCommand {
    userGuid?: string;

    constructor(data?: IInviteUserToPlatformCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGuid = _data["userGuid"];
        }
    }

    static fromJS(data: any): InviteUserToPlatformCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InviteUserToPlatformCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid;
        return data;
    }
}

export interface IInviteUserToPlatformCommand {
    userGuid?: string;
}

export class IsAvailableForTripQueryResult implements IIsAvailableForTripQueryResult {
    isAvailable?: boolean;
    conflicts?: IsAvailableForTripQueryResultConflict[] | null;

    constructor(data?: IIsAvailableForTripQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
            if (Array.isArray(_data["conflicts"])) {
                this.conflicts = [] as any;
                for (let item of _data["conflicts"])
                    this.conflicts!.push(IsAvailableForTripQueryResultConflict.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IsAvailableForTripQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsAvailableForTripQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        if (Array.isArray(this.conflicts)) {
            data["conflicts"] = [];
            for (let item of this.conflicts)
                data["conflicts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIsAvailableForTripQueryResult {
    isAvailable?: boolean;
    conflicts?: IsAvailableForTripQueryResultConflict[] | null;
}

export class IsAvailableForTripQueryResultConflict implements IIsAvailableForTripQueryResultConflict {
    bookingGuid?: string;
    bookingId?: number;

    constructor(data?: IIsAvailableForTripQueryResultConflict) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.bookingId = _data["bookingId"];
        }
    }

    static fromJS(data: any): IsAvailableForTripQueryResultConflict {
        data = typeof data === 'object' ? data : {};
        let result = new IsAvailableForTripQueryResultConflict();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["bookingId"] = this.bookingId;
        return data;
    }
}

export interface IIsAvailableForTripQueryResultConflict {
    bookingGuid?: string;
    bookingId?: number;
}

export class ListingBoatPictureResultModel implements IListingBoatPictureResultModel {
    readonly pictureGuid?: string | null;
    readonly host?: string | null;
    bucket?: string | null;
    readonly name?: string | null;
    readonly extension?: string | null;
    readonly height?: number | null;
    readonly width?: number | null;
    readonly size?: number | null;
    sortOrder?: number;
    description?: string | null;

    constructor(data?: IListingBoatPictureResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).pictureGuid = _data["pictureGuid"];
            (<any>this).host = _data["host"];
            this.bucket = _data["bucket"];
            (<any>this).name = _data["name"];
            (<any>this).extension = _data["extension"];
            (<any>this).height = _data["height"];
            (<any>this).width = _data["width"];
            (<any>this).size = _data["size"];
            this.sortOrder = _data["sortOrder"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ListingBoatPictureResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListingBoatPictureResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pictureGuid"] = this.pictureGuid;
        data["host"] = this.host;
        data["bucket"] = this.bucket;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["height"] = this.height;
        data["width"] = this.width;
        data["size"] = this.size;
        data["sortOrder"] = this.sortOrder;
        data["description"] = this.description;
        return data;
    }
}

export interface IListingBoatPictureResultModel {
    pictureGuid?: string | null;
    host?: string | null;
    bucket?: string | null;
    name?: string | null;
    extension?: string | null;
    height?: number | null;
    width?: number | null;
    size?: number | null;
    sortOrder?: number;
    description?: string | null;
}

export class ListingBoatResult implements IListingBoatResult {
    guid!: string;
    defaultListingTitle!: string | null;
    registeredName!: string | null;
    passengers!: number | null;
    length!: number | null;
    isDeleted!: boolean;
    sortPriority!: number | null;
    isComplete!: boolean;
    bathroomsCount!: number | null;
    crewCapacity!: number | null;
    boatOwner!: UserResult;

    constructor(data?: IListingBoatResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boatOwner = new UserResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.defaultListingTitle = _data["defaultListingTitle"];
            this.registeredName = _data["registeredName"];
            this.passengers = _data["passengers"];
            this.length = _data["length"];
            this.isDeleted = _data["isDeleted"];
            this.sortPriority = _data["sortPriority"];
            this.isComplete = _data["isComplete"];
            this.bathroomsCount = _data["bathroomsCount"];
            this.crewCapacity = _data["crewCapacity"];
            this.boatOwner = _data["boatOwner"] ? UserResult.fromJS(_data["boatOwner"]) : new UserResult();
        }
    }

    static fromJS(data: any): ListingBoatResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListingBoatResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["defaultListingTitle"] = this.defaultListingTitle;
        data["registeredName"] = this.registeredName;
        data["passengers"] = this.passengers;
        data["length"] = this.length;
        data["isDeleted"] = this.isDeleted;
        data["sortPriority"] = this.sortPriority;
        data["isComplete"] = this.isComplete;
        data["bathroomsCount"] = this.bathroomsCount;
        data["crewCapacity"] = this.crewCapacity;
        data["boatOwner"] = this.boatOwner ? this.boatOwner.toJSON() : this.boatOwner;
        return data;
    }
}

export interface IListingBoatResult {
    guid: string;
    defaultListingTitle: string | null;
    registeredName: string | null;
    passengers: number | null;
    length: number | null;
    isDeleted: boolean;
    sortPriority: number | null;
    isComplete: boolean;
    bathroomsCount: number | null;
    crewCapacity: number | null;
    boatOwner: UserResult;
}

export class ListingOwnerTakeRate implements IListingOwnerTakeRate {
    percentage?: number | null;
    wholesaleAmount?: number | null;

    constructor(data?: IListingOwnerTakeRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.wholesaleAmount = _data["wholesaleAmount"];
        }
    }

    static fromJS(data: any): ListingOwnerTakeRate {
        data = typeof data === 'object' ? data : {};
        let result = new ListingOwnerTakeRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["wholesaleAmount"] = this.wholesaleAmount;
        return data;
    }
}

export interface IListingOwnerTakeRate {
    percentage?: number | null;
    wholesaleAmount?: number | null;
}

export class ListingRecalculationStatusDto implements IListingRecalculationStatusDto {
    listingGuid?: string;
    state?: RecalculationState;
    startedAt?: Date | null;
    completedAt?: Date | null;
    errorMessage?: string | null;

    constructor(data?: IListingRecalculationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingGuid = _data["listingGuid"];
            this.state = _data["state"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>null;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>null;
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ListingRecalculationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingRecalculationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingGuid"] = this.listingGuid;
        data["state"] = this.state;
        data["startedAt"] = this.startedAt && this.startedAt.toISOString();
        data["completedAt"] = this.completedAt && this.completedAt.toISOString();
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IListingRecalculationStatusDto {
    listingGuid?: string;
    state?: RecalculationState;
    startedAt?: Date | null;
    completedAt?: Date | null;
    errorMessage?: string | null;
}

export enum ListingSortOptions {
    Title = "Title",
    BoatIdentifier = "BoatIdentifier",
}

export class LocaleSettingsResult implements ILocaleSettingsResult {
    culture!: string | null;
    country!: string | null;
    language!: string | null;
    timeZoneInfoId!: string | null;
    measurementSystem!: MeasurementSystem;
    dateFormat!: DateFormatResult;
    timeFormat!: TimeFormatResult;
    currencyFormat!: CurrencyFormatResult;
    measurementUnits!: MeasurementUnitsResult;

    constructor(data?: ILocaleSettingsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dateFormat = new DateFormatResult();
            this.timeFormat = new TimeFormatResult();
            this.currencyFormat = new CurrencyFormatResult();
            this.measurementUnits = new MeasurementUnitsResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.culture = _data["culture"];
            this.country = _data["country"];
            this.language = _data["language"];
            this.timeZoneInfoId = _data["timeZoneInfoId"];
            this.measurementSystem = _data["measurementSystem"];
            this.dateFormat = _data["dateFormat"] ? DateFormatResult.fromJS(_data["dateFormat"]) : new DateFormatResult();
            this.timeFormat = _data["timeFormat"] ? TimeFormatResult.fromJS(_data["timeFormat"]) : new TimeFormatResult();
            this.currencyFormat = _data["currencyFormat"] ? CurrencyFormatResult.fromJS(_data["currencyFormat"]) : new CurrencyFormatResult();
            this.measurementUnits = _data["measurementUnits"] ? MeasurementUnitsResult.fromJS(_data["measurementUnits"]) : new MeasurementUnitsResult();
        }
    }

    static fromJS(data: any): LocaleSettingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new LocaleSettingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["culture"] = this.culture;
        data["country"] = this.country;
        data["language"] = this.language;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        data["measurementSystem"] = this.measurementSystem;
        data["dateFormat"] = this.dateFormat ? this.dateFormat.toJSON() : this.dateFormat;
        data["timeFormat"] = this.timeFormat ? this.timeFormat.toJSON() : this.timeFormat;
        data["currencyFormat"] = this.currencyFormat ? this.currencyFormat.toJSON() : this.currencyFormat;
        data["measurementUnits"] = this.measurementUnits ? this.measurementUnits.toJSON() : this.measurementUnits;
        return data;
    }
}

export interface ILocaleSettingsResult {
    culture: string | null;
    country: string | null;
    language: string | null;
    timeZoneInfoId: string | null;
    measurementSystem: MeasurementSystem;
    dateFormat: DateFormatResult;
    timeFormat: TimeFormatResult;
    currencyFormat: CurrencyFormatResult;
    measurementUnits: MeasurementUnitsResult;
}

export class LocationAddress implements ILocationAddress {
    line!: string | null;
    city!: string | null;
    postalCode!: string | null;
    country!: string | null;
    state?: string | null;
    latitude?: number;
    longitude?: number;

    constructor(data?: ILocationAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line = _data["line"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): LocationAddress {
        data = typeof data === 'object' ? data : {};
        let result = new LocationAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line"] = this.line;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["state"] = this.state;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface ILocationAddress {
    line: string | null;
    city: string | null;
    postalCode: string | null;
    country: string | null;
    state?: string | null;
    latitude?: number;
    longitude?: number;
}

export class LocationResult implements ILocationResult {
    guid!: string;
    title!: string | null;
    city!: string | null;
    fullAddress!: string | null;
    shortAddress!: string | null;
    timeZoneInfoId!: string | null;
    marketGuid!: string;
    marketCode!: string | null;
    marketTitle!: string | null;

    constructor(data?: ILocationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.city = _data["city"];
            this.fullAddress = _data["fullAddress"];
            this.shortAddress = _data["shortAddress"];
            this.timeZoneInfoId = _data["timeZoneInfoId"];
            this.marketGuid = _data["marketGuid"];
            this.marketCode = _data["marketCode"];
            this.marketTitle = _data["marketTitle"];
        }
    }

    static fromJS(data: any): LocationResult {
        data = typeof data === 'object' ? data : {};
        let result = new LocationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["city"] = this.city;
        data["fullAddress"] = this.fullAddress;
        data["shortAddress"] = this.shortAddress;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        data["marketGuid"] = this.marketGuid;
        data["marketCode"] = this.marketCode;
        data["marketTitle"] = this.marketTitle;
        return data;
    }
}

export interface ILocationResult {
    guid: string;
    title: string | null;
    city: string | null;
    fullAddress: string | null;
    shortAddress: string | null;
    timeZoneInfoId: string | null;
    marketGuid: string;
    marketCode: string | null;
    marketTitle: string | null;
}

export enum LocationSortOptions {
    Title = "Title",
    MarketName = "MarketName",
}

export enum MakeSortOptions {
    Name = "Name",
}

export class MapToMarina implements IMapToMarina {
    providerScheme?: string | null;
    name?: string | null;
    extension?: string | null;
    contentType?: string | null;
    alias?: string | null;

    constructor(data?: IMapToMarina) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerScheme = _data["providerScheme"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.contentType = _data["contentType"];
            this.alias = _data["alias"];
        }
    }

    static fromJS(data: any): MapToMarina {
        data = typeof data === 'object' ? data : {};
        let result = new MapToMarina();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerScheme"] = this.providerScheme;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["contentType"] = this.contentType;
        data["alias"] = this.alias;
        return data;
    }
}

export interface IMapToMarina {
    providerScheme?: string | null;
    name?: string | null;
    extension?: string | null;
    contentType?: string | null;
    alias?: string | null;
}

export class MarketResult implements IMarketResult {
    guid!: string;
    code!: string | null;
    title!: string | null;

    constructor(data?: IMarketResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.code = _data["code"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): MarketResult {
        data = typeof data === 'object' ? data : {};
        let result = new MarketResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["code"] = this.code;
        data["title"] = this.title;
        return data;
    }
}

export interface IMarketResult {
    guid: string;
    code: string | null;
    title: string | null;
}

export enum MarketSortOptions {
    Title = "Title",
    Code = "Code",
}

export enum MeasurementSystem {
    NotSet = "NotSet",
    Metric = "Metric",
    Imperial = "Imperial",
}

export class MeasurementUnitsResult implements IMeasurementUnitsResult {
    lengthUnit!: string | null;
    volumeUnit!: string | null;
    fuelConsumptionUnit!: string | null;
    distanceUnit!: string | null;
    speedUnit!: string | null;
    cabinLabel!: string | null;

    constructor(data?: IMeasurementUnitsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lengthUnit = _data["lengthUnit"];
            this.volumeUnit = _data["volumeUnit"];
            this.fuelConsumptionUnit = _data["fuelConsumptionUnit"];
            this.distanceUnit = _data["distanceUnit"];
            this.speedUnit = _data["speedUnit"];
            this.cabinLabel = _data["cabinLabel"];
        }
    }

    static fromJS(data: any): MeasurementUnitsResult {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementUnitsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lengthUnit"] = this.lengthUnit;
        data["volumeUnit"] = this.volumeUnit;
        data["fuelConsumptionUnit"] = this.fuelConsumptionUnit;
        data["distanceUnit"] = this.distanceUnit;
        data["speedUnit"] = this.speedUnit;
        data["cabinLabel"] = this.cabinLabel;
        return data;
    }
}

export interface IMeasurementUnitsResult {
    lengthUnit: string | null;
    volumeUnit: string | null;
    fuelConsumptionUnit: string | null;
    distanceUnit: string | null;
    speedUnit: string | null;
    cabinLabel: string | null;
}

export enum MerchantEnvironmentEnum {
    Supermarket = "Supermarket",
    Moto = "Moto",
    CardPresent = "CardPresent",
    Fuel = "Fuel",
    ServiceStation = "ServiceStation",
    Restaurant = "Restaurant",
    Ecommerce = "Ecommerce",
}

export enum MessageChannel {
    NotSet = "NotSet",
    Email = "Email",
    Sms = "Sms",
}

export enum MessageDirection {
    NotSet = "NotSet",
    Outbound = "Outbound",
    Inbound = "Inbound",
}

export class MonthDay implements IMonthDay {
    month?: number;
    day?: number;

    constructor(data?: IMonthDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.day = _data["day"];
        }
    }

    static fromJS(data: any): MonthDay {
        data = typeof data === 'object' ? data : {};
        let result = new MonthDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["day"] = this.day;
        return data;
    }
}

export interface IMonthDay {
    month?: number;
    day?: number;
}

export enum MyTodoStatusFilter {
    NotSet = "NotSet",
    All = "All",
    Open = "Open",
    Done = "Done",
}

export enum MyTodoTypeFilter {
    NotSet = "NotSet",
    All = "All",
    Leads = "Leads",
    Enquiries = "Enquiries",
    NewBookings = "NewBookings",
}

export class OnlineCustomerFee implements IOnlineCustomerFee {
    percentage?: number;
    amount?: number;
    chargedToCustomer?: boolean;
    operatorSharePercentage?: number;
    operatorShareAmount?: number;
    readonly propellerShareAmount?: number;

    constructor(data?: IOnlineCustomerFee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.amount = _data["amount"];
            this.chargedToCustomer = _data["chargedToCustomer"];
            this.operatorSharePercentage = _data["operatorSharePercentage"];
            this.operatorShareAmount = _data["operatorShareAmount"];
            (<any>this).propellerShareAmount = _data["propellerShareAmount"];
        }
    }

    static fromJS(data: any): OnlineCustomerFee {
        data = typeof data === 'object' ? data : {};
        let result = new OnlineCustomerFee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["amount"] = this.amount;
        data["chargedToCustomer"] = this.chargedToCustomer;
        data["operatorSharePercentage"] = this.operatorSharePercentage;
        data["operatorShareAmount"] = this.operatorShareAmount;
        data["propellerShareAmount"] = this.propellerShareAmount;
        return data;
    }
}

export interface IOnlineCustomerFee {
    percentage?: number;
    amount?: number;
    chargedToCustomer?: boolean;
    operatorSharePercentage?: number;
    operatorShareAmount?: number;
    propellerShareAmount?: number;
}

export enum OperatorPayoutSortOptions {
    CreatedAt = "CreatedAt",
    Amount = "Amount",
    PayoutDate = "PayoutDate",
    PaymentPaidOn = "PaymentPaidOn",
}

export enum OperatorPayoutStatus {
    NotSet = "NotSet",
    Available = "Available",
    Processing = "Processing",
    PaidOut = "PaidOut",
}

export enum OperatorPayoutType {
    NotSet = "NotSet",
    Booking = "Booking",
    CustomerBalanceTopUp = "CustomerBalanceTopUp",
}

export class OptionRequest implements IOptionRequest {
    name!: string | null;
    description?: string | null;
    basePrice!: number;
    isDefault?: boolean;
    sortOrder?: number;

    constructor(data?: IOptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.basePrice = _data["basePrice"];
            this.isDefault = _data["isDefault"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): OptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["basePrice"] = this.basePrice;
        data["isDefault"] = this.isDefault;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IOptionRequest {
    name: string | null;
    description?: string | null;
    basePrice: number;
    isDefault?: boolean;
    sortOrder?: number;
}

export class OrderingLocationAddress implements IOrderingLocationAddress {
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;
    latitude?: number;
    longitude?: number;

    constructor(data?: IOrderingLocationAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line = _data["line"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): OrderingLocationAddress {
        data = typeof data === 'object' ? data : {};
        let result = new OrderingLocationAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line"] = this.line;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["state"] = this.state;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IOrderingLocationAddress {
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;
    latitude?: number;
    longitude?: number;
}

export class OverlappingRangeInfo implements IOverlappingRangeInfo {
    seasonName!: string | null;
    startDate!: MonthDay;
    endDate!: MonthDay;

    constructor(data?: IOverlappingRangeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.startDate = new MonthDay();
            this.endDate = new MonthDay();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonName = _data["seasonName"];
            this.startDate = _data["startDate"] ? MonthDay.fromJS(_data["startDate"]) : new MonthDay();
            this.endDate = _data["endDate"] ? MonthDay.fromJS(_data["endDate"]) : new MonthDay();
        }
    }

    static fromJS(data: any): OverlappingRangeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OverlappingRangeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonName"] = this.seasonName;
        data["startDate"] = this.startDate ? this.startDate.toJSON() : this.startDate;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : this.endDate;
        return data;
    }
}

export interface IOverlappingRangeInfo {
    seasonName: string | null;
    startDate: MonthDay;
    endDate: MonthDay;
}

export enum OwnerSortOptions {
    FullName = "FullName",
}

export enum PackageSortOptions {
    Name = "Name",
    Duration = "Duration",
    NumberOfBoats = "NumberOfBoats",
    StartTimes = "StartTimes",
}

export class PackagesCountModel implements IPackagesCountModel {
    market?: MarketResult;
    count?: number;

    constructor(data?: IPackagesCountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.market = _data["market"] ? MarketResult.fromJS(_data["market"]) : <any>null;
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): PackagesCountModel {
        data = typeof data === 'object' ? data : {};
        let result = new PackagesCountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["market"] = this.market ? this.market.toJSON() : this.market;
        data["count"] = this.count;
        return data;
    }
}

export interface IPackagesCountModel {
    market?: MarketResult;
    count?: number;
}

export class PaginatedResult_1 implements IPaginatedResult_1 {
    baseCount?: number;
    readonly isFiltered?: boolean;
    readonly count?: number;
    items?: TResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    readonly pageCount?: number;

    constructor(data?: IPaginatedResult_1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseCount = _data["baseCount"];
            (<any>this).isFiltered = _data["isFiltered"];
            (<any>this).count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TResult.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (<any>this).pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): PaginatedResult_1 {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResult_1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseCount"] = this.baseCount;
        data["isFiltered"] = this.isFiltered;
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IPaginatedResult_1 {
    baseCount?: number;
    isFiltered?: boolean;
    count?: number;
    items?: TResult[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
    pageCount?: number;
}

export class PayBookingUsingBalanceCommand implements IPayBookingUsingBalanceCommand {
    bookingGuid!: string;
    amount!: number;
    note!: string | null;

    constructor(data?: IPayBookingUsingBalanceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PayBookingUsingBalanceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PayBookingUsingBalanceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }
}

export interface IPayBookingUsingBalanceCommand {
    bookingGuid: string;
    amount: number;
    note: string | null;
}

export class PayBookingUsingBalanceCommandResponse implements IPayBookingUsingBalanceCommandResponse {
    paymentGuid?: string;

    constructor(data?: IPayBookingUsingBalanceCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGuid = _data["paymentGuid"];
        }
    }

    static fromJS(data: any): PayBookingUsingBalanceCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PayBookingUsingBalanceCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGuid"] = this.paymentGuid;
        return data;
    }
}

export interface IPayBookingUsingBalanceCommandResponse {
    paymentGuid?: string;
}

export class PayBookingUsingExternalPaymentCommand implements IPayBookingUsingExternalPaymentCommand {
    bookingGuid!: string;
    paymentMethodGuid!: string;
    paidOn!: Date;
    amount!: number;
    note!: string | null;

    constructor(data?: IPayBookingUsingExternalPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.paymentMethodGuid = _data["paymentMethodGuid"];
            this.paidOn = _data["paidOn"] ? new Date(_data["paidOn"].toString()) : <any>null;
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PayBookingUsingExternalPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PayBookingUsingExternalPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["paymentMethodGuid"] = this.paymentMethodGuid;
        data["paidOn"] = this.paidOn && this.paidOn.toISOString();
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }
}

export interface IPayBookingUsingExternalPaymentCommand {
    bookingGuid: string;
    paymentMethodGuid: string;
    paidOn: Date;
    amount: number;
    note: string | null;
}

export class PayMultibookingUsingBalanceCommand implements IPayMultibookingUsingBalanceCommand {
    amount!: number;
    note!: string | null;

    constructor(data?: IPayMultibookingUsingBalanceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PayMultibookingUsingBalanceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PayMultibookingUsingBalanceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }
}

export interface IPayMultibookingUsingBalanceCommand {
    amount: number;
    note: string | null;
}

export class PayMultibookingUsingBalanceCommandResponse implements IPayMultibookingUsingBalanceCommandResponse {
    paymentGuid?: string;

    constructor(data?: IPayMultibookingUsingBalanceCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGuid = _data["paymentGuid"];
        }
    }

    static fromJS(data: any): PayMultibookingUsingBalanceCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PayMultibookingUsingBalanceCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGuid"] = this.paymentGuid;
        return data;
    }
}

export interface IPayMultibookingUsingBalanceCommandResponse {
    paymentGuid?: string;
}

export class PayMultibookingUsingExternalPaymentCommand implements IPayMultibookingUsingExternalPaymentCommand {
    paymentMethodGuid!: string;
    paidOn!: Date;
    amount!: number;
    note!: string | null;

    constructor(data?: IPayMultibookingUsingExternalPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethodGuid = _data["paymentMethodGuid"];
            this.paidOn = _data["paidOn"] ? new Date(_data["paidOn"].toString()) : <any>null;
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PayMultibookingUsingExternalPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PayMultibookingUsingExternalPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodGuid"] = this.paymentMethodGuid;
        data["paidOn"] = this.paidOn && this.paidOn.toISOString();
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }
}

export interface IPayMultibookingUsingExternalPaymentCommand {
    paymentMethodGuid: string;
    paidOn: Date;
    amount: number;
    note: string | null;
}

export enum PaymentFeeType {
    OnlineCustomerFee = "OnlineCustomerFee",
    PropellerTakeRate = "PropellerTakeRate",
}

export enum PaymentGateway {
    Stripe = "Stripe",
    AuthorizeNet = "AuthorizeNet",
    WorldPay = "WorldPay",
}

export enum PaymentMethodSource {
    Admin = "Admin",
    PublicApi = "PublicApi",
    CustomerPortal = "CustomerPortal",
}

export enum PaymentProvider {
    NotSet = "NotSet",
    None = "None",
    Stripe = "Stripe",
    External = "External",
    Balance = "Balance",
    AuthorizeNet = "AuthorizeNet",
    WorldPay = "WorldPay",
}

export enum PaymentSortOptions {
    CreatedAt = "CreatedAt",
}

export enum PaymentStatus {
    NotSet = "NotSet",
    Intent = "Intent",
    Processing = "Processing",
    Complete = "Complete",
    Failed = "Failed",
    Expired = "Expired",
    Cancelled = "Cancelled",
    CheckoutPending = "CheckoutPending",
}

export class PaymentUser implements IPaymentUser {
    readonly guid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
    readonly fullName?: string | null;

    constructor(data?: IPaymentUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.status = _data["status"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): PaymentUser {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IPaymentUser {
    guid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
    fullName?: string | null;
}

export class PictureResultModel implements IPictureResultModel {
    readonly pictureGuid?: string | null;
    readonly host?: string | null;
    bucket?: string | null;
    readonly name?: string | null;
    readonly extension?: string | null;
    readonly description?: string | null;
    readonly height?: number | null;
    readonly width?: number | null;
    readonly size?: number | null;

    constructor(data?: IPictureResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).pictureGuid = _data["pictureGuid"];
            (<any>this).host = _data["host"];
            this.bucket = _data["bucket"];
            (<any>this).name = _data["name"];
            (<any>this).extension = _data["extension"];
            (<any>this).description = _data["description"];
            (<any>this).height = _data["height"];
            (<any>this).width = _data["width"];
            (<any>this).size = _data["size"];
        }
    }

    static fromJS(data: any): PictureResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new PictureResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pictureGuid"] = this.pictureGuid;
        data["host"] = this.host;
        data["bucket"] = this.bucket;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["description"] = this.description;
        data["height"] = this.height;
        data["width"] = this.width;
        data["size"] = this.size;
        return data;
    }
}

export interface IPictureResultModel {
    pictureGuid?: string | null;
    host?: string | null;
    bucket?: string | null;
    name?: string | null;
    extension?: string | null;
    description?: string | null;
    height?: number | null;
    width?: number | null;
    size?: number | null;
}

export class PlatformAccountBankInfo implements IPlatformAccountBankInfo {
    bankName?: string | null;
    accountNumber?: string | null;
    routingNumber?: string | null;
    nachaFileOperatorName?: string | null;

    constructor(data?: IPlatformAccountBankInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankName = _data["bankName"];
            this.accountNumber = _data["accountNumber"];
            this.routingNumber = _data["routingNumber"];
            this.nachaFileOperatorName = _data["nachaFileOperatorName"];
        }
    }

    static fromJS(data: any): PlatformAccountBankInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformAccountBankInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["accountNumber"] = this.accountNumber;
        data["routingNumber"] = this.routingNumber;
        data["nachaFileOperatorName"] = this.nachaFileOperatorName;
        return data;
    }
}

export interface IPlatformAccountBankInfo {
    bankName?: string | null;
    accountNumber?: string | null;
    routingNumber?: string | null;
    nachaFileOperatorName?: string | null;
}

export class PlatformAccountBillingInfo implements IPlatformAccountBillingInfo {
    vatNumber!: string | null;
    line!: string | null;
    city!: string | null;
    postalCode!: string | null;
    country!: string | null;
    state?: string | null;

    constructor(data?: IPlatformAccountBillingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vatNumber = _data["vatNumber"];
            this.line = _data["line"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): PlatformAccountBillingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformAccountBillingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vatNumber"] = this.vatNumber;
        data["line"] = this.line;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["state"] = this.state;
        return data;
    }
}

export interface IPlatformAccountBillingInfo {
    vatNumber: string | null;
    line: string | null;
    city: string | null;
    postalCode: string | null;
    country: string | null;
    state?: string | null;
}

export class PlatformAccountDocusignConfiguration implements IPlatformAccountDocusignConfiguration {
    secretKey?: string | null;
    basePath?: string | null;
    emailSubject?: string | null;
    userId?: string | null;
    integratorKey?: string | null;
    privateKey?: string | null;
    oauthBasePath?: string | null;
    accountId?: string | null;
    templateId?: string | null;
    webhookAuthenticationUserName?: string | null;
    webhookAuthenticationPassword?: string | null;

    constructor(data?: IPlatformAccountDocusignConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secretKey = _data["secretKey"];
            this.basePath = _data["basePath"];
            this.emailSubject = _data["emailSubject"];
            this.userId = _data["userId"];
            this.integratorKey = _data["integratorKey"];
            this.privateKey = _data["privateKey"];
            this.oauthBasePath = _data["oauthBasePath"];
            this.accountId = _data["accountId"];
            this.templateId = _data["templateId"];
            this.webhookAuthenticationUserName = _data["webhookAuthenticationUserName"];
            this.webhookAuthenticationPassword = _data["webhookAuthenticationPassword"];
        }
    }

    static fromJS(data: any): PlatformAccountDocusignConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformAccountDocusignConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secretKey"] = this.secretKey;
        data["basePath"] = this.basePath;
        data["emailSubject"] = this.emailSubject;
        data["userId"] = this.userId;
        data["integratorKey"] = this.integratorKey;
        data["privateKey"] = this.privateKey;
        data["oauthBasePath"] = this.oauthBasePath;
        data["accountId"] = this.accountId;
        data["templateId"] = this.templateId;
        data["webhookAuthenticationUserName"] = this.webhookAuthenticationUserName;
        data["webhookAuthenticationPassword"] = this.webhookAuthenticationPassword;
        return data;
    }
}

export interface IPlatformAccountDocusignConfiguration {
    secretKey?: string | null;
    basePath?: string | null;
    emailSubject?: string | null;
    userId?: string | null;
    integratorKey?: string | null;
    privateKey?: string | null;
    oauthBasePath?: string | null;
    accountId?: string | null;
    templateId?: string | null;
    webhookAuthenticationUserName?: string | null;
    webhookAuthenticationPassword?: string | null;
}

export enum PlatformAccountSettingKey {
    NotSet = "NotSet",
    ConversionTrackingEnabled = "ConversionTrackingEnabled",
    HideLocationSection = "HideLocationSection",
    AircallEnabled = "AircallEnabled",
}

export class PlatformAccountSettings implements IPlatformAccountSettings {
    measurementSystem?: MeasurementSystem;
    conversionTrackingEnabled?: boolean;
    widget?: WidgetSettings;
    bookingSummary?: BookingSummarySettings;
    aircallEnabled?: boolean;
    salesLead?: SalesLeadSettings;

    constructor(data?: IPlatformAccountSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementSystem = _data["measurementSystem"];
            this.conversionTrackingEnabled = _data["conversionTrackingEnabled"];
            this.widget = _data["widget"] ? WidgetSettings.fromJS(_data["widget"]) : <any>null;
            this.bookingSummary = _data["bookingSummary"] ? BookingSummarySettings.fromJS(_data["bookingSummary"]) : <any>null;
            this.aircallEnabled = _data["aircallEnabled"];
            this.salesLead = _data["salesLead"] ? SalesLeadSettings.fromJS(_data["salesLead"]) : <any>null;
        }
    }

    static fromJS(data: any): PlatformAccountSettings {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformAccountSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementSystem"] = this.measurementSystem;
        data["conversionTrackingEnabled"] = this.conversionTrackingEnabled;
        data["widget"] = this.widget ? this.widget.toJSON() : this.widget;
        data["bookingSummary"] = this.bookingSummary ? this.bookingSummary.toJSON() : this.bookingSummary;
        data["aircallEnabled"] = this.aircallEnabled;
        data["salesLead"] = this.salesLead ? this.salesLead.toJSON() : this.salesLead;
        return data;
    }
}

export interface IPlatformAccountSettings {
    measurementSystem?: MeasurementSystem;
    conversionTrackingEnabled?: boolean;
    widget?: WidgetSettings;
    bookingSummary?: BookingSummarySettings;
    aircallEnabled?: boolean;
    salesLead?: SalesLeadSettings;
}

export enum PlatformAccountSortOptions {
    Name = "Name",
    Status = "Status",
}

export enum PlatformAccountStatus {
    NotSet = "NotSet",
    Inactive = "Inactive",
    Active = "Active",
    Deleted = "Deleted",
}

export class PolicyKeyValue implements IPolicyKeyValue {
    key?: PropellerPoliciesEnum;
    value?: boolean;

    constructor(data?: IPolicyKeyValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PolicyKeyValue {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyKeyValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IPolicyKeyValue {
    key?: PropellerPoliciesEnum;
    value?: boolean;
}

export enum PrePaymentConditionType {
    Always = "Always",
    DaysThreshold = "DaysThreshold",
}

export class PrePaymentInfo implements IPrePaymentInfo {
    percentage?: number;
    amount?: number;
    amountWithOnlineFee?: number;

    constructor(data?: IPrePaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.amount = _data["amount"];
            this.amountWithOnlineFee = _data["amountWithOnlineFee"];
        }
    }

    static fromJS(data: any): PrePaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PrePaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["amount"] = this.amount;
        data["amountWithOnlineFee"] = this.amountWithOnlineFee;
        return data;
    }
}

export interface IPrePaymentInfo {
    percentage?: number;
    amount?: number;
    amountWithOnlineFee?: number;
}

export class PricedAmount implements IPricedAmount {
    netAmount?: number;
    taxes?: TaxLine[] | null;
    grossAmount?: number;
    readonly totalTaxAmount?: number;

    constructor(data?: IPricedAmount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.netAmount = _data["netAmount"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TaxLine.fromJS(item));
            }
            this.grossAmount = _data["grossAmount"];
            (<any>this).totalTaxAmount = _data["totalTaxAmount"];
        }
    }

    static fromJS(data: any): PricedAmount {
        data = typeof data === 'object' ? data : {};
        let result = new PricedAmount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["netAmount"] = this.netAmount;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        data["grossAmount"] = this.grossAmount;
        data["totalTaxAmount"] = this.totalTaxAmount;
        return data;
    }
}

export interface IPricedAmount {
    netAmount?: number;
    taxes?: TaxLine[] | null;
    grossAmount?: number;
    totalTaxAmount?: number;
}

export class PricingAdditionalFeeRecord implements IPricingAdditionalFeeRecord {
    additionalFeeTypeGuid?: string;
    code?: string | null;
    name?: string | null;
    amount?: number;

    constructor(data?: IPricingAdditionalFeeRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalFeeTypeGuid = _data["additionalFeeTypeGuid"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): PricingAdditionalFeeRecord {
        data = typeof data === 'object' ? data : {};
        let result = new PricingAdditionalFeeRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalFeeTypeGuid"] = this.additionalFeeTypeGuid;
        data["code"] = this.code;
        data["name"] = this.name;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IPricingAdditionalFeeRecord {
    additionalFeeTypeGuid?: string;
    code?: string | null;
    name?: string | null;
    amount?: number;
}

export class PricingLineItem implements IPricingLineItem {
    name?: string | null;
    price?: number;
    type?: PricingLineItemType;
    feeGuid?: string | null;
    taxes?: TaxLine[] | null;

    constructor(data?: IPricingLineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.type = _data["type"];
            this.feeGuid = _data["feeGuid"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TaxLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PricingLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new PricingLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["type"] = this.type;
        data["feeGuid"] = this.feeGuid;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPricingLineItem {
    name?: string | null;
    price?: number;
    type?: PricingLineItemType;
    feeGuid?: string | null;
    taxes?: TaxLine[] | null;
}

export enum PricingLineItemType {
    RentalPrice = "RentalPrice",
    AdditionalFee = "AdditionalFee",
    PromoCodeDiscount = "PromoCodeDiscount",
    CampaignDiscount = "CampaignDiscount",
    ProcessingFee = "ProcessingFee",
}

export enum PricingMode {
    Packages = "Packages",
    Calendar = "Calendar",
}

export enum PricingModel {
    NotSet = "NotSet",
    PerItem = "PerItem",
    PerItemPerDay = "PerItemPerDay",
}

export class PricingPackage implements IPricingPackage {
    readonly guid?: string;
    readonly name?: string | null;
    duration?: TimeSpan;
    readonly startTimes?: TimeOnly[] | null;
    readonly isSunset?: boolean;

    constructor(data?: IPricingPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).name = _data["name"];
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : <any>null;
            if (Array.isArray(_data["startTimes"])) {
                (<any>this).startTimes = [] as any;
                for (let item of _data["startTimes"])
                    (<any>this).startTimes!.push(TimeOnly.fromJS(item));
            }
            (<any>this).isSunset = _data["isSunset"];
        }
    }

    static fromJS(data: any): PricingPackage {
        data = typeof data === 'object' ? data : {};
        let result = new PricingPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["duration"] = this.duration ? this.duration.toJSON() : this.duration;
        if (Array.isArray(this.startTimes)) {
            data["startTimes"] = [];
            for (let item of this.startTimes)
                data["startTimes"].push(item.toJSON());
        }
        data["isSunset"] = this.isSunset;
        return data;
    }
}

export interface IPricingPackage {
    guid?: string;
    name?: string | null;
    duration?: TimeSpan;
    startTimes?: TimeOnly[] | null;
    isSunset?: boolean;
}

export enum PricingSortOptions {
    Name = "Name",
    Market = "Market",
    BasePrice = "BasePrice",
    SortOrder = "SortOrder",
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class ProcessAuthorizeNetCheckoutSessionPaymentCommand implements IProcessAuthorizeNetCheckoutSessionPaymentCommand {
    checkoutSessionGuid!: string;
    creditCardPaymentRequest?: CreditCardPaymentRequest;
    bankAccountPaymentRequest?: BankAccountPaymentRequest;
    note?: string | null;

    constructor(data?: IProcessAuthorizeNetCheckoutSessionPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkoutSessionGuid = _data["checkoutSessionGuid"];
            this.creditCardPaymentRequest = _data["creditCardPaymentRequest"] ? CreditCardPaymentRequest.fromJS(_data["creditCardPaymentRequest"]) : <any>null;
            this.bankAccountPaymentRequest = _data["bankAccountPaymentRequest"] ? BankAccountPaymentRequest.fromJS(_data["bankAccountPaymentRequest"]) : <any>null;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ProcessAuthorizeNetCheckoutSessionPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAuthorizeNetCheckoutSessionPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkoutSessionGuid"] = this.checkoutSessionGuid;
        data["creditCardPaymentRequest"] = this.creditCardPaymentRequest ? this.creditCardPaymentRequest.toJSON() : this.creditCardPaymentRequest;
        data["bankAccountPaymentRequest"] = this.bankAccountPaymentRequest ? this.bankAccountPaymentRequest.toJSON() : this.bankAccountPaymentRequest;
        data["note"] = this.note;
        return data;
    }
}

export interface IProcessAuthorizeNetCheckoutSessionPaymentCommand {
    checkoutSessionGuid: string;
    creditCardPaymentRequest?: CreditCardPaymentRequest;
    bankAccountPaymentRequest?: BankAccountPaymentRequest;
    note?: string | null;
}

export class ProcessAuthorizeNetCheckoutSessionPaymentCommandResult implements IProcessAuthorizeNetCheckoutSessionPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: AuthorizeNetTransactionStatus;
    paymentStatus?: PaymentStatus;

    constructor(data?: IProcessAuthorizeNetCheckoutSessionPaymentCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGuid = _data["paymentGuid"];
            this.transactionStatus = _data["transactionStatus"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): ProcessAuthorizeNetCheckoutSessionPaymentCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessAuthorizeNetCheckoutSessionPaymentCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGuid"] = this.paymentGuid;
        data["transactionStatus"] = this.transactionStatus;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IProcessAuthorizeNetCheckoutSessionPaymentCommandResult {
    paymentGuid?: string;
    transactionStatus?: AuthorizeNetTransactionStatus;
    paymentStatus?: PaymentStatus;
}

export class ProcessWorldPayCheckoutSessionPaymentCommand implements IProcessWorldPayCheckoutSessionPaymentCommand {
    sessionGuid!: string;
    token!: string | null;
    tokenId!: string | null;
    last4Digits!: string | null;

    constructor(data?: IProcessWorldPayCheckoutSessionPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionGuid = _data["sessionGuid"];
            this.token = _data["token"];
            this.tokenId = _data["tokenId"];
            this.last4Digits = _data["last4Digits"];
        }
    }

    static fromJS(data: any): ProcessWorldPayCheckoutSessionPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWorldPayCheckoutSessionPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionGuid"] = this.sessionGuid;
        data["token"] = this.token;
        data["tokenId"] = this.tokenId;
        data["last4Digits"] = this.last4Digits;
        return data;
    }
}

export interface IProcessWorldPayCheckoutSessionPaymentCommand {
    sessionGuid: string;
    token: string | null;
    tokenId: string | null;
    last4Digits: string | null;
}

export class ProcessWorldPayCheckoutSessionPaymentCommandResult implements IProcessWorldPayCheckoutSessionPaymentCommandResult {
    paymentGuid!: string;
    transactionStatus!: WorldPayTransactionStatus;
    success!: boolean;
    errorMessage?: string | null;
    paymentMethodGuid?: string | null;
    isNewPaymentMethod?: boolean;

    constructor(data?: IProcessWorldPayCheckoutSessionPaymentCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGuid = _data["paymentGuid"];
            this.transactionStatus = _data["transactionStatus"];
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.paymentMethodGuid = _data["paymentMethodGuid"];
            this.isNewPaymentMethod = _data["isNewPaymentMethod"];
        }
    }

    static fromJS(data: any): ProcessWorldPayCheckoutSessionPaymentCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessWorldPayCheckoutSessionPaymentCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGuid"] = this.paymentGuid;
        data["transactionStatus"] = this.transactionStatus;
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["paymentMethodGuid"] = this.paymentMethodGuid;
        data["isNewPaymentMethod"] = this.isNewPaymentMethod;
        return data;
    }
}

export interface IProcessWorldPayCheckoutSessionPaymentCommandResult {
    paymentGuid: string;
    transactionStatus: WorldPayTransactionStatus;
    success: boolean;
    errorMessage?: string | null;
    paymentMethodGuid?: string | null;
    isNewPaymentMethod?: boolean;
}

export enum PromoCodeType {
    NotSet = "NotSet",
    Discount = "Discount",
    Donate = "Donate",
}

export enum PropellerPoliciesEnum {
    Admin_AdditionalFee_List = "Admin_AdditionalFee_List",
    Admin_AdditionalFee_Create = "Admin_AdditionalFee_Create",
    Admin_AdditionalFee_Detail = "Admin_AdditionalFee_Detail",
    Admin_AdditionalFee_Edit = "Admin_AdditionalFee_Edit",
    Admin_AvailabilityDayPricings_List = "Admin_AvailabilityDayPricings_List",
    Admin_ExternalPaymentMethod_List = "Admin_ExternalPaymentMethod_List",
    Admin_ExternalPaymentMethod_Create = "Admin_ExternalPaymentMethod_Create",
    Admin_ExternalPaymentMethod_Edit = "Admin_ExternalPaymentMethod_Edit",
    Admin_ExternalPaymentMethod_Delete = "Admin_ExternalPaymentMethod_Delete",
    Admin_Boats_Create = "Admin_Boats_Create",
    Admin_Boats_Detail = "Admin_Boats_Detail",
    Admin_Boats_Edit = "Admin_Boats_Edit",
    Admin_Boats_Delete = "Admin_Boats_Delete",
    Admin_Boats_List = "Admin_Boats_List",
    Admin_Boats_Statistics = "Admin_Boats_Statistics",
    Admin_Boats_List_TotalTrips = "Admin_Boats_List_TotalTrips",
    Admin_Boats_List_TotalRevenue = "Admin_Boats_List_TotalRevenue",
    Admin_Boats_List_PrioritySort = "Admin_Boats_List_PrioritySort",
    Admin_Boats_ViewOwnerTakeRate = "Admin_Boats_ViewOwnerTakeRate",
    Admin_Boats_TuneUps_List = "Admin_Boats_TuneUps_List",
    Admin_Boats_TuneUps_Create = "Admin_Boats_TuneUps_Create",
    Admin_Boats_TuneUps_Edit = "Admin_Boats_TuneUps_Edit",
    Admin_Boats_TuneUps_Delete = "Admin_Boats_TuneUps_Delete",
    Admin_Boats_TuneUps_List_Export = "Admin_Boats_TuneUps_List_Export",
    Admin_Boats_Parts_List = "Admin_Boats_Parts_List",
    Admin_Boats_Parts_Create = "Admin_Boats_Parts_Create",
    Admin_Boats_Parts_Edit = "Admin_Boats_Parts_Edit",
    Admin_Boats_Parts_Delete = "Admin_Boats_Parts_Delete",
    Admin_Boats_Parts_List_Export = "Admin_Boats_Parts_List_Export",
    Admin_Boats_Issues_List = "Admin_Boats_Issues_List",
    Admin_Boats_Issues_Create = "Admin_Boats_Issues_Create",
    Admin_Boats_Issues_Edit = "Admin_Boats_Issues_Edit",
    Admin_Boats_Issues_Delete = "Admin_Boats_Issues_Delete",
    Admin_Boats_Issues_List_Export = "Admin_Boats_Issues_List_Export",
    Admin_Boats_Detail_FE_Lists = "Admin_Boats_Detail_FE_Lists",
    Admin_Boats_Availability_List = "Admin_Boats_Availability_List",
    Admin_Boats_Performance = "Admin_Boats_Performance",
    Admin_Boats_Calendar = "Admin_Boats_Calendar",
    Admin_BoatEvents_Create = "Admin_BoatEvents_Create",
    Admin_BoatEvents_Edit = "Admin_BoatEvents_Edit",
    Admin_BoatEvents_Detail = "Admin_BoatEvents_Detail",
    Admin_BoatEvents_Delete = "Admin_BoatEvents_Delete",
    Admin_Bookings_Balance = "Admin_Bookings_Balance",
    Admin_Bookings_Create = "Admin_Bookings_Create",
    Admin_Bookings_Detail = "Admin_Bookings_Detail",
    Admin_Bookings_Edit = "Admin_Bookings_Edit",
    Admin_Bookings_Edit_BookingNotes = "Admin_Bookings_Edit_BookingNotes",
    Admin_Bookings_List = "Admin_Bookings_List",
    Admin_Bookings_List_Export = "Admin_Bookings_List_Export",
    Admin_Bookings_ItemsList = "Admin_Bookings_ItemsList",
    Admin_Bookings_List_Filters = "Admin_Bookings_List_Filters",
    Admin_Bookings_List_OlderThan14Days = "Admin_Bookings_List_OlderThan14Days",
    Admin_Bookings_List_NotCreatedOrAssigned = "Admin_Bookings_List_NotCreatedOrAssigned",
    Admin_Bookings_List_NotDraftOfferReservationCancelled = "Admin_Bookings_List_NotDraftOfferReservationCancelled",
    Admin_Bookings_List_SearchLessThan3Characters = "Admin_Bookings_List_SearchLessThan3Characters",
    Admin_Bookings_Export_Payouts = "Admin_Bookings_Export_Payouts",
    Admin_Bookings_Calendar_List = "Admin_Bookings_Calendar_List",
    Admin_Bookings_Notifications = "Admin_Bookings_Notifications",
    Admin_Bookings_PaymentList = "Admin_Bookings_PaymentList",
    Admin_Bookings_PricingDetails = "Admin_Bookings_PricingDetails",
    Admin_Bookings_EventLogs = "Admin_Bookings_EventLogs",
    Admin_Bookings_Print = "Admin_Bookings_Print",
    Admin_Bookings_Clone = "Admin_Bookings_Clone",
    Admin_Bookings_SendContract = "Admin_Bookings_SendContract",
    Admin_Bookings_SendHandoff = "Admin_Bookings_SendHandoff",
    Admin_Bookings_SendOffer = "Admin_Bookings_SendOffer",
    Admin_Bookings_Cancel = "Admin_Bookings_Cancel",
    Admin_Bookings_Postpone = "Admin_Bookings_Postpone",
    Admin_Bookings_Attachments_Upload = "Admin_Bookings_Attachments_Upload",
    Admin_Bookings_Attachments_Delete = "Admin_Bookings_Attachments_Delete",
    Admin_Bookings_Attachments_View = "Admin_Bookings_Attachments_View",
    Admin_Bookings_Attachments_List = "Admin_Bookings_Attachments_List",
    Admin_Contracts_List = "Admin_Contracts_List",
    Admin_Bookings_CreateExternalContract = "Admin_Bookings_CreateExternalContract",
    Admin_Customers_Create = "Admin_Customers_Create",
    Admin_Customers_Detail = "Admin_Customers_Detail",
    Admin_Customers_Detail_Statistics = "Admin_Customers_Detail_Statistics",
    Admin_Customers_Detail_Preferences = "Admin_Customers_Detail_Preferences",
    Admin_Customers_Edit = "Admin_Customers_Edit",
    Admin_Customers_Edit_Preferences = "Admin_Customers_Edit_Preferences",
    Admin_Customers_List = "Admin_Customers_List",
    Admin_Customers_List_Statistics = "Admin_Customers_List_Statistics",
    Admin_Customers_Delete = "Admin_Customers_Delete",
    Admin_Customers_Export = "Admin_Customers_Export",
    Admin_Customers_UpcomingBookings = "Admin_Customers_UpcomingBookings",
    Admin_Customers_HistoryBookings = "Admin_Customers_HistoryBookings",
    Admin_Customers_Email = "Admin_Customers_Email",
    Admin_Customers_Phone = "Admin_Customers_Phone",
    Admin_Customers_BookingAndNumber = "Admin_Customers_BookingAndNumber",
    Admin_Customers_TotalSpent = "Admin_Customers_TotalSpent",
    Admin_SalesLeads_List = "Admin_SalesLeads_List",
    Admin_SalesLeads_Detail = "Admin_SalesLeads_Detail",
    Admin_SalesLeads_Manage = "Admin_SalesLeads_Manage",
    Admin_SalesLeads_Create = "Admin_SalesLeads_Create",
    Admin_SalesLeads_Export = "Admin_SalesLeads_Export",
    Admin_DayPerformances_Detail = "Admin_DayPerformances_Detail",
    Admin_DayPerformances_Revenue_Detail = "Admin_DayPerformances_Revenue_Detail",
    Admin_EmailTemplates_List = "Admin_EmailTemplates_List",
    Admin_EmailTemplates_Create = "Admin_EmailTemplates_Create",
    Admin_EmailTemplates_Detail = "Admin_EmailTemplates_Detail",
    Admin_EmailTemplates_Edit = "Admin_EmailTemplates_Edit",
    Admin_EmailTemplates_Delete = "Admin_EmailTemplates_Delete",
    Admin_EmailTemplates_Preview = "Admin_EmailTemplates_Preview",
    Admin_EmailTemplates_Macros = "Admin_EmailTemplates_Macros",
    Admin_InternalNotes_Create = "Admin_InternalNotes_Create",
    Admin_InternalNotes_Edit = "Admin_InternalNotes_Edit",
    Admin_InternalNotes_List = "Admin_InternalNotes_List",
    Admin_InternalNotes_Delete = "Admin_InternalNotes_Delete",
    Admin_Listings_List = "Admin_Listings_List",
    Admin_Locations_Create = "Admin_Locations_Create",
    Admin_Locations_Edit = "Admin_Locations_Edit",
    Admin_Locations_Detail = "Admin_Locations_Detail",
    Admin_Locations_List = "Admin_Locations_List",
    Admin_Locations_Activate = "Admin_Locations_Activate",
    Admin_Markets_List = "Admin_Markets_List",
    Admin_Markets_Detail = "Admin_Markets_Detail",
    Admin_Markets_Edit = "Admin_Markets_Edit",
    Admin_Markets_Create = "Admin_Markets_Create",
    Admin_Markets_Delete = "Admin_Markets_Delete",
    Admin_Packages_Create = "Admin_Packages_Create",
    Admin_Packages_Detail = "Admin_Packages_Detail",
    Admin_Packages_Edit = "Admin_Packages_Edit",
    Admin_Packages_List = "Admin_Packages_List",
    Admin_Payments_Create = "Admin_Payments_Create",
    Admin_Payments_Create_Card = "Admin_Payments_Create_Card",
    Admin_Payments_Create_External = "Admin_Payments_Create_External",
    Admin_Payments_Void_External = "Admin_Payments_Void_External",
    Admin_Payments_Create_Balance = "Admin_Payments_Create_Balance",
    Admin_Payments_Detail = "Admin_Payments_Detail",
    Admin_Payments_List = "Admin_Payments_List",
    Admin_PaymentMethods_List = "Admin_PaymentMethods_List",
    Admin_Payments_ExportWithFeesCsv = "Admin_Payments_ExportWithFeesCsv",
    Admin_Payments_FeesSummary = "Admin_Payments_FeesSummary",
    Admin_Payments_WithFees = "Admin_Payments_WithFees",
    Admin_Payments_AllList = "Admin_Payments_AllList",
    Admin_Accounting_ExportPaymentsCsv = "Admin_Accounting_ExportPaymentsCsv",
    Admin_Accounting_ExportBookingItemsCsv = "Admin_Accounting_ExportBookingItemsCsv",
    Admin_Pricings_Create = "Admin_Pricings_Create",
    Admin_Pricings_Detail = "Admin_Pricings_Detail",
    Admin_Pricings_Edit = "Admin_Pricings_Edit",
    Admin_Pricings_List = "Admin_Pricings_List",
    Admin_Pricings_Delete = "Admin_Pricings_Delete",
    Admin_Pricings_Calendar = "Admin_Pricings_Calendar",
    Admin_Skippers_List = "Admin_Skippers_List",
    Admin_Stewardesses_List = "Admin_Stewardesses_List",
    Admin_CheckinPersons_List = "Admin_CheckinPersons_List",
    Admin_StickyNotes_Create = "Admin_StickyNotes_Create",
    Admin_StickyNotes_Delete = "Admin_StickyNotes_Delete",
    Admin_StickyNotes_Detail = "Admin_StickyNotes_Detail",
    Admin_StickyNotes_Edit = "Admin_StickyNotes_Edit",
    Admin_StickyNotes_List = "Admin_StickyNotes_List",
    Admin_AuthenticationUsers_Create = "Admin_AuthenticationUsers_Create",
    Admin_Users_Create = "Admin_Users_Create",
    Admin_Users_Detail = "Admin_Users_Detail",
    Admin_Users_Edit = "Admin_Users_Edit",
    Admin_Users_List = "Admin_Users_List",
    Admin_Vendors_List = "Admin_Vendors_List",
    Admin_Vendors_Create = "Admin_Vendors_Create",
    Admin_Vendors_Edit = "Admin_Vendors_Edit",
    Admin_Vendors_Delete = "Admin_Vendors_Delete",
    Admin_Addons_List = "Admin_Addons_List",
    Admin_Addons_Create = "Admin_Addons_Create",
    Admin_Addons_Edit = "Admin_Addons_Edit",
    Admin_Addons_Delete = "Admin_Addons_Delete",
    Admin_AddonCategories_List = "Admin_AddonCategories_List",
    Admin_AddonCategories_Create = "Admin_AddonCategories_Create",
    Admin_AddonCategories_Edit = "Admin_AddonCategories_Edit",
    Admin_AddonCategories_Delete = "Admin_AddonCategories_Delete",
    Admin_Payouts_List = "Admin_Payouts_List",
    Admin_Payouts_Edit = "Admin_Payouts_Edit",
    Admin_Payouts_Export = "Admin_Payouts_Export",
    Admin_Payouts_ExportOperatorPayoutsCsv = "Admin_Payouts_ExportOperatorPayoutsCsv",
    Admin_Payouts_ExportOperatorPayoutsCnbAch = "Admin_Payouts_ExportOperatorPayoutsCnbAch",
    Admin_Payouts_Summary = "Admin_Payouts_Summary",
    Admin_Payouts_NachaFileExport = "Admin_Payouts_NachaFileExport",
    Admin_Balance_ExportOperatorActivitiesCsv = "Admin_Balance_ExportOperatorActivitiesCsv",
    Admin_Balance_GetOperatorBalanceActivitiesQuery = "Admin_Balance_GetOperatorBalanceActivitiesQuery",
    Admin_Balance_GetOperatorSummary = "Admin_Balance_GetOperatorSummary",
    Admin_Channels_Create = "Admin_Channels_Create",
    Admin_Channels_Delete = "Admin_Channels_Delete",
    Admin_Channels_Update = "Admin_Channels_Update",
    Admin_Channels_List = "Admin_Channels_List",
    Admin_Campaigns_Create = "Admin_Campaigns_Create",
    Admin_Campaigns_Delete = "Admin_Campaigns_Delete",
    Admin_Campaigns_Update = "Admin_Campaigns_Update",
    Admin_Campaigns_Payments_List = "Admin_Campaigns_Payments_List",
    Admin_CampaignUrls_Create = "Admin_CampaignUrls_Create",
    Admin_CampaignUrls_Update = "Admin_CampaignUrls_Update",
    Admin_CampaignUrls_Delete = "Admin_CampaignUrls_Delete",
    Admin_CampaignUrls_List = "Admin_CampaignUrls_List",
    Admin_Agents_List = "Admin_Agents_List",
    Admin_Agents_Create = "Admin_Agents_Create",
    Admin_Agents_Detail = "Admin_Agents_Detail",
    Admin_Agents_Update = "Admin_Agents_Update",
    Admin_Agents_Delete = "Admin_Agents_Delete",
    Admin_Agents_Groups_List = "Admin_Agents_Groups_List",
    Admin_Brokers_Create = "Admin_Brokers_Create",
    Admin_Brokers_Update = "Admin_Brokers_Update",
    Admin_Brokers_Delete = "Admin_Brokers_Delete",
    Admin_DiscountType_List = "Admin_DiscountType_List",
    Admin_DiscountType_Create = "Admin_DiscountType_Create",
    Admin_DiscountType_Edit = "Admin_DiscountType_Edit",
    Admin_DiscountType_Delete = "Admin_DiscountType_Delete",
    Admin_DirectChannels_List = "Admin_DirectChannels_List",
    Admin_DirectChannels_Create = "Admin_DirectChannels_Create",
    Admin_DirectChannels_Detail = "Admin_DirectChannels_Detail",
    Admin_DirectChannels_Update = "Admin_DirectChannels_Update",
    Admin_DirectChannels_Delete = "Admin_DirectChannels_Delete",
    Admin_PrePaymentPolicy_View = "Admin_PrePaymentPolicy_View",
    Admin_PrePaymentPolicy_Edit = "Admin_PrePaymentPolicy_Edit",
    Admin_Bookings_Create_AsBroker = "Admin_Bookings_Create_AsBroker",
    Admin_Bookings_Overbooking = "Admin_Bookings_Overbooking",
    Admin_Bookings_ConvertToProforma = "Admin_Bookings_ConvertToProforma",
    Admin_Bookings_Edit_Price = "Admin_Bookings_Edit_Price",
    Admin_Bookings_Edit_Staff = "Admin_Bookings_Edit_Staff",
    Admin_Bookings_Edit_Attribution = "Admin_Bookings_Edit_Attribution",
    Admin_Bookings_Edit_Commission = "Admin_Bookings_Edit_Commission",
    Admin_Bookings_Edit_ProformaExpiration = "Admin_Bookings_Edit_ProformaExpiration",
    Admin_Multibookings_List = "Admin_Multibookings_List",
    Admin_Multibookings_Detail = "Admin_Multibookings_Detail",
    Admin_Multibookings_Create = "Admin_Multibookings_Create",
    Admin_Multibookings_Edit = "Admin_Multibookings_Edit",
    Admin_Multibookings_SendOffer = "Admin_Multibookings_SendOffer",
    Admin_Customers_Edit_AgentBroker = "Admin_Customers_Edit_AgentBroker",
    Admin_Customers_Block = "Admin_Customers_Block",
    Admin_Dashboard_Sales = "Admin_Dashboard_Sales",
    Admin_Dashboard_Operations = "Admin_Dashboard_Operations",
    Admin_Dashboard_MyTodo = "Admin_Dashboard_MyTodo",
    Admin_Dashboard_Revenue = "Admin_Dashboard_Revenue",
    Admin_Dashboard_Dismiss = "Admin_Dashboard_Dismiss",
    Admin_PlatformAccounts_EditRegionalSettings = "Admin_PlatformAccounts_EditRegionalSettings",
    User_Booking_Detail = "User_Booking_Detail",
    User_Booking_Customer_Detail = "User_Booking_Customer_Detail",
    User_Multibooking_Detail = "User_Multibooking_Detail",
    User_Multibooking_Payment = "User_Multibooking_Payment",
}

export class PropellerTakeRate implements IPropellerTakeRate {
    percentage?: number;
    amount?: number;

    constructor(data?: IPropellerTakeRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): PropellerTakeRate {
        data = typeof data === 'object' ? data : {};
        let result = new PropellerTakeRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IPropellerTakeRate {
    percentage?: number;
    amount?: number;
}

export enum ProspectsSortOptions {
    CustomerNumber = "CustomerNumber",
    FullName = "FullName",
    LastEnquiryStartDate = "LastEnquiryStartDate",
    LastEnquiryCreatedAtUtc = "LastEnquiryCreatedAtUtc",
    LastEnquiryBaseAmount = "LastEnquiryBaseAmount",
    TotalEnquiries = "TotalEnquiries",
    TotalBasePrice = "TotalBasePrice",
}

export enum PublishStatus {
    NotSet = "NotSet",
    Unpublished = "Unpublished",
    PublishedAdminOnly = "PublishedAdminOnly",
    Published = "Published",
}

export enum RecalculationState {
    Idle = "Idle",
    InProgress = "InProgress",
    Completed = "Completed",
    Failed = "Failed",
}

export class RemovePlatformAccountAccessTokenCommand implements IRemovePlatformAccountAccessTokenCommand {
    guid!: string;
    token!: string | null;

    constructor(data?: IRemovePlatformAccountAccessTokenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): RemovePlatformAccountAccessTokenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemovePlatformAccountAccessTokenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["token"] = this.token;
        return data;
    }
}

export interface IRemovePlatformAccountAccessTokenCommand {
    guid: string;
    token: string | null;
}

export enum RenterSortOptions {
    CustomerNumber = "CustomerNumber",
    FullName = "FullName",
    Rating = "Rating",
    TotalSpent = "TotalSpent",
    AverageSpent = "AverageSpent",
    FutureBookings = "FutureBookings",
    PastBookings = "PastBookings",
    TotalBookings = "TotalBookings",
    LastBooking = "LastBooking",
}

export class ResetToSeasonPriceCommand implements IResetToSeasonPriceCommand {
    dates!: Date[] | null;

    constructor(data?: IResetToSeasonPriceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(parseDateOnly(item));
            }
        }
    }

    static fromJS(data: any): ResetToSeasonPriceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetToSeasonPriceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(formatDate(item));
        }
        return data;
    }
}

export interface IResetToSeasonPriceCommand {
    dates: Date[] | null;
}

export class RevenueByPaymentMethodModel implements IRevenueByPaymentMethodModel {
    provider?: PaymentProvider;
    externalPaymentMethodGuid?: string | null;
    externalPaymentMethodCode?: string | null;
    revenue?: number;
    percentage?: number;

    constructor(data?: IRevenueByPaymentMethodModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"];
            this.externalPaymentMethodGuid = _data["externalPaymentMethodGuid"];
            this.externalPaymentMethodCode = _data["externalPaymentMethodCode"];
            this.revenue = _data["revenue"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): RevenueByPaymentMethodModel {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueByPaymentMethodModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["externalPaymentMethodGuid"] = this.externalPaymentMethodGuid;
        data["externalPaymentMethodCode"] = this.externalPaymentMethodCode;
        data["revenue"] = this.revenue;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IRevenueByPaymentMethodModel {
    provider?: PaymentProvider;
    externalPaymentMethodGuid?: string | null;
    externalPaymentMethodCode?: string | null;
    revenue?: number;
    percentage?: number;
}

export enum RevenueGranularity {
    Daily = "Daily",
    Monthly = "Monthly",
    Yearly = "Yearly",
}

export enum RoleName {
    Admin = "Admin",
    Owner = "Owner",
    SalesPerson = "SalesPerson",
    Skipper = "Skipper",
    Stewardess = "Stewardess",
    Customer = "Customer",
    FinanceAdmin = "FinanceAdmin",
    Broker = "Broker",
    Analytics = "Analytics",
    CheckinPerson = "CheckinPerson",
}

export enum RunnerJobStatus {
    NotSet = "NotSet",
    Enqueued = "Enqueued",
    Scheduled = "Scheduled",
    Succeeded = "Succeeded",
    Cancelled = "Cancelled",
    Failed = "Failed",
}

export class SalesLeadBoat implements ISalesLeadBoat {
    readonly guid?: string;
    readonly defaultListingTitle?: string | null;

    constructor(data?: ISalesLeadBoat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).defaultListingTitle = _data["defaultListingTitle"];
        }
    }

    static fromJS(data: any): SalesLeadBoat {
        data = typeof data === 'object' ? data : {};
        let result = new SalesLeadBoat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["defaultListingTitle"] = this.defaultListingTitle;
        return data;
    }
}

export interface ISalesLeadBoat {
    guid?: string;
    defaultListingTitle?: string | null;
}

export class SalesLeadBooking implements ISalesLeadBooking {
    readonly guid?: string;
    totalPrice?: number;
    status?: BookingStatus;
    readonly createdAtUtc?: Date;

    constructor(data?: ISalesLeadBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.totalPrice = _data["totalPrice"];
            this.status = _data["status"];
            (<any>this).createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): SalesLeadBooking {
        data = typeof data === 'object' ? data : {};
        let result = new SalesLeadBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["totalPrice"] = this.totalPrice;
        data["status"] = this.status;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        return data;
    }
}

export interface ISalesLeadBooking {
    guid?: string;
    totalPrice?: number;
    status?: BookingStatus;
    createdAtUtc?: Date;
}

export class SalesLeadCustomer implements ISalesLeadCustomer {
    readonly guid?: string;
    customerNumber?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    readonly fullName?: string | null;

    constructor(data?: ISalesLeadCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.customerNumber = _data["customerNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): SalesLeadCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new SalesLeadCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["customerNumber"] = this.customerNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ISalesLeadCustomer {
    guid?: string;
    customerNumber?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    fullName?: string | null;
}

export class SalesLeadDetailAircallDataResult implements ISalesLeadDetailAircallDataResult {
    aircallId?: number;
    direction?: string | null;
    duration?: number | null;
    status?: string | null;
    startedAt?: Date | null;
    answeredAt?: Date | null;
    endedAt?: Date | null;
    recording?: string | null;
    voicemail?: string | null;
    tags?: string[] | null;
    comments?: string | null;
    user?: AircallUserResult;
    number?: AircallNumberResult;
    summary?: AircallSummaryResult;
    sentiment?: string | null;
    transcription?: AircallTranscriptionResult;

    constructor(data?: ISalesLeadDetailAircallDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aircallId = _data["aircallId"];
            this.direction = _data["direction"];
            this.duration = _data["duration"];
            this.status = _data["status"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>null;
            this.answeredAt = _data["answeredAt"] ? new Date(_data["answeredAt"].toString()) : <any>null;
            this.endedAt = _data["endedAt"] ? new Date(_data["endedAt"].toString()) : <any>null;
            this.recording = _data["recording"];
            this.voicemail = _data["voicemail"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.comments = _data["comments"];
            this.user = _data["user"] ? AircallUserResult.fromJS(_data["user"]) : <any>null;
            this.number = _data["number"] ? AircallNumberResult.fromJS(_data["number"]) : <any>null;
            this.summary = _data["summary"] ? AircallSummaryResult.fromJS(_data["summary"]) : <any>null;
            this.sentiment = _data["sentiment"];
            this.transcription = _data["transcription"] ? AircallTranscriptionResult.fromJS(_data["transcription"]) : <any>null;
        }
    }

    static fromJS(data: any): SalesLeadDetailAircallDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new SalesLeadDetailAircallDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aircallId"] = this.aircallId;
        data["direction"] = this.direction;
        data["duration"] = this.duration;
        data["status"] = this.status;
        data["startedAt"] = this.startedAt && this.startedAt.toISOString();
        data["answeredAt"] = this.answeredAt && this.answeredAt.toISOString();
        data["endedAt"] = this.endedAt && this.endedAt.toISOString();
        data["recording"] = this.recording;
        data["voicemail"] = this.voicemail;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["comments"] = this.comments;
        data["user"] = this.user ? this.user.toJSON() : this.user;
        data["number"] = this.number ? this.number.toJSON() : this.number;
        data["summary"] = this.summary ? this.summary.toJSON() : this.summary;
        data["sentiment"] = this.sentiment;
        data["transcription"] = this.transcription ? this.transcription.toJSON() : this.transcription;
        return data;
    }
}

export interface ISalesLeadDetailAircallDataResult {
    aircallId?: number;
    direction?: string | null;
    duration?: number | null;
    status?: string | null;
    startedAt?: Date | null;
    answeredAt?: Date | null;
    endedAt?: Date | null;
    recording?: string | null;
    voicemail?: string | null;
    tags?: string[] | null;
    comments?: string | null;
    user?: AircallUserResult;
    number?: AircallNumberResult;
    summary?: AircallSummaryResult;
    sentiment?: string | null;
    transcription?: AircallTranscriptionResult;
}

export class SalesLeadMessageDto implements ISalesLeadMessageDto {
    guid!: string;
    channel!: MessageChannel;
    direction!: MessageDirection;
    from!: string | null;
    to!: string | null;
    body!: string | null;
    sentAt!: Date;
    isRead!: boolean;
    sentByUserGuid?: string | null;
    sentByUserName?: string | null;
    subject?: string | null;
    smsDeliveryStatus?: SmsDeliveryStatus;
    emailDeliveryStatus?: EmailDeliveryStatus;

    constructor(data?: ISalesLeadMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.channel = _data["channel"];
            this.direction = _data["direction"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.body = _data["body"];
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : <any>null;
            this.isRead = _data["isRead"];
            this.sentByUserGuid = _data["sentByUserGuid"];
            this.sentByUserName = _data["sentByUserName"];
            this.subject = _data["subject"];
            this.smsDeliveryStatus = _data["smsDeliveryStatus"];
            this.emailDeliveryStatus = _data["emailDeliveryStatus"];
        }
    }

    static fromJS(data: any): SalesLeadMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesLeadMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["channel"] = this.channel;
        data["direction"] = this.direction;
        data["from"] = this.from;
        data["to"] = this.to;
        data["body"] = this.body;
        data["sentAt"] = this.sentAt && this.sentAt.toISOString();
        data["isRead"] = this.isRead;
        data["sentByUserGuid"] = this.sentByUserGuid;
        data["sentByUserName"] = this.sentByUserName;
        data["subject"] = this.subject;
        data["smsDeliveryStatus"] = this.smsDeliveryStatus;
        data["emailDeliveryStatus"] = this.emailDeliveryStatus;
        return data;
    }
}

export interface ISalesLeadMessageDto {
    guid: string;
    channel: MessageChannel;
    direction: MessageDirection;
    from: string | null;
    to: string | null;
    body: string | null;
    sentAt: Date;
    isRead: boolean;
    sentByUserGuid?: string | null;
    sentByUserName?: string | null;
    subject?: string | null;
    smsDeliveryStatus?: SmsDeliveryStatus;
    emailDeliveryStatus?: EmailDeliveryStatus;
}

export class SalesLeadNote implements ISalesLeadNote {
    readonly guid?: string;
    content?: string | null;
    readonly createdAtUtc?: Date;
    createdByGuid?: string;

    constructor(data?: ISalesLeadNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.content = _data["content"];
            (<any>this).createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>null;
            this.createdByGuid = _data["createdByGuid"];
        }
    }

    static fromJS(data: any): SalesLeadNote {
        data = typeof data === 'object' ? data : {};
        let result = new SalesLeadNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["content"] = this.content;
        data["createdAtUtc"] = this.createdAtUtc && this.createdAtUtc.toISOString();
        data["createdByGuid"] = this.createdByGuid;
        return data;
    }
}

export interface ISalesLeadNote {
    guid?: string;
    content?: string | null;
    createdAtUtc?: Date;
    createdByGuid?: string;
}

export enum SalesLeadOrigin {
    NotSet = "NotSet",
    Form = "Form",
    Call = "Call",
    Email = "Email",
    Sms = "Sms",
    Other = "Other",
    Aircall = "Aircall",
}

export class SalesLeadOwnerStatistic implements ISalesLeadOwnerStatistic {
    assignedUser!: SalesLeadUser;
    count!: number;

    constructor(data?: ISalesLeadOwnerStatistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.assignedUser = new SalesLeadUser();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedUser = _data["assignedUser"] ? SalesLeadUser.fromJS(_data["assignedUser"]) : new SalesLeadUser();
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): SalesLeadOwnerStatistic {
        data = typeof data === 'object' ? data : {};
        let result = new SalesLeadOwnerStatistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : this.assignedUser;
        data["count"] = this.count;
        return data;
    }
}

export interface ISalesLeadOwnerStatistic {
    assignedUser: SalesLeadUser;
    count: number;
}

export class SalesLeadSettings implements ISalesLeadSettings {
    termsUrl?: string | null;
    messagingEnabled?: boolean;

    constructor(data?: ISalesLeadSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termsUrl = _data["termsUrl"];
            this.messagingEnabled = _data["messagingEnabled"];
        }
    }

    static fromJS(data: any): SalesLeadSettings {
        data = typeof data === 'object' ? data : {};
        let result = new SalesLeadSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termsUrl"] = this.termsUrl;
        data["messagingEnabled"] = this.messagingEnabled;
        return data;
    }
}

export interface ISalesLeadSettings {
    termsUrl?: string | null;
    messagingEnabled?: boolean;
}

export enum SalesLeadSortOptions {
    Name = "Name",
    Status = "Status",
    Assignee = "Assignee",
    CustomerNumber = "CustomerNumber",
    Guests = "Guests",
    Budget = "Budget",
    DepartureDate = "DepartureDate",
    Boat = "Boat",
    Source = "Source",
    SubmissionDate = "SubmissionDate",
}

export enum SalesLeadStatus {
    NotSet = "NotSet",
    New = "New",
    Working = "Working",
    ClosedSold = "ClosedSold",
    ClosedLost = "ClosedLost",
}

export class SalesLeadUser implements ISalesLeadUser {
    readonly guid?: string;
    readonly firstName?: string | null;
    readonly lastName?: string | null;
    readonly middleName?: string | null;
    readonly email?: string | null;
    readonly phone?: string | null;
    status?: UserStatus;
    readonly fullName?: string | null;

    constructor(data?: ISalesLeadUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).firstName = _data["firstName"];
            (<any>this).lastName = _data["lastName"];
            (<any>this).middleName = _data["middleName"];
            (<any>this).email = _data["email"];
            (<any>this).phone = _data["phone"];
            this.status = _data["status"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): SalesLeadUser {
        data = typeof data === 'object' ? data : {};
        let result = new SalesLeadUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["status"] = this.status;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface ISalesLeadUser {
    guid?: string;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
    status?: UserStatus;
    fullName?: string | null;
}

export enum SalesPersonSortOptions {
    FullName = "FullName",
}

export class SeasonFeesDto implements ISeasonFeesDto {
    seasonGuid?: string;
    seasonName?: string | null;
    fees?: FeeItemDto[] | null;

    constructor(data?: ISeasonFeesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonGuid = _data["seasonGuid"];
            this.seasonName = _data["seasonName"];
            if (Array.isArray(_data["fees"])) {
                this.fees = [] as any;
                for (let item of _data["fees"])
                    this.fees!.push(FeeItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeasonFeesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonFeesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonGuid"] = this.seasonGuid;
        data["seasonName"] = this.seasonName;
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeasonFeesDto {
    seasonGuid?: string;
    seasonName?: string | null;
    fees?: FeeItemDto[] | null;
}

export class SeasonPriceDto implements ISeasonPriceDto {
    seasonGuid?: string;
    seasonName?: string | null;
    seasonColor?: string | null;
    basePrice?: number;

    constructor(data?: ISeasonPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonGuid = _data["seasonGuid"];
            this.seasonName = _data["seasonName"];
            this.seasonColor = _data["seasonColor"];
            this.basePrice = _data["basePrice"];
        }
    }

    static fromJS(data: any): SeasonPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeasonPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonGuid"] = this.seasonGuid;
        data["seasonName"] = this.seasonName;
        data["seasonColor"] = this.seasonColor;
        data["basePrice"] = this.basePrice;
        return data;
    }
}

export interface ISeasonPriceDto {
    seasonGuid?: string;
    seasonName?: string | null;
    seasonColor?: string | null;
    basePrice?: number;
}

export enum SeasonalEnum {
    YearRound = "YearRound",
    Seasonal = "Seasonal",
}

export class SendBookingOfferCommand implements ISendBookingOfferCommand {
    customerEmails?: string[] | null;
    ccEmails?: string[] | null;
    additionalMessage?: string | null;
    availabilityBlock?: boolean;

    constructor(data?: ISendBookingOfferCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customerEmails"])) {
                this.customerEmails = [] as any;
                for (let item of _data["customerEmails"])
                    this.customerEmails!.push(item);
            }
            if (Array.isArray(_data["ccEmails"])) {
                this.ccEmails = [] as any;
                for (let item of _data["ccEmails"])
                    this.ccEmails!.push(item);
            }
            this.additionalMessage = _data["additionalMessage"];
            this.availabilityBlock = _data["availabilityBlock"];
        }
    }

    static fromJS(data: any): SendBookingOfferCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendBookingOfferCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerEmails)) {
            data["customerEmails"] = [];
            for (let item of this.customerEmails)
                data["customerEmails"].push(item);
        }
        if (Array.isArray(this.ccEmails)) {
            data["ccEmails"] = [];
            for (let item of this.ccEmails)
                data["ccEmails"].push(item);
        }
        data["additionalMessage"] = this.additionalMessage;
        data["availabilityBlock"] = this.availabilityBlock;
        return data;
    }
}

export interface ISendBookingOfferCommand {
    customerEmails?: string[] | null;
    ccEmails?: string[] | null;
    additionalMessage?: string | null;
    availabilityBlock?: boolean;
}

export class SendContractCommand implements ISendContractCommand {
    bookingGuid!: string;
    recipientEmail!: string | null;
    ccEmails?: string[] | null;

    constructor(data?: ISendContractCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            this.recipientEmail = _data["recipientEmail"];
            if (Array.isArray(_data["ccEmails"])) {
                this.ccEmails = [] as any;
                for (let item of _data["ccEmails"])
                    this.ccEmails!.push(item);
            }
        }
    }

    static fromJS(data: any): SendContractCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendContractCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        data["recipientEmail"] = this.recipientEmail;
        if (Array.isArray(this.ccEmails)) {
            data["ccEmails"] = [];
            for (let item of this.ccEmails)
                data["ccEmails"].push(item);
        }
        return data;
    }
}

export interface ISendContractCommand {
    bookingGuid: string;
    recipientEmail: string | null;
    ccEmails?: string[] | null;
}

export class SendHandoffEmailCommand implements ISendHandoffEmailCommand {
    bookingGuid?: string;
    customerEmails?: string[] | null;
    customerEmailCcs?: string[] | null;
    skipperEmails?: string[] | null;
    checkinPersonEmails?: string[] | null;
    stewardessEmails?: string[] | null;
    additionalMessage?: string | null;

    constructor(data?: ISendHandoffEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
            if (Array.isArray(_data["customerEmails"])) {
                this.customerEmails = [] as any;
                for (let item of _data["customerEmails"])
                    this.customerEmails!.push(item);
            }
            if (Array.isArray(_data["customerEmailCcs"])) {
                this.customerEmailCcs = [] as any;
                for (let item of _data["customerEmailCcs"])
                    this.customerEmailCcs!.push(item);
            }
            if (Array.isArray(_data["skipperEmails"])) {
                this.skipperEmails = [] as any;
                for (let item of _data["skipperEmails"])
                    this.skipperEmails!.push(item);
            }
            if (Array.isArray(_data["checkinPersonEmails"])) {
                this.checkinPersonEmails = [] as any;
                for (let item of _data["checkinPersonEmails"])
                    this.checkinPersonEmails!.push(item);
            }
            if (Array.isArray(_data["stewardessEmails"])) {
                this.stewardessEmails = [] as any;
                for (let item of _data["stewardessEmails"])
                    this.stewardessEmails!.push(item);
            }
            this.additionalMessage = _data["additionalMessage"];
        }
    }

    static fromJS(data: any): SendHandoffEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendHandoffEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        if (Array.isArray(this.customerEmails)) {
            data["customerEmails"] = [];
            for (let item of this.customerEmails)
                data["customerEmails"].push(item);
        }
        if (Array.isArray(this.customerEmailCcs)) {
            data["customerEmailCcs"] = [];
            for (let item of this.customerEmailCcs)
                data["customerEmailCcs"].push(item);
        }
        if (Array.isArray(this.skipperEmails)) {
            data["skipperEmails"] = [];
            for (let item of this.skipperEmails)
                data["skipperEmails"].push(item);
        }
        if (Array.isArray(this.checkinPersonEmails)) {
            data["checkinPersonEmails"] = [];
            for (let item of this.checkinPersonEmails)
                data["checkinPersonEmails"].push(item);
        }
        if (Array.isArray(this.stewardessEmails)) {
            data["stewardessEmails"] = [];
            for (let item of this.stewardessEmails)
                data["stewardessEmails"].push(item);
        }
        data["additionalMessage"] = this.additionalMessage;
        return data;
    }
}

export interface ISendHandoffEmailCommand {
    bookingGuid?: string;
    customerEmails?: string[] | null;
    customerEmailCcs?: string[] | null;
    skipperEmails?: string[] | null;
    checkinPersonEmails?: string[] | null;
    stewardessEmails?: string[] | null;
    additionalMessage?: string | null;
}

export class SendHandoffMessageCommand implements ISendHandoffMessageCommand {
    bookingGuid?: string;

    constructor(data?: ISendHandoffMessageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingGuid = _data["bookingGuid"];
        }
    }

    static fromJS(data: any): SendHandoffMessageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendHandoffMessageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingGuid"] = this.bookingGuid;
        return data;
    }
}

export interface ISendHandoffMessageCommand {
    bookingGuid?: string;
}

export class SendMultibookingOfferCommand implements ISendMultibookingOfferCommand {
    customerEmails?: string[] | null;
    ccEmails?: string[] | null;
    additionalMessage?: string | null;

    constructor(data?: ISendMultibookingOfferCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customerEmails"])) {
                this.customerEmails = [] as any;
                for (let item of _data["customerEmails"])
                    this.customerEmails!.push(item);
            }
            if (Array.isArray(_data["ccEmails"])) {
                this.ccEmails = [] as any;
                for (let item of _data["ccEmails"])
                    this.ccEmails!.push(item);
            }
            this.additionalMessage = _data["additionalMessage"];
        }
    }

    static fromJS(data: any): SendMultibookingOfferCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendMultibookingOfferCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerEmails)) {
            data["customerEmails"] = [];
            for (let item of this.customerEmails)
                data["customerEmails"].push(item);
        }
        if (Array.isArray(this.ccEmails)) {
            data["ccEmails"] = [];
            for (let item of this.ccEmails)
                data["ccEmails"].push(item);
        }
        data["additionalMessage"] = this.additionalMessage;
        return data;
    }
}

export interface ISendMultibookingOfferCommand {
    customerEmails?: string[] | null;
    ccEmails?: string[] | null;
    additionalMessage?: string | null;
}

export class SendResetPasswordEmailCommand implements ISendResetPasswordEmailCommand {
    email?: string | null;

    constructor(data?: ISendResetPasswordEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SendResetPasswordEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendResetPasswordEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface ISendResetPasswordEmailCommand {
    email?: string | null;
}

export class SendSalesLeadEmailCommandResult implements ISendSalesLeadEmailCommandResult {
    messageGuid!: string;

    constructor(data?: ISendSalesLeadEmailCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageGuid = _data["messageGuid"];
        }
    }

    static fromJS(data: any): SendSalesLeadEmailCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new SendSalesLeadEmailCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageGuid"] = this.messageGuid;
        return data;
    }
}

export interface ISendSalesLeadEmailCommandResult {
    messageGuid: string;
}

export class SendSalesLeadEmailRequest implements ISendSalesLeadEmailRequest {
    subject!: string | null;
    body!: string | null;

    constructor(data?: ISendSalesLeadEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): SendSalesLeadEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendSalesLeadEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface ISendSalesLeadEmailRequest {
    subject: string | null;
    body: string | null;
}

export class SendSalesLeadSmsCommandResult implements ISendSalesLeadSmsCommandResult {
    messageGuid!: string;

    constructor(data?: ISendSalesLeadSmsCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageGuid = _data["messageGuid"];
        }
    }

    static fromJS(data: any): SendSalesLeadSmsCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new SendSalesLeadSmsCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageGuid"] = this.messageGuid;
        return data;
    }
}

export interface ISendSalesLeadSmsCommandResult {
    messageGuid: string;
}

export class SendSalesLeadSmsRequest implements ISendSalesLeadSmsRequest {
    body!: string | null;

    constructor(data?: ISendSalesLeadSmsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): SendSalesLeadSmsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendSalesLeadSmsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        return data;
    }
}

export interface ISendSalesLeadSmsRequest {
    body: string | null;
}

export class SetBookingCommissionCommand implements ISetBookingCommissionCommand {
    commissionPercentage!: number;

    constructor(data?: ISetBookingCommissionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commissionPercentage = _data["commissionPercentage"];
        }
    }

    static fromJS(data: any): SetBookingCommissionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetBookingCommissionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commissionPercentage"] = this.commissionPercentage;
        return data;
    }
}

export interface ISetBookingCommissionCommand {
    commissionPercentage: number;
}

export class SetBookingPrePaymentOverrideCommand implements ISetBookingPrePaymentOverrideCommand {
    prePaymentPercentage?: number | null;

    constructor(data?: ISetBookingPrePaymentOverrideCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prePaymentPercentage = _data["prePaymentPercentage"];
        }
    }

    static fromJS(data: any): SetBookingPrePaymentOverrideCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetBookingPrePaymentOverrideCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prePaymentPercentage"] = this.prePaymentPercentage;
        return data;
    }
}

export interface ISetBookingPrePaymentOverrideCommand {
    prePaymentPercentage?: number | null;
}

export class SetBrokerActiveCommand implements ISetBrokerActiveCommand {
    isActive!: boolean;

    constructor(data?: ISetBrokerActiveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SetBrokerActiveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetBrokerActiveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISetBrokerActiveCommand {
    isActive: boolean;
}

export class SetCustomDayPriceCommand implements ISetCustomDayPriceCommand {
    customDayPrices!: SetCustomDayPriceDto[] | null;

    constructor(data?: ISetCustomDayPriceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customDayPrices"])) {
                this.customDayPrices = [] as any;
                for (let item of _data["customDayPrices"])
                    this.customDayPrices!.push(SetCustomDayPriceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetCustomDayPriceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetCustomDayPriceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customDayPrices)) {
            data["customDayPrices"] = [];
            for (let item of this.customDayPrices)
                data["customDayPrices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetCustomDayPriceCommand {
    customDayPrices: SetCustomDayPriceDto[] | null;
}

export class SetCustomDayPriceDto implements ISetCustomDayPriceDto {
    date!: Date;
    basePrice!: number;

    constructor(data?: ISetCustomDayPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? parseDateOnly(_data["date"].toString()) : <any>null;
            this.basePrice = _data["basePrice"];
        }
    }

    static fromJS(data: any): SetCustomDayPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetCustomDayPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date && formatDate(this.date);
        data["basePrice"] = this.basePrice;
        return data;
    }
}

export interface ISetCustomDayPriceDto {
    date: Date;
    basePrice: number;
}

export class SetDefaultPricingCommand implements ISetDefaultPricingCommand {

    constructor(data?: ISetDefaultPricingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SetDefaultPricingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultPricingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISetDefaultPricingCommand {
}

export class SetEmailTemplateActiveCommand implements ISetEmailTemplateActiveCommand {
    isActive!: boolean;

    constructor(data?: ISetEmailTemplateActiveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SetEmailTemplateActiveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetEmailTemplateActiveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISetEmailTemplateActiveCommand {
    isActive: boolean;
}

export class SetEmailTemplateEnabledCommand implements ISetEmailTemplateEnabledCommand {
    readonly guid?: string;
    isEnabled!: boolean;

    constructor(data?: ISetEmailTemplateEnabledCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): SetEmailTemplateEnabledCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetEmailTemplateEnabledCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface ISetEmailTemplateEnabledCommand {
    guid?: string;
    isEnabled: boolean;
}

export class SetPricingModeCommand implements ISetPricingModeCommand {
    pricingMode!: PricingMode;

    constructor(data?: ISetPricingModeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricingMode = _data["pricingMode"];
        }
    }

    static fromJS(data: any): SetPricingModeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetPricingModeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricingMode"] = this.pricingMode;
        return data;
    }
}

export interface ISetPricingModeCommand {
    pricingMode: PricingMode;
}

export class SetProformaExpirationCommand implements ISetProformaExpirationCommand {
    expiresAtDate?: Date | null;
    expiresAtTime?: TimeOnly;

    constructor(data?: ISetProformaExpirationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiresAtDate = _data["expiresAtDate"] ? parseDateOnly(_data["expiresAtDate"].toString()) : <any>null;
            this.expiresAtTime = _data["expiresAtTime"] ? TimeOnly.fromJS(_data["expiresAtTime"]) : <any>null;
        }
    }

    static fromJS(data: any): SetProformaExpirationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetProformaExpirationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiresAtDate"] = this.expiresAtDate && formatDate(this.expiresAtDate);
        data["expiresAtTime"] = this.expiresAtTime ? this.expiresAtTime.toJSON() : this.expiresAtTime;
        return data;
    }
}

export interface ISetProformaExpirationCommand {
    expiresAtDate?: Date | null;
    expiresAtTime?: TimeOnly;
}

export class SetSeasonFeeItemDto implements ISetSeasonFeeItemDto {
    additionalFeeTypeGuid!: string;
    amount!: number;

    constructor(data?: ISetSeasonFeeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalFeeTypeGuid = _data["additionalFeeTypeGuid"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): SetSeasonFeeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetSeasonFeeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalFeeTypeGuid"] = this.additionalFeeTypeGuid;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ISetSeasonFeeItemDto {
    additionalFeeTypeGuid: string;
    amount: number;
}

export class SetSeasonFeesCommand implements ISetSeasonFeesCommand {
    fees!: SetSeasonFeeItemDto[] | null;

    constructor(data?: ISetSeasonFeesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fees"])) {
                this.fees = [] as any;
                for (let item of _data["fees"])
                    this.fees!.push(SetSeasonFeeItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetSeasonFeesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetSeasonFeesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetSeasonFeesCommand {
    fees: SetSeasonFeeItemDto[] | null;
}

export class SetSeasonPriceCommand implements ISetSeasonPriceCommand {
    basePrice!: number;

    constructor(data?: ISetSeasonPriceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.basePrice = _data["basePrice"];
        }
    }

    static fromJS(data: any): SetSeasonPriceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetSeasonPriceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basePrice"] = this.basePrice;
        return data;
    }
}

export interface ISetSeasonPriceCommand {
    basePrice: number;
}

export class SetStripeConnectedAccountIdCommand implements ISetStripeConnectedAccountIdCommand {
    stripeConnectedAccountId?: string | null;

    constructor(data?: ISetStripeConnectedAccountIdCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stripeConnectedAccountId = _data["stripeConnectedAccountId"];
        }
    }

    static fromJS(data: any): SetStripeConnectedAccountIdCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetStripeConnectedAccountIdCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stripeConnectedAccountId"] = this.stripeConnectedAccountId;
        return data;
    }
}

export interface ISetStripeConnectedAccountIdCommand {
    stripeConnectedAccountId?: string | null;
}

export class SetWorldPayMerchantIdCommand implements ISetWorldPayMerchantIdCommand {
    worldPayMerchantId?: string | null;

    constructor(data?: ISetWorldPayMerchantIdCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.worldPayMerchantId = _data["worldPayMerchantId"];
        }
    }

    static fromJS(data: any): SetWorldPayMerchantIdCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetWorldPayMerchantIdCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["worldPayMerchantId"] = this.worldPayMerchantId;
        return data;
    }
}

export interface ISetWorldPayMerchantIdCommand {
    worldPayMerchantId?: string | null;
}

export class SkipperAssignedListing implements ISkipperAssignedListing {
    guid?: string;
    title?: string | null;

    constructor(data?: ISkipperAssignedListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): SkipperAssignedListing {
        data = typeof data === 'object' ? data : {};
        let result = new SkipperAssignedListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        return data;
    }
}

export interface ISkipperAssignedListing {
    guid?: string;
    title?: string | null;
}

export enum SkipperSortOptions {
    FullName = "FullName",
}

export enum SmsDeliveryStatus {
    NotSet = "NotSet",
    Queued = "Queued",
    Sent = "Sent",
    Delivered = "Delivered",
    Failed = "Failed",
}

export class StewardessAssignedListing implements IStewardessAssignedListing {
    guid?: string;
    title?: string | null;

    constructor(data?: IStewardessAssignedListing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): StewardessAssignedListing {
        data = typeof data === 'object' ? data : {};
        let result = new StewardessAssignedListing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["title"] = this.title;
        return data;
    }
}

export interface IStewardessAssignedListing {
    guid?: string;
    title?: string | null;
}

export enum StewardessSortOptions {
    FullName = "FullName",
}

export class StripePaymentInfo implements IStripePaymentInfo {
    readonly guid?: string;
    readonly paymentIntentId?: string | null;
    readonly checkoutSessionId?: string | null;
    readonly paymentProcessorCost?: number | null;
    readonly availableOn?: Date | null;
    paymentMethod?: StripePaymentMethodInfo;

    constructor(data?: IStripePaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).paymentIntentId = _data["paymentIntentId"];
            (<any>this).checkoutSessionId = _data["checkoutSessionId"];
            (<any>this).paymentProcessorCost = _data["paymentProcessorCost"];
            (<any>this).availableOn = _data["availableOn"] ? new Date(_data["availableOn"].toString()) : <any>null;
            this.paymentMethod = _data["paymentMethod"] ? StripePaymentMethodInfo.fromJS(_data["paymentMethod"]) : <any>null;
        }
    }

    static fromJS(data: any): StripePaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StripePaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["paymentIntentId"] = this.paymentIntentId;
        data["checkoutSessionId"] = this.checkoutSessionId;
        data["paymentProcessorCost"] = this.paymentProcessorCost;
        data["availableOn"] = this.availableOn && this.availableOn.toISOString();
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : this.paymentMethod;
        return data;
    }
}

export interface IStripePaymentInfo {
    guid?: string;
    paymentIntentId?: string | null;
    checkoutSessionId?: string | null;
    paymentProcessorCost?: number | null;
    availableOn?: Date | null;
    paymentMethod?: StripePaymentMethodInfo;
}

export class StripePaymentMethod implements IStripePaymentMethod {
    readonly guid?: string;
    paymentMethodId!: string | null;
    cardLast4?: string | null;
    cardBrand?: string | null;
    cardExpMonth?: number | null;
    cardExpYear?: number | null;
    type!: string | null;

    constructor(data?: IStripePaymentMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.cardLast4 = _data["cardLast4"];
            this.cardBrand = _data["cardBrand"];
            this.cardExpMonth = _data["cardExpMonth"];
            this.cardExpYear = _data["cardExpYear"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): StripePaymentMethod {
        data = typeof data === 'object' ? data : {};
        let result = new StripePaymentMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["paymentMethodId"] = this.paymentMethodId;
        data["cardLast4"] = this.cardLast4;
        data["cardBrand"] = this.cardBrand;
        data["cardExpMonth"] = this.cardExpMonth;
        data["cardExpYear"] = this.cardExpYear;
        data["type"] = this.type;
        return data;
    }
}

export interface IStripePaymentMethod {
    guid?: string;
    paymentMethodId: string | null;
    cardLast4?: string | null;
    cardBrand?: string | null;
    cardExpMonth?: number | null;
    cardExpYear?: number | null;
    type: string | null;
}

export class StripePaymentMethodInfo implements IStripePaymentMethodInfo {
    paymentMethodId!: string | null;
    cardLast4?: string | null;
    cardBrand?: string | null;
    cardExpMonth?: number | null;
    cardExpYear?: number | null;
    type!: string | null;

    constructor(data?: IStripePaymentMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentMethodId = _data["paymentMethodId"];
            this.cardLast4 = _data["cardLast4"];
            this.cardBrand = _data["cardBrand"];
            this.cardExpMonth = _data["cardExpMonth"];
            this.cardExpYear = _data["cardExpYear"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): StripePaymentMethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StripePaymentMethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethodId"] = this.paymentMethodId;
        data["cardLast4"] = this.cardLast4;
        data["cardBrand"] = this.cardBrand;
        data["cardExpMonth"] = this.cardExpMonth;
        data["cardExpYear"] = this.cardExpYear;
        data["type"] = this.type;
        return data;
    }
}

export interface IStripePaymentMethodInfo {
    paymentMethodId: string | null;
    cardLast4?: string | null;
    cardBrand?: string | null;
    cardExpMonth?: number | null;
    cardExpYear?: number | null;
    type: string | null;
}

export class TResult implements ITResult {

    constructor(data?: ITResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TResult {
        data = typeof data === 'object' ? data : {};
        let result = new TResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITResult {
}

export class TaxItemRequest implements ITaxItemRequest {
    name?: string | null;
    ratePercentage?: number;

    constructor(data?: ITaxItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.ratePercentage = _data["ratePercentage"];
        }
    }

    static fromJS(data: any): TaxItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaxItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ratePercentage"] = this.ratePercentage;
        return data;
    }
}

export interface ITaxItemRequest {
    name?: string | null;
    ratePercentage?: number;
}

export class TaxLine implements ITaxLine {
    name?: string | null;
    ratePercentage?: number;
    amount?: number;
    includedInPrice?: boolean;

    constructor(data?: ITaxLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.ratePercentage = _data["ratePercentage"];
            this.amount = _data["amount"];
            this.includedInPrice = _data["includedInPrice"];
        }
    }

    static fromJS(data: any): TaxLine {
        data = typeof data === 'object' ? data : {};
        let result = new TaxLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ratePercentage"] = this.ratePercentage;
        data["amount"] = this.amount;
        data["includedInPrice"] = this.includedInPrice;
        return data;
    }
}

export interface ITaxLine {
    name?: string | null;
    ratePercentage?: number;
    amount?: number;
    includedInPrice?: boolean;
}

export enum TaxType {
    NotSet = "NotSet",
    NoTax = "NoTax",
    ValueAddedTax = "ValueAddedTax",
    SalesTax = "SalesTax",
}

export class TimeFormatResult implements ITimeFormatResult {
    pattern!: string | null;
    use12Hour!: boolean;
    showPeriod!: boolean;
    showLeadingZero!: boolean;

    constructor(data?: ITimeFormatResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pattern = _data["pattern"];
            this.use12Hour = _data["use12Hour"];
            this.showPeriod = _data["showPeriod"];
            this.showLeadingZero = _data["showLeadingZero"];
        }
    }

    static fromJS(data: any): TimeFormatResult {
        data = typeof data === 'object' ? data : {};
        let result = new TimeFormatResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pattern"] = this.pattern;
        data["use12Hour"] = this.use12Hour;
        data["showPeriod"] = this.showPeriod;
        data["showLeadingZero"] = this.showLeadingZero;
        return data;
    }
}

export interface ITimeFormatResult {
    pattern: string | null;
    use12Hour: boolean;
    showPeriod: boolean;
    showLeadingZero: boolean;
}

export class TimeOnly implements ITimeOnly {
    hour!: number;
    minute!: number;

    constructor(data?: ITimeOnly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour = _data["hour"];
            this.minute = _data["minute"];
        }
    }

    static fromJS(data: any): TimeOnly {
        data = typeof data === 'object' ? data : {};
        let result = new TimeOnly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour"] = this.hour;
        data["minute"] = this.minute;
        return data;
    }
}

export interface ITimeOnly {
    hour: number;
    minute: number;
}

export class TimeSpan implements ITimeSpan {
    hours?: number;
    minutes?: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hours = _data["hours"];
            this.minutes = _data["minutes"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hours"] = this.hours;
        data["minutes"] = this.minutes;
        return data;
    }
}

export interface ITimeSpan {
    hours?: number;
    minutes?: number;
}

export class TimeZoneDateTime implements ITimeZoneDateTime {
    readonly utcDateTime?: Date;
    readonly localDateTime?: Date;
    readonly timeZoneId?: string | null;
    offset?: TimeSpan;

    constructor(data?: ITimeZoneDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).utcDateTime = _data["utcDateTime"] ? new Date(_data["utcDateTime"].toString()) : <any>null;
            (<any>this).localDateTime = _data["localDateTime"] ? new Date(_data["localDateTime"].toString()) : <any>null;
            (<any>this).timeZoneId = _data["timeZoneId"];
            this.offset = _data["offset"] ? TimeSpan.fromJS(_data["offset"]) : <any>null;
        }
    }

    static fromJS(data: any): TimeZoneDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utcDateTime"] = this.utcDateTime && this.utcDateTime.toISOString();
        data["localDateTime"] = this.localDateTime && this.localDateTime.toISOString();
        data["timeZoneId"] = this.timeZoneId;
        data["offset"] = this.offset ? this.offset.toJSON() : this.offset;
        return data;
    }
}

export interface ITimeZoneDateTime {
    utcDateTime?: Date;
    localDateTime?: Date;
    timeZoneId?: string | null;
    offset?: TimeSpan;
}

export enum TimezoneEnum {
    EST = "EST",
    CST = "CST",
    PST = "PST",
    MST = "MST",
    AKST = "AKST",
    HST = "HST",
    SST = "SST",
    CHST = "CHST",
    AST = "AST",
    PWT = "PWT",
    MHT = "MHT",
    CHUT = "CHUT",
    NST = "NST",
}

export class TopUpBalanceByExternalPaymentCommand implements ITopUpBalanceByExternalPaymentCommand {
    customerGuid!: string;
    paymentMethodGuid!: string;
    paidOn!: Date;
    amount!: number;
    note!: string | null;

    constructor(data?: ITopUpBalanceByExternalPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerGuid = _data["customerGuid"];
            this.paymentMethodGuid = _data["paymentMethodGuid"];
            this.paidOn = _data["paidOn"] ? new Date(_data["paidOn"].toString()) : <any>null;
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): TopUpBalanceByExternalPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TopUpBalanceByExternalPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerGuid"] = this.customerGuid;
        data["paymentMethodGuid"] = this.paymentMethodGuid;
        data["paidOn"] = this.paidOn && this.paidOn.toISOString();
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }
}

export interface ITopUpBalanceByExternalPaymentCommand {
    customerGuid: string;
    paymentMethodGuid: string;
    paidOn: Date;
    amount: number;
    note: string | null;
}

export class TopUpBalanceByExternalPaymentCommandResult implements ITopUpBalanceByExternalPaymentCommandResult {
    balanceAccountGUid?: string;

    constructor(data?: ITopUpBalanceByExternalPaymentCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balanceAccountGUid = _data["balanceAccountGUid"];
        }
    }

    static fromJS(data: any): TopUpBalanceByExternalPaymentCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new TopUpBalanceByExternalPaymentCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balanceAccountGUid"] = this.balanceAccountGUid;
        return data;
    }
}

export interface ITopUpBalanceByExternalPaymentCommandResult {
    balanceAccountGUid?: string;
}

export class UncoveredDateRangeDto implements IUncoveredDateRangeDto {
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IUncoveredDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UncoveredDateRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UncoveredDateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["endDate"] = this.endDate && formatDate(this.endDate);
        return data;
    }
}

export interface IUncoveredDateRangeDto {
    startDate?: Date;
    endDate?: Date;
}

export class UpdateAdditionalFeeTypeCommand implements IUpdateAdditionalFeeTypeCommand {
    name?: string | null;
    isActive?: boolean | null;
    defaultTaxes?: TaxLine[] | null;

    constructor(data?: IUpdateAdditionalFeeTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateAdditionalFeeTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdditionalFeeTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateAdditionalFeeTypeCommand {
    name?: string | null;
    isActive?: boolean | null;
    defaultTaxes?: TaxLine[] | null;
}

export class UpdateAdditionalFeeTypeDisplayOrderCommand implements IUpdateAdditionalFeeTypeDisplayOrderCommand {
    displayOrder?: number;

    constructor(data?: IUpdateAdditionalFeeTypeDisplayOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): UpdateAdditionalFeeTypeDisplayOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdditionalFeeTypeDisplayOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IUpdateAdditionalFeeTypeDisplayOrderCommand {
    displayOrder?: number;
}

export class UpdateAddonCategoryCommand implements IUpdateAddonCategoryCommand {
    name!: string | null;
    publishStatus!: PublishStatus;

    constructor(data?: IUpdateAddonCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.publishStatus = _data["publishStatus"];
        }
    }

    static fromJS(data: any): UpdateAddonCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddonCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["publishStatus"] = this.publishStatus;
        return data;
    }
}

export interface IUpdateAddonCategoryCommand {
    name: string | null;
    publishStatus: PublishStatus;
}

export class UpdateAddonCategoryPublishStatusCommand implements IUpdateAddonCategoryPublishStatusCommand {
    publishStatus?: PublishStatus;

    constructor(data?: IUpdateAddonCategoryPublishStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publishStatus = _data["publishStatus"];
        }
    }

    static fromJS(data: any): UpdateAddonCategoryPublishStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddonCategoryPublishStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishStatus"] = this.publishStatus;
        return data;
    }
}

export interface IUpdateAddonCategoryPublishStatusCommand {
    publishStatus?: PublishStatus;
}

export class UpdateAddonCommand implements IUpdateAddonCommand {
    name!: string | null;
    description?: string | null;
    categoryGuid!: string;
    vendorGuid!: string;
    pricingModel!: PricingModel;
    basePrice!: number;
    defaultTaxes?: TaxLine[] | null;
    commissionable!: boolean;
    commissionRatePercentage!: number;
    bookability!: AddonBookability;
    maxQuantity?: number | null;
    selectionType?: AddonSelectionType;
    options?: OptionRequest[] | null;

    constructor(data?: IUpdateAddonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.categoryGuid = _data["categoryGuid"];
            this.vendorGuid = _data["vendorGuid"];
            this.pricingModel = _data["pricingModel"];
            this.basePrice = _data["basePrice"];
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
            this.commissionable = _data["commissionable"];
            this.commissionRatePercentage = _data["commissionRatePercentage"];
            this.bookability = _data["bookability"];
            this.maxQuantity = _data["maxQuantity"];
            this.selectionType = _data["selectionType"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(OptionRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateAddonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["categoryGuid"] = this.categoryGuid;
        data["vendorGuid"] = this.vendorGuid;
        data["pricingModel"] = this.pricingModel;
        data["basePrice"] = this.basePrice;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        data["commissionable"] = this.commissionable;
        data["commissionRatePercentage"] = this.commissionRatePercentage;
        data["bookability"] = this.bookability;
        data["maxQuantity"] = this.maxQuantity;
        data["selectionType"] = this.selectionType;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateAddonCommand {
    name: string | null;
    description?: string | null;
    categoryGuid: string;
    vendorGuid: string;
    pricingModel: PricingModel;
    basePrice: number;
    defaultTaxes?: TaxLine[] | null;
    commissionable: boolean;
    commissionRatePercentage: number;
    bookability: AddonBookability;
    maxQuantity?: number | null;
    selectionType?: AddonSelectionType;
    options?: OptionRequest[] | null;
}

export class UpdateAddonPublishStatusCommand implements IUpdateAddonPublishStatusCommand {
    publishStatus?: PublishStatus;

    constructor(data?: IUpdateAddonPublishStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publishStatus = _data["publishStatus"];
        }
    }

    static fromJS(data: any): UpdateAddonPublishStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddonPublishStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishStatus"] = this.publishStatus;
        return data;
    }
}

export interface IUpdateAddonPublishStatusCommand {
    publishStatus?: PublishStatus;
}

export class UpdateAgentBillingInfoDto implements IUpdateAgentBillingInfoDto {
    companyName?: string | null;
    vatId?: string | null;
    addressLine?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;

    constructor(data?: IUpdateAgentBillingInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.vatId = _data["vatId"];
            this.addressLine = _data["addressLine"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): UpdateAgentBillingInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgentBillingInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["vatId"] = this.vatId;
        data["addressLine"] = this.addressLine;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        return data;
    }
}

export interface IUpdateAgentBillingInfoDto {
    companyName?: string | null;
    vatId?: string | null;
    addressLine?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
}

export class UpdateAgentCommand implements IUpdateAgentCommand {
    name!: string | null;
    group!: string | null;
    commissionPercent?: number;
    internalOwnerUserGuid!: string;
    billingInfo?: UpdateAgentBillingInfoDto;

    constructor(data?: IUpdateAgentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.group = _data["group"];
            this.commissionPercent = _data["commissionPercent"];
            this.internalOwnerUserGuid = _data["internalOwnerUserGuid"];
            this.billingInfo = _data["billingInfo"] ? UpdateAgentBillingInfoDto.fromJS(_data["billingInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateAgentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["group"] = this.group;
        data["commissionPercent"] = this.commissionPercent;
        data["internalOwnerUserGuid"] = this.internalOwnerUserGuid;
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : this.billingInfo;
        return data;
    }
}

export interface IUpdateAgentCommand {
    name: string | null;
    group: string | null;
    commissionPercent?: number;
    internalOwnerUserGuid: string;
    billingInfo?: UpdateAgentBillingInfoDto;
}

export class UpdateBoatAllowedAddonsCommand implements IUpdateBoatAllowedAddonsCommand {
    allowAllAddons!: boolean;
    allowedAddonGuids!: string[] | null;

    constructor(data?: IUpdateBoatAllowedAddonsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowAllAddons = _data["allowAllAddons"];
            if (Array.isArray(_data["allowedAddonGuids"])) {
                this.allowedAddonGuids = [] as any;
                for (let item of _data["allowedAddonGuids"])
                    this.allowedAddonGuids!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateBoatAllowedAddonsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBoatAllowedAddonsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowAllAddons"] = this.allowAllAddons;
        if (Array.isArray(this.allowedAddonGuids)) {
            data["allowedAddonGuids"] = [];
            for (let item of this.allowedAddonGuids)
                data["allowedAddonGuids"].push(item);
        }
        return data;
    }
}

export interface IUpdateBoatAllowedAddonsCommand {
    allowAllAddons: boolean;
    allowedAddonGuids: string[] | null;
}

export class UpdateBoatBasicInfoCommand implements IUpdateBoatBasicInfoCommand {
    defaultListingTitle!: string | null;
    registeredName!: string | null;
    makeAndModel!: string | null;
    description?: string | null;
    sortPriority?: number | null;
    ownerGuid?: string | null;
    ownerType?: BoatOwnerType;

    constructor(data?: IUpdateBoatBasicInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultListingTitle = _data["defaultListingTitle"];
            this.registeredName = _data["registeredName"];
            this.makeAndModel = _data["makeAndModel"];
            this.description = _data["description"];
            this.sortPriority = _data["sortPriority"];
            this.ownerGuid = _data["ownerGuid"];
            this.ownerType = _data["ownerType"];
        }
    }

    static fromJS(data: any): UpdateBoatBasicInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBoatBasicInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultListingTitle"] = this.defaultListingTitle;
        data["registeredName"] = this.registeredName;
        data["makeAndModel"] = this.makeAndModel;
        data["description"] = this.description;
        data["sortPriority"] = this.sortPriority;
        data["ownerGuid"] = this.ownerGuid;
        data["ownerType"] = this.ownerType;
        return data;
    }
}

export interface IUpdateBoatBasicInfoCommand {
    defaultListingTitle: string | null;
    registeredName: string | null;
    makeAndModel: string | null;
    description?: string | null;
    sortPriority?: number | null;
    ownerGuid?: string | null;
    ownerType?: BoatOwnerType;
}

export class UpdateBoatEventCommand implements IUpdateBoatEventCommand {
    type!: BoatEventType;
    dateFrom!: Date;
    dateTo!: Date;
    isBlockingAvailability!: boolean;
    note?: string | null;
    timeFrom?: TimeOnly;
    timeTo?: TimeOnly;

    constructor(data?: IUpdateBoatEventCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.dateFrom = _data["dateFrom"] ? parseDateOnly(_data["dateFrom"].toString()) : <any>null;
            this.dateTo = _data["dateTo"] ? parseDateOnly(_data["dateTo"].toString()) : <any>null;
            this.isBlockingAvailability = _data["isBlockingAvailability"];
            this.note = _data["note"];
            this.timeFrom = _data["timeFrom"] ? TimeOnly.fromJS(_data["timeFrom"]) : <any>null;
            this.timeTo = _data["timeTo"] ? TimeOnly.fromJS(_data["timeTo"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateBoatEventCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBoatEventCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["dateFrom"] = this.dateFrom && formatDate(this.dateFrom);
        data["dateTo"] = this.dateTo && formatDate(this.dateTo);
        data["isBlockingAvailability"] = this.isBlockingAvailability;
        data["note"] = this.note;
        data["timeFrom"] = this.timeFrom ? this.timeFrom.toJSON() : this.timeFrom;
        data["timeTo"] = this.timeTo ? this.timeTo.toJSON() : this.timeTo;
        return data;
    }
}

export interface IUpdateBoatEventCommand {
    type: BoatEventType;
    dateFrom: Date;
    dateTo: Date;
    isBlockingAvailability: boolean;
    note?: string | null;
    timeFrom?: TimeOnly;
    timeTo?: TimeOnly;
}

export class UpdateBoatIssueCommand implements IUpdateBoatIssueCommand {
    title!: string | null;
    responsible!: string | null;
    type!: BoatIssueType;
    status!: BoatIssueStatus;
    fixDate?: Date | null;
    notes?: string | null;

    constructor(data?: IUpdateBoatIssueCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.responsible = _data["responsible"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.fixDate = _data["fixDate"] ? new Date(_data["fixDate"].toString()) : <any>null;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateBoatIssueCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBoatIssueCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["responsible"] = this.responsible;
        data["type"] = this.type;
        data["status"] = this.status;
        data["fixDate"] = this.fixDate && this.fixDate.toISOString();
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateBoatIssueCommand {
    title: string | null;
    responsible: string | null;
    type: BoatIssueType;
    status: BoatIssueStatus;
    fixDate?: Date | null;
    notes?: string | null;
}

export class UpdateBoatPartCommand implements IUpdateBoatPartCommand {
    name!: string | null;
    number?: string | null;
    vendorGuid?: string | null;
    cost?: number | null;
    note?: string | null;
    type!: BoatPartType;
    manufacturer?: string | null;
    manufacturerPartNumber?: string | null;
    reorderVendorNumber?: string | null;
    reorderUnitSize?: string | null;
    reorderDate?: Date | null;

    constructor(data?: IUpdateBoatPartCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.number = _data["number"];
            this.vendorGuid = _data["vendorGuid"];
            this.cost = _data["cost"];
            this.note = _data["note"];
            this.type = _data["type"];
            this.manufacturer = _data["manufacturer"];
            this.manufacturerPartNumber = _data["manufacturerPartNumber"];
            this.reorderVendorNumber = _data["reorderVendorNumber"];
            this.reorderUnitSize = _data["reorderUnitSize"];
            this.reorderDate = _data["reorderDate"] ? new Date(_data["reorderDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UpdateBoatPartCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBoatPartCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["number"] = this.number;
        data["vendorGuid"] = this.vendorGuid;
        data["cost"] = this.cost;
        data["note"] = this.note;
        data["type"] = this.type;
        data["manufacturer"] = this.manufacturer;
        data["manufacturerPartNumber"] = this.manufacturerPartNumber;
        data["reorderVendorNumber"] = this.reorderVendorNumber;
        data["reorderUnitSize"] = this.reorderUnitSize;
        data["reorderDate"] = this.reorderDate && this.reorderDate.toISOString();
        return data;
    }
}

export interface IUpdateBoatPartCommand {
    name: string | null;
    number?: string | null;
    vendorGuid?: string | null;
    cost?: number | null;
    note?: string | null;
    type: BoatPartType;
    manufacturer?: string | null;
    manufacturerPartNumber?: string | null;
    reorderVendorNumber?: string | null;
    reorderUnitSize?: string | null;
    reorderDate?: Date | null;
}

export class UpdateBoatSpecificationCommand implements IUpdateBoatSpecificationCommand {
    specification!: BoatSpecification;

    constructor(data?: IUpdateBoatSpecificationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.specification = new BoatSpecification();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specification = _data["specification"] ? BoatSpecification.fromJS(_data["specification"]) : new BoatSpecification();
        }
    }

    static fromJS(data: any): UpdateBoatSpecificationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBoatSpecificationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specification"] = this.specification ? this.specification.toJSON() : this.specification;
        return data;
    }
}

export interface IUpdateBoatSpecificationCommand {
    specification: BoatSpecification;
}

export class UpdateBoatTuneUpCommand implements IUpdateBoatTuneUpCommand {
    type!: BoatTuneUpType;
    date!: Date;
    notes!: string | null;

    constructor(data?: IUpdateBoatTuneUpCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateBoatTuneUpCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBoatTuneUpCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["date"] = this.date && this.date.toISOString();
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateBoatTuneUpCommand {
    type: BoatTuneUpType;
    date: Date;
    notes: string | null;
}

export class UpdateBookingAddonCommand implements IUpdateBookingAddonCommand {
    name?: string | null;
    description?: string | null;
    vendorGuid?: string;
    categoryGuid?: string;
    pricingModel?: PricingModel;
    quantity?: number;
    days?: number | null;
    unitBasePrice?: number;
    taxes?: TaxItemRequest[] | null;
    commissionable?: boolean;
    commissionRatePercentage?: number;
    note?: string | null;
    selectionType?: AddonSelectionType;
    selectedOptionGuid?: string | null;
    selectedOptionName?: string | null;

    constructor(data?: IUpdateBookingAddonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.vendorGuid = _data["vendorGuid"];
            this.categoryGuid = _data["categoryGuid"];
            this.pricingModel = _data["pricingModel"];
            this.quantity = _data["quantity"];
            this.days = _data["days"];
            this.unitBasePrice = _data["unitBasePrice"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TaxItemRequest.fromJS(item));
            }
            this.commissionable = _data["commissionable"];
            this.commissionRatePercentage = _data["commissionRatePercentage"];
            this.note = _data["note"];
            this.selectionType = _data["selectionType"];
            this.selectedOptionGuid = _data["selectedOptionGuid"];
            this.selectedOptionName = _data["selectedOptionName"];
        }
    }

    static fromJS(data: any): UpdateBookingAddonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingAddonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["vendorGuid"] = this.vendorGuid;
        data["categoryGuid"] = this.categoryGuid;
        data["pricingModel"] = this.pricingModel;
        data["quantity"] = this.quantity;
        data["days"] = this.days;
        data["unitBasePrice"] = this.unitBasePrice;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        data["commissionable"] = this.commissionable;
        data["commissionRatePercentage"] = this.commissionRatePercentage;
        data["note"] = this.note;
        data["selectionType"] = this.selectionType;
        data["selectedOptionGuid"] = this.selectedOptionGuid;
        data["selectedOptionName"] = this.selectedOptionName;
        return data;
    }
}

export interface IUpdateBookingAddonCommand {
    name?: string | null;
    description?: string | null;
    vendorGuid?: string;
    categoryGuid?: string;
    pricingModel?: PricingModel;
    quantity?: number;
    days?: number | null;
    unitBasePrice?: number;
    taxes?: TaxItemRequest[] | null;
    commissionable?: boolean;
    commissionRatePercentage?: number;
    note?: string | null;
    selectionType?: AddonSelectionType;
    selectedOptionGuid?: string | null;
    selectedOptionName?: string | null;
}

export class UpdateBookingAttributionCommand implements IUpdateBookingAttributionCommand {
    channelType!: BookingChannelType;
    agentGuid?: string | null;
    brokerGuid?: string | null;
    directChannelGuid?: string | null;

    constructor(data?: IUpdateBookingAttributionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelType = _data["channelType"];
            this.agentGuid = _data["agentGuid"];
            this.brokerGuid = _data["brokerGuid"];
            this.directChannelGuid = _data["directChannelGuid"];
        }
    }

    static fromJS(data: any): UpdateBookingAttributionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingAttributionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelType"] = this.channelType;
        data["agentGuid"] = this.agentGuid;
        data["brokerGuid"] = this.brokerGuid;
        data["directChannelGuid"] = this.directChannelGuid;
        return data;
    }
}

export interface IUpdateBookingAttributionCommand {
    channelType: BookingChannelType;
    agentGuid?: string | null;
    brokerGuid?: string | null;
    directChannelGuid?: string | null;
}

export class UpdateBookingInfoCommand implements IUpdateBookingInfoCommand {
    listingGuid?: string;
    pricingGuid?: string | null;
    startDate?: Date;
    startTime?: TimeOnly;
    endDate?: Date | null;
    endTime?: TimeOnly;
    passengers?: number;
    enableOverbooking?: boolean;

    constructor(data?: IUpdateBookingInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listingGuid = _data["listingGuid"];
            this.pricingGuid = _data["pricingGuid"];
            this.startDate = _data["startDate"] ? parseDateOnly(_data["startDate"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? TimeOnly.fromJS(_data["startTime"]) : <any>null;
            this.endDate = _data["endDate"] ? parseDateOnly(_data["endDate"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? TimeOnly.fromJS(_data["endTime"]) : <any>null;
            this.passengers = _data["passengers"];
            this.enableOverbooking = _data["enableOverbooking"];
        }
    }

    static fromJS(data: any): UpdateBookingInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listingGuid"] = this.listingGuid;
        data["pricingGuid"] = this.pricingGuid;
        data["startDate"] = this.startDate && formatDate(this.startDate);
        data["startTime"] = this.startTime ? this.startTime.toJSON() : this.startTime;
        data["endDate"] = this.endDate && formatDate(this.endDate);
        data["endTime"] = this.endTime ? this.endTime.toJSON() : this.endTime;
        data["passengers"] = this.passengers;
        data["enableOverbooking"] = this.enableOverbooking;
        return data;
    }
}

export interface IUpdateBookingInfoCommand {
    listingGuid?: string;
    pricingGuid?: string | null;
    startDate?: Date;
    startTime?: TimeOnly;
    endDate?: Date | null;
    endTime?: TimeOnly;
    passengers?: number;
    enableOverbooking?: boolean;
}

export class UpdateBookingInternalNoteCommand implements IUpdateBookingInternalNoteCommand {
    guid?: string;
    note?: string | null;

    constructor(data?: IUpdateBookingInternalNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateBookingInternalNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingInternalNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["note"] = this.note;
        return data;
    }
}

export interface IUpdateBookingInternalNoteCommand {
    guid?: string;
    note?: string | null;
}

export class UpdateBookingLocationCommand implements IUpdateBookingLocationCommand {
    pickupLocationGuid?: string;
    dropOffLocationGuid?: string;

    constructor(data?: IUpdateBookingLocationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickupLocationGuid = _data["pickupLocationGuid"];
            this.dropOffLocationGuid = _data["dropOffLocationGuid"];
        }
    }

    static fromJS(data: any): UpdateBookingLocationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingLocationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickupLocationGuid"] = this.pickupLocationGuid;
        data["dropOffLocationGuid"] = this.dropOffLocationGuid;
        return data;
    }
}

export interface IUpdateBookingLocationCommand {
    pickupLocationGuid?: string;
    dropOffLocationGuid?: string;
}

export class UpdateBookingNotesCommand implements IUpdateBookingNotesCommand {
    notes?: BookingNotes;

    constructor(data?: IUpdateBookingNotesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notes = _data["notes"] ? BookingNotes.fromJS(_data["notes"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateBookingNotesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingNotesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notes"] = this.notes ? this.notes.toJSON() : this.notes;
        return data;
    }
}

export interface IUpdateBookingNotesCommand {
    notes?: BookingNotes;
}

export class UpdateBookingPriceCommand implements IUpdateBookingPriceCommand {
    basePrice!: number;
    basePriceDiscount!: number;
    discountTypeGuid?: string | null;
    rentalTaxes?: TaxItemRequest[] | null;
    additionalFees!: AdditionalBookingFeeItemDto[] | null;
    commissionPercentage?: number | null;

    constructor(data?: IUpdateBookingPriceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.basePrice = _data["basePrice"];
            this.basePriceDiscount = _data["basePriceDiscount"];
            this.discountTypeGuid = _data["discountTypeGuid"];
            if (Array.isArray(_data["rentalTaxes"])) {
                this.rentalTaxes = [] as any;
                for (let item of _data["rentalTaxes"])
                    this.rentalTaxes!.push(TaxItemRequest.fromJS(item));
            }
            if (Array.isArray(_data["additionalFees"])) {
                this.additionalFees = [] as any;
                for (let item of _data["additionalFees"])
                    this.additionalFees!.push(AdditionalBookingFeeItemDto.fromJS(item));
            }
            this.commissionPercentage = _data["commissionPercentage"];
        }
    }

    static fromJS(data: any): UpdateBookingPriceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingPriceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basePrice"] = this.basePrice;
        data["basePriceDiscount"] = this.basePriceDiscount;
        data["discountTypeGuid"] = this.discountTypeGuid;
        if (Array.isArray(this.rentalTaxes)) {
            data["rentalTaxes"] = [];
            for (let item of this.rentalTaxes)
                data["rentalTaxes"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalFees)) {
            data["additionalFees"] = [];
            for (let item of this.additionalFees)
                data["additionalFees"].push(item.toJSON());
        }
        data["commissionPercentage"] = this.commissionPercentage;
        return data;
    }
}

export interface IUpdateBookingPriceCommand {
    basePrice: number;
    basePriceDiscount: number;
    discountTypeGuid?: string | null;
    rentalTaxes?: TaxItemRequest[] | null;
    additionalFees: AdditionalBookingFeeItemDto[] | null;
    commissionPercentage?: number | null;
}

export class UpdateBookingStaffCommand implements IUpdateBookingStaffCommand {
    skipperGuid?: string | null;
    checkinPersonGuid?: string | null;
    salesPersonGuid?: string | null;
    stewardessesGuid?: string[] | null;

    constructor(data?: IUpdateBookingStaffCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skipperGuid = _data["skipperGuid"];
            this.checkinPersonGuid = _data["checkinPersonGuid"];
            this.salesPersonGuid = _data["salesPersonGuid"];
            if (Array.isArray(_data["stewardessesGuid"])) {
                this.stewardessesGuid = [] as any;
                for (let item of _data["stewardessesGuid"])
                    this.stewardessesGuid!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateBookingStaffCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingStaffCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skipperGuid"] = this.skipperGuid;
        data["checkinPersonGuid"] = this.checkinPersonGuid;
        data["salesPersonGuid"] = this.salesPersonGuid;
        if (Array.isArray(this.stewardessesGuid)) {
            data["stewardessesGuid"] = [];
            for (let item of this.stewardessesGuid)
                data["stewardessesGuid"].push(item);
        }
        return data;
    }
}

export interface IUpdateBookingStaffCommand {
    skipperGuid?: string | null;
    checkinPersonGuid?: string | null;
    salesPersonGuid?: string | null;
    stewardessesGuid?: string[] | null;
}

export class UpdateBookingSummarySettingsCommand implements IUpdateBookingSummarySettingsCommand {
    hideLocationSection?: boolean;
    fuelNotice?: string | null;
    phoneVisible?: boolean;
    phoneRequired?: boolean;
    addressVisible?: boolean;
    addressRequired?: boolean;
    companyVisible?: boolean;
    companyRequired?: boolean;
    taxIdVisible?: boolean;
    taxIdRequired?: boolean;
    billingInfoVisible?: boolean;
    billingInfoRequired?: boolean;
    idPassportNumberVisible?: boolean;
    idPassportNumberRequired?: boolean;

    constructor(data?: IUpdateBookingSummarySettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hideLocationSection = _data["hideLocationSection"];
            this.fuelNotice = _data["fuelNotice"];
            this.phoneVisible = _data["phoneVisible"];
            this.phoneRequired = _data["phoneRequired"];
            this.addressVisible = _data["addressVisible"];
            this.addressRequired = _data["addressRequired"];
            this.companyVisible = _data["companyVisible"];
            this.companyRequired = _data["companyRequired"];
            this.taxIdVisible = _data["taxIdVisible"];
            this.taxIdRequired = _data["taxIdRequired"];
            this.billingInfoVisible = _data["billingInfoVisible"];
            this.billingInfoRequired = _data["billingInfoRequired"];
            this.idPassportNumberVisible = _data["idPassportNumberVisible"];
            this.idPassportNumberRequired = _data["idPassportNumberRequired"];
        }
    }

    static fromJS(data: any): UpdateBookingSummarySettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBookingSummarySettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hideLocationSection"] = this.hideLocationSection;
        data["fuelNotice"] = this.fuelNotice;
        data["phoneVisible"] = this.phoneVisible;
        data["phoneRequired"] = this.phoneRequired;
        data["addressVisible"] = this.addressVisible;
        data["addressRequired"] = this.addressRequired;
        data["companyVisible"] = this.companyVisible;
        data["companyRequired"] = this.companyRequired;
        data["taxIdVisible"] = this.taxIdVisible;
        data["taxIdRequired"] = this.taxIdRequired;
        data["billingInfoVisible"] = this.billingInfoVisible;
        data["billingInfoRequired"] = this.billingInfoRequired;
        data["idPassportNumberVisible"] = this.idPassportNumberVisible;
        data["idPassportNumberRequired"] = this.idPassportNumberRequired;
        return data;
    }
}

export interface IUpdateBookingSummarySettingsCommand {
    hideLocationSection?: boolean;
    fuelNotice?: string | null;
    phoneVisible?: boolean;
    phoneRequired?: boolean;
    addressVisible?: boolean;
    addressRequired?: boolean;
    companyVisible?: boolean;
    companyRequired?: boolean;
    taxIdVisible?: boolean;
    taxIdRequired?: boolean;
    billingInfoVisible?: boolean;
    billingInfoRequired?: boolean;
    idPassportNumberVisible?: boolean;
    idPassportNumberRequired?: boolean;
}

export class UpdateBrokerCommand implements IUpdateBrokerCommand {
    firstName!: string | null;
    lastName!: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;

    constructor(data?: IUpdateBrokerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): UpdateBrokerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBrokerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IUpdateBrokerCommand {
    firstName: string | null;
    lastName: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
}

export class UpdateCampaignCommand implements IUpdateCampaignCommand {
    name!: string | null;
    commissionAmount!: number;
    newCustomerDiscountAmount!: number;
    expiresAtUtc?: Date | null;
    isActive?: boolean;
    campaignLandingUrlGuid?: string;

    constructor(data?: IUpdateCampaignCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.commissionAmount = _data["commissionAmount"];
            this.newCustomerDiscountAmount = _data["newCustomerDiscountAmount"];
            this.expiresAtUtc = _data["expiresAtUtc"] ? new Date(_data["expiresAtUtc"].toString()) : <any>null;
            this.isActive = _data["isActive"];
            this.campaignLandingUrlGuid = _data["campaignLandingUrlGuid"];
        }
    }

    static fromJS(data: any): UpdateCampaignCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCampaignCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["commissionAmount"] = this.commissionAmount;
        data["newCustomerDiscountAmount"] = this.newCustomerDiscountAmount;
        data["expiresAtUtc"] = this.expiresAtUtc && this.expiresAtUtc.toISOString();
        data["isActive"] = this.isActive;
        data["campaignLandingUrlGuid"] = this.campaignLandingUrlGuid;
        return data;
    }
}

export interface IUpdateCampaignCommand {
    name: string | null;
    commissionAmount: number;
    newCustomerDiscountAmount: number;
    expiresAtUtc?: Date | null;
    isActive?: boolean;
    campaignLandingUrlGuid?: string;
}

export class UpdateCampaignUrlCommand implements IUpdateCampaignUrlCommand {
    url!: string | null;
    description!: string | null;

    constructor(data?: IUpdateCampaignUrlCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateCampaignUrlCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCampaignUrlCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateCampaignUrlCommand {
    url: string | null;
    description: string | null;
}

export class UpdateChannelCommand implements IUpdateChannelCommand {
    name!: string | null;
    type?: ChannelType;
    isActive?: boolean;
    email!: string | null;
    phoneNumber!: string | null;
    notes!: string | null;

    constructor(data?: IUpdateChannelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.isActive = _data["isActive"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateChannelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChannelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["isActive"] = this.isActive;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateChannelCommand {
    name: string | null;
    type?: ChannelType;
    isActive?: boolean;
    email: string | null;
    phoneNumber: string | null;
    notes: string | null;
}

export class UpdateContractProviderConfigurationCommand implements IUpdateContractProviderConfigurationCommand {
    providerType?: ContractProviderType;
    urlTemplate?: string | null;

    constructor(data?: IUpdateContractProviderConfigurationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerType = _data["providerType"];
            this.urlTemplate = _data["urlTemplate"];
        }
    }

    static fromJS(data: any): UpdateContractProviderConfigurationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContractProviderConfigurationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerType"] = this.providerType;
        data["urlTemplate"] = this.urlTemplate;
        return data;
    }
}

export interface IUpdateContractProviderConfigurationCommand {
    providerType?: ContractProviderType;
    urlTemplate?: string | null;
}

export class UpdateConversionTrackingDomainConfigCommand implements IUpdateConversionTrackingDomainConfigCommand {
    ga4MeasurementId?: string | null;
    ga4ApiSecret?: string | null;
    googleAdsCustomerId?: string | null;
    googleAdsConversionActionId?: string | null;
    metaPixelId?: string | null;
    metaAccessToken?: string | null;

    constructor(data?: IUpdateConversionTrackingDomainConfigCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ga4MeasurementId = _data["ga4MeasurementId"];
            this.ga4ApiSecret = _data["ga4ApiSecret"];
            this.googleAdsCustomerId = _data["googleAdsCustomerId"];
            this.googleAdsConversionActionId = _data["googleAdsConversionActionId"];
            this.metaPixelId = _data["metaPixelId"];
            this.metaAccessToken = _data["metaAccessToken"];
        }
    }

    static fromJS(data: any): UpdateConversionTrackingDomainConfigCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConversionTrackingDomainConfigCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ga4MeasurementId"] = this.ga4MeasurementId;
        data["ga4ApiSecret"] = this.ga4ApiSecret;
        data["googleAdsCustomerId"] = this.googleAdsCustomerId;
        data["googleAdsConversionActionId"] = this.googleAdsConversionActionId;
        data["metaPixelId"] = this.metaPixelId;
        data["metaAccessToken"] = this.metaAccessToken;
        return data;
    }
}

export interface IUpdateConversionTrackingDomainConfigCommand {
    ga4MeasurementId?: string | null;
    ga4ApiSecret?: string | null;
    googleAdsCustomerId?: string | null;
    googleAdsConversionActionId?: string | null;
    metaPixelId?: string | null;
    metaAccessToken?: string | null;
}

export class UpdateCustomerAddressCommand implements IUpdateCustomerAddressCommand {
    address!: CustomerAddress;

    constructor(data?: IUpdateCustomerAddressCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new CustomerAddress();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? CustomerAddress.fromJS(_data["address"]) : new CustomerAddress();
        }
    }

    static fromJS(data: any): UpdateCustomerAddressCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerAddressCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : this.address;
        return data;
    }
}

export interface IUpdateCustomerAddressCommand {
    address: CustomerAddress;
}

export class UpdateCustomerAgentBrokerCommand implements IUpdateCustomerAgentBrokerCommand {
    agentGuid?: string | null;
    brokerGuid?: string | null;

    constructor(data?: IUpdateCustomerAgentBrokerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentGuid = _data["agentGuid"];
            this.brokerGuid = _data["brokerGuid"];
        }
    }

    static fromJS(data: any): UpdateCustomerAgentBrokerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerAgentBrokerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentGuid"] = this.agentGuid;
        data["brokerGuid"] = this.brokerGuid;
        return data;
    }
}

export interface IUpdateCustomerAgentBrokerCommand {
    agentGuid?: string | null;
    brokerGuid?: string | null;
}

export class UpdateCustomerBasicInfoCommand implements IUpdateCustomerBasicInfoCommand {
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
    customerClass?: CustomerClass;
    concierge?: CustomerConcierge;
    idPassportNumber?: string | null;

    constructor(data?: IUpdateCustomerBasicInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.customerClass = _data["customerClass"];
            this.concierge = _data["concierge"] ? CustomerConcierge.fromJS(_data["concierge"]) : <any>null;
            this.idPassportNumber = _data["idPassportNumber"];
        }
    }

    static fromJS(data: any): UpdateCustomerBasicInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerBasicInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["customerClass"] = this.customerClass;
        data["concierge"] = this.concierge ? this.concierge.toJSON() : this.concierge;
        data["idPassportNumber"] = this.idPassportNumber;
        return data;
    }
}

export interface IUpdateCustomerBasicInfoCommand {
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
    customerClass?: CustomerClass;
    concierge?: CustomerConcierge;
    idPassportNumber?: string | null;
}

export class UpdateCustomerBillingInfoCommand implements IUpdateCustomerBillingInfoCommand {
    billingInfo!: CustomerBillingInfo;

    constructor(data?: IUpdateCustomerBillingInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.billingInfo = new CustomerBillingInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingInfo = _data["billingInfo"] ? CustomerBillingInfo.fromJS(_data["billingInfo"]) : new CustomerBillingInfo();
        }
    }

    static fromJS(data: any): UpdateCustomerBillingInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerBillingInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : this.billingInfo;
        return data;
    }
}

export interface IUpdateCustomerBillingInfoCommand {
    billingInfo: CustomerBillingInfo;
}

export class UpdateCustomerNoteCommand implements IUpdateCustomerNoteCommand {
    guid?: string;
    note?: string | null;

    constructor(data?: IUpdateCustomerNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateCustomerNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["note"] = this.note;
        return data;
    }
}

export interface IUpdateCustomerNoteCommand {
    guid?: string;
    note?: string | null;
}

export class UpdateCustomerPreferencesCommand implements IUpdateCustomerPreferencesCommand {
    preferences!: CustomerPreferences;

    constructor(data?: IUpdateCustomerPreferencesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.preferences = new CustomerPreferences();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferences = _data["preferences"] ? CustomerPreferences.fromJS(_data["preferences"]) : new CustomerPreferences();
        }
    }

    static fromJS(data: any): UpdateCustomerPreferencesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerPreferencesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferences"] = this.preferences ? this.preferences.toJSON() : this.preferences;
        return data;
    }
}

export interface IUpdateCustomerPreferencesCommand {
    preferences: CustomerPreferences;
}

export class UpdateDirectChannelCommand implements IUpdateDirectChannelCommand {
    name!: string | null;

    constructor(data?: IUpdateDirectChannelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateDirectChannelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDirectChannelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateDirectChannelCommand {
    name: string | null;
}

export class UpdateDiscountTypeCommand implements IUpdateDiscountTypeCommand {
    name?: string | null;

    constructor(data?: IUpdateDiscountTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateDiscountTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDiscountTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateDiscountTypeCommand {
    name?: string | null;
}

export class UpdateEmailTemplateCommand implements IUpdateEmailTemplateCommand {
    subject!: string | null;
    preHeader?: string | null;
    additionalHeaderInfo?: string | null;
    sections?: { [key: string]: string; } | null;
    emailCCs?: string[] | null;

    constructor(data?: IUpdateEmailTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.preHeader = _data["preHeader"];
            this.additionalHeaderInfo = _data["additionalHeaderInfo"];
            if (_data["sections"]) {
                this.sections = {} as any;
                for (let key in _data["sections"]) {
                    if (_data["sections"].hasOwnProperty(key))
                        (<any>this.sections)![key] = _data["sections"][key];
                }
            }
            if (Array.isArray(_data["emailCCs"])) {
                this.emailCCs = [] as any;
                for (let item of _data["emailCCs"])
                    this.emailCCs!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateEmailTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["preHeader"] = this.preHeader;
        data["additionalHeaderInfo"] = this.additionalHeaderInfo;
        if (this.sections) {
            data["sections"] = {};
            for (let key in this.sections) {
                if (this.sections.hasOwnProperty(key))
                    (<any>data["sections"])[key] = (<any>this.sections)[key];
            }
        }
        if (Array.isArray(this.emailCCs)) {
            data["emailCCs"] = [];
            for (let item of this.emailCCs)
                data["emailCCs"].push(item);
        }
        return data;
    }
}

export interface IUpdateEmailTemplateCommand {
    subject: string | null;
    preHeader?: string | null;
    additionalHeaderInfo?: string | null;
    sections?: { [key: string]: string; } | null;
    emailCCs?: string[] | null;
}

export class UpdateExternalPaymentMethodCommand implements IUpdateExternalPaymentMethodCommand {
    name?: string | null;
    isActive?: boolean | null;

    constructor(data?: IUpdateExternalPaymentMethodCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateExternalPaymentMethodCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExternalPaymentMethodCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateExternalPaymentMethodCommand {
    name?: string | null;
    isActive?: boolean | null;
}

export class UpdateExternalPaymentMethodDisplayOrderCommand implements IUpdateExternalPaymentMethodDisplayOrderCommand {
    displayOrder?: number;

    constructor(data?: IUpdateExternalPaymentMethodDisplayOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): UpdateExternalPaymentMethodDisplayOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExternalPaymentMethodDisplayOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IUpdateExternalPaymentMethodDisplayOrderCommand {
    displayOrder?: number;
}

export class UpdateListingBookingTypeCommand implements IUpdateListingBookingTypeCommand {
    bookingType?: BookingType;

    constructor(data?: IUpdateListingBookingTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingType = _data["bookingType"];
        }
    }

    static fromJS(data: any): UpdateListingBookingTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateListingBookingTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingType"] = this.bookingType;
        return data;
    }
}

export interface IUpdateListingBookingTypeCommand {
    bookingType?: BookingType;
}

export class UpdateListingCommand implements IUpdateListingCommand {
    boatGuid!: string;
    defaultPickUpLocationGuid!: string;
    defaultDropOffLocationGuid!: string;
    slipNumber?: string | null;
    notes?: string | null;
    ownerTakeRate!: ListingOwnerTakeRate;
    marketSpecificTitle?: string | null;
    skipperGuid?: string | null;
    stewardessGuid?: string | null;
    checkinPersonGuid?: string | null;
    boatIdentifier?: string | null;

    constructor(data?: IUpdateListingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ownerTakeRate = new ListingOwnerTakeRate();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boatGuid = _data["boatGuid"];
            this.defaultPickUpLocationGuid = _data["defaultPickUpLocationGuid"];
            this.defaultDropOffLocationGuid = _data["defaultDropOffLocationGuid"];
            this.slipNumber = _data["slipNumber"];
            this.notes = _data["notes"];
            this.ownerTakeRate = _data["ownerTakeRate"] ? ListingOwnerTakeRate.fromJS(_data["ownerTakeRate"]) : new ListingOwnerTakeRate();
            this.marketSpecificTitle = _data["marketSpecificTitle"];
            this.skipperGuid = _data["skipperGuid"];
            this.stewardessGuid = _data["stewardessGuid"];
            this.checkinPersonGuid = _data["checkinPersonGuid"];
            this.boatIdentifier = _data["boatIdentifier"];
        }
    }

    static fromJS(data: any): UpdateListingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateListingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boatGuid"] = this.boatGuid;
        data["defaultPickUpLocationGuid"] = this.defaultPickUpLocationGuid;
        data["defaultDropOffLocationGuid"] = this.defaultDropOffLocationGuid;
        data["slipNumber"] = this.slipNumber;
        data["notes"] = this.notes;
        data["ownerTakeRate"] = this.ownerTakeRate ? this.ownerTakeRate.toJSON() : this.ownerTakeRate;
        data["marketSpecificTitle"] = this.marketSpecificTitle;
        data["skipperGuid"] = this.skipperGuid;
        data["stewardessGuid"] = this.stewardessGuid;
        data["checkinPersonGuid"] = this.checkinPersonGuid;
        data["boatIdentifier"] = this.boatIdentifier;
        return data;
    }
}

export interface IUpdateListingCommand {
    boatGuid: string;
    defaultPickUpLocationGuid: string;
    defaultDropOffLocationGuid: string;
    slipNumber?: string | null;
    notes?: string | null;
    ownerTakeRate: ListingOwnerTakeRate;
    marketSpecificTitle?: string | null;
    skipperGuid?: string | null;
    stewardessGuid?: string | null;
    checkinPersonGuid?: string | null;
    boatIdentifier?: string | null;
}

export class UpdateListingOwnerTakeRateCommand implements IUpdateListingOwnerTakeRateCommand {
    boatOwnerTakeRate!: ListingOwnerTakeRate;

    constructor(data?: IUpdateListingOwnerTakeRateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.boatOwnerTakeRate = new ListingOwnerTakeRate();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boatOwnerTakeRate = _data["boatOwnerTakeRate"] ? ListingOwnerTakeRate.fromJS(_data["boatOwnerTakeRate"]) : new ListingOwnerTakeRate();
        }
    }

    static fromJS(data: any): UpdateListingOwnerTakeRateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateListingOwnerTakeRateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boatOwnerTakeRate"] = this.boatOwnerTakeRate ? this.boatOwnerTakeRate.toJSON() : this.boatOwnerTakeRate;
        return data;
    }
}

export interface IUpdateListingOwnerTakeRateCommand {
    boatOwnerTakeRate: ListingOwnerTakeRate;
}

export class UpdateListingPublishStatusCommand implements IUpdateListingPublishStatusCommand {
    publishStatus?: PublishStatus;

    constructor(data?: IUpdateListingPublishStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publishStatus = _data["publishStatus"];
        }
    }

    static fromJS(data: any): UpdateListingPublishStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateListingPublishStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishStatus"] = this.publishStatus;
        return data;
    }
}

export interface IUpdateListingPublishStatusCommand {
    publishStatus?: PublishStatus;
}

export class UpdateLocationActivationCommand implements IUpdateLocationActivationCommand {
    isActive!: boolean;

    constructor(data?: IUpdateLocationActivationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateLocationActivationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLocationActivationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateLocationActivationCommand {
    isActive: boolean;
}

export class UpdateLocationAddressCommand implements IUpdateLocationAddressCommand {
    address?: LocationAddress;

    constructor(data?: IUpdateLocationAddressCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? LocationAddress.fromJS(_data["address"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateLocationAddressCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLocationAddressCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : this.address;
        return data;
    }
}

export interface IUpdateLocationAddressCommand {
    address?: LocationAddress;
}

export class UpdateLocationBasicInfoCommand implements IUpdateLocationBasicInfoCommand {
    title?: string | null;
    dock?: string | null;
    pickupInstructions?: string | null;
    parkingNotes?: string | null;
    marina?: string | null;
    marketGuid?: string;

    constructor(data?: IUpdateLocationBasicInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.dock = _data["dock"];
            this.pickupInstructions = _data["pickupInstructions"];
            this.parkingNotes = _data["parkingNotes"];
            this.marina = _data["marina"];
            this.marketGuid = _data["marketGuid"];
        }
    }

    static fromJS(data: any): UpdateLocationBasicInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLocationBasicInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dock"] = this.dock;
        data["pickupInstructions"] = this.pickupInstructions;
        data["parkingNotes"] = this.parkingNotes;
        data["marina"] = this.marina;
        data["marketGuid"] = this.marketGuid;
        return data;
    }
}

export interface IUpdateLocationBasicInfoCommand {
    title?: string | null;
    dock?: string | null;
    pickupInstructions?: string | null;
    parkingNotes?: string | null;
    marina?: string | null;
    marketGuid?: string;
}

export class UpdateMakeBasicInfoCommand implements IUpdateMakeBasicInfoCommand {
    name!: string | null;

    constructor(data?: IUpdateMakeBasicInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateMakeBasicInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMakeBasicInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateMakeBasicInfoCommand {
    name: string | null;
}

export class UpdateMarketBasicInfoCommand implements IUpdateMarketBasicInfoCommand {
    title!: string | null;
    code!: string | null;
    color!: string | null;

    constructor(data?: IUpdateMarketBasicInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.code = _data["code"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): UpdateMarketBasicInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMarketBasicInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["color"] = this.color;
        return data;
    }
}

export interface IUpdateMarketBasicInfoCommand {
    title: string | null;
    code: string | null;
    color: string | null;
}

export class UpdatePackageCommand implements IUpdatePackageCommand {
    name!: string | null;
    startTimes!: TimeOnly[] | null;
    duration!: TimeSpan;
    availableDaysOfWeek!: DayOfWeek[] | null;
    isSunsetPackage!: boolean;

    constructor(data?: IUpdatePackageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.duration = new TimeSpan();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["startTimes"])) {
                this.startTimes = [] as any;
                for (let item of _data["startTimes"])
                    this.startTimes!.push(TimeOnly.fromJS(item));
            }
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : new TimeSpan();
            if (Array.isArray(_data["availableDaysOfWeek"])) {
                this.availableDaysOfWeek = [] as any;
                for (let item of _data["availableDaysOfWeek"])
                    this.availableDaysOfWeek!.push(item);
            }
            this.isSunsetPackage = _data["isSunsetPackage"];
        }
    }

    static fromJS(data: any): UpdatePackageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePackageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.startTimes)) {
            data["startTimes"] = [];
            for (let item of this.startTimes)
                data["startTimes"].push(item.toJSON());
        }
        data["duration"] = this.duration ? this.duration.toJSON() : this.duration;
        if (Array.isArray(this.availableDaysOfWeek)) {
            data["availableDaysOfWeek"] = [];
            for (let item of this.availableDaysOfWeek)
                data["availableDaysOfWeek"].push(item);
        }
        data["isSunsetPackage"] = this.isSunsetPackage;
        return data;
    }
}

export interface IUpdatePackageCommand {
    name: string | null;
    startTimes: TimeOnly[] | null;
    duration: TimeSpan;
    availableDaysOfWeek: DayOfWeek[] | null;
    isSunsetPackage: boolean;
}

export class UpdatePlatformAccountAircallSettingsCommand implements IUpdatePlatformAccountAircallSettingsCommand {
    aircallSettings!: AircallSettingsDTO;

    constructor(data?: IUpdatePlatformAccountAircallSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.aircallSettings = new AircallSettingsDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aircallSettings = _data["aircallSettings"] ? AircallSettingsDTO.fromJS(_data["aircallSettings"]) : new AircallSettingsDTO();
        }
    }

    static fromJS(data: any): UpdatePlatformAccountAircallSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlatformAccountAircallSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aircallSettings"] = this.aircallSettings ? this.aircallSettings.toJSON() : this.aircallSettings;
        return data;
    }
}

export interface IUpdatePlatformAccountAircallSettingsCommand {
    aircallSettings: AircallSettingsDTO;
}

export class UpdatePlatformAccountBasicInfoCommand implements IUpdatePlatformAccountBasicInfoCommand {
    name!: string | null;
    email!: string | null;
    phone?: string | null;
    onlineCustomerFeePercentage?: number | null;
    propellerTakeRatePercentage?: number | null;
    operatorProcessingFeeSharePercentage?: number | null;
    paymentGateway?: PaymentGateway;
    logoUrl?: string | null;
    formLeadSenderEmail?: string | null;
    formLeadSenderDisplayName?: string | null;
    twilioPhoneNumber?: string | null;

    constructor(data?: IUpdatePlatformAccountBasicInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.onlineCustomerFeePercentage = _data["onlineCustomerFeePercentage"];
            this.propellerTakeRatePercentage = _data["propellerTakeRatePercentage"];
            this.operatorProcessingFeeSharePercentage = _data["operatorProcessingFeeSharePercentage"];
            this.paymentGateway = _data["paymentGateway"];
            this.logoUrl = _data["logoUrl"];
            this.formLeadSenderEmail = _data["formLeadSenderEmail"];
            this.formLeadSenderDisplayName = _data["formLeadSenderDisplayName"];
            this.twilioPhoneNumber = _data["twilioPhoneNumber"];
        }
    }

    static fromJS(data: any): UpdatePlatformAccountBasicInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlatformAccountBasicInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["onlineCustomerFeePercentage"] = this.onlineCustomerFeePercentage;
        data["propellerTakeRatePercentage"] = this.propellerTakeRatePercentage;
        data["operatorProcessingFeeSharePercentage"] = this.operatorProcessingFeeSharePercentage;
        data["paymentGateway"] = this.paymentGateway;
        data["logoUrl"] = this.logoUrl;
        data["formLeadSenderEmail"] = this.formLeadSenderEmail;
        data["formLeadSenderDisplayName"] = this.formLeadSenderDisplayName;
        data["twilioPhoneNumber"] = this.twilioPhoneNumber;
        return data;
    }
}

export interface IUpdatePlatformAccountBasicInfoCommand {
    name: string | null;
    email: string | null;
    phone?: string | null;
    onlineCustomerFeePercentage?: number | null;
    propellerTakeRatePercentage?: number | null;
    operatorProcessingFeeSharePercentage?: number | null;
    paymentGateway?: PaymentGateway;
    logoUrl?: string | null;
    formLeadSenderEmail?: string | null;
    formLeadSenderDisplayName?: string | null;
    twilioPhoneNumber?: string | null;
}

export class UpdatePlatformAccountBillingInfoCommand implements IUpdatePlatformAccountBillingInfoCommand {
    billingInfo!: PlatformAccountBillingInfo;

    constructor(data?: IUpdatePlatformAccountBillingInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.billingInfo = new PlatformAccountBillingInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingInfo = _data["billingInfo"] ? PlatformAccountBillingInfo.fromJS(_data["billingInfo"]) : new PlatformAccountBillingInfo();
        }
    }

    static fromJS(data: any): UpdatePlatformAccountBillingInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlatformAccountBillingInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : this.billingInfo;
        return data;
    }
}

export interface IUpdatePlatformAccountBillingInfoCommand {
    billingInfo: PlatformAccountBillingInfo;
}

export class UpdatePlatformAccountBookingWebhookSettingsCommand implements IUpdatePlatformAccountBookingWebhookSettingsCommand {
    url?: string | null;
    apiToken?: string | null;

    constructor(data?: IUpdatePlatformAccountBookingWebhookSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.apiToken = _data["apiToken"];
        }
    }

    static fromJS(data: any): UpdatePlatformAccountBookingWebhookSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlatformAccountBookingWebhookSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["apiToken"] = this.apiToken;
        return data;
    }
}

export interface IUpdatePlatformAccountBookingWebhookSettingsCommand {
    url?: string | null;
    apiToken?: string | null;
}

export class UpdatePlatformAccountCultureCommand implements IUpdatePlatformAccountCultureCommand {
    culture!: string | null;
    timeZoneInfoId!: string | null;

    constructor(data?: IUpdatePlatformAccountCultureCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.culture = _data["culture"];
            this.timeZoneInfoId = _data["timeZoneInfoId"];
        }
    }

    static fromJS(data: any): UpdatePlatformAccountCultureCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlatformAccountCultureCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["culture"] = this.culture;
        data["timeZoneInfoId"] = this.timeZoneInfoId;
        return data;
    }
}

export interface IUpdatePlatformAccountCultureCommand {
    culture: string | null;
    timeZoneInfoId: string | null;
}

export class UpdatePlatformAccountLogoCommand implements IUpdatePlatformAccountLogoCommand {
    logoUrl?: string | null;
    logoStyle?: string | null;

    constructor(data?: IUpdatePlatformAccountLogoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoUrl = _data["logoUrl"];
            this.logoStyle = _data["logoStyle"];
        }
    }

    static fromJS(data: any): UpdatePlatformAccountLogoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlatformAccountLogoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoUrl"] = this.logoUrl;
        data["logoStyle"] = this.logoStyle;
        return data;
    }
}

export interface IUpdatePlatformAccountLogoCommand {
    logoUrl?: string | null;
    logoStyle?: string | null;
}

export class UpdatePlatformAccountMeasurementSystemCommand implements IUpdatePlatformAccountMeasurementSystemCommand {
    measurementSystem!: MeasurementSystem;

    constructor(data?: IUpdatePlatformAccountMeasurementSystemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementSystem = _data["measurementSystem"];
        }
    }

    static fromJS(data: any): UpdatePlatformAccountMeasurementSystemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlatformAccountMeasurementSystemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementSystem"] = this.measurementSystem;
        return data;
    }
}

export interface IUpdatePlatformAccountMeasurementSystemCommand {
    measurementSystem: MeasurementSystem;
}

export class UpdatePlatformAccountPrePaymentSettingsCommand implements IUpdatePlatformAccountPrePaymentSettingsCommand {
    defaultPercentage!: number;
    conditionType!: PrePaymentConditionType;
    thresholdDays?: number | null;

    constructor(data?: IUpdatePlatformAccountPrePaymentSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultPercentage = _data["defaultPercentage"];
            this.conditionType = _data["conditionType"];
            this.thresholdDays = _data["thresholdDays"];
        }
    }

    static fromJS(data: any): UpdatePlatformAccountPrePaymentSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlatformAccountPrePaymentSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultPercentage"] = this.defaultPercentage;
        data["conditionType"] = this.conditionType;
        data["thresholdDays"] = this.thresholdDays;
        return data;
    }
}

export interface IUpdatePlatformAccountPrePaymentSettingsCommand {
    defaultPercentage: number;
    conditionType: PrePaymentConditionType;
    thresholdDays?: number | null;
}

export class UpdatePlatformAccountRegionalSettingsCommand implements IUpdatePlatformAccountRegionalSettingsCommand {
    currencyRegionCode!: string | null;
    culture!: string | null;

    constructor(data?: IUpdatePlatformAccountRegionalSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyRegionCode = _data["currencyRegionCode"];
            this.culture = _data["culture"];
        }
    }

    static fromJS(data: any): UpdatePlatformAccountRegionalSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlatformAccountRegionalSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyRegionCode"] = this.currencyRegionCode;
        data["culture"] = this.culture;
        return data;
    }
}

export interface IUpdatePlatformAccountRegionalSettingsCommand {
    currencyRegionCode: string | null;
    culture: string | null;
}

export class UpdatePlatformAccountSalesLeadSettingsCommand implements IUpdatePlatformAccountSalesLeadSettingsCommand {
    termsUrl?: string | null;
    messagingEnabled!: boolean;

    constructor(data?: IUpdatePlatformAccountSalesLeadSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termsUrl = _data["termsUrl"];
            this.messagingEnabled = _data["messagingEnabled"];
        }
    }

    static fromJS(data: any): UpdatePlatformAccountSalesLeadSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlatformAccountSalesLeadSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termsUrl"] = this.termsUrl;
        data["messagingEnabled"] = this.messagingEnabled;
        return data;
    }
}

export interface IUpdatePlatformAccountSalesLeadSettingsCommand {
    termsUrl?: string | null;
    messagingEnabled: boolean;
}

export class UpdatePlatformAccountTaxConfigurationCommand implements IUpdatePlatformAccountTaxConfigurationCommand {
    taxType!: TaxType;
    defaultTaxes?: TaxLine[] | null;
    onlineCustomerFeeTaxes?: TaxLine[] | null;

    constructor(data?: IUpdatePlatformAccountTaxConfigurationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxType = _data["taxType"];
            if (Array.isArray(_data["defaultTaxes"])) {
                this.defaultTaxes = [] as any;
                for (let item of _data["defaultTaxes"])
                    this.defaultTaxes!.push(TaxLine.fromJS(item));
            }
            if (Array.isArray(_data["onlineCustomerFeeTaxes"])) {
                this.onlineCustomerFeeTaxes = [] as any;
                for (let item of _data["onlineCustomerFeeTaxes"])
                    this.onlineCustomerFeeTaxes!.push(TaxLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePlatformAccountTaxConfigurationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlatformAccountTaxConfigurationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxType"] = this.taxType;
        if (Array.isArray(this.defaultTaxes)) {
            data["defaultTaxes"] = [];
            for (let item of this.defaultTaxes)
                data["defaultTaxes"].push(item.toJSON());
        }
        if (Array.isArray(this.onlineCustomerFeeTaxes)) {
            data["onlineCustomerFeeTaxes"] = [];
            for (let item of this.onlineCustomerFeeTaxes)
                data["onlineCustomerFeeTaxes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdatePlatformAccountTaxConfigurationCommand {
    taxType: TaxType;
    defaultTaxes?: TaxLine[] | null;
    onlineCustomerFeeTaxes?: TaxLine[] | null;
}

export class UpdatePricingCommand implements IUpdatePricingCommand {
    basePrice!: number;
    includedPassengers!: number;
    extraPassengerPrice!: number;
    extraPassengers!: number;
    additionalFees?: AdditionalFeeItemDto[] | null;

    constructor(data?: IUpdatePricingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.basePrice = _data["basePrice"];
            this.includedPassengers = _data["includedPassengers"];
            this.extraPassengerPrice = _data["extraPassengerPrice"];
            this.extraPassengers = _data["extraPassengers"];
            if (Array.isArray(_data["additionalFees"])) {
                this.additionalFees = [] as any;
                for (let item of _data["additionalFees"])
                    this.additionalFees!.push(AdditionalFeeItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePricingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePricingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basePrice"] = this.basePrice;
        data["includedPassengers"] = this.includedPassengers;
        data["extraPassengerPrice"] = this.extraPassengerPrice;
        data["extraPassengers"] = this.extraPassengers;
        if (Array.isArray(this.additionalFees)) {
            data["additionalFees"] = [];
            for (let item of this.additionalFees)
                data["additionalFees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdatePricingCommand {
    basePrice: number;
    includedPassengers: number;
    extraPassengerPrice: number;
    extraPassengers: number;
    additionalFees?: AdditionalFeeItemDto[] | null;
}

export class UpdatePricingSortOrderCommand implements IUpdatePricingSortOrderCommand {
    sortOrder?: number;

    constructor(data?: IUpdatePricingSortOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): UpdatePricingSortOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePricingSortOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IUpdatePricingSortOrderCommand {
    sortOrder?: number;
}

export class UpdateSeasonCommand implements IUpdateSeasonCommand {
    name!: string | null;
    color!: string | null;
    dateRanges!: UpdateSeasonDateRangeDto[] | null;

    constructor(data?: IUpdateSeasonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.color = _data["color"];
            if (Array.isArray(_data["dateRanges"])) {
                this.dateRanges = [] as any;
                for (let item of _data["dateRanges"])
                    this.dateRanges!.push(UpdateSeasonDateRangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSeasonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSeasonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["color"] = this.color;
        if (Array.isArray(this.dateRanges)) {
            data["dateRanges"] = [];
            for (let item of this.dateRanges)
                data["dateRanges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSeasonCommand {
    name: string | null;
    color: string | null;
    dateRanges: UpdateSeasonDateRangeDto[] | null;
}

export class UpdateSeasonDateRangeDto implements IUpdateSeasonDateRangeDto {
    startDate!: MonthDay;
    endDate!: MonthDay;

    constructor(data?: IUpdateSeasonDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.startDate = new MonthDay();
            this.endDate = new MonthDay();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? MonthDay.fromJS(_data["startDate"]) : new MonthDay();
            this.endDate = _data["endDate"] ? MonthDay.fromJS(_data["endDate"]) : new MonthDay();
        }
    }

    static fromJS(data: any): UpdateSeasonDateRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSeasonDateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toJSON() : this.startDate;
        data["endDate"] = this.endDate ? this.endDate.toJSON() : this.endDate;
        return data;
    }
}

export interface IUpdateSeasonDateRangeDto {
    startDate: MonthDay;
    endDate: MonthDay;
}

export class UpdateSkipperCommand implements IUpdateSkipperCommand {
    isAlternative?: boolean;

    constructor(data?: IUpdateSkipperCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAlternative = _data["isAlternative"];
        }
    }

    static fromJS(data: any): UpdateSkipperCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSkipperCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAlternative"] = this.isAlternative;
        return data;
    }
}

export interface IUpdateSkipperCommand {
    isAlternative?: boolean;
}

export class UpdateStickyNoteCommand implements IUpdateStickyNoteCommand {
    title?: string | null;
    description?: string | null;

    constructor(data?: IUpdateStickyNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateStickyNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStickyNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateStickyNoteCommand {
    title?: string | null;
    description?: string | null;
}

export class UpdateUserAddressCommand implements IUpdateUserAddressCommand {
    address!: UserAddress;

    constructor(data?: IUpdateUserAddressCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new UserAddress();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? UserAddress.fromJS(_data["address"]) : new UserAddress();
        }
    }

    static fromJS(data: any): UpdateUserAddressCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserAddressCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : this.address;
        return data;
    }
}

export interface IUpdateUserAddressCommand {
    address: UserAddress;
}

export class UpdateUserBasicInfoCommand implements IUpdateUserBasicInfoCommand {
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
    roles?: RoleName[] | null;

    constructor(data?: IUpdateUserBasicInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserBasicInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserBasicInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserBasicInfoCommand {
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    email?: string | null;
    phone?: string | null;
    roles?: RoleName[] | null;
}

export class UpdateUserBillingInfoCommand implements IUpdateUserBillingInfoCommand {
    billingInfo!: UserBillingInfo;

    constructor(data?: IUpdateUserBillingInfoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.billingInfo = new UserBillingInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingInfo = _data["billingInfo"] ? UserBillingInfo.fromJS(_data["billingInfo"]) : new UserBillingInfo();
        }
    }

    static fromJS(data: any): UpdateUserBillingInfoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserBillingInfoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingInfo"] = this.billingInfo ? this.billingInfo.toJSON() : this.billingInfo;
        return data;
    }
}

export interface IUpdateUserBillingInfoCommand {
    billingInfo: UserBillingInfo;
}

export class UpdateVendorCommand implements IUpdateVendorCommand {
    name!: string | null;
    type!: VendorType;
    area?: string | null;
    corporatePhoneNumber?: string | null;
    email?: string | null;
    contactPerson?: VendorContactPerson;
    notes?: string | null;

    constructor(data?: IUpdateVendorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.area = _data["area"];
            this.corporatePhoneNumber = _data["corporatePhoneNumber"];
            this.email = _data["email"];
            this.contactPerson = _data["contactPerson"] ? VendorContactPerson.fromJS(_data["contactPerson"]) : <any>null;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateVendorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVendorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["area"] = this.area;
        data["corporatePhoneNumber"] = this.corporatePhoneNumber;
        data["email"] = this.email;
        data["contactPerson"] = this.contactPerson ? this.contactPerson.toJSON() : this.contactPerson;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateVendorCommand {
    name: string | null;
    type: VendorType;
    area?: string | null;
    corporatePhoneNumber?: string | null;
    email?: string | null;
    contactPerson?: VendorContactPerson;
    notes?: string | null;
}

export class UpdateWidgetRequiredFieldsCommand implements IUpdateWidgetRequiredFieldsCommand {
    nameVisible?: boolean;
    nameRequired?: boolean;
    emailVisible?: boolean;
    emailRequired?: boolean;
    phoneVisible?: boolean;
    phoneRequired?: boolean;

    constructor(data?: IUpdateWidgetRequiredFieldsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameVisible = _data["nameVisible"];
            this.nameRequired = _data["nameRequired"];
            this.emailVisible = _data["emailVisible"];
            this.emailRequired = _data["emailRequired"];
            this.phoneVisible = _data["phoneVisible"];
            this.phoneRequired = _data["phoneRequired"];
        }
    }

    static fromJS(data: any): UpdateWidgetRequiredFieldsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWidgetRequiredFieldsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameVisible"] = this.nameVisible;
        data["nameRequired"] = this.nameRequired;
        data["emailVisible"] = this.emailVisible;
        data["emailRequired"] = this.emailRequired;
        data["phoneVisible"] = this.phoneVisible;
        data["phoneRequired"] = this.phoneRequired;
        return data;
    }
}

export interface IUpdateWidgetRequiredFieldsCommand {
    nameVisible?: boolean;
    nameRequired?: boolean;
    emailVisible?: boolean;
    emailRequired?: boolean;
    phoneVisible?: boolean;
    phoneRequired?: boolean;
}

export class UserAddress implements IUserAddress {
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;

    constructor(data?: IUserAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line = _data["line"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): UserAddress {
        data = typeof data === 'object' ? data : {};
        let result = new UserAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line"] = this.line;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["state"] = this.state;
        return data;
    }
}

export interface IUserAddress {
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;
}

export class UserBillingInfo implements IUserBillingInfo {
    companyName?: string | null;
    taxId?: string | null;
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;

    constructor(data?: IUserBillingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.taxId = _data["taxId"];
            this.line = _data["line"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): UserBillingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserBillingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["taxId"] = this.taxId;
        data["line"] = this.line;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["state"] = this.state;
        return data;
    }
}

export interface IUserBillingInfo {
    companyName?: string | null;
    taxId?: string | null;
    line?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
    state?: string | null;
}

export class UserResult implements IUserResult {
    guid!: string;
    userGuid!: string;
    firstName!: string | null;
    lastName!: string | null;
    middleName!: string | null;
    readonly fullName?: string | null;
    email!: string | null;
    phone!: string | null;

    constructor(data?: IUserResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.userGuid = _data["userGuid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            (<any>this).fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): UserResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["userGuid"] = this.userGuid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IUserResult {
    guid: string;
    userGuid: string;
    firstName: string | null;
    lastName: string | null;
    middleName: string | null;
    fullName?: string | null;
    email: string | null;
    phone: string | null;
}

export enum UserSortOptions {
    FullName = "FullName",
}

export enum UserStatus {
    Created = "Created",
    Invited = "Invited",
    Active = "Active",
    Expired = "Expired",
    Deactivated = "Deactivated",
}

export class ValidateBookingCheckoutQueryResult implements IValidateBookingCheckoutQueryResult {
    checkoutSessionUrl?: string | null;
    provider?: PaymentGateway;

    constructor(data?: IValidateBookingCheckoutQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkoutSessionUrl = _data["checkoutSessionUrl"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): ValidateBookingCheckoutQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateBookingCheckoutQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        data["provider"] = this.provider;
        return data;
    }
}

export interface IValidateBookingCheckoutQueryResult {
    checkoutSessionUrl?: string | null;
    provider?: PaymentGateway;
}

export class ValidateSeasonDateRangesQuery implements IValidateSeasonDateRangesQuery {
    seasonGuid?: string | null;
    marketGuid!: string;
    dateRanges!: UpdateSeasonDateRangeDto[] | null;

    constructor(data?: IValidateSeasonDateRangesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seasonGuid = _data["seasonGuid"];
            this.marketGuid = _data["marketGuid"];
            if (Array.isArray(_data["dateRanges"])) {
                this.dateRanges = [] as any;
                for (let item of _data["dateRanges"])
                    this.dateRanges!.push(UpdateSeasonDateRangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidateSeasonDateRangesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateSeasonDateRangesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seasonGuid"] = this.seasonGuid;
        data["marketGuid"] = this.marketGuid;
        if (Array.isArray(this.dateRanges)) {
            data["dateRanges"] = [];
            for (let item of this.dateRanges)
                data["dateRanges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidateSeasonDateRangesQuery {
    seasonGuid?: string | null;
    marketGuid: string;
    dateRanges: UpdateSeasonDateRangeDto[] | null;
}

export class ValidateSeasonDateRangesQueryResult implements IValidateSeasonDateRangesQueryResult {
    hasOverlaps?: boolean;
    overlappingRanges?: OverlappingRangeInfo[] | null;
    hasAffectedCustomPrices?: boolean;
    affectedCustomPricesCount?: number;
    affectedListingGuids?: string[] | null;
    affectedCustomPrices?: AffectedCustomPriceInfo[] | null;

    constructor(data?: IValidateSeasonDateRangesQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasOverlaps = _data["hasOverlaps"];
            if (Array.isArray(_data["overlappingRanges"])) {
                this.overlappingRanges = [] as any;
                for (let item of _data["overlappingRanges"])
                    this.overlappingRanges!.push(OverlappingRangeInfo.fromJS(item));
            }
            this.hasAffectedCustomPrices = _data["hasAffectedCustomPrices"];
            this.affectedCustomPricesCount = _data["affectedCustomPricesCount"];
            if (Array.isArray(_data["affectedListingGuids"])) {
                this.affectedListingGuids = [] as any;
                for (let item of _data["affectedListingGuids"])
                    this.affectedListingGuids!.push(item);
            }
            if (Array.isArray(_data["affectedCustomPrices"])) {
                this.affectedCustomPrices = [] as any;
                for (let item of _data["affectedCustomPrices"])
                    this.affectedCustomPrices!.push(AffectedCustomPriceInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidateSeasonDateRangesQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateSeasonDateRangesQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasOverlaps"] = this.hasOverlaps;
        if (Array.isArray(this.overlappingRanges)) {
            data["overlappingRanges"] = [];
            for (let item of this.overlappingRanges)
                data["overlappingRanges"].push(item.toJSON());
        }
        data["hasAffectedCustomPrices"] = this.hasAffectedCustomPrices;
        data["affectedCustomPricesCount"] = this.affectedCustomPricesCount;
        if (Array.isArray(this.affectedListingGuids)) {
            data["affectedListingGuids"] = [];
            for (let item of this.affectedListingGuids)
                data["affectedListingGuids"].push(item);
        }
        if (Array.isArray(this.affectedCustomPrices)) {
            data["affectedCustomPrices"] = [];
            for (let item of this.affectedCustomPrices)
                data["affectedCustomPrices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidateSeasonDateRangesQueryResult {
    hasOverlaps?: boolean;
    overlappingRanges?: OverlappingRangeInfo[] | null;
    hasAffectedCustomPrices?: boolean;
    affectedCustomPricesCount?: number;
    affectedListingGuids?: string[] | null;
    affectedCustomPrices?: AffectedCustomPriceInfo[] | null;
}

export class VendorContactPerson implements IVendorContactPerson {
    name?: string | null;
    phone?: string | null;

    constructor(data?: IVendorContactPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): VendorContactPerson {
        data = typeof data === 'object' ? data : {};
        let result = new VendorContactPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IVendorContactPerson {
    name?: string | null;
    phone?: string | null;
}

export enum VendorType {
    NotSet = "NotSet",
    Services = "Services",
    Parts = "Parts",
    Addons = "Addons",
}

export class VoidExternalPaymentCommand implements IVoidExternalPaymentCommand {
    paymentGuid!: string;
    note!: string | null;

    constructor(data?: IVoidExternalPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentGuid = _data["paymentGuid"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): VoidExternalPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new VoidExternalPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentGuid"] = this.paymentGuid;
        data["note"] = this.note;
        return data;
    }
}

export interface IVoidExternalPaymentCommand {
    paymentGuid: string;
    note: string | null;
}

export enum WidgetMode {
    Standard = "Standard",
    Enquiry = "Enquiry",
}

export class WidgetRequiredFields implements IWidgetRequiredFields {
    nameVisible?: boolean;
    nameRequired?: boolean;
    emailVisible?: boolean;
    emailRequired?: boolean;
    phoneVisible?: boolean;
    phoneRequired?: boolean;

    constructor(data?: IWidgetRequiredFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameVisible = _data["nameVisible"];
            this.nameRequired = _data["nameRequired"];
            this.emailVisible = _data["emailVisible"];
            this.emailRequired = _data["emailRequired"];
            this.phoneVisible = _data["phoneVisible"];
            this.phoneRequired = _data["phoneRequired"];
        }
    }

    static fromJS(data: any): WidgetRequiredFields {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetRequiredFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameVisible"] = this.nameVisible;
        data["nameRequired"] = this.nameRequired;
        data["emailVisible"] = this.emailVisible;
        data["emailRequired"] = this.emailRequired;
        data["phoneVisible"] = this.phoneVisible;
        data["phoneRequired"] = this.phoneRequired;
        return data;
    }
}

export interface IWidgetRequiredFields {
    nameVisible?: boolean;
    nameRequired?: boolean;
    emailVisible?: boolean;
    emailRequired?: boolean;
    phoneVisible?: boolean;
    phoneRequired?: boolean;
}

export class WidgetSettings implements IWidgetSettings {
    requiredFields?: WidgetRequiredFields;
    mode?: WidgetMode;
    theme?: WidgetTheme;

    constructor(data?: IWidgetSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requiredFields = _data["requiredFields"] ? WidgetRequiredFields.fromJS(_data["requiredFields"]) : <any>null;
            this.mode = _data["mode"];
            this.theme = _data["theme"] ? WidgetTheme.fromJS(_data["theme"]) : <any>null;
        }
    }

    static fromJS(data: any): WidgetSettings {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requiredFields"] = this.requiredFields ? this.requiredFields.toJSON() : this.requiredFields;
        data["mode"] = this.mode;
        data["theme"] = this.theme ? this.theme.toJSON() : this.theme;
        return data;
    }
}

export interface IWidgetSettings {
    requiredFields?: WidgetRequiredFields;
    mode?: WidgetMode;
    theme?: WidgetTheme;
}

export class WidgetTheme implements IWidgetTheme {
    primaryColor?: string | null;
    primaryLightColor?: string | null;
    primaryTextColor?: string | null;
    calendarTextColor?: string | null;
    buttonRadius?: string | null;

    constructor(data?: IWidgetTheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryColor = _data["primaryColor"];
            this.primaryLightColor = _data["primaryLightColor"];
            this.primaryTextColor = _data["primaryTextColor"];
            this.calendarTextColor = _data["calendarTextColor"];
            this.buttonRadius = _data["buttonRadius"];
        }
    }

    static fromJS(data: any): WidgetTheme {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetTheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryColor"] = this.primaryColor;
        data["primaryLightColor"] = this.primaryLightColor;
        data["primaryTextColor"] = this.primaryTextColor;
        data["calendarTextColor"] = this.calendarTextColor;
        data["buttonRadius"] = this.buttonRadius;
        return data;
    }
}

export interface IWidgetTheme {
    primaryColor?: string | null;
    primaryLightColor?: string | null;
    primaryTextColor?: string | null;
    calendarTextColor?: string | null;
    buttonRadius?: string | null;
}

export class WorldPayBookingCheckoutSessionResponse implements IWorldPayBookingCheckoutSessionResponse {
    start?: Date;
    end?: Date;
    passengers?: number;
    listingTitle?: string | null;
    contactPhone?: string | null;

    constructor(data?: IWorldPayBookingCheckoutSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
            this.passengers = _data["passengers"];
            this.listingTitle = _data["listingTitle"];
            this.contactPhone = _data["contactPhone"];
        }
    }

    static fromJS(data: any): WorldPayBookingCheckoutSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorldPayBookingCheckoutSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start && this.start.toISOString();
        data["end"] = this.end && this.end.toISOString();
        data["passengers"] = this.passengers;
        data["listingTitle"] = this.listingTitle;
        data["contactPhone"] = this.contactPhone;
        return data;
    }
}

export interface IWorldPayBookingCheckoutSessionResponse {
    start?: Date;
    end?: Date;
    passengers?: number;
    listingTitle?: string | null;
    contactPhone?: string | null;
}

export class WorldPayCheckoutSessionLineItem implements IWorldPayCheckoutSessionLineItem {
    readonly guid?: string;
    name?: string | null;
    unitPrice?: number;
    quantity?: number;
    totalPrice?: number;

    constructor(data?: IWorldPayCheckoutSessionLineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            this.name = _data["name"];
            this.unitPrice = _data["unitPrice"];
            this.quantity = _data["quantity"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): WorldPayCheckoutSessionLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new WorldPayCheckoutSessionLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["unitPrice"] = this.unitPrice;
        data["quantity"] = this.quantity;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IWorldPayCheckoutSessionLineItem {
    guid?: string;
    name?: string | null;
    unitPrice?: number;
    quantity?: number;
    totalPrice?: number;
}

export class WorldPayPaymentInfo implements IWorldPayPaymentInfo {
    readonly guid?: string;
    readonly transactionId?: string | null;
    readonly worldPayCustomerId?: string | null;
    readonly checkoutSessionGuid?: string | null;
    readonly checkoutSessionUrl?: string | null;
    readonly authorizationCode?: string | null;
    transactionStatus?: WorldPayTransactionStatus;
    readonly errorCode?: string | null;
    readonly errorMessage?: string | null;
    readonly paymentProcessorCost?: number | null;
    readonly paymentMethodType?: string | null;
    paymentMethodInfo?: WorldPayPaymentMethod;

    constructor(data?: IWorldPayPaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).transactionId = _data["transactionId"];
            (<any>this).worldPayCustomerId = _data["worldPayCustomerId"];
            (<any>this).checkoutSessionGuid = _data["checkoutSessionGuid"];
            (<any>this).checkoutSessionUrl = _data["checkoutSessionUrl"];
            (<any>this).authorizationCode = _data["authorizationCode"];
            this.transactionStatus = _data["transactionStatus"];
            (<any>this).errorCode = _data["errorCode"];
            (<any>this).errorMessage = _data["errorMessage"];
            (<any>this).paymentProcessorCost = _data["paymentProcessorCost"];
            (<any>this).paymentMethodType = _data["paymentMethodType"];
            this.paymentMethodInfo = _data["paymentMethodInfo"] ? WorldPayPaymentMethod.fromJS(_data["paymentMethodInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): WorldPayPaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WorldPayPaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["transactionId"] = this.transactionId;
        data["worldPayCustomerId"] = this.worldPayCustomerId;
        data["checkoutSessionGuid"] = this.checkoutSessionGuid;
        data["checkoutSessionUrl"] = this.checkoutSessionUrl;
        data["authorizationCode"] = this.authorizationCode;
        data["transactionStatus"] = this.transactionStatus;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["paymentProcessorCost"] = this.paymentProcessorCost;
        data["paymentMethodType"] = this.paymentMethodType;
        data["paymentMethodInfo"] = this.paymentMethodInfo ? this.paymentMethodInfo.toJSON() : this.paymentMethodInfo;
        return data;
    }
}

export interface IWorldPayPaymentInfo {
    guid?: string;
    transactionId?: string | null;
    worldPayCustomerId?: string | null;
    checkoutSessionGuid?: string | null;
    checkoutSessionUrl?: string | null;
    authorizationCode?: string | null;
    transactionStatus?: WorldPayTransactionStatus;
    errorCode?: string | null;
    errorMessage?: string | null;
    paymentProcessorCost?: number | null;
    paymentMethodType?: string | null;
    paymentMethodInfo?: WorldPayPaymentMethod;
}

export class WorldPayPaymentMethod implements IWorldPayPaymentMethod {
    readonly guid?: string;
    readonly tokenId?: string | null;
    readonly token?: string | null;
    readonly lastFourDigits?: string | null;
    readonly expiration?: string | null;
    source?: PaymentMethodSource;
    readonly isReusable?: boolean;
    readonly createdAt?: Date;
    readonly lastUsedAt?: Date | null;
    readonly usageCount?: number;

    constructor(data?: IWorldPayPaymentMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["guid"];
            (<any>this).tokenId = _data["tokenId"];
            (<any>this).token = _data["token"];
            (<any>this).lastFourDigits = _data["lastFourDigits"];
            (<any>this).expiration = _data["expiration"];
            this.source = _data["source"];
            (<any>this).isReusable = _data["isReusable"];
            (<any>this).createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            (<any>this).lastUsedAt = _data["lastUsedAt"] ? new Date(_data["lastUsedAt"].toString()) : <any>null;
            (<any>this).usageCount = _data["usageCount"];
        }
    }

    static fromJS(data: any): WorldPayPaymentMethod {
        data = typeof data === 'object' ? data : {};
        let result = new WorldPayPaymentMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["tokenId"] = this.tokenId;
        data["token"] = this.token;
        data["lastFourDigits"] = this.lastFourDigits;
        data["expiration"] = this.expiration;
        data["source"] = this.source;
        data["isReusable"] = this.isReusable;
        data["createdAt"] = this.createdAt && this.createdAt.toISOString();
        data["lastUsedAt"] = this.lastUsedAt && this.lastUsedAt.toISOString();
        data["usageCount"] = this.usageCount;
        return data;
    }
}

export interface IWorldPayPaymentMethod {
    guid?: string;
    tokenId?: string | null;
    token?: string | null;
    lastFourDigits?: string | null;
    expiration?: string | null;
    source?: PaymentMethodSource;
    isReusable?: boolean;
    createdAt?: Date;
    lastUsedAt?: Date | null;
    usageCount?: number;
}

export class WorldPayPaymentMethodResponse implements IWorldPayPaymentMethodResponse {
    guid?: string;
    lastFourDigits?: string | null;
    expiration?: string | null;
    source?: PaymentMethodSource;
    isReusable?: boolean;

    constructor(data?: IWorldPayPaymentMethodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.lastFourDigits = _data["lastFourDigits"];
            this.expiration = _data["expiration"];
            this.source = _data["source"];
            this.isReusable = _data["isReusable"];
        }
    }

    static fromJS(data: any): WorldPayPaymentMethodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorldPayPaymentMethodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["lastFourDigits"] = this.lastFourDigits;
        data["expiration"] = this.expiration;
        data["source"] = this.source;
        data["isReusable"] = this.isReusable;
        return data;
    }
}

export interface IWorldPayPaymentMethodResponse {
    guid?: string;
    lastFourDigits?: string | null;
    expiration?: string | null;
    source?: PaymentMethodSource;
    isReusable?: boolean;
}

export enum WorldPayTransactionStatus {
    Pending = "Pending",
    Approved = "Approved",
    Failed = "Failed",
    Captured = "Captured",
    Settled = "Settled",
    Returned = "Returned",
    Voided = "Voided",
    Unknown = "Unknown",
}

export enum BankAccountTypeEnum {
    Checking = "checking",
    Savings = "savings",
    BusinessChecking = "businessChecking",
}

export class Body implements IBody {
    messageSid?: string;
    accountSid?: string;
    from?: string;
    to?: string;
    body?: string;
    numMedia?: number;

    [key: string]: any;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.messageSid = _data["MessageSid"];
            this.accountSid = _data["AccountSid"];
            this.from = _data["From"];
            this.to = _data["To"];
            this.body = _data["Body"];
            this.numMedia = _data["NumMedia"];
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["MessageSid"] = this.messageSid;
        data["AccountSid"] = this.accountSid;
        data["From"] = this.from;
        data["To"] = this.to;
        data["Body"] = this.body;
        data["NumMedia"] = this.numMedia;
        return data;
    }
}

export interface IBody {
    messageSid?: string;
    accountSid?: string;
    from?: string;
    to?: string;
    body?: string;
    numMedia?: number;

    [key: string]: any;
}

export class Body2 implements IBody2 {
    messageSid?: string;
    accountSid?: string;
    from?: string;
    to?: string;
    messageStatus?: string;
    errorCode?: string;
    errorMessage?: string;

    [key: string]: any;

    constructor(data?: IBody2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.messageSid = _data["MessageSid"];
            this.accountSid = _data["AccountSid"];
            this.from = _data["From"];
            this.to = _data["To"];
            this.messageStatus = _data["MessageStatus"];
            this.errorCode = _data["ErrorCode"];
            this.errorMessage = _data["ErrorMessage"];
        }
    }

    static fromJS(data: any): Body2 {
        data = typeof data === 'object' ? data : {};
        let result = new Body2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["MessageSid"] = this.messageSid;
        data["AccountSid"] = this.accountSid;
        data["From"] = this.from;
        data["To"] = this.to;
        data["MessageStatus"] = this.messageStatus;
        data["ErrorCode"] = this.errorCode;
        data["ErrorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IBody2 {
    messageSid?: string;
    accountSid?: string;
    from?: string;
    to?: string;
    messageStatus?: string;
    errorCode?: string;
    errorMessage?: string;

    [key: string]: any;
}

export class Body3 implements IBody3 {
    callSid?: string;
    accountSid?: string;
    from?: string;
    to?: string;
    callStatus?: string;
    direction?: string;

    [key: string]: any;

    constructor(data?: IBody3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.callSid = _data["CallSid"];
            this.accountSid = _data["AccountSid"];
            this.from = _data["From"];
            this.to = _data["To"];
            this.callStatus = _data["CallStatus"];
            this.direction = _data["Direction"];
        }
    }

    static fromJS(data: any): Body3 {
        data = typeof data === 'object' ? data : {};
        let result = new Body3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["CallSid"] = this.callSid;
        data["AccountSid"] = this.accountSid;
        data["From"] = this.from;
        data["To"] = this.to;
        data["CallStatus"] = this.callStatus;
        data["Direction"] = this.direction;
        return data;
    }
}

export interface IBody3 {
    callSid?: string;
    accountSid?: string;
    from?: string;
    to?: string;
    callStatus?: string;
    direction?: string;

    [key: string]: any;
}

export function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

function parseDateOnly(s: string) {
    const date = new Date(s);
    return new Date(date.getTime() + 
        date.getTimezoneOffset() * 60000);
}
//-----/CustomTypes.File-----

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

export function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

//-----/Types.File-----

import { addResultTypeFactory } from './axios-client/helpers';
export { setBaseUrl, getBaseUrl } from './axios-client/helpers';
export { setAxiosFactory, getAxios } from './axios-client/helpers';


//-----PersistorHydrator.File-----
import type { PersistedClient } from '@tanstack/react-query-persist-client';
import type { DehydratedState, QueryKey } from '@tanstack/react-query'
import { getResultTypeFactory } from './axios-client/helpers';

/*
 * If you have Dates in QueryKeys (i.e. in request parameters), you need to deserialize them to Dates correctly
 * (otherwise they are deserialized as strings by default, and your queries are broken).
 */
export function deserializeDate(str: unknown) {
  if (!str || typeof str !== 'string') return str;
  if (!/^\d\d\d\d\-\d\d\-\d\d/.test(str)) return str;
  
  const date = new Date(str);
  const isDate = date instanceof Date && !isNaN(date as any);
  
  return isDate ? date : str;
}

export function deserializeDatesInQueryKeys(queryKey: QueryKey) {
  return queryKey
    // We need to replace `null` with `undefined` in query key, because
    // `undefined` is serialized as `null`.
    // And most probably if we have `null` in QueryKey it actually means `undefined`.
    // We can't keep nulls, because they have a different meaning, and e.g. boolean parameters are not allowed to be null.
    .map(x => (x === null ? undefined : x))
    .map(x => deserializeDate(x));
}

export function deserializeClassesInQueryData(queryKey: QueryKey, data: any) {
  if (!data) {
    return data;
  } else if (typeof data !== 'object') {
    return data;
  } else if ('pages' in data && 'pageParams' in data && Array.isArray(data.pages) && Array.isArray(data.pageParams)) {
    // infinite query
    data.pages = data.pages.map((page:any) => deserializeClassesInQueryData(queryKey, page));
  } else if (Array.isArray(data)) {
    return data.map(elem => constructDtoClass(queryKey, elem));
  } else {
    return constructDtoClass(queryKey, data);
  }
}

/*
 * Pass this function as `deserialize` option to createSyncStoragePersister/createAsyncStoragePersister
 * to correctly deserialize your DTOs (including Dates)
 */
export function persisterDeserialize(cache: string): PersistedClient {
  const client: PersistedClient = JSON.parse(cache);
  client.clientState.queries.forEach((query) => {
    query.state.data = deserializeClassesInQueryData(query.queryKey, query.state.data);
    query.queryKey = deserializeDatesInQueryKeys(query.queryKey);
  });

  return client;
}

export function constructDtoClass(queryKey: QueryKey, data: any): unknown {
  const resultTypeKey = getResultTypeClassKey(queryKey);
  const constructorFunction = getResultTypeFactory(resultTypeKey);

  if (!data || !constructorFunction)
    return data;

  return constructorFunction(data);
}

export function getResultTypeClassKey(queryKey: QueryKey): string {
  if (!Array.isArray(queryKey)) {
    return queryKey as unknown as string;
  }
  if (queryKey.length >= 2) {
    // We concatenate first and second elements, because they uniquely identify the query.
    // All other QueryKey elements are query parameters
    return `${queryKey[0]}___${queryKey[1]}`;
  }

  // We actually should never reach this point :)
  return queryKey.join('___');
}

export function initPersister() {
  
  addResultTypeFactory('Client___adminAdditionalFeesGET', (data: any) => { const result = new GetAllAdditionalFeeTypesQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminAdditionalFeesGuidGET', (data: any) => { const result = new GetAdditionalFeeTypeQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminAddonsGET', (data: any) => { const result = new AddonDtoPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminAddonsGuidGET', (data: any) => { const result = new AddonDto(); result.init(data); return result; });
  addResultTypeFactory('Client___adminAddonCategoriesGET', (data: any) => { const result = new GetAllAddonCategoriesQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminAddonCategoriesGuidGET', (data: any) => { const result = new AddonCategoryDto(); result.init(data); return result; });
  addResultTypeFactory('Client___apiAdminAgentsGET', (data: any) => { const result = new GetAgentsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___apiAdminAgentsGuidGET', (data: any) => { const result = new GetAgentQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___authAvailablePlatformAccountsGET', (data: any) => { const result = new GetAvailablePlatformAccountsForAuthenticationUserQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCustomerGuidBalanceGET', (data: any) => { const result = new GetCustomerBalanceQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCustomerGuidBalanceActivitiesGET', (data: any) => { const result = new GetCustomerBalanceActivitiesResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBalanceOperatorActivitiesGET', (data: any) => { const result = new GetOperatorBalanceActivitiesResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBalanceOperatorSummaryGET', (data: any) => { const result = new GetOperatorBalanceSummaryQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBoatsGET', (data: any) => { const result = new GetBoatsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBoatsStatisticsGET', (data: any) => { const result = new GetBoatsYearsStatisticsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBoatsGuidGET', (data: any) => { const result = new GetBoatQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBoatsGuidPerformanceGET', (data: any) => { const result = new GetBoatPerformanceQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBoatsGuidCalendarGET', (data: any) => { const result = new GetBoatCalendarQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBoatsGuidCalendarDateGET', (data: any) => { const result = new GetBoatCalendarDayQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBoatsGuidAddonsGET', (data: any) => { const result = new GetBoatAllowedAddonsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBoatsByLocationLocationguidGET', (data: any) => { const result = new GetBoatsByLocationQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBoatEventsGuidGET', (data: any) => { const result = new GetBoatEventQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBoatsBoatguidIssuesGET', (data: any) => { const result = new GetBoatIssuesQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBoatsBoatguidPartsGET', (data: any) => { const result = new GetBoatPartsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBoatsBoatguidTuneUpsGET', (data: any) => { const result = new GetBoatTuneUpsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBookingsGET', (data: any) => { const result = new GetBookingsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBookingsItemsGET', (data: any) => { const result = new GetBookingItemsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBookingsCalendarGET', (data: any) => { const result = new GetCalendarBookingsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBookingsAvailabilityBookedSlotsGET', (data: any) => { const result = new GetBookingsForAvailabilityBookedSlotsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBookingsGuidGET', (data: any) => { const result = new GetBookingQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBookingsGuidCustomerGET', (data: any) => { const result = new GetBookingCustomerQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBookingsCustomerUpcomingGET', (data: any) => { const result = new GetCustomerUpcomingBookingsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBookingsCustomerHistoryGET', (data: any) => { const result = new GetCustomerBookingHistoryQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBookingsGuidMailersGET', (data: any) => { const result = new GetBookingMailersQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBookingsGuidLogsGET', (data: any) => { const result = new GetBookingLogsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBookingsWidgetDomainsGET', (data: any) => { const result = new GetBookingWidgetDomainsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBookingsGuidAttachmentsGET', (data: any) => { const result = new BookingAttachmentDto(); result.init(data); return result; });
  addResultTypeFactory('Client___adminBookingInternalNotesBookingguidGET', (data: any) => { const result = new GetBookingInternalNotesQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___apiAdminBookingMailerNotificationsBookingBookingguidGET', (data: any) => { const result = new GetBookingMailerNotificationsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminListingsListingguidCalendarPricingGET', (data: any) => { const result = new GetCalendarPricingQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminListingsListingguidCalendarPricingCalendarGET', (data: any) => { const result = new GetMarketplaceCalendarPricingQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminContractsBookingBookingguidGET', (data: any) => { const result = new GetContractsByBookingGuidQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCustomersGET', (data: any) => { const result = new GetCustomersQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCustomersRentersGET', (data: any) => { const result = new GetRentersQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCustomersProspectsGET', (data: any) => { const result = new GetProspectsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCustomersGuidGET', (data: any) => { const result = new GetCustomerQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCustomersGuidPreferencesGET', (data: any) => { const result = new CustomerPreferences(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCustomersStatisticsGET', (data: any) => { const result = new GetCustomersStatisticsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCustomersGuidStatisticsGET', (data: any) => { const result = new GetCustomerStatisticsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCustomersProspectsStatisticsGET', (data: any) => { const result = new GetProspectsStatisticsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCustomersCustomerguidWorldpayCustomerIdGET', (data: any) => { const result = new GetWorldPayCustomerIdQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCustomerNotesCustomerguidGET', (data: any) => { const result = new GetCustomerNotesQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminDashboardSalesLeadsGET', (data: any) => { const result = new DashboardCardResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminDashboardSalesEnquiriesGET', (data: any) => { const result = new DashboardCardResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminDashboardSalesBookingsGET', (data: any) => { const result = new DashboardCardResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminDashboardOperationsBookingsGET', (data: any) => { const result = new DashboardOperationsResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminDashboardMyTodoGET', (data: any) => { const result = new DashboardMyTodoResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminDashboardAvailableBoatsGET', (data: any) => { const result = new DashboardAvailableBoatResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___apiAdminDirectChannelsGET', (data: any) => { const result = new GetDirectChannelsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___apiAdminDirectChannelsGuidGET', (data: any) => { const result = new GetDirectChannelQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminDiscountTypesGET', (data: any) => { const result = new GetAllDiscountTypesQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminEmailTemplatesGET', (data: any) => { const result = new GetEmailTemplatesQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminEmailTemplatesGuidGET', (data: any) => { const result = new GetEmailTemplateQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminEmailTemplatesByTypeTemplatetypeGET', (data: any) => { const result = new GetEmailTemplateQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminExternalPaymentMethodsGET', (data: any) => { const result = new GetExternalPaymentMethodsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminHandoffsGET', (data: any) => { const result = new GetHandoffsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___apiAdminChannelsGET', (data: any) => { const result = new GetChannelsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___apiAdminChannelsGuidCampaignsCampaignguidPayoutsGET', (data: any) => { const result = new GetCampaignCommissionPayoutsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___apiAdminChannelsGuidCampaignsCampaignguidPayoutsTotalsGET', (data: any) => { const result = new GetCampaignCommissionPayoutTotalsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___apiAdminChannelsCampaignUrlsGET', (data: any) => { const result = new GetCampaignUrlsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCheckinPersonsGET', (data: any) => { const result = new GetCheckinPersonsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCheckinPersonsGuidGET', (data: any) => { const result = new GetCheckinPersonQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminCheckinPersonsDetailGET', (data: any) => { const result = new GetCheckinPersonQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminListingsGET', (data: any) => { const result = new GetListingsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminListingsAvailableForBookingGET', (data: any) => { const result = new GetListingsForBookingQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminListingsGuidGET', (data: any) => { const result = new GetListingQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminListingsCalendarDaysGET', (data: any) => { const result = new GetCalendarDaysQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminListingsCalendarDayPricingsGET', (data: any) => { const result = new GetCalendarDayPricingsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminListingsAvailabilityDayPricingsGET', (data: any) => { const result = new GetAvailabilityDayPricingsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminListingsIsAvailableForTripGET', (data: any) => { const result = new IsAvailableForTripQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminLocationsGET', (data: any) => { const result = new GetLocationsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminLocationsGuidGET', (data: any) => { const result = new GetLocationQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminMailersTemplatesGET', (data: any) => { const result = new PaginatedResult_1(); result.init(data); return result; });
  addResultTypeFactory('Client___adminMakesGET', (data: any) => { const result = new GetMakesQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminMakesGuidGET', (data: any) => { const result = new GetMakeQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminMarketsGET', (data: any) => { const result = new GetMarketsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminMarketsGuidGET', (data: any) => { const result = new GetMarketQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminMarketsGuidCalendarRecalculationStatusGET', (data: any) => { const result = new GetCalendarRecalculationStatusQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminMarketsPricingModesGET', (data: any) => { const result = new GetPricingModeInfoQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminMultibookingsGET', (data: any) => { const result = new GetMultibookingsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminMultibookingsGuidGET', (data: any) => { const result = new GetMultibookingQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminMultibookingsGuidNotificationsGET', (data: any) => { const result = new GetBookingMailerNotificationsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminMultibookingsGuidPaymentsGET', (data: any) => { const result = new GetMultibookingPaymentsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminOperatorPayoutsGET', (data: any) => { const result = new GetOperatorPayoutsResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminOperatorPayoutsSummaryGET', (data: any) => { const result = new GetOperatorPayoutsSummaryQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminOwnersGET', (data: any) => { const result = new GetOwnersQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminOwnersDetailGET', (data: any) => { const result = new GetOwnerQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPackagesGET', (data: any) => { const result = new GetPackagesQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPackagesGuidGET', (data: any) => { const result = new GetPackageQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPackagesCountGET', (data: any) => { const result = new PackagesCountModel(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPaymentsGuidGET', (data: any) => { const result = new GetPaymentQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPaymentsMethodsGET', (data: any) => { const result = new StripePaymentMethod(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPaymentsAuthorize_NetMethodsGET', (data: any) => { const result = new GetAuthorizeNetPaymentProfilesQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPaymentsBookingGET', (data: any) => { const result = new GetPaymentsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPaymentsFeesSummaryGET', (data: any) => { const result = new GetPaymentsFeesSummaryQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPaymentsWithFeesGET', (data: any) => { const result = new GetPaymentsWithFeesQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPaymentsAllListGET', (data: any) => { const result = new GetAllPaymentsListResponse(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPaymentsAuthorize_NetCheckoutSessionGuidGET', (data: any) => { const result = new GetAuthorizeNetCheckoutSessionQueryResponse(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPaymentsWorldpayMethodsFinancecustomerguidGET', (data: any) => { const result = new GetWorldPayPaymentMethodsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPaymentsWorldpayCheckoutSessionGuidGET', (data: any) => { const result = new GetWorldPayCheckoutSessionQueryResponse(); result.init(data); return result; });
  addResultTypeFactory('Client___managementPlatformAccountsGET', (data: any) => { const result = new GetPlatformAccountsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___managementPlatformAccountsGuidGET', (data: any) => { const result = new GetPlatformAccountQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___managementPlatformAccountsGuidPublicGET', (data: any) => { const result = new GetPublicPlatformAccountQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___managementPlatformAccountsSettingsGET', (data: any) => { const result = new GetPlatformAccountSettingsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___managementPlatformAccountsAccessTokenGET', (data: any) => { const result = new GetPlatformAccountAccessTokensQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___managementPlatformAccountsGoogleAdsAuthUrlGET', (data: any) => { const result = new GetGoogleAdsAuthUrlQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPrePaymentPoliciesGET', (data: any) => { const result = new GetPlatformAccountPrePaymentSettingsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPricingsGuidGET', (data: any) => { const result = new GetPricingQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPricingsGET', (data: any) => { const result = new GetPricingsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPricingsCalendarGET', (data: any) => { const result = new GetBoatPricingsCalendarQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminPricingsCalculateCalendarGET', (data: any) => { const result = new GetAdminCalendarCalculatedPriceQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminRevenuesPerformanceGET', (data: any) => { const result = new GetPerformanceQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminRevenuesRevenueGET', (data: any) => { const result = new GetRevenueQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminRevenuesRevenuePaymentMethodsGET', (data: any) => { const result = new GetRevenueByPaymentMethodQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminSalesLeadsGET', (data: any) => { const result = new GetSalesLeadsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminSalesLeadsGuidGET', (data: any) => { const result = new GetSalesLeadDetailQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminSalesLeadsStatisticsGET', (data: any) => { const result = new GetSalesLeadStatisticsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminSalesLeadsAircallGET', (data: any) => { const result = new GetAircallSalesLeadsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminSalesLeadsGuidMessagesGET', (data: any) => { const result = new GetSalesLeadMessagesQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminSalesPersonsGET', (data: any) => { const result = new GetSalesPersonsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminSalesPersonsDetailGET', (data: any) => { const result = new GetSalesPersonQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminSeasonsGET', (data: any) => { const result = new GetSeasonsQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminSeasonsGuidGET', (data: any) => { const result = new GetSeasonQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminSeasonsUncoveredGET', (data: any) => { const result = new GetUncoveredDatesQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminSkippersGET', (data: any) => { const result = new GetSkippersQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminSkippersGuidGET', (data: any) => { const result = new GetSkipperQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminSkippersDetailGET', (data: any) => { const result = new GetSkipperQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminStewardessesGET', (data: any) => { const result = new GetStewardessesQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminStewardessesDetailGET', (data: any) => { const result = new GetStewardessQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminStickyNotesGET', (data: any) => { const result = new GetStickyNotesQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminUsersGET', (data: any) => { const result = new GetUsersQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminUsersGuidGET', (data: any) => { const result = new GetUserQueryResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminVendorsGET', (data: any) => { const result = new GetVendorsQueryResultPaginatedResult(); result.init(data); return result; });
  addResultTypeFactory('Client___adminWorldpayMerchantsPlatformaccountguidGET', (data: any) => { const result = new GetWorldPayMerchantQueryResult(); result.init(data); return result; });


}
//-----/PersistorHydrator.File----